/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.app = (function() {

    /**
     * Namespace app.
     * @exports app
     * @namespace
     */
    var app = {};

    app.ForceOffline = (function() {

        /**
         * Properties of a ForceOffline.
         * @memberof app
         * @interface IForceOffline
         */

        /**
         * Constructs a new ForceOffline.
         * @memberof app
         * @classdesc Represents a ForceOffline.
         * @implements IForceOffline
         * @constructor
         * @param {app.IForceOffline=} [properties] Properties to set
         */
        function ForceOffline(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ForceOffline instance using the specified properties.
         * @function create
         * @memberof app.ForceOffline
         * @static
         * @param {app.IForceOffline=} [properties] Properties to set
         * @returns {app.ForceOffline} ForceOffline instance
         */
        ForceOffline.create = function create(properties) {
            return new ForceOffline(properties);
        };

        /**
         * Encodes the specified ForceOffline message. Does not implicitly {@link app.ForceOffline.verify|verify} messages.
         * @function encode
         * @memberof app.ForceOffline
         * @static
         * @param {app.IForceOffline} message ForceOffline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ForceOffline.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ForceOffline message, length delimited. Does not implicitly {@link app.ForceOffline.verify|verify} messages.
         * @function encodeDelimited
         * @memberof app.ForceOffline
         * @static
         * @param {app.IForceOffline} message ForceOffline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ForceOffline.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ForceOffline message from the specified reader or buffer.
         * @function decode
         * @memberof app.ForceOffline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {app.ForceOffline} ForceOffline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ForceOffline.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.ForceOffline();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ForceOffline message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof app.ForceOffline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {app.ForceOffline} ForceOffline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ForceOffline.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ForceOffline message.
         * @function verify
         * @memberof app.ForceOffline
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ForceOffline.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a ForceOffline message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof app.ForceOffline
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {app.ForceOffline} ForceOffline
         */
        ForceOffline.fromObject = function fromObject(object) {
            if (object instanceof $root.app.ForceOffline)
                return object;
            return new $root.app.ForceOffline();
        };

        /**
         * Creates a plain object from a ForceOffline message. Also converts values to other types if specified.
         * @function toObject
         * @memberof app.ForceOffline
         * @static
         * @param {app.ForceOffline} message ForceOffline
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ForceOffline.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ForceOffline to JSON.
         * @function toJSON
         * @memberof app.ForceOffline
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ForceOffline.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        ForceOffline.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof app.ForceOffline
             * @interface IRequest
             * @property {string|null} [token] Request token
             * @property {string|null} [deviceId] Request deviceId
             * @property {string|null} [offlineDeviceId] Request offlineDeviceId
             */

            /**
             * Constructs a new Request.
             * @memberof app.ForceOffline
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {app.ForceOffline.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request token.
             * @member {string} token
             * @memberof app.ForceOffline.Request
             * @instance
             */
            Request.prototype.token = "";

            /**
             * Request deviceId.
             * @member {string} deviceId
             * @memberof app.ForceOffline.Request
             * @instance
             */
            Request.prototype.deviceId = "";

            /**
             * Request offlineDeviceId.
             * @member {string} offlineDeviceId
             * @memberof app.ForceOffline.Request
             * @instance
             */
            Request.prototype.offlineDeviceId = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof app.ForceOffline.Request
             * @static
             * @param {app.ForceOffline.IRequest=} [properties] Properties to set
             * @returns {app.ForceOffline.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link app.ForceOffline.Request.verify|verify} messages.
             * @function encode
             * @memberof app.ForceOffline.Request
             * @static
             * @param {app.ForceOffline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.token);
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.deviceId);
                if (message.offlineDeviceId != null && Object.hasOwnProperty.call(message, "offlineDeviceId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.offlineDeviceId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link app.ForceOffline.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.ForceOffline.Request
             * @static
             * @param {app.ForceOffline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof app.ForceOffline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.ForceOffline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.ForceOffline.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.token = reader.string();
                        break;
                    case 2:
                        message.deviceId = reader.string();
                        break;
                    case 4:
                        message.offlineDeviceId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.ForceOffline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.ForceOffline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof app.ForceOffline.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.offlineDeviceId != null && message.hasOwnProperty("offlineDeviceId"))
                    if (!$util.isString(message.offlineDeviceId))
                        return "offlineDeviceId: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.ForceOffline.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.ForceOffline.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.app.ForceOffline.Request)
                    return object;
                var message = new $root.app.ForceOffline.Request();
                if (object.token != null)
                    message.token = String(object.token);
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.offlineDeviceId != null)
                    message.offlineDeviceId = String(object.offlineDeviceId);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.ForceOffline.Request
             * @static
             * @param {app.ForceOffline.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.token = "";
                    object.deviceId = "";
                    object.offlineDeviceId = "";
                }
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.offlineDeviceId != null && message.hasOwnProperty("offlineDeviceId"))
                    object.offlineDeviceId = message.offlineDeviceId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof app.ForceOffline.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        ForceOffline.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof app.ForceOffline
             * @interface IResponse
             */

            /**
             * Constructs a new Response.
             * @memberof app.ForceOffline
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {app.ForceOffline.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof app.ForceOffline.Response
             * @static
             * @param {app.ForceOffline.IResponse=} [properties] Properties to set
             * @returns {app.ForceOffline.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link app.ForceOffline.Response.verify|verify} messages.
             * @function encode
             * @memberof app.ForceOffline.Response
             * @static
             * @param {app.ForceOffline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link app.ForceOffline.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.ForceOffline.Response
             * @static
             * @param {app.ForceOffline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof app.ForceOffline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.ForceOffline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.ForceOffline.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.ForceOffline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.ForceOffline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof app.ForceOffline.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.ForceOffline.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.ForceOffline.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.app.ForceOffline.Response)
                    return object;
                return new $root.app.ForceOffline.Response();
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.ForceOffline.Response
             * @static
             * @param {app.ForceOffline.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof app.ForceOffline.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return ForceOffline;
    })();

    app.OnForceOffline = (function() {

        /**
         * Properties of an OnForceOffline.
         * @memberof app
         * @interface IOnForceOffline
         */

        /**
         * Constructs a new OnForceOffline.
         * @memberof app
         * @classdesc Represents an OnForceOffline.
         * @implements IOnForceOffline
         * @constructor
         * @param {app.IOnForceOffline=} [properties] Properties to set
         */
        function OnForceOffline(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new OnForceOffline instance using the specified properties.
         * @function create
         * @memberof app.OnForceOffline
         * @static
         * @param {app.IOnForceOffline=} [properties] Properties to set
         * @returns {app.OnForceOffline} OnForceOffline instance
         */
        OnForceOffline.create = function create(properties) {
            return new OnForceOffline(properties);
        };

        /**
         * Encodes the specified OnForceOffline message. Does not implicitly {@link app.OnForceOffline.verify|verify} messages.
         * @function encode
         * @memberof app.OnForceOffline
         * @static
         * @param {app.IOnForceOffline} message OnForceOffline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OnForceOffline.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified OnForceOffline message, length delimited. Does not implicitly {@link app.OnForceOffline.verify|verify} messages.
         * @function encodeDelimited
         * @memberof app.OnForceOffline
         * @static
         * @param {app.IOnForceOffline} message OnForceOffline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OnForceOffline.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OnForceOffline message from the specified reader or buffer.
         * @function decode
         * @memberof app.OnForceOffline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {app.OnForceOffline} OnForceOffline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OnForceOffline.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.OnForceOffline();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OnForceOffline message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof app.OnForceOffline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {app.OnForceOffline} OnForceOffline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OnForceOffline.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OnForceOffline message.
         * @function verify
         * @memberof app.OnForceOffline
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OnForceOffline.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an OnForceOffline message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof app.OnForceOffline
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {app.OnForceOffline} OnForceOffline
         */
        OnForceOffline.fromObject = function fromObject(object) {
            if (object instanceof $root.app.OnForceOffline)
                return object;
            return new $root.app.OnForceOffline();
        };

        /**
         * Creates a plain object from an OnForceOffline message. Also converts values to other types if specified.
         * @function toObject
         * @memberof app.OnForceOffline
         * @static
         * @param {app.OnForceOffline} message OnForceOffline
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OnForceOffline.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this OnForceOffline to JSON.
         * @function toJSON
         * @memberof app.OnForceOffline
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OnForceOffline.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        OnForceOffline.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof app.OnForceOffline
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof app.OnForceOffline
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {app.OnForceOffline.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {app.OnForceOffline.IRequest=} [properties] Properties to set
             * @returns {app.OnForceOffline.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link app.OnForceOffline.Request.verify|verify} messages.
             * @function encode
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {app.OnForceOffline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link app.OnForceOffline.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {app.OnForceOffline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.OnForceOffline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.OnForceOffline.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.OnForceOffline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.OnForceOffline.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.app.OnForceOffline.Request)
                    return object;
                return new $root.app.OnForceOffline.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {app.OnForceOffline.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof app.OnForceOffline.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        OnForceOffline.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof app.OnForceOffline
             * @interface IResponse
             */

            /**
             * Constructs a new Response.
             * @memberof app.OnForceOffline
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {app.OnForceOffline.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {app.OnForceOffline.IResponse=} [properties] Properties to set
             * @returns {app.OnForceOffline.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link app.OnForceOffline.Response.verify|verify} messages.
             * @function encode
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {app.OnForceOffline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link app.OnForceOffline.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {app.OnForceOffline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.OnForceOffline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.OnForceOffline.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.OnForceOffline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.OnForceOffline.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.app.OnForceOffline.Response)
                    return object;
                return new $root.app.OnForceOffline.Response();
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {app.OnForceOffline.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof app.OnForceOffline.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return OnForceOffline;
    })();

    app.OnlineDeviceList = (function() {

        /**
         * Properties of an OnlineDeviceList.
         * @memberof app
         * @interface IOnlineDeviceList
         * @property {user.ISSOUserInfo|null} [userInfo] OnlineDeviceList userInfo
         * @property {number|null} [loginTime] OnlineDeviceList loginTime
         * @property {user.IUserAgent|null} [userAgent] OnlineDeviceList userAgent
         * @property {string|null} [location] OnlineDeviceList location
         * @property {string|null} [deviceId] OnlineDeviceList deviceId
         */

        /**
         * Constructs a new OnlineDeviceList.
         * @memberof app
         * @classdesc Represents an OnlineDeviceList.
         * @implements IOnlineDeviceList
         * @constructor
         * @param {app.IOnlineDeviceList=} [properties] Properties to set
         */
        function OnlineDeviceList(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OnlineDeviceList userInfo.
         * @member {user.ISSOUserInfo|null|undefined} userInfo
         * @memberof app.OnlineDeviceList
         * @instance
         */
        OnlineDeviceList.prototype.userInfo = null;

        /**
         * OnlineDeviceList loginTime.
         * @member {number} loginTime
         * @memberof app.OnlineDeviceList
         * @instance
         */
        OnlineDeviceList.prototype.loginTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * OnlineDeviceList userAgent.
         * @member {user.IUserAgent|null|undefined} userAgent
         * @memberof app.OnlineDeviceList
         * @instance
         */
        OnlineDeviceList.prototype.userAgent = null;

        /**
         * OnlineDeviceList location.
         * @member {string} location
         * @memberof app.OnlineDeviceList
         * @instance
         */
        OnlineDeviceList.prototype.location = "";

        /**
         * OnlineDeviceList deviceId.
         * @member {string} deviceId
         * @memberof app.OnlineDeviceList
         * @instance
         */
        OnlineDeviceList.prototype.deviceId = "";

        /**
         * Creates a new OnlineDeviceList instance using the specified properties.
         * @function create
         * @memberof app.OnlineDeviceList
         * @static
         * @param {app.IOnlineDeviceList=} [properties] Properties to set
         * @returns {app.OnlineDeviceList} OnlineDeviceList instance
         */
        OnlineDeviceList.create = function create(properties) {
            return new OnlineDeviceList(properties);
        };

        /**
         * Encodes the specified OnlineDeviceList message. Does not implicitly {@link app.OnlineDeviceList.verify|verify} messages.
         * @function encode
         * @memberof app.OnlineDeviceList
         * @static
         * @param {app.IOnlineDeviceList} message OnlineDeviceList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OnlineDeviceList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
                $root.user.SSOUserInfo.encode(message.userInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.loginTime != null && Object.hasOwnProperty.call(message, "loginTime"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.loginTime);
            if (message.userAgent != null && Object.hasOwnProperty.call(message, "userAgent"))
                $root.user.UserAgent.encode(message.userAgent, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.location);
            if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.deviceId);
            return writer;
        };

        /**
         * Encodes the specified OnlineDeviceList message, length delimited. Does not implicitly {@link app.OnlineDeviceList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof app.OnlineDeviceList
         * @static
         * @param {app.IOnlineDeviceList} message OnlineDeviceList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OnlineDeviceList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OnlineDeviceList message from the specified reader or buffer.
         * @function decode
         * @memberof app.OnlineDeviceList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {app.OnlineDeviceList} OnlineDeviceList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OnlineDeviceList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.OnlineDeviceList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.userInfo = $root.user.SSOUserInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.loginTime = reader.int64();
                    break;
                case 3:
                    message.userAgent = $root.user.UserAgent.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.location = reader.string();
                    break;
                case 5:
                    message.deviceId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OnlineDeviceList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof app.OnlineDeviceList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {app.OnlineDeviceList} OnlineDeviceList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OnlineDeviceList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OnlineDeviceList message.
         * @function verify
         * @memberof app.OnlineDeviceList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OnlineDeviceList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
                var error = $root.user.SSOUserInfo.verify(message.userInfo);
                if (error)
                    return "userInfo." + error;
            }
            if (message.loginTime != null && message.hasOwnProperty("loginTime"))
                if (!$util.isInteger(message.loginTime) && !(message.loginTime && $util.isInteger(message.loginTime.low) && $util.isInteger(message.loginTime.high)))
                    return "loginTime: integer|Long expected";
            if (message.userAgent != null && message.hasOwnProperty("userAgent")) {
                var error = $root.user.UserAgent.verify(message.userAgent);
                if (error)
                    return "userAgent." + error;
            }
            if (message.location != null && message.hasOwnProperty("location"))
                if (!$util.isString(message.location))
                    return "location: string expected";
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (!$util.isString(message.deviceId))
                    return "deviceId: string expected";
            return null;
        };

        /**
         * Creates an OnlineDeviceList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof app.OnlineDeviceList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {app.OnlineDeviceList} OnlineDeviceList
         */
        OnlineDeviceList.fromObject = function fromObject(object) {
            if (object instanceof $root.app.OnlineDeviceList)
                return object;
            var message = new $root.app.OnlineDeviceList();
            if (object.userInfo != null) {
                if (typeof object.userInfo !== "object")
                    throw TypeError(".app.OnlineDeviceList.userInfo: object expected");
                message.userInfo = $root.user.SSOUserInfo.fromObject(object.userInfo);
            }
            if (object.loginTime != null)
                if ($util.Long)
                    (message.loginTime = $util.Long.fromValue(object.loginTime)).unsigned = false;
                else if (typeof object.loginTime === "string")
                    message.loginTime = parseInt(object.loginTime, 10);
                else if (typeof object.loginTime === "number")
                    message.loginTime = object.loginTime;
                else if (typeof object.loginTime === "object")
                    message.loginTime = new $util.LongBits(object.loginTime.low >>> 0, object.loginTime.high >>> 0).toNumber();
            if (object.userAgent != null) {
                if (typeof object.userAgent !== "object")
                    throw TypeError(".app.OnlineDeviceList.userAgent: object expected");
                message.userAgent = $root.user.UserAgent.fromObject(object.userAgent);
            }
            if (object.location != null)
                message.location = String(object.location);
            if (object.deviceId != null)
                message.deviceId = String(object.deviceId);
            return message;
        };

        /**
         * Creates a plain object from an OnlineDeviceList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof app.OnlineDeviceList
         * @static
         * @param {app.OnlineDeviceList} message OnlineDeviceList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OnlineDeviceList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.userInfo = null;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.loginTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.loginTime = options.longs === String ? "0" : 0;
                object.userAgent = null;
                object.location = "";
                object.deviceId = "";
            }
            if (message.userInfo != null && message.hasOwnProperty("userInfo"))
                object.userInfo = $root.user.SSOUserInfo.toObject(message.userInfo, options);
            if (message.loginTime != null && message.hasOwnProperty("loginTime"))
                if (typeof message.loginTime === "number")
                    object.loginTime = options.longs === String ? String(message.loginTime) : message.loginTime;
                else
                    object.loginTime = options.longs === String ? $util.Long.prototype.toString.call(message.loginTime) : options.longs === Number ? new $util.LongBits(message.loginTime.low >>> 0, message.loginTime.high >>> 0).toNumber() : message.loginTime;
            if (message.userAgent != null && message.hasOwnProperty("userAgent"))
                object.userAgent = $root.user.UserAgent.toObject(message.userAgent, options);
            if (message.location != null && message.hasOwnProperty("location"))
                object.location = message.location;
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                object.deviceId = message.deviceId;
            return object;
        };

        /**
         * Converts this OnlineDeviceList to JSON.
         * @function toJSON
         * @memberof app.OnlineDeviceList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OnlineDeviceList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OnlineDeviceList;
    })();

    app.OtherDeviceOnline = (function() {

        /**
         * Properties of an OtherDeviceOnline.
         * @memberof app
         * @interface IOtherDeviceOnline
         */

        /**
         * Constructs a new OtherDeviceOnline.
         * @memberof app
         * @classdesc Represents an OtherDeviceOnline.
         * @implements IOtherDeviceOnline
         * @constructor
         * @param {app.IOtherDeviceOnline=} [properties] Properties to set
         */
        function OtherDeviceOnline(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new OtherDeviceOnline instance using the specified properties.
         * @function create
         * @memberof app.OtherDeviceOnline
         * @static
         * @param {app.IOtherDeviceOnline=} [properties] Properties to set
         * @returns {app.OtherDeviceOnline} OtherDeviceOnline instance
         */
        OtherDeviceOnline.create = function create(properties) {
            return new OtherDeviceOnline(properties);
        };

        /**
         * Encodes the specified OtherDeviceOnline message. Does not implicitly {@link app.OtherDeviceOnline.verify|verify} messages.
         * @function encode
         * @memberof app.OtherDeviceOnline
         * @static
         * @param {app.IOtherDeviceOnline} message OtherDeviceOnline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OtherDeviceOnline.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified OtherDeviceOnline message, length delimited. Does not implicitly {@link app.OtherDeviceOnline.verify|verify} messages.
         * @function encodeDelimited
         * @memberof app.OtherDeviceOnline
         * @static
         * @param {app.IOtherDeviceOnline} message OtherDeviceOnline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OtherDeviceOnline.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OtherDeviceOnline message from the specified reader or buffer.
         * @function decode
         * @memberof app.OtherDeviceOnline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {app.OtherDeviceOnline} OtherDeviceOnline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OtherDeviceOnline.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.OtherDeviceOnline();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OtherDeviceOnline message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof app.OtherDeviceOnline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {app.OtherDeviceOnline} OtherDeviceOnline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OtherDeviceOnline.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OtherDeviceOnline message.
         * @function verify
         * @memberof app.OtherDeviceOnline
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OtherDeviceOnline.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an OtherDeviceOnline message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof app.OtherDeviceOnline
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {app.OtherDeviceOnline} OtherDeviceOnline
         */
        OtherDeviceOnline.fromObject = function fromObject(object) {
            if (object instanceof $root.app.OtherDeviceOnline)
                return object;
            return new $root.app.OtherDeviceOnline();
        };

        /**
         * Creates a plain object from an OtherDeviceOnline message. Also converts values to other types if specified.
         * @function toObject
         * @memberof app.OtherDeviceOnline
         * @static
         * @param {app.OtherDeviceOnline} message OtherDeviceOnline
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OtherDeviceOnline.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this OtherDeviceOnline to JSON.
         * @function toJSON
         * @memberof app.OtherDeviceOnline
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OtherDeviceOnline.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        OtherDeviceOnline.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof app.OtherDeviceOnline
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof app.OtherDeviceOnline
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {app.OtherDeviceOnline.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof app.OtherDeviceOnline.Request
             * @static
             * @param {app.OtherDeviceOnline.IRequest=} [properties] Properties to set
             * @returns {app.OtherDeviceOnline.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link app.OtherDeviceOnline.Request.verify|verify} messages.
             * @function encode
             * @memberof app.OtherDeviceOnline.Request
             * @static
             * @param {app.OtherDeviceOnline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link app.OtherDeviceOnline.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.OtherDeviceOnline.Request
             * @static
             * @param {app.OtherDeviceOnline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof app.OtherDeviceOnline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.OtherDeviceOnline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.OtherDeviceOnline.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.OtherDeviceOnline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.OtherDeviceOnline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof app.OtherDeviceOnline.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.OtherDeviceOnline.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.OtherDeviceOnline.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.app.OtherDeviceOnline.Request)
                    return object;
                return new $root.app.OtherDeviceOnline.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.OtherDeviceOnline.Request
             * @static
             * @param {app.OtherDeviceOnline.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof app.OtherDeviceOnline.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        OtherDeviceOnline.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof app.OtherDeviceOnline
             * @interface IResponse
             * @property {app.IOnlineDeviceList|null} [currentDevice] Response currentDevice
             * @property {Array.<app.IOnlineDeviceList>|null} [onlineDeviceList] Response onlineDeviceList
             */

            /**
             * Constructs a new Response.
             * @memberof app.OtherDeviceOnline
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {app.OtherDeviceOnline.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.onlineDeviceList = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response currentDevice.
             * @member {app.IOnlineDeviceList|null|undefined} currentDevice
             * @memberof app.OtherDeviceOnline.Response
             * @instance
             */
            Response.prototype.currentDevice = null;

            /**
             * Response onlineDeviceList.
             * @member {Array.<app.IOnlineDeviceList>} onlineDeviceList
             * @memberof app.OtherDeviceOnline.Response
             * @instance
             */
            Response.prototype.onlineDeviceList = $util.emptyArray;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof app.OtherDeviceOnline.Response
             * @static
             * @param {app.OtherDeviceOnline.IResponse=} [properties] Properties to set
             * @returns {app.OtherDeviceOnline.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link app.OtherDeviceOnline.Response.verify|verify} messages.
             * @function encode
             * @memberof app.OtherDeviceOnline.Response
             * @static
             * @param {app.OtherDeviceOnline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.currentDevice != null && Object.hasOwnProperty.call(message, "currentDevice"))
                    $root.app.OnlineDeviceList.encode(message.currentDevice, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.onlineDeviceList != null && message.onlineDeviceList.length)
                    for (var i = 0; i < message.onlineDeviceList.length; ++i)
                        $root.app.OnlineDeviceList.encode(message.onlineDeviceList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link app.OtherDeviceOnline.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.OtherDeviceOnline.Response
             * @static
             * @param {app.OtherDeviceOnline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof app.OtherDeviceOnline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.OtherDeviceOnline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.OtherDeviceOnline.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.currentDevice = $root.app.OnlineDeviceList.decode(reader, reader.uint32());
                        break;
                    case 2:
                        if (!(message.onlineDeviceList && message.onlineDeviceList.length))
                            message.onlineDeviceList = [];
                        message.onlineDeviceList.push($root.app.OnlineDeviceList.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.OtherDeviceOnline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.OtherDeviceOnline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof app.OtherDeviceOnline.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.currentDevice != null && message.hasOwnProperty("currentDevice")) {
                    var error = $root.app.OnlineDeviceList.verify(message.currentDevice);
                    if (error)
                        return "currentDevice." + error;
                }
                if (message.onlineDeviceList != null && message.hasOwnProperty("onlineDeviceList")) {
                    if (!Array.isArray(message.onlineDeviceList))
                        return "onlineDeviceList: array expected";
                    for (var i = 0; i < message.onlineDeviceList.length; ++i) {
                        var error = $root.app.OnlineDeviceList.verify(message.onlineDeviceList[i]);
                        if (error)
                            return "onlineDeviceList." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.OtherDeviceOnline.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.OtherDeviceOnline.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.app.OtherDeviceOnline.Response)
                    return object;
                var message = new $root.app.OtherDeviceOnline.Response();
                if (object.currentDevice != null) {
                    if (typeof object.currentDevice !== "object")
                        throw TypeError(".app.OtherDeviceOnline.Response.currentDevice: object expected");
                    message.currentDevice = $root.app.OnlineDeviceList.fromObject(object.currentDevice);
                }
                if (object.onlineDeviceList) {
                    if (!Array.isArray(object.onlineDeviceList))
                        throw TypeError(".app.OtherDeviceOnline.Response.onlineDeviceList: array expected");
                    message.onlineDeviceList = [];
                    for (var i = 0; i < object.onlineDeviceList.length; ++i) {
                        if (typeof object.onlineDeviceList[i] !== "object")
                            throw TypeError(".app.OtherDeviceOnline.Response.onlineDeviceList: object expected");
                        message.onlineDeviceList[i] = $root.app.OnlineDeviceList.fromObject(object.onlineDeviceList[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.OtherDeviceOnline.Response
             * @static
             * @param {app.OtherDeviceOnline.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.onlineDeviceList = [];
                if (options.defaults)
                    object.currentDevice = null;
                if (message.currentDevice != null && message.hasOwnProperty("currentDevice"))
                    object.currentDevice = $root.app.OnlineDeviceList.toObject(message.currentDevice, options);
                if (message.onlineDeviceList && message.onlineDeviceList.length) {
                    object.onlineDeviceList = [];
                    for (var j = 0; j < message.onlineDeviceList.length; ++j)
                        object.onlineDeviceList[j] = $root.app.OnlineDeviceList.toObject(message.onlineDeviceList[j], options);
                }
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof app.OtherDeviceOnline.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return OtherDeviceOnline;
    })();

    app.OtherDeviceOffline = (function() {

        /**
         * Properties of an OtherDeviceOffline.
         * @memberof app
         * @interface IOtherDeviceOffline
         */

        /**
         * Constructs a new OtherDeviceOffline.
         * @memberof app
         * @classdesc Represents an OtherDeviceOffline.
         * @implements IOtherDeviceOffline
         * @constructor
         * @param {app.IOtherDeviceOffline=} [properties] Properties to set
         */
        function OtherDeviceOffline(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new OtherDeviceOffline instance using the specified properties.
         * @function create
         * @memberof app.OtherDeviceOffline
         * @static
         * @param {app.IOtherDeviceOffline=} [properties] Properties to set
         * @returns {app.OtherDeviceOffline} OtherDeviceOffline instance
         */
        OtherDeviceOffline.create = function create(properties) {
            return new OtherDeviceOffline(properties);
        };

        /**
         * Encodes the specified OtherDeviceOffline message. Does not implicitly {@link app.OtherDeviceOffline.verify|verify} messages.
         * @function encode
         * @memberof app.OtherDeviceOffline
         * @static
         * @param {app.IOtherDeviceOffline} message OtherDeviceOffline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OtherDeviceOffline.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified OtherDeviceOffline message, length delimited. Does not implicitly {@link app.OtherDeviceOffline.verify|verify} messages.
         * @function encodeDelimited
         * @memberof app.OtherDeviceOffline
         * @static
         * @param {app.IOtherDeviceOffline} message OtherDeviceOffline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OtherDeviceOffline.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OtherDeviceOffline message from the specified reader or buffer.
         * @function decode
         * @memberof app.OtherDeviceOffline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {app.OtherDeviceOffline} OtherDeviceOffline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OtherDeviceOffline.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.OtherDeviceOffline();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OtherDeviceOffline message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof app.OtherDeviceOffline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {app.OtherDeviceOffline} OtherDeviceOffline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OtherDeviceOffline.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OtherDeviceOffline message.
         * @function verify
         * @memberof app.OtherDeviceOffline
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OtherDeviceOffline.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an OtherDeviceOffline message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof app.OtherDeviceOffline
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {app.OtherDeviceOffline} OtherDeviceOffline
         */
        OtherDeviceOffline.fromObject = function fromObject(object) {
            if (object instanceof $root.app.OtherDeviceOffline)
                return object;
            return new $root.app.OtherDeviceOffline();
        };

        /**
         * Creates a plain object from an OtherDeviceOffline message. Also converts values to other types if specified.
         * @function toObject
         * @memberof app.OtherDeviceOffline
         * @static
         * @param {app.OtherDeviceOffline} message OtherDeviceOffline
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OtherDeviceOffline.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this OtherDeviceOffline to JSON.
         * @function toJSON
         * @memberof app.OtherDeviceOffline
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OtherDeviceOffline.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        OtherDeviceOffline.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof app.OtherDeviceOffline
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof app.OtherDeviceOffline
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {app.OtherDeviceOffline.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof app.OtherDeviceOffline.Request
             * @static
             * @param {app.OtherDeviceOffline.IRequest=} [properties] Properties to set
             * @returns {app.OtherDeviceOffline.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link app.OtherDeviceOffline.Request.verify|verify} messages.
             * @function encode
             * @memberof app.OtherDeviceOffline.Request
             * @static
             * @param {app.OtherDeviceOffline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link app.OtherDeviceOffline.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.OtherDeviceOffline.Request
             * @static
             * @param {app.OtherDeviceOffline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof app.OtherDeviceOffline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.OtherDeviceOffline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.OtherDeviceOffline.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.OtherDeviceOffline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.OtherDeviceOffline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof app.OtherDeviceOffline.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.OtherDeviceOffline.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.OtherDeviceOffline.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.app.OtherDeviceOffline.Request)
                    return object;
                return new $root.app.OtherDeviceOffline.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.OtherDeviceOffline.Request
             * @static
             * @param {app.OtherDeviceOffline.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof app.OtherDeviceOffline.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        OtherDeviceOffline.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof app.OtherDeviceOffline
             * @interface IResponse
             * @property {app.IOnlineDeviceList|null} [currentDevice] Response currentDevice
             * @property {Array.<app.IOnlineDeviceList>|null} [onlineDeviceList] Response onlineDeviceList
             */

            /**
             * Constructs a new Response.
             * @memberof app.OtherDeviceOffline
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {app.OtherDeviceOffline.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.onlineDeviceList = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response currentDevice.
             * @member {app.IOnlineDeviceList|null|undefined} currentDevice
             * @memberof app.OtherDeviceOffline.Response
             * @instance
             */
            Response.prototype.currentDevice = null;

            /**
             * Response onlineDeviceList.
             * @member {Array.<app.IOnlineDeviceList>} onlineDeviceList
             * @memberof app.OtherDeviceOffline.Response
             * @instance
             */
            Response.prototype.onlineDeviceList = $util.emptyArray;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof app.OtherDeviceOffline.Response
             * @static
             * @param {app.OtherDeviceOffline.IResponse=} [properties] Properties to set
             * @returns {app.OtherDeviceOffline.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link app.OtherDeviceOffline.Response.verify|verify} messages.
             * @function encode
             * @memberof app.OtherDeviceOffline.Response
             * @static
             * @param {app.OtherDeviceOffline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.currentDevice != null && Object.hasOwnProperty.call(message, "currentDevice"))
                    $root.app.OnlineDeviceList.encode(message.currentDevice, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.onlineDeviceList != null && message.onlineDeviceList.length)
                    for (var i = 0; i < message.onlineDeviceList.length; ++i)
                        $root.app.OnlineDeviceList.encode(message.onlineDeviceList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link app.OtherDeviceOffline.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.OtherDeviceOffline.Response
             * @static
             * @param {app.OtherDeviceOffline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof app.OtherDeviceOffline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.OtherDeviceOffline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.OtherDeviceOffline.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.currentDevice = $root.app.OnlineDeviceList.decode(reader, reader.uint32());
                        break;
                    case 2:
                        if (!(message.onlineDeviceList && message.onlineDeviceList.length))
                            message.onlineDeviceList = [];
                        message.onlineDeviceList.push($root.app.OnlineDeviceList.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.OtherDeviceOffline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.OtherDeviceOffline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof app.OtherDeviceOffline.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.currentDevice != null && message.hasOwnProperty("currentDevice")) {
                    var error = $root.app.OnlineDeviceList.verify(message.currentDevice);
                    if (error)
                        return "currentDevice." + error;
                }
                if (message.onlineDeviceList != null && message.hasOwnProperty("onlineDeviceList")) {
                    if (!Array.isArray(message.onlineDeviceList))
                        return "onlineDeviceList: array expected";
                    for (var i = 0; i < message.onlineDeviceList.length; ++i) {
                        var error = $root.app.OnlineDeviceList.verify(message.onlineDeviceList[i]);
                        if (error)
                            return "onlineDeviceList." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.OtherDeviceOffline.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.OtherDeviceOffline.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.app.OtherDeviceOffline.Response)
                    return object;
                var message = new $root.app.OtherDeviceOffline.Response();
                if (object.currentDevice != null) {
                    if (typeof object.currentDevice !== "object")
                        throw TypeError(".app.OtherDeviceOffline.Response.currentDevice: object expected");
                    message.currentDevice = $root.app.OnlineDeviceList.fromObject(object.currentDevice);
                }
                if (object.onlineDeviceList) {
                    if (!Array.isArray(object.onlineDeviceList))
                        throw TypeError(".app.OtherDeviceOffline.Response.onlineDeviceList: array expected");
                    message.onlineDeviceList = [];
                    for (var i = 0; i < object.onlineDeviceList.length; ++i) {
                        if (typeof object.onlineDeviceList[i] !== "object")
                            throw TypeError(".app.OtherDeviceOffline.Response.onlineDeviceList: object expected");
                        message.onlineDeviceList[i] = $root.app.OnlineDeviceList.fromObject(object.onlineDeviceList[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.OtherDeviceOffline.Response
             * @static
             * @param {app.OtherDeviceOffline.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.onlineDeviceList = [];
                if (options.defaults)
                    object.currentDevice = null;
                if (message.currentDevice != null && message.hasOwnProperty("currentDevice"))
                    object.currentDevice = $root.app.OnlineDeviceList.toObject(message.currentDevice, options);
                if (message.onlineDeviceList && message.onlineDeviceList.length) {
                    object.onlineDeviceList = [];
                    for (var j = 0; j < message.onlineDeviceList.length; ++j)
                        object.onlineDeviceList[j] = $root.app.OnlineDeviceList.toObject(message.onlineDeviceList[j], options);
                }
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof app.OtherDeviceOffline.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return OtherDeviceOffline;
    })();

    app.SendMessagesToOtherDevices = (function() {

        /**
         * Properties of a SendMessagesToOtherDevices.
         * @memberof app
         * @interface ISendMessagesToOtherDevices
         */

        /**
         * Constructs a new SendMessagesToOtherDevices.
         * @memberof app
         * @classdesc Represents a SendMessagesToOtherDevices.
         * @implements ISendMessagesToOtherDevices
         * @constructor
         * @param {app.ISendMessagesToOtherDevices=} [properties] Properties to set
         */
        function SendMessagesToOtherDevices(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SendMessagesToOtherDevices instance using the specified properties.
         * @function create
         * @memberof app.SendMessagesToOtherDevices
         * @static
         * @param {app.ISendMessagesToOtherDevices=} [properties] Properties to set
         * @returns {app.SendMessagesToOtherDevices} SendMessagesToOtherDevices instance
         */
        SendMessagesToOtherDevices.create = function create(properties) {
            return new SendMessagesToOtherDevices(properties);
        };

        /**
         * Encodes the specified SendMessagesToOtherDevices message. Does not implicitly {@link app.SendMessagesToOtherDevices.verify|verify} messages.
         * @function encode
         * @memberof app.SendMessagesToOtherDevices
         * @static
         * @param {app.ISendMessagesToOtherDevices} message SendMessagesToOtherDevices message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendMessagesToOtherDevices.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified SendMessagesToOtherDevices message, length delimited. Does not implicitly {@link app.SendMessagesToOtherDevices.verify|verify} messages.
         * @function encodeDelimited
         * @memberof app.SendMessagesToOtherDevices
         * @static
         * @param {app.ISendMessagesToOtherDevices} message SendMessagesToOtherDevices message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendMessagesToOtherDevices.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SendMessagesToOtherDevices message from the specified reader or buffer.
         * @function decode
         * @memberof app.SendMessagesToOtherDevices
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {app.SendMessagesToOtherDevices} SendMessagesToOtherDevices
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendMessagesToOtherDevices.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.SendMessagesToOtherDevices();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SendMessagesToOtherDevices message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof app.SendMessagesToOtherDevices
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {app.SendMessagesToOtherDevices} SendMessagesToOtherDevices
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendMessagesToOtherDevices.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SendMessagesToOtherDevices message.
         * @function verify
         * @memberof app.SendMessagesToOtherDevices
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SendMessagesToOtherDevices.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a SendMessagesToOtherDevices message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof app.SendMessagesToOtherDevices
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {app.SendMessagesToOtherDevices} SendMessagesToOtherDevices
         */
        SendMessagesToOtherDevices.fromObject = function fromObject(object) {
            if (object instanceof $root.app.SendMessagesToOtherDevices)
                return object;
            return new $root.app.SendMessagesToOtherDevices();
        };

        /**
         * Creates a plain object from a SendMessagesToOtherDevices message. Also converts values to other types if specified.
         * @function toObject
         * @memberof app.SendMessagesToOtherDevices
         * @static
         * @param {app.SendMessagesToOtherDevices} message SendMessagesToOtherDevices
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendMessagesToOtherDevices.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SendMessagesToOtherDevices to JSON.
         * @function toJSON
         * @memberof app.SendMessagesToOtherDevices
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendMessagesToOtherDevices.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SendMessagesToOtherDevices.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof app.SendMessagesToOtherDevices
             * @interface IRequest
             * @property {string|null} [deviceId] Request deviceId
             * @property {string|null} [apiName] Request apiName
             * @property {string|null} [data] Request data
             */

            /**
             * Constructs a new Request.
             * @memberof app.SendMessagesToOtherDevices
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {app.SendMessagesToOtherDevices.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request deviceId.
             * @member {string} deviceId
             * @memberof app.SendMessagesToOtherDevices.Request
             * @instance
             */
            Request.prototype.deviceId = "";

            /**
             * Request apiName.
             * @member {string} apiName
             * @memberof app.SendMessagesToOtherDevices.Request
             * @instance
             */
            Request.prototype.apiName = "";

            /**
             * Request data.
             * @member {string} data
             * @memberof app.SendMessagesToOtherDevices.Request
             * @instance
             */
            Request.prototype.data = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof app.SendMessagesToOtherDevices.Request
             * @static
             * @param {app.SendMessagesToOtherDevices.IRequest=} [properties] Properties to set
             * @returns {app.SendMessagesToOtherDevices.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link app.SendMessagesToOtherDevices.Request.verify|verify} messages.
             * @function encode
             * @memberof app.SendMessagesToOtherDevices.Request
             * @static
             * @param {app.SendMessagesToOtherDevices.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                if (message.apiName != null && Object.hasOwnProperty.call(message, "apiName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.apiName);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.data);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link app.SendMessagesToOtherDevices.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.SendMessagesToOtherDevices.Request
             * @static
             * @param {app.SendMessagesToOtherDevices.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof app.SendMessagesToOtherDevices.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.SendMessagesToOtherDevices.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.SendMessagesToOtherDevices.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deviceId = reader.string();
                        break;
                    case 2:
                        message.apiName = reader.string();
                        break;
                    case 3:
                        message.data = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.SendMessagesToOtherDevices.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.SendMessagesToOtherDevices.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof app.SendMessagesToOtherDevices.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.apiName != null && message.hasOwnProperty("apiName"))
                    if (!$util.isString(message.apiName))
                        return "apiName: string expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!$util.isString(message.data))
                        return "data: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.SendMessagesToOtherDevices.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.SendMessagesToOtherDevices.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.app.SendMessagesToOtherDevices.Request)
                    return object;
                var message = new $root.app.SendMessagesToOtherDevices.Request();
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.apiName != null)
                    message.apiName = String(object.apiName);
                if (object.data != null)
                    message.data = String(object.data);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.SendMessagesToOtherDevices.Request
             * @static
             * @param {app.SendMessagesToOtherDevices.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.deviceId = "";
                    object.apiName = "";
                    object.data = "";
                }
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.apiName != null && message.hasOwnProperty("apiName"))
                    object.apiName = message.apiName;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = message.data;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof app.SendMessagesToOtherDevices.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        SendMessagesToOtherDevices.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof app.SendMessagesToOtherDevices
             * @interface IResponse
             */

            /**
             * Constructs a new Response.
             * @memberof app.SendMessagesToOtherDevices
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {app.SendMessagesToOtherDevices.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof app.SendMessagesToOtherDevices.Response
             * @static
             * @param {app.SendMessagesToOtherDevices.IResponse=} [properties] Properties to set
             * @returns {app.SendMessagesToOtherDevices.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link app.SendMessagesToOtherDevices.Response.verify|verify} messages.
             * @function encode
             * @memberof app.SendMessagesToOtherDevices.Response
             * @static
             * @param {app.SendMessagesToOtherDevices.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link app.SendMessagesToOtherDevices.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.SendMessagesToOtherDevices.Response
             * @static
             * @param {app.SendMessagesToOtherDevices.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof app.SendMessagesToOtherDevices.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.SendMessagesToOtherDevices.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.SendMessagesToOtherDevices.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.SendMessagesToOtherDevices.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.SendMessagesToOtherDevices.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof app.SendMessagesToOtherDevices.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.SendMessagesToOtherDevices.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.SendMessagesToOtherDevices.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.app.SendMessagesToOtherDevices.Response)
                    return object;
                return new $root.app.SendMessagesToOtherDevices.Response();
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.SendMessagesToOtherDevices.Response
             * @static
             * @param {app.SendMessagesToOtherDevices.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof app.SendMessagesToOtherDevices.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return SendMessagesToOtherDevices;
    })();

    app.ReceiveMessagesFromOtherDevices = (function() {

        /**
         * Properties of a ReceiveMessagesFromOtherDevices.
         * @memberof app
         * @interface IReceiveMessagesFromOtherDevices
         */

        /**
         * Constructs a new ReceiveMessagesFromOtherDevices.
         * @memberof app
         * @classdesc Represents a ReceiveMessagesFromOtherDevices.
         * @implements IReceiveMessagesFromOtherDevices
         * @constructor
         * @param {app.IReceiveMessagesFromOtherDevices=} [properties] Properties to set
         */
        function ReceiveMessagesFromOtherDevices(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ReceiveMessagesFromOtherDevices instance using the specified properties.
         * @function create
         * @memberof app.ReceiveMessagesFromOtherDevices
         * @static
         * @param {app.IReceiveMessagesFromOtherDevices=} [properties] Properties to set
         * @returns {app.ReceiveMessagesFromOtherDevices} ReceiveMessagesFromOtherDevices instance
         */
        ReceiveMessagesFromOtherDevices.create = function create(properties) {
            return new ReceiveMessagesFromOtherDevices(properties);
        };

        /**
         * Encodes the specified ReceiveMessagesFromOtherDevices message. Does not implicitly {@link app.ReceiveMessagesFromOtherDevices.verify|verify} messages.
         * @function encode
         * @memberof app.ReceiveMessagesFromOtherDevices
         * @static
         * @param {app.IReceiveMessagesFromOtherDevices} message ReceiveMessagesFromOtherDevices message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReceiveMessagesFromOtherDevices.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ReceiveMessagesFromOtherDevices message, length delimited. Does not implicitly {@link app.ReceiveMessagesFromOtherDevices.verify|verify} messages.
         * @function encodeDelimited
         * @memberof app.ReceiveMessagesFromOtherDevices
         * @static
         * @param {app.IReceiveMessagesFromOtherDevices} message ReceiveMessagesFromOtherDevices message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReceiveMessagesFromOtherDevices.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReceiveMessagesFromOtherDevices message from the specified reader or buffer.
         * @function decode
         * @memberof app.ReceiveMessagesFromOtherDevices
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {app.ReceiveMessagesFromOtherDevices} ReceiveMessagesFromOtherDevices
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReceiveMessagesFromOtherDevices.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.ReceiveMessagesFromOtherDevices();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReceiveMessagesFromOtherDevices message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof app.ReceiveMessagesFromOtherDevices
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {app.ReceiveMessagesFromOtherDevices} ReceiveMessagesFromOtherDevices
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReceiveMessagesFromOtherDevices.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReceiveMessagesFromOtherDevices message.
         * @function verify
         * @memberof app.ReceiveMessagesFromOtherDevices
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReceiveMessagesFromOtherDevices.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a ReceiveMessagesFromOtherDevices message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof app.ReceiveMessagesFromOtherDevices
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {app.ReceiveMessagesFromOtherDevices} ReceiveMessagesFromOtherDevices
         */
        ReceiveMessagesFromOtherDevices.fromObject = function fromObject(object) {
            if (object instanceof $root.app.ReceiveMessagesFromOtherDevices)
                return object;
            return new $root.app.ReceiveMessagesFromOtherDevices();
        };

        /**
         * Creates a plain object from a ReceiveMessagesFromOtherDevices message. Also converts values to other types if specified.
         * @function toObject
         * @memberof app.ReceiveMessagesFromOtherDevices
         * @static
         * @param {app.ReceiveMessagesFromOtherDevices} message ReceiveMessagesFromOtherDevices
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReceiveMessagesFromOtherDevices.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ReceiveMessagesFromOtherDevices to JSON.
         * @function toJSON
         * @memberof app.ReceiveMessagesFromOtherDevices
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReceiveMessagesFromOtherDevices.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        ReceiveMessagesFromOtherDevices.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof app.ReceiveMessagesFromOtherDevices
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof app.ReceiveMessagesFromOtherDevices
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {app.ReceiveMessagesFromOtherDevices.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof app.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {app.ReceiveMessagesFromOtherDevices.IRequest=} [properties] Properties to set
             * @returns {app.ReceiveMessagesFromOtherDevices.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link app.ReceiveMessagesFromOtherDevices.Request.verify|verify} messages.
             * @function encode
             * @memberof app.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {app.ReceiveMessagesFromOtherDevices.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link app.ReceiveMessagesFromOtherDevices.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {app.ReceiveMessagesFromOtherDevices.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof app.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.ReceiveMessagesFromOtherDevices.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.ReceiveMessagesFromOtherDevices.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.ReceiveMessagesFromOtherDevices.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof app.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.ReceiveMessagesFromOtherDevices.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.app.ReceiveMessagesFromOtherDevices.Request)
                    return object;
                return new $root.app.ReceiveMessagesFromOtherDevices.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {app.ReceiveMessagesFromOtherDevices.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof app.ReceiveMessagesFromOtherDevices.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        ReceiveMessagesFromOtherDevices.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof app.ReceiveMessagesFromOtherDevices
             * @interface IResponse
             * @property {string|null} [deviceId] Response deviceId
             * @property {string|null} [apiName] Response apiName
             * @property {string|null} [data] Response data
             */

            /**
             * Constructs a new Response.
             * @memberof app.ReceiveMessagesFromOtherDevices
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {app.ReceiveMessagesFromOtherDevices.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response deviceId.
             * @member {string} deviceId
             * @memberof app.ReceiveMessagesFromOtherDevices.Response
             * @instance
             */
            Response.prototype.deviceId = "";

            /**
             * Response apiName.
             * @member {string} apiName
             * @memberof app.ReceiveMessagesFromOtherDevices.Response
             * @instance
             */
            Response.prototype.apiName = "";

            /**
             * Response data.
             * @member {string} data
             * @memberof app.ReceiveMessagesFromOtherDevices.Response
             * @instance
             */
            Response.prototype.data = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof app.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {app.ReceiveMessagesFromOtherDevices.IResponse=} [properties] Properties to set
             * @returns {app.ReceiveMessagesFromOtherDevices.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link app.ReceiveMessagesFromOtherDevices.Response.verify|verify} messages.
             * @function encode
             * @memberof app.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {app.ReceiveMessagesFromOtherDevices.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                if (message.apiName != null && Object.hasOwnProperty.call(message, "apiName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.apiName);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.data);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link app.ReceiveMessagesFromOtherDevices.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {app.ReceiveMessagesFromOtherDevices.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof app.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.ReceiveMessagesFromOtherDevices.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.ReceiveMessagesFromOtherDevices.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deviceId = reader.string();
                        break;
                    case 2:
                        message.apiName = reader.string();
                        break;
                    case 3:
                        message.data = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.ReceiveMessagesFromOtherDevices.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof app.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.apiName != null && message.hasOwnProperty("apiName"))
                    if (!$util.isString(message.apiName))
                        return "apiName: string expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!$util.isString(message.data))
                        return "data: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.ReceiveMessagesFromOtherDevices.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.app.ReceiveMessagesFromOtherDevices.Response)
                    return object;
                var message = new $root.app.ReceiveMessagesFromOtherDevices.Response();
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.apiName != null)
                    message.apiName = String(object.apiName);
                if (object.data != null)
                    message.data = String(object.data);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {app.ReceiveMessagesFromOtherDevices.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.deviceId = "";
                    object.apiName = "";
                    object.data = "";
                }
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.apiName != null && message.hasOwnProperty("apiName"))
                    object.apiName = message.apiName;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = message.data;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof app.ReceiveMessagesFromOtherDevices.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return ReceiveMessagesFromOtherDevices;
    })();

    return app;
})();

$root.user = (function() {

    /**
     * Namespace user.
     * @exports user
     * @namespace
     */
    var user = {};

    user.BaseUserInfo = (function() {

        /**
         * Properties of a BaseUserInfo.
         * @memberof user
         * @interface IBaseUserInfo
         * @property {string|null} [uid] BaseUserInfo uid
         * @property {string|null} [avatar] BaseUserInfo avatar
         * @property {string|null} [nickname] BaseUserInfo nickname
         * @property {string|null} [username] BaseUserInfo username
         */

        /**
         * Constructs a new BaseUserInfo.
         * @memberof user
         * @classdesc Represents a BaseUserInfo.
         * @implements IBaseUserInfo
         * @constructor
         * @param {user.IBaseUserInfo=} [properties] Properties to set
         */
        function BaseUserInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BaseUserInfo uid.
         * @member {string} uid
         * @memberof user.BaseUserInfo
         * @instance
         */
        BaseUserInfo.prototype.uid = "";

        /**
         * BaseUserInfo avatar.
         * @member {string} avatar
         * @memberof user.BaseUserInfo
         * @instance
         */
        BaseUserInfo.prototype.avatar = "";

        /**
         * BaseUserInfo nickname.
         * @member {string} nickname
         * @memberof user.BaseUserInfo
         * @instance
         */
        BaseUserInfo.prototype.nickname = "";

        /**
         * BaseUserInfo username.
         * @member {string} username
         * @memberof user.BaseUserInfo
         * @instance
         */
        BaseUserInfo.prototype.username = "";

        /**
         * Creates a new BaseUserInfo instance using the specified properties.
         * @function create
         * @memberof user.BaseUserInfo
         * @static
         * @param {user.IBaseUserInfo=} [properties] Properties to set
         * @returns {user.BaseUserInfo} BaseUserInfo instance
         */
        BaseUserInfo.create = function create(properties) {
            return new BaseUserInfo(properties);
        };

        /**
         * Encodes the specified BaseUserInfo message. Does not implicitly {@link user.BaseUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.BaseUserInfo
         * @static
         * @param {user.IBaseUserInfo} message BaseUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BaseUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.uid);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.nickname);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.username);
            return writer;
        };

        /**
         * Encodes the specified BaseUserInfo message, length delimited. Does not implicitly {@link user.BaseUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.BaseUserInfo
         * @static
         * @param {user.IBaseUserInfo} message BaseUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BaseUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BaseUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.BaseUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.BaseUserInfo} BaseUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BaseUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.BaseUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.string();
                    break;
                case 2:
                    message.avatar = reader.string();
                    break;
                case 3:
                    message.nickname = reader.string();
                    break;
                case 4:
                    message.username = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BaseUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.BaseUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.BaseUserInfo} BaseUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BaseUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BaseUserInfo message.
         * @function verify
         * @memberof user.BaseUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BaseUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isString(message.uid))
                    return "uid: string expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            return null;
        };

        /**
         * Creates a BaseUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.BaseUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.BaseUserInfo} BaseUserInfo
         */
        BaseUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.BaseUserInfo)
                return object;
            var message = new $root.user.BaseUserInfo();
            if (object.uid != null)
                message.uid = String(object.uid);
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.username != null)
                message.username = String(object.username);
            return message;
        };

        /**
         * Creates a plain object from a BaseUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.BaseUserInfo
         * @static
         * @param {user.BaseUserInfo} message BaseUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BaseUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = "";
                object.avatar = "";
                object.nickname = "";
                object.username = "";
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            return object;
        };

        /**
         * Converts this BaseUserInfo to JSON.
         * @function toJSON
         * @memberof user.BaseUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BaseUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BaseUserInfo;
    })();

    user.StrangerUserInfo = (function() {

        /**
         * Properties of a StrangerUserInfo.
         * @memberof user
         * @interface IStrangerUserInfo
         * @property {number|null} [uid] StrangerUserInfo uid
         * @property {number|null} [email] StrangerUserInfo email
         * @property {string|null} [avatar] StrangerUserInfo avatar
         * @property {string|null} [nickname] StrangerUserInfo nickname
         * @property {string|null} [username] StrangerUserInfo username
         * @property {string|null} [bio] StrangerUserInfo bio
         * @property {boolean|null} [isAdded] StrangerUserInfo isAdded
         */

        /**
         * Constructs a new StrangerUserInfo.
         * @memberof user
         * @classdesc Represents a StrangerUserInfo.
         * @implements IStrangerUserInfo
         * @constructor
         * @param {user.IStrangerUserInfo=} [properties] Properties to set
         */
        function StrangerUserInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StrangerUserInfo uid.
         * @member {number} uid
         * @memberof user.StrangerUserInfo
         * @instance
         */
        StrangerUserInfo.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * StrangerUserInfo email.
         * @member {number} email
         * @memberof user.StrangerUserInfo
         * @instance
         */
        StrangerUserInfo.prototype.email = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * StrangerUserInfo avatar.
         * @member {string} avatar
         * @memberof user.StrangerUserInfo
         * @instance
         */
        StrangerUserInfo.prototype.avatar = "";

        /**
         * StrangerUserInfo nickname.
         * @member {string} nickname
         * @memberof user.StrangerUserInfo
         * @instance
         */
        StrangerUserInfo.prototype.nickname = "";

        /**
         * StrangerUserInfo username.
         * @member {string} username
         * @memberof user.StrangerUserInfo
         * @instance
         */
        StrangerUserInfo.prototype.username = "";

        /**
         * StrangerUserInfo bio.
         * @member {string} bio
         * @memberof user.StrangerUserInfo
         * @instance
         */
        StrangerUserInfo.prototype.bio = "";

        /**
         * StrangerUserInfo isAdded.
         * @member {boolean} isAdded
         * @memberof user.StrangerUserInfo
         * @instance
         */
        StrangerUserInfo.prototype.isAdded = false;

        /**
         * Creates a new StrangerUserInfo instance using the specified properties.
         * @function create
         * @memberof user.StrangerUserInfo
         * @static
         * @param {user.IStrangerUserInfo=} [properties] Properties to set
         * @returns {user.StrangerUserInfo} StrangerUserInfo instance
         */
        StrangerUserInfo.create = function create(properties) {
            return new StrangerUserInfo(properties);
        };

        /**
         * Encodes the specified StrangerUserInfo message. Does not implicitly {@link user.StrangerUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.StrangerUserInfo
         * @static
         * @param {user.IStrangerUserInfo} message StrangerUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StrangerUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.uid);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.email);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.avatar);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.nickname);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.username);
            if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.bio);
            if (message.isAdded != null && Object.hasOwnProperty.call(message, "isAdded"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isAdded);
            return writer;
        };

        /**
         * Encodes the specified StrangerUserInfo message, length delimited. Does not implicitly {@link user.StrangerUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.StrangerUserInfo
         * @static
         * @param {user.IStrangerUserInfo} message StrangerUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StrangerUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StrangerUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.StrangerUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.StrangerUserInfo} StrangerUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StrangerUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.StrangerUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int64();
                    break;
                case 2:
                    message.email = reader.int64();
                    break;
                case 3:
                    message.avatar = reader.string();
                    break;
                case 4:
                    message.nickname = reader.string();
                    break;
                case 5:
                    message.username = reader.string();
                    break;
                case 6:
                    message.bio = reader.string();
                    break;
                case 7:
                    message.isAdded = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StrangerUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.StrangerUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.StrangerUserInfo} StrangerUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StrangerUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StrangerUserInfo message.
         * @function verify
         * @memberof user.StrangerUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StrangerUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid) && !(message.uid && $util.isInteger(message.uid.low) && $util.isInteger(message.uid.high)))
                    return "uid: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isInteger(message.email) && !(message.email && $util.isInteger(message.email.low) && $util.isInteger(message.email.high)))
                    return "email: integer|Long expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.bio != null && message.hasOwnProperty("bio"))
                if (!$util.isString(message.bio))
                    return "bio: string expected";
            if (message.isAdded != null && message.hasOwnProperty("isAdded"))
                if (typeof message.isAdded !== "boolean")
                    return "isAdded: boolean expected";
            return null;
        };

        /**
         * Creates a StrangerUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.StrangerUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.StrangerUserInfo} StrangerUserInfo
         */
        StrangerUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.StrangerUserInfo)
                return object;
            var message = new $root.user.StrangerUserInfo();
            if (object.uid != null)
                if ($util.Long)
                    (message.uid = $util.Long.fromValue(object.uid)).unsigned = false;
                else if (typeof object.uid === "string")
                    message.uid = parseInt(object.uid, 10);
                else if (typeof object.uid === "number")
                    message.uid = object.uid;
                else if (typeof object.uid === "object")
                    message.uid = new $util.LongBits(object.uid.low >>> 0, object.uid.high >>> 0).toNumber();
            if (object.email != null)
                if ($util.Long)
                    (message.email = $util.Long.fromValue(object.email)).unsigned = false;
                else if (typeof object.email === "string")
                    message.email = parseInt(object.email, 10);
                else if (typeof object.email === "number")
                    message.email = object.email;
                else if (typeof object.email === "object")
                    message.email = new $util.LongBits(object.email.low >>> 0, object.email.high >>> 0).toNumber();
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.username != null)
                message.username = String(object.username);
            if (object.bio != null)
                message.bio = String(object.bio);
            if (object.isAdded != null)
                message.isAdded = Boolean(object.isAdded);
            return message;
        };

        /**
         * Creates a plain object from a StrangerUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.StrangerUserInfo
         * @static
         * @param {user.StrangerUserInfo} message StrangerUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StrangerUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.uid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.uid = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.email = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.email = options.longs === String ? "0" : 0;
                object.avatar = "";
                object.nickname = "";
                object.username = "";
                object.bio = "";
                object.isAdded = false;
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (typeof message.uid === "number")
                    object.uid = options.longs === String ? String(message.uid) : message.uid;
                else
                    object.uid = options.longs === String ? $util.Long.prototype.toString.call(message.uid) : options.longs === Number ? new $util.LongBits(message.uid.low >>> 0, message.uid.high >>> 0).toNumber() : message.uid;
            if (message.email != null && message.hasOwnProperty("email"))
                if (typeof message.email === "number")
                    object.email = options.longs === String ? String(message.email) : message.email;
                else
                    object.email = options.longs === String ? $util.Long.prototype.toString.call(message.email) : options.longs === Number ? new $util.LongBits(message.email.low >>> 0, message.email.high >>> 0).toNumber() : message.email;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.bio != null && message.hasOwnProperty("bio"))
                object.bio = message.bio;
            if (message.isAdded != null && message.hasOwnProperty("isAdded"))
                object.isAdded = message.isAdded;
            return object;
        };

        /**
         * Converts this StrangerUserInfo to JSON.
         * @function toJSON
         * @memberof user.StrangerUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StrangerUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StrangerUserInfo;
    })();

    user.FriendLogUserInfo = (function() {

        /**
         * Properties of a FriendLogUserInfo.
         * @memberof user
         * @interface IFriendLogUserInfo
         * @property {number|null} [uid] FriendLogUserInfo uid
         * @property {string|null} [avatar] FriendLogUserInfo avatar
         * @property {string|null} [nickname] FriendLogUserInfo nickname
         * @property {string|null} [username] FriendLogUserInfo username
         */

        /**
         * Constructs a new FriendLogUserInfo.
         * @memberof user
         * @classdesc Represents a FriendLogUserInfo.
         * @implements IFriendLogUserInfo
         * @constructor
         * @param {user.IFriendLogUserInfo=} [properties] Properties to set
         */
        function FriendLogUserInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FriendLogUserInfo uid.
         * @member {number} uid
         * @memberof user.FriendLogUserInfo
         * @instance
         */
        FriendLogUserInfo.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * FriendLogUserInfo avatar.
         * @member {string} avatar
         * @memberof user.FriendLogUserInfo
         * @instance
         */
        FriendLogUserInfo.prototype.avatar = "";

        /**
         * FriendLogUserInfo nickname.
         * @member {string} nickname
         * @memberof user.FriendLogUserInfo
         * @instance
         */
        FriendLogUserInfo.prototype.nickname = "";

        /**
         * FriendLogUserInfo username.
         * @member {string} username
         * @memberof user.FriendLogUserInfo
         * @instance
         */
        FriendLogUserInfo.prototype.username = "";

        /**
         * Creates a new FriendLogUserInfo instance using the specified properties.
         * @function create
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {user.IFriendLogUserInfo=} [properties] Properties to set
         * @returns {user.FriendLogUserInfo} FriendLogUserInfo instance
         */
        FriendLogUserInfo.create = function create(properties) {
            return new FriendLogUserInfo(properties);
        };

        /**
         * Encodes the specified FriendLogUserInfo message. Does not implicitly {@link user.FriendLogUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {user.IFriendLogUserInfo} message FriendLogUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FriendLogUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.uid);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.nickname);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.username);
            return writer;
        };

        /**
         * Encodes the specified FriendLogUserInfo message, length delimited. Does not implicitly {@link user.FriendLogUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {user.IFriendLogUserInfo} message FriendLogUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FriendLogUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FriendLogUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.FriendLogUserInfo} FriendLogUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FriendLogUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.FriendLogUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int64();
                    break;
                case 2:
                    message.avatar = reader.string();
                    break;
                case 3:
                    message.nickname = reader.string();
                    break;
                case 4:
                    message.username = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FriendLogUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.FriendLogUserInfo} FriendLogUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FriendLogUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FriendLogUserInfo message.
         * @function verify
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FriendLogUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid) && !(message.uid && $util.isInteger(message.uid.low) && $util.isInteger(message.uid.high)))
                    return "uid: integer|Long expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            return null;
        };

        /**
         * Creates a FriendLogUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.FriendLogUserInfo} FriendLogUserInfo
         */
        FriendLogUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.FriendLogUserInfo)
                return object;
            var message = new $root.user.FriendLogUserInfo();
            if (object.uid != null)
                if ($util.Long)
                    (message.uid = $util.Long.fromValue(object.uid)).unsigned = false;
                else if (typeof object.uid === "string")
                    message.uid = parseInt(object.uid, 10);
                else if (typeof object.uid === "number")
                    message.uid = object.uid;
                else if (typeof object.uid === "object")
                    message.uid = new $util.LongBits(object.uid.low >>> 0, object.uid.high >>> 0).toNumber();
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.username != null)
                message.username = String(object.username);
            return message;
        };

        /**
         * Creates a plain object from a FriendLogUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {user.FriendLogUserInfo} message FriendLogUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FriendLogUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.uid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.uid = options.longs === String ? "0" : 0;
                object.avatar = "";
                object.nickname = "";
                object.username = "";
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (typeof message.uid === "number")
                    object.uid = options.longs === String ? String(message.uid) : message.uid;
                else
                    object.uid = options.longs === String ? $util.Long.prototype.toString.call(message.uid) : options.longs === Number ? new $util.LongBits(message.uid.low >>> 0, message.uid.high >>> 0).toNumber() : message.uid;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            return object;
        };

        /**
         * Converts this FriendLogUserInfo to JSON.
         * @function toJSON
         * @memberof user.FriendLogUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FriendLogUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FriendLogUserInfo;
    })();

    user.FriendUserInfo = (function() {

        /**
         * Properties of a FriendUserInfo.
         * @memberof user
         * @interface IFriendUserInfo
         * @property {number|null} [uid] FriendUserInfo uid
         * @property {string|null} [avatar] FriendUserInfo avatar
         * @property {string|null} [nickname] FriendUserInfo nickname
         * @property {string|null} [username] FriendUserInfo username
         * @property {string|null} [letter] FriendUserInfo letter
         * @property {string|null} [email] FriendUserInfo email
         * @property {string|null} [bio] FriendUserInfo bio
         */

        /**
         * Constructs a new FriendUserInfo.
         * @memberof user
         * @classdesc Represents a FriendUserInfo.
         * @implements IFriendUserInfo
         * @constructor
         * @param {user.IFriendUserInfo=} [properties] Properties to set
         */
        function FriendUserInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FriendUserInfo uid.
         * @member {number} uid
         * @memberof user.FriendUserInfo
         * @instance
         */
        FriendUserInfo.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * FriendUserInfo avatar.
         * @member {string} avatar
         * @memberof user.FriendUserInfo
         * @instance
         */
        FriendUserInfo.prototype.avatar = "";

        /**
         * FriendUserInfo nickname.
         * @member {string} nickname
         * @memberof user.FriendUserInfo
         * @instance
         */
        FriendUserInfo.prototype.nickname = "";

        /**
         * FriendUserInfo username.
         * @member {string} username
         * @memberof user.FriendUserInfo
         * @instance
         */
        FriendUserInfo.prototype.username = "";

        /**
         * FriendUserInfo letter.
         * @member {string} letter
         * @memberof user.FriendUserInfo
         * @instance
         */
        FriendUserInfo.prototype.letter = "";

        /**
         * FriendUserInfo email.
         * @member {string} email
         * @memberof user.FriendUserInfo
         * @instance
         */
        FriendUserInfo.prototype.email = "";

        /**
         * FriendUserInfo bio.
         * @member {string} bio
         * @memberof user.FriendUserInfo
         * @instance
         */
        FriendUserInfo.prototype.bio = "";

        /**
         * Creates a new FriendUserInfo instance using the specified properties.
         * @function create
         * @memberof user.FriendUserInfo
         * @static
         * @param {user.IFriendUserInfo=} [properties] Properties to set
         * @returns {user.FriendUserInfo} FriendUserInfo instance
         */
        FriendUserInfo.create = function create(properties) {
            return new FriendUserInfo(properties);
        };

        /**
         * Encodes the specified FriendUserInfo message. Does not implicitly {@link user.FriendUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.FriendUserInfo
         * @static
         * @param {user.IFriendUserInfo} message FriendUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FriendUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.uid);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.nickname);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.username);
            if (message.letter != null && Object.hasOwnProperty.call(message, "letter"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.letter);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.email);
            if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.bio);
            return writer;
        };

        /**
         * Encodes the specified FriendUserInfo message, length delimited. Does not implicitly {@link user.FriendUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.FriendUserInfo
         * @static
         * @param {user.IFriendUserInfo} message FriendUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FriendUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FriendUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.FriendUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.FriendUserInfo} FriendUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FriendUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.FriendUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int64();
                    break;
                case 2:
                    message.avatar = reader.string();
                    break;
                case 3:
                    message.nickname = reader.string();
                    break;
                case 4:
                    message.username = reader.string();
                    break;
                case 5:
                    message.letter = reader.string();
                    break;
                case 6:
                    message.email = reader.string();
                    break;
                case 7:
                    message.bio = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FriendUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.FriendUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.FriendUserInfo} FriendUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FriendUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FriendUserInfo message.
         * @function verify
         * @memberof user.FriendUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FriendUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid) && !(message.uid && $util.isInteger(message.uid.low) && $util.isInteger(message.uid.high)))
                    return "uid: integer|Long expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.letter != null && message.hasOwnProperty("letter"))
                if (!$util.isString(message.letter))
                    return "letter: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.bio != null && message.hasOwnProperty("bio"))
                if (!$util.isString(message.bio))
                    return "bio: string expected";
            return null;
        };

        /**
         * Creates a FriendUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.FriendUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.FriendUserInfo} FriendUserInfo
         */
        FriendUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.FriendUserInfo)
                return object;
            var message = new $root.user.FriendUserInfo();
            if (object.uid != null)
                if ($util.Long)
                    (message.uid = $util.Long.fromValue(object.uid)).unsigned = false;
                else if (typeof object.uid === "string")
                    message.uid = parseInt(object.uid, 10);
                else if (typeof object.uid === "number")
                    message.uid = object.uid;
                else if (typeof object.uid === "object")
                    message.uid = new $util.LongBits(object.uid.low >>> 0, object.uid.high >>> 0).toNumber();
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.username != null)
                message.username = String(object.username);
            if (object.letter != null)
                message.letter = String(object.letter);
            if (object.email != null)
                message.email = String(object.email);
            if (object.bio != null)
                message.bio = String(object.bio);
            return message;
        };

        /**
         * Creates a plain object from a FriendUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.FriendUserInfo
         * @static
         * @param {user.FriendUserInfo} message FriendUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FriendUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.uid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.uid = options.longs === String ? "0" : 0;
                object.avatar = "";
                object.nickname = "";
                object.username = "";
                object.letter = "";
                object.email = "";
                object.bio = "";
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (typeof message.uid === "number")
                    object.uid = options.longs === String ? String(message.uid) : message.uid;
                else
                    object.uid = options.longs === String ? $util.Long.prototype.toString.call(message.uid) : options.longs === Number ? new $util.LongBits(message.uid.low >>> 0, message.uid.high >>> 0).toNumber() : message.uid;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.letter != null && message.hasOwnProperty("letter"))
                object.letter = message.letter;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.bio != null && message.hasOwnProperty("bio"))
                object.bio = message.bio;
            return object;
        };

        /**
         * Converts this FriendUserInfo to JSON.
         * @function toJSON
         * @memberof user.FriendUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FriendUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FriendUserInfo;
    })();

    user.RoomUserInfo = (function() {

        /**
         * Properties of a RoomUserInfo.
         * @memberof user
         * @interface IRoomUserInfo
         * @property {number|null} [uid] RoomUserInfo uid
         * @property {string|null} [avatar] RoomUserInfo avatar
         * @property {string|null} [nickname] RoomUserInfo nickname
         * @property {string|null} [username] RoomUserInfo username
         * @property {string|null} [letter] RoomUserInfo letter
         * @property {string|null} [email] RoomUserInfo email
         * @property {string|null} [bio] RoomUserInfo bio
         */

        /**
         * Constructs a new RoomUserInfo.
         * @memberof user
         * @classdesc Represents a RoomUserInfo.
         * @implements IRoomUserInfo
         * @constructor
         * @param {user.IRoomUserInfo=} [properties] Properties to set
         */
        function RoomUserInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RoomUserInfo uid.
         * @member {number} uid
         * @memberof user.RoomUserInfo
         * @instance
         */
        RoomUserInfo.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * RoomUserInfo avatar.
         * @member {string} avatar
         * @memberof user.RoomUserInfo
         * @instance
         */
        RoomUserInfo.prototype.avatar = "";

        /**
         * RoomUserInfo nickname.
         * @member {string} nickname
         * @memberof user.RoomUserInfo
         * @instance
         */
        RoomUserInfo.prototype.nickname = "";

        /**
         * RoomUserInfo username.
         * @member {string} username
         * @memberof user.RoomUserInfo
         * @instance
         */
        RoomUserInfo.prototype.username = "";

        /**
         * RoomUserInfo letter.
         * @member {string} letter
         * @memberof user.RoomUserInfo
         * @instance
         */
        RoomUserInfo.prototype.letter = "";

        /**
         * RoomUserInfo email.
         * @member {string} email
         * @memberof user.RoomUserInfo
         * @instance
         */
        RoomUserInfo.prototype.email = "";

        /**
         * RoomUserInfo bio.
         * @member {string} bio
         * @memberof user.RoomUserInfo
         * @instance
         */
        RoomUserInfo.prototype.bio = "";

        /**
         * Creates a new RoomUserInfo instance using the specified properties.
         * @function create
         * @memberof user.RoomUserInfo
         * @static
         * @param {user.IRoomUserInfo=} [properties] Properties to set
         * @returns {user.RoomUserInfo} RoomUserInfo instance
         */
        RoomUserInfo.create = function create(properties) {
            return new RoomUserInfo(properties);
        };

        /**
         * Encodes the specified RoomUserInfo message. Does not implicitly {@link user.RoomUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.RoomUserInfo
         * @static
         * @param {user.IRoomUserInfo} message RoomUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.uid);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.nickname);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.username);
            if (message.letter != null && Object.hasOwnProperty.call(message, "letter"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.letter);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.email);
            if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.bio);
            return writer;
        };

        /**
         * Encodes the specified RoomUserInfo message, length delimited. Does not implicitly {@link user.RoomUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.RoomUserInfo
         * @static
         * @param {user.IRoomUserInfo} message RoomUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RoomUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.RoomUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.RoomUserInfo} RoomUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.RoomUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int64();
                    break;
                case 2:
                    message.avatar = reader.string();
                    break;
                case 3:
                    message.nickname = reader.string();
                    break;
                case 4:
                    message.username = reader.string();
                    break;
                case 5:
                    message.letter = reader.string();
                    break;
                case 6:
                    message.email = reader.string();
                    break;
                case 7:
                    message.bio = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RoomUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.RoomUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.RoomUserInfo} RoomUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RoomUserInfo message.
         * @function verify
         * @memberof user.RoomUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RoomUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid) && !(message.uid && $util.isInteger(message.uid.low) && $util.isInteger(message.uid.high)))
                    return "uid: integer|Long expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.letter != null && message.hasOwnProperty("letter"))
                if (!$util.isString(message.letter))
                    return "letter: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.bio != null && message.hasOwnProperty("bio"))
                if (!$util.isString(message.bio))
                    return "bio: string expected";
            return null;
        };

        /**
         * Creates a RoomUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.RoomUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.RoomUserInfo} RoomUserInfo
         */
        RoomUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.RoomUserInfo)
                return object;
            var message = new $root.user.RoomUserInfo();
            if (object.uid != null)
                if ($util.Long)
                    (message.uid = $util.Long.fromValue(object.uid)).unsigned = false;
                else if (typeof object.uid === "string")
                    message.uid = parseInt(object.uid, 10);
                else if (typeof object.uid === "number")
                    message.uid = object.uid;
                else if (typeof object.uid === "object")
                    message.uid = new $util.LongBits(object.uid.low >>> 0, object.uid.high >>> 0).toNumber();
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.username != null)
                message.username = String(object.username);
            if (object.letter != null)
                message.letter = String(object.letter);
            if (object.email != null)
                message.email = String(object.email);
            if (object.bio != null)
                message.bio = String(object.bio);
            return message;
        };

        /**
         * Creates a plain object from a RoomUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.RoomUserInfo
         * @static
         * @param {user.RoomUserInfo} message RoomUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RoomUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.uid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.uid = options.longs === String ? "0" : 0;
                object.avatar = "";
                object.nickname = "";
                object.username = "";
                object.letter = "";
                object.email = "";
                object.bio = "";
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (typeof message.uid === "number")
                    object.uid = options.longs === String ? String(message.uid) : message.uid;
                else
                    object.uid = options.longs === String ? $util.Long.prototype.toString.call(message.uid) : options.longs === Number ? new $util.LongBits(message.uid.low >>> 0, message.uid.high >>> 0).toNumber() : message.uid;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.letter != null && message.hasOwnProperty("letter"))
                object.letter = message.letter;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.bio != null && message.hasOwnProperty("bio"))
                object.bio = message.bio;
            return object;
        };

        /**
         * Converts this RoomUserInfo to JSON.
         * @function toJSON
         * @memberof user.RoomUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RoomUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RoomUserInfo;
    })();

    user.AnonymousUserInfo = (function() {

        /**
         * Properties of an AnonymousUserInfo.
         * @memberof user
         * @interface IAnonymousUserInfo
         * @property {number|null} [uid] AnonymousUserInfo uid
         * @property {string|null} [avatar] AnonymousUserInfo avatar
         * @property {string|null} [nickname] AnonymousUserInfo nickname
         * @property {string|null} [username] AnonymousUserInfo username
         * @property {string|null} [letter] AnonymousUserInfo letter
         * @property {string|null} [email] AnonymousUserInfo email
         * @property {string|null} [bio] AnonymousUserInfo bio
         */

        /**
         * Constructs a new AnonymousUserInfo.
         * @memberof user
         * @classdesc Represents an AnonymousUserInfo.
         * @implements IAnonymousUserInfo
         * @constructor
         * @param {user.IAnonymousUserInfo=} [properties] Properties to set
         */
        function AnonymousUserInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AnonymousUserInfo uid.
         * @member {number} uid
         * @memberof user.AnonymousUserInfo
         * @instance
         */
        AnonymousUserInfo.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * AnonymousUserInfo avatar.
         * @member {string} avatar
         * @memberof user.AnonymousUserInfo
         * @instance
         */
        AnonymousUserInfo.prototype.avatar = "";

        /**
         * AnonymousUserInfo nickname.
         * @member {string} nickname
         * @memberof user.AnonymousUserInfo
         * @instance
         */
        AnonymousUserInfo.prototype.nickname = "";

        /**
         * AnonymousUserInfo username.
         * @member {string} username
         * @memberof user.AnonymousUserInfo
         * @instance
         */
        AnonymousUserInfo.prototype.username = "";

        /**
         * AnonymousUserInfo letter.
         * @member {string} letter
         * @memberof user.AnonymousUserInfo
         * @instance
         */
        AnonymousUserInfo.prototype.letter = "";

        /**
         * AnonymousUserInfo email.
         * @member {string} email
         * @memberof user.AnonymousUserInfo
         * @instance
         */
        AnonymousUserInfo.prototype.email = "";

        /**
         * AnonymousUserInfo bio.
         * @member {string} bio
         * @memberof user.AnonymousUserInfo
         * @instance
         */
        AnonymousUserInfo.prototype.bio = "";

        /**
         * Creates a new AnonymousUserInfo instance using the specified properties.
         * @function create
         * @memberof user.AnonymousUserInfo
         * @static
         * @param {user.IAnonymousUserInfo=} [properties] Properties to set
         * @returns {user.AnonymousUserInfo} AnonymousUserInfo instance
         */
        AnonymousUserInfo.create = function create(properties) {
            return new AnonymousUserInfo(properties);
        };

        /**
         * Encodes the specified AnonymousUserInfo message. Does not implicitly {@link user.AnonymousUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.AnonymousUserInfo
         * @static
         * @param {user.IAnonymousUserInfo} message AnonymousUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AnonymousUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.uid);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.nickname);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.username);
            if (message.letter != null && Object.hasOwnProperty.call(message, "letter"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.letter);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.email);
            if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.bio);
            return writer;
        };

        /**
         * Encodes the specified AnonymousUserInfo message, length delimited. Does not implicitly {@link user.AnonymousUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.AnonymousUserInfo
         * @static
         * @param {user.IAnonymousUserInfo} message AnonymousUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AnonymousUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AnonymousUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.AnonymousUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.AnonymousUserInfo} AnonymousUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AnonymousUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.AnonymousUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int64();
                    break;
                case 2:
                    message.avatar = reader.string();
                    break;
                case 3:
                    message.nickname = reader.string();
                    break;
                case 4:
                    message.username = reader.string();
                    break;
                case 5:
                    message.letter = reader.string();
                    break;
                case 6:
                    message.email = reader.string();
                    break;
                case 7:
                    message.bio = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AnonymousUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.AnonymousUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.AnonymousUserInfo} AnonymousUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AnonymousUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AnonymousUserInfo message.
         * @function verify
         * @memberof user.AnonymousUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AnonymousUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid) && !(message.uid && $util.isInteger(message.uid.low) && $util.isInteger(message.uid.high)))
                    return "uid: integer|Long expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.letter != null && message.hasOwnProperty("letter"))
                if (!$util.isString(message.letter))
                    return "letter: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.bio != null && message.hasOwnProperty("bio"))
                if (!$util.isString(message.bio))
                    return "bio: string expected";
            return null;
        };

        /**
         * Creates an AnonymousUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.AnonymousUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.AnonymousUserInfo} AnonymousUserInfo
         */
        AnonymousUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.AnonymousUserInfo)
                return object;
            var message = new $root.user.AnonymousUserInfo();
            if (object.uid != null)
                if ($util.Long)
                    (message.uid = $util.Long.fromValue(object.uid)).unsigned = false;
                else if (typeof object.uid === "string")
                    message.uid = parseInt(object.uid, 10);
                else if (typeof object.uid === "number")
                    message.uid = object.uid;
                else if (typeof object.uid === "object")
                    message.uid = new $util.LongBits(object.uid.low >>> 0, object.uid.high >>> 0).toNumber();
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.username != null)
                message.username = String(object.username);
            if (object.letter != null)
                message.letter = String(object.letter);
            if (object.email != null)
                message.email = String(object.email);
            if (object.bio != null)
                message.bio = String(object.bio);
            return message;
        };

        /**
         * Creates a plain object from an AnonymousUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.AnonymousUserInfo
         * @static
         * @param {user.AnonymousUserInfo} message AnonymousUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AnonymousUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.uid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.uid = options.longs === String ? "0" : 0;
                object.avatar = "";
                object.nickname = "";
                object.username = "";
                object.letter = "";
                object.email = "";
                object.bio = "";
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (typeof message.uid === "number")
                    object.uid = options.longs === String ? String(message.uid) : message.uid;
                else
                    object.uid = options.longs === String ? $util.Long.prototype.toString.call(message.uid) : options.longs === Number ? new $util.LongBits(message.uid.low >>> 0, message.uid.high >>> 0).toNumber() : message.uid;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.letter != null && message.hasOwnProperty("letter"))
                object.letter = message.letter;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.bio != null && message.hasOwnProperty("bio"))
                object.bio = message.bio;
            return object;
        };

        /**
         * Converts this AnonymousUserInfo to JSON.
         * @function toJSON
         * @memberof user.AnonymousUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AnonymousUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AnonymousUserInfo;
    })();

    user.SSOUserInfo = (function() {

        /**
         * Properties of a SSOUserInfo.
         * @memberof user
         * @interface ISSOUserInfo
         * @property {string|null} [id] SSOUserInfo id
         * @property {number|null} [uid] SSOUserInfo uid
         * @property {string|null} [username] SSOUserInfo username
         * @property {string|null} [nickname] SSOUserInfo nickname
         * @property {string|null} [avatar] SSOUserInfo avatar
         * @property {string|null} [city] SSOUserInfo city
         * @property {string|null} [bio] SSOUserInfo bio
         * @property {number|null} [gender] SSOUserInfo gender
         * @property {number|null} [status] SSOUserInfo status
         * @property {string|null} [birthday] SSOUserInfo birthday
         * @property {user.SSOUserInfo.IBackgroundImage|null} [backgroundImage] SSOUserInfo backgroundImage
         * @property {string|null} [createTime] SSOUserInfo createTime
         */

        /**
         * Constructs a new SSOUserInfo.
         * @memberof user
         * @classdesc Represents a SSOUserInfo.
         * @implements ISSOUserInfo
         * @constructor
         * @param {user.ISSOUserInfo=} [properties] Properties to set
         */
        function SSOUserInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SSOUserInfo id.
         * @member {string} id
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.id = "";

        /**
         * SSOUserInfo uid.
         * @member {number} uid
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SSOUserInfo username.
         * @member {string} username
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.username = "";

        /**
         * SSOUserInfo nickname.
         * @member {string} nickname
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.nickname = "";

        /**
         * SSOUserInfo avatar.
         * @member {string} avatar
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.avatar = "";

        /**
         * SSOUserInfo city.
         * @member {string} city
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.city = "";

        /**
         * SSOUserInfo bio.
         * @member {string} bio
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.bio = "";

        /**
         * SSOUserInfo gender.
         * @member {number} gender
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.gender = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SSOUserInfo status.
         * @member {number} status
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.status = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SSOUserInfo birthday.
         * @member {string} birthday
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.birthday = "";

        /**
         * SSOUserInfo backgroundImage.
         * @member {user.SSOUserInfo.IBackgroundImage|null|undefined} backgroundImage
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.backgroundImage = null;

        /**
         * SSOUserInfo createTime.
         * @member {string} createTime
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.createTime = "";

        /**
         * Creates a new SSOUserInfo instance using the specified properties.
         * @function create
         * @memberof user.SSOUserInfo
         * @static
         * @param {user.ISSOUserInfo=} [properties] Properties to set
         * @returns {user.SSOUserInfo} SSOUserInfo instance
         */
        SSOUserInfo.create = function create(properties) {
            return new SSOUserInfo(properties);
        };

        /**
         * Encodes the specified SSOUserInfo message. Does not implicitly {@link user.SSOUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.SSOUserInfo
         * @static
         * @param {user.ISSOUserInfo} message SSOUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SSOUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.uid);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.username);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.nickname);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.avatar);
            if (message.city != null && Object.hasOwnProperty.call(message, "city"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.city);
            if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.bio);
            if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.gender);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.status);
            if (message.birthday != null && Object.hasOwnProperty.call(message, "birthday"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.birthday);
            if (message.backgroundImage != null && Object.hasOwnProperty.call(message, "backgroundImage"))
                $root.user.SSOUserInfo.BackgroundImage.encode(message.backgroundImage, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.createTime);
            return writer;
        };

        /**
         * Encodes the specified SSOUserInfo message, length delimited. Does not implicitly {@link user.SSOUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.SSOUserInfo
         * @static
         * @param {user.ISSOUserInfo} message SSOUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SSOUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SSOUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.SSOUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.SSOUserInfo} SSOUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SSOUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.SSOUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.uid = reader.int64();
                    break;
                case 3:
                    message.username = reader.string();
                    break;
                case 4:
                    message.nickname = reader.string();
                    break;
                case 5:
                    message.avatar = reader.string();
                    break;
                case 6:
                    message.city = reader.string();
                    break;
                case 7:
                    message.bio = reader.string();
                    break;
                case 8:
                    message.gender = reader.int64();
                    break;
                case 9:
                    message.status = reader.int64();
                    break;
                case 11:
                    message.birthday = reader.string();
                    break;
                case 12:
                    message.backgroundImage = $root.user.SSOUserInfo.BackgroundImage.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.createTime = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SSOUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.SSOUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.SSOUserInfo} SSOUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SSOUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SSOUserInfo message.
         * @function verify
         * @memberof user.SSOUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SSOUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid) && !(message.uid && $util.isInteger(message.uid.low) && $util.isInteger(message.uid.high)))
                    return "uid: integer|Long expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.city != null && message.hasOwnProperty("city"))
                if (!$util.isString(message.city))
                    return "city: string expected";
            if (message.bio != null && message.hasOwnProperty("bio"))
                if (!$util.isString(message.bio))
                    return "bio: string expected";
            if (message.gender != null && message.hasOwnProperty("gender"))
                if (!$util.isInteger(message.gender) && !(message.gender && $util.isInteger(message.gender.low) && $util.isInteger(message.gender.high)))
                    return "gender: integer|Long expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status) && !(message.status && $util.isInteger(message.status.low) && $util.isInteger(message.status.high)))
                    return "status: integer|Long expected";
            if (message.birthday != null && message.hasOwnProperty("birthday"))
                if (!$util.isString(message.birthday))
                    return "birthday: string expected";
            if (message.backgroundImage != null && message.hasOwnProperty("backgroundImage")) {
                var error = $root.user.SSOUserInfo.BackgroundImage.verify(message.backgroundImage);
                if (error)
                    return "backgroundImage." + error;
            }
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (!$util.isString(message.createTime))
                    return "createTime: string expected";
            return null;
        };

        /**
         * Creates a SSOUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.SSOUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.SSOUserInfo} SSOUserInfo
         */
        SSOUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.SSOUserInfo)
                return object;
            var message = new $root.user.SSOUserInfo();
            if (object.id != null)
                message.id = String(object.id);
            if (object.uid != null)
                if ($util.Long)
                    (message.uid = $util.Long.fromValue(object.uid)).unsigned = false;
                else if (typeof object.uid === "string")
                    message.uid = parseInt(object.uid, 10);
                else if (typeof object.uid === "number")
                    message.uid = object.uid;
                else if (typeof object.uid === "object")
                    message.uid = new $util.LongBits(object.uid.low >>> 0, object.uid.high >>> 0).toNumber();
            if (object.username != null)
                message.username = String(object.username);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.city != null)
                message.city = String(object.city);
            if (object.bio != null)
                message.bio = String(object.bio);
            if (object.gender != null)
                if ($util.Long)
                    (message.gender = $util.Long.fromValue(object.gender)).unsigned = false;
                else if (typeof object.gender === "string")
                    message.gender = parseInt(object.gender, 10);
                else if (typeof object.gender === "number")
                    message.gender = object.gender;
                else if (typeof object.gender === "object")
                    message.gender = new $util.LongBits(object.gender.low >>> 0, object.gender.high >>> 0).toNumber();
            if (object.status != null)
                if ($util.Long)
                    (message.status = $util.Long.fromValue(object.status)).unsigned = false;
                else if (typeof object.status === "string")
                    message.status = parseInt(object.status, 10);
                else if (typeof object.status === "number")
                    message.status = object.status;
                else if (typeof object.status === "object")
                    message.status = new $util.LongBits(object.status.low >>> 0, object.status.high >>> 0).toNumber();
            if (object.birthday != null)
                message.birthday = String(object.birthday);
            if (object.backgroundImage != null) {
                if (typeof object.backgroundImage !== "object")
                    throw TypeError(".user.SSOUserInfo.backgroundImage: object expected");
                message.backgroundImage = $root.user.SSOUserInfo.BackgroundImage.fromObject(object.backgroundImage);
            }
            if (object.createTime != null)
                message.createTime = String(object.createTime);
            return message;
        };

        /**
         * Creates a plain object from a SSOUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.SSOUserInfo
         * @static
         * @param {user.SSOUserInfo} message SSOUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SSOUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.uid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.uid = options.longs === String ? "0" : 0;
                object.username = "";
                object.nickname = "";
                object.avatar = "";
                object.city = "";
                object.bio = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.gender = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gender = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.status = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.status = options.longs === String ? "0" : 0;
                object.birthday = "";
                object.backgroundImage = null;
                object.createTime = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (typeof message.uid === "number")
                    object.uid = options.longs === String ? String(message.uid) : message.uid;
                else
                    object.uid = options.longs === String ? $util.Long.prototype.toString.call(message.uid) : options.longs === Number ? new $util.LongBits(message.uid.low >>> 0, message.uid.high >>> 0).toNumber() : message.uid;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.city != null && message.hasOwnProperty("city"))
                object.city = message.city;
            if (message.bio != null && message.hasOwnProperty("bio"))
                object.bio = message.bio;
            if (message.gender != null && message.hasOwnProperty("gender"))
                if (typeof message.gender === "number")
                    object.gender = options.longs === String ? String(message.gender) : message.gender;
                else
                    object.gender = options.longs === String ? $util.Long.prototype.toString.call(message.gender) : options.longs === Number ? new $util.LongBits(message.gender.low >>> 0, message.gender.high >>> 0).toNumber() : message.gender;
            if (message.status != null && message.hasOwnProperty("status"))
                if (typeof message.status === "number")
                    object.status = options.longs === String ? String(message.status) : message.status;
                else
                    object.status = options.longs === String ? $util.Long.prototype.toString.call(message.status) : options.longs === Number ? new $util.LongBits(message.status.low >>> 0, message.status.high >>> 0).toNumber() : message.status;
            if (message.birthday != null && message.hasOwnProperty("birthday"))
                object.birthday = message.birthday;
            if (message.backgroundImage != null && message.hasOwnProperty("backgroundImage"))
                object.backgroundImage = $root.user.SSOUserInfo.BackgroundImage.toObject(message.backgroundImage, options);
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                object.createTime = message.createTime;
            return object;
        };

        /**
         * Converts this SSOUserInfo to JSON.
         * @function toJSON
         * @memberof user.SSOUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SSOUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SSOUserInfo.BackgroundImage = (function() {

            /**
             * Properties of a BackgroundImage.
             * @memberof user.SSOUserInfo
             * @interface IBackgroundImage
             * @property {string|null} [src] BackgroundImage src
             * @property {number|null} [size] BackgroundImage size
             */

            /**
             * Constructs a new BackgroundImage.
             * @memberof user.SSOUserInfo
             * @classdesc Represents a BackgroundImage.
             * @implements IBackgroundImage
             * @constructor
             * @param {user.SSOUserInfo.IBackgroundImage=} [properties] Properties to set
             */
            function BackgroundImage(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BackgroundImage src.
             * @member {string} src
             * @memberof user.SSOUserInfo.BackgroundImage
             * @instance
             */
            BackgroundImage.prototype.src = "";

            /**
             * BackgroundImage size.
             * @member {number} size
             * @memberof user.SSOUserInfo.BackgroundImage
             * @instance
             */
            BackgroundImage.prototype.size = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new BackgroundImage instance using the specified properties.
             * @function create
             * @memberof user.SSOUserInfo.BackgroundImage
             * @static
             * @param {user.SSOUserInfo.IBackgroundImage=} [properties] Properties to set
             * @returns {user.SSOUserInfo.BackgroundImage} BackgroundImage instance
             */
            BackgroundImage.create = function create(properties) {
                return new BackgroundImage(properties);
            };

            /**
             * Encodes the specified BackgroundImage message. Does not implicitly {@link user.SSOUserInfo.BackgroundImage.verify|verify} messages.
             * @function encode
             * @memberof user.SSOUserInfo.BackgroundImage
             * @static
             * @param {user.SSOUserInfo.IBackgroundImage} message BackgroundImage message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BackgroundImage.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.src != null && Object.hasOwnProperty.call(message, "src"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.src);
                if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.size);
                return writer;
            };

            /**
             * Encodes the specified BackgroundImage message, length delimited. Does not implicitly {@link user.SSOUserInfo.BackgroundImage.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.SSOUserInfo.BackgroundImage
             * @static
             * @param {user.SSOUserInfo.IBackgroundImage} message BackgroundImage message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BackgroundImage.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BackgroundImage message from the specified reader or buffer.
             * @function decode
             * @memberof user.SSOUserInfo.BackgroundImage
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.SSOUserInfo.BackgroundImage} BackgroundImage
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BackgroundImage.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.SSOUserInfo.BackgroundImage();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.src = reader.string();
                        break;
                    case 2:
                        message.size = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BackgroundImage message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.SSOUserInfo.BackgroundImage
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.SSOUserInfo.BackgroundImage} BackgroundImage
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BackgroundImage.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BackgroundImage message.
             * @function verify
             * @memberof user.SSOUserInfo.BackgroundImage
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BackgroundImage.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.src != null && message.hasOwnProperty("src"))
                    if (!$util.isString(message.src))
                        return "src: string expected";
                if (message.size != null && message.hasOwnProperty("size"))
                    if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                        return "size: integer|Long expected";
                return null;
            };

            /**
             * Creates a BackgroundImage message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.SSOUserInfo.BackgroundImage
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.SSOUserInfo.BackgroundImage} BackgroundImage
             */
            BackgroundImage.fromObject = function fromObject(object) {
                if (object instanceof $root.user.SSOUserInfo.BackgroundImage)
                    return object;
                var message = new $root.user.SSOUserInfo.BackgroundImage();
                if (object.src != null)
                    message.src = String(object.src);
                if (object.size != null)
                    if ($util.Long)
                        (message.size = $util.Long.fromValue(object.size)).unsigned = false;
                    else if (typeof object.size === "string")
                        message.size = parseInt(object.size, 10);
                    else if (typeof object.size === "number")
                        message.size = object.size;
                    else if (typeof object.size === "object")
                        message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a BackgroundImage message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.SSOUserInfo.BackgroundImage
             * @static
             * @param {user.SSOUserInfo.BackgroundImage} message BackgroundImage
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BackgroundImage.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.src = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.size = options.longs === String ? "0" : 0;
                }
                if (message.src != null && message.hasOwnProperty("src"))
                    object.src = message.src;
                if (message.size != null && message.hasOwnProperty("size"))
                    if (typeof message.size === "number")
                        object.size = options.longs === String ? String(message.size) : message.size;
                    else
                        object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber() : message.size;
                return object;
            };

            /**
             * Converts this BackgroundImage to JSON.
             * @function toJSON
             * @memberof user.SSOUserInfo.BackgroundImage
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BackgroundImage.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BackgroundImage;
        })();

        return SSOUserInfo;
    })();

    user.UpdateLoginUserProfile = (function() {

        /**
         * Properties of an UpdateLoginUserProfile.
         * @memberof user
         * @interface IUpdateLoginUserProfile
         */

        /**
         * Constructs a new UpdateLoginUserProfile.
         * @memberof user
         * @classdesc Represents an UpdateLoginUserProfile.
         * @implements IUpdateLoginUserProfile
         * @constructor
         * @param {user.IUpdateLoginUserProfile=} [properties] Properties to set
         */
        function UpdateLoginUserProfile(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateLoginUserProfile instance using the specified properties.
         * @function create
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {user.IUpdateLoginUserProfile=} [properties] Properties to set
         * @returns {user.UpdateLoginUserProfile} UpdateLoginUserProfile instance
         */
        UpdateLoginUserProfile.create = function create(properties) {
            return new UpdateLoginUserProfile(properties);
        };

        /**
         * Encodes the specified UpdateLoginUserProfile message. Does not implicitly {@link user.UpdateLoginUserProfile.verify|verify} messages.
         * @function encode
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {user.IUpdateLoginUserProfile} message UpdateLoginUserProfile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateLoginUserProfile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified UpdateLoginUserProfile message, length delimited. Does not implicitly {@link user.UpdateLoginUserProfile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {user.IUpdateLoginUserProfile} message UpdateLoginUserProfile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateLoginUserProfile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateLoginUserProfile message from the specified reader or buffer.
         * @function decode
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.UpdateLoginUserProfile} UpdateLoginUserProfile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateLoginUserProfile.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UpdateLoginUserProfile();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateLoginUserProfile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.UpdateLoginUserProfile} UpdateLoginUserProfile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateLoginUserProfile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateLoginUserProfile message.
         * @function verify
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateLoginUserProfile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an UpdateLoginUserProfile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.UpdateLoginUserProfile} UpdateLoginUserProfile
         */
        UpdateLoginUserProfile.fromObject = function fromObject(object) {
            if (object instanceof $root.user.UpdateLoginUserProfile)
                return object;
            return new $root.user.UpdateLoginUserProfile();
        };

        /**
         * Creates a plain object from an UpdateLoginUserProfile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {user.UpdateLoginUserProfile} message UpdateLoginUserProfile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateLoginUserProfile.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateLoginUserProfile to JSON.
         * @function toJSON
         * @memberof user.UpdateLoginUserProfile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateLoginUserProfile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        UpdateLoginUserProfile.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof user.UpdateLoginUserProfile
             * @interface IRequest
             * @property {string|null} [userToken] Request userToken
             * @property {string|null} [avatar] Request avatar
             * @property {string|null} [username] Request username
             * @property {string|null} [nickname] Request nickname
             * @property {string|null} [bio] Request bio
             */

            /**
             * Constructs a new Request.
             * @memberof user.UpdateLoginUserProfile
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {user.UpdateLoginUserProfile.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request userToken.
             * @member {string} userToken
             * @memberof user.UpdateLoginUserProfile.Request
             * @instance
             */
            Request.prototype.userToken = "";

            /**
             * Request avatar.
             * @member {string} avatar
             * @memberof user.UpdateLoginUserProfile.Request
             * @instance
             */
            Request.prototype.avatar = "";

            /**
             * Request username.
             * @member {string} username
             * @memberof user.UpdateLoginUserProfile.Request
             * @instance
             */
            Request.prototype.username = "";

            /**
             * Request nickname.
             * @member {string} nickname
             * @memberof user.UpdateLoginUserProfile.Request
             * @instance
             */
            Request.prototype.nickname = "";

            /**
             * Request bio.
             * @member {string} bio
             * @memberof user.UpdateLoginUserProfile.Request
             * @instance
             */
            Request.prototype.bio = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {user.UpdateLoginUserProfile.IRequest=} [properties] Properties to set
             * @returns {user.UpdateLoginUserProfile.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link user.UpdateLoginUserProfile.Request.verify|verify} messages.
             * @function encode
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {user.UpdateLoginUserProfile.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userToken != null && Object.hasOwnProperty.call(message, "userToken"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userToken);
                if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
                if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.username);
                if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.nickname);
                if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.bio);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link user.UpdateLoginUserProfile.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {user.UpdateLoginUserProfile.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UpdateLoginUserProfile.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UpdateLoginUserProfile.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.userToken = reader.string();
                        break;
                    case 2:
                        message.avatar = reader.string();
                        break;
                    case 3:
                        message.username = reader.string();
                        break;
                    case 4:
                        message.nickname = reader.string();
                        break;
                    case 5:
                        message.bio = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UpdateLoginUserProfile.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userToken != null && message.hasOwnProperty("userToken"))
                    if (!$util.isString(message.userToken))
                        return "userToken: string expected";
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    if (!$util.isString(message.avatar))
                        return "avatar: string expected";
                if (message.username != null && message.hasOwnProperty("username"))
                    if (!$util.isString(message.username))
                        return "username: string expected";
                if (message.nickname != null && message.hasOwnProperty("nickname"))
                    if (!$util.isString(message.nickname))
                        return "nickname: string expected";
                if (message.bio != null && message.hasOwnProperty("bio"))
                    if (!$util.isString(message.bio))
                        return "bio: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UpdateLoginUserProfile.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UpdateLoginUserProfile.Request)
                    return object;
                var message = new $root.user.UpdateLoginUserProfile.Request();
                if (object.userToken != null)
                    message.userToken = String(object.userToken);
                if (object.avatar != null)
                    message.avatar = String(object.avatar);
                if (object.username != null)
                    message.username = String(object.username);
                if (object.nickname != null)
                    message.nickname = String(object.nickname);
                if (object.bio != null)
                    message.bio = String(object.bio);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {user.UpdateLoginUserProfile.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.userToken = "";
                    object.avatar = "";
                    object.username = "";
                    object.nickname = "";
                    object.bio = "";
                }
                if (message.userToken != null && message.hasOwnProperty("userToken"))
                    object.userToken = message.userToken;
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    object.avatar = message.avatar;
                if (message.username != null && message.hasOwnProperty("username"))
                    object.username = message.username;
                if (message.nickname != null && message.hasOwnProperty("nickname"))
                    object.nickname = message.nickname;
                if (message.bio != null && message.hasOwnProperty("bio"))
                    object.bio = message.bio;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof user.UpdateLoginUserProfile.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        UpdateLoginUserProfile.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof user.UpdateLoginUserProfile
             * @interface IResponse
             * @property {string|null} [deviceId] Response deviceId
             * @property {string|null} [token] Response token
             * @property {user.ISSOUserInfo|null} [userInfo] Response userInfo
             */

            /**
             * Constructs a new Response.
             * @memberof user.UpdateLoginUserProfile
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {user.UpdateLoginUserProfile.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response deviceId.
             * @member {string} deviceId
             * @memberof user.UpdateLoginUserProfile.Response
             * @instance
             */
            Response.prototype.deviceId = "";

            /**
             * Response token.
             * @member {string} token
             * @memberof user.UpdateLoginUserProfile.Response
             * @instance
             */
            Response.prototype.token = "";

            /**
             * Response userInfo.
             * @member {user.ISSOUserInfo|null|undefined} userInfo
             * @memberof user.UpdateLoginUserProfile.Response
             * @instance
             */
            Response.prototype.userInfo = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {user.UpdateLoginUserProfile.IResponse=} [properties] Properties to set
             * @returns {user.UpdateLoginUserProfile.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link user.UpdateLoginUserProfile.Response.verify|verify} messages.
             * @function encode
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {user.UpdateLoginUserProfile.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
                if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
                    $root.user.SSOUserInfo.encode(message.userInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link user.UpdateLoginUserProfile.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {user.UpdateLoginUserProfile.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UpdateLoginUserProfile.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UpdateLoginUserProfile.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deviceId = reader.string();
                        break;
                    case 2:
                        message.token = reader.string();
                        break;
                    case 3:
                        message.userInfo = $root.user.SSOUserInfo.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UpdateLoginUserProfile.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
                    var error = $root.user.SSOUserInfo.verify(message.userInfo);
                    if (error)
                        return "userInfo." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UpdateLoginUserProfile.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UpdateLoginUserProfile.Response)
                    return object;
                var message = new $root.user.UpdateLoginUserProfile.Response();
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.token != null)
                    message.token = String(object.token);
                if (object.userInfo != null) {
                    if (typeof object.userInfo !== "object")
                        throw TypeError(".user.UpdateLoginUserProfile.Response.userInfo: object expected");
                    message.userInfo = $root.user.SSOUserInfo.fromObject(object.userInfo);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {user.UpdateLoginUserProfile.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.deviceId = "";
                    object.token = "";
                    object.userInfo = null;
                }
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.userInfo != null && message.hasOwnProperty("userInfo"))
                    object.userInfo = $root.user.SSOUserInfo.toObject(message.userInfo, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof user.UpdateLoginUserProfile.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return UpdateLoginUserProfile;
    })();

    user.UpdateAnonymousUserProfile = (function() {

        /**
         * Properties of an UpdateAnonymousUserProfile.
         * @memberof user
         * @interface IUpdateAnonymousUserProfile
         */

        /**
         * Constructs a new UpdateAnonymousUserProfile.
         * @memberof user
         * @classdesc Represents an UpdateAnonymousUserProfile.
         * @implements IUpdateAnonymousUserProfile
         * @constructor
         * @param {user.IUpdateAnonymousUserProfile=} [properties] Properties to set
         */
        function UpdateAnonymousUserProfile(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateAnonymousUserProfile instance using the specified properties.
         * @function create
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {user.IUpdateAnonymousUserProfile=} [properties] Properties to set
         * @returns {user.UpdateAnonymousUserProfile} UpdateAnonymousUserProfile instance
         */
        UpdateAnonymousUserProfile.create = function create(properties) {
            return new UpdateAnonymousUserProfile(properties);
        };

        /**
         * Encodes the specified UpdateAnonymousUserProfile message. Does not implicitly {@link user.UpdateAnonymousUserProfile.verify|verify} messages.
         * @function encode
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {user.IUpdateAnonymousUserProfile} message UpdateAnonymousUserProfile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateAnonymousUserProfile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified UpdateAnonymousUserProfile message, length delimited. Does not implicitly {@link user.UpdateAnonymousUserProfile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {user.IUpdateAnonymousUserProfile} message UpdateAnonymousUserProfile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateAnonymousUserProfile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateAnonymousUserProfile message from the specified reader or buffer.
         * @function decode
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.UpdateAnonymousUserProfile} UpdateAnonymousUserProfile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateAnonymousUserProfile.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UpdateAnonymousUserProfile();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateAnonymousUserProfile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.UpdateAnonymousUserProfile} UpdateAnonymousUserProfile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateAnonymousUserProfile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateAnonymousUserProfile message.
         * @function verify
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateAnonymousUserProfile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an UpdateAnonymousUserProfile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.UpdateAnonymousUserProfile} UpdateAnonymousUserProfile
         */
        UpdateAnonymousUserProfile.fromObject = function fromObject(object) {
            if (object instanceof $root.user.UpdateAnonymousUserProfile)
                return object;
            return new $root.user.UpdateAnonymousUserProfile();
        };

        /**
         * Creates a plain object from an UpdateAnonymousUserProfile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {user.UpdateAnonymousUserProfile} message UpdateAnonymousUserProfile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateAnonymousUserProfile.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateAnonymousUserProfile to JSON.
         * @function toJSON
         * @memberof user.UpdateAnonymousUserProfile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateAnonymousUserProfile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        UpdateAnonymousUserProfile.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof user.UpdateAnonymousUserProfile
             * @interface IRequest
             * @property {string|null} [userToken] Request userToken
             * @property {string|null} [avatar] Request avatar
             * @property {string|null} [username] Request username
             * @property {string|null} [nickname] Request nickname
             * @property {string|null} [bio] Request bio
             */

            /**
             * Constructs a new Request.
             * @memberof user.UpdateAnonymousUserProfile
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {user.UpdateAnonymousUserProfile.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request userToken.
             * @member {string} userToken
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @instance
             */
            Request.prototype.userToken = "";

            /**
             * Request avatar.
             * @member {string} avatar
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @instance
             */
            Request.prototype.avatar = "";

            /**
             * Request username.
             * @member {string} username
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @instance
             */
            Request.prototype.username = "";

            /**
             * Request nickname.
             * @member {string} nickname
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @instance
             */
            Request.prototype.nickname = "";

            /**
             * Request bio.
             * @member {string} bio
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @instance
             */
            Request.prototype.bio = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {user.UpdateAnonymousUserProfile.IRequest=} [properties] Properties to set
             * @returns {user.UpdateAnonymousUserProfile.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link user.UpdateAnonymousUserProfile.Request.verify|verify} messages.
             * @function encode
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {user.UpdateAnonymousUserProfile.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userToken != null && Object.hasOwnProperty.call(message, "userToken"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userToken);
                if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
                if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.username);
                if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.nickname);
                if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.bio);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link user.UpdateAnonymousUserProfile.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {user.UpdateAnonymousUserProfile.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UpdateAnonymousUserProfile.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UpdateAnonymousUserProfile.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.userToken = reader.string();
                        break;
                    case 2:
                        message.avatar = reader.string();
                        break;
                    case 3:
                        message.username = reader.string();
                        break;
                    case 4:
                        message.nickname = reader.string();
                        break;
                    case 5:
                        message.bio = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UpdateAnonymousUserProfile.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userToken != null && message.hasOwnProperty("userToken"))
                    if (!$util.isString(message.userToken))
                        return "userToken: string expected";
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    if (!$util.isString(message.avatar))
                        return "avatar: string expected";
                if (message.username != null && message.hasOwnProperty("username"))
                    if (!$util.isString(message.username))
                        return "username: string expected";
                if (message.nickname != null && message.hasOwnProperty("nickname"))
                    if (!$util.isString(message.nickname))
                        return "nickname: string expected";
                if (message.bio != null && message.hasOwnProperty("bio"))
                    if (!$util.isString(message.bio))
                        return "bio: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UpdateAnonymousUserProfile.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UpdateAnonymousUserProfile.Request)
                    return object;
                var message = new $root.user.UpdateAnonymousUserProfile.Request();
                if (object.userToken != null)
                    message.userToken = String(object.userToken);
                if (object.avatar != null)
                    message.avatar = String(object.avatar);
                if (object.username != null)
                    message.username = String(object.username);
                if (object.nickname != null)
                    message.nickname = String(object.nickname);
                if (object.bio != null)
                    message.bio = String(object.bio);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {user.UpdateAnonymousUserProfile.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.userToken = "";
                    object.avatar = "";
                    object.username = "";
                    object.nickname = "";
                    object.bio = "";
                }
                if (message.userToken != null && message.hasOwnProperty("userToken"))
                    object.userToken = message.userToken;
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    object.avatar = message.avatar;
                if (message.username != null && message.hasOwnProperty("username"))
                    object.username = message.username;
                if (message.nickname != null && message.hasOwnProperty("nickname"))
                    object.nickname = message.nickname;
                if (message.bio != null && message.hasOwnProperty("bio"))
                    object.bio = message.bio;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        UpdateAnonymousUserProfile.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof user.UpdateAnonymousUserProfile
             * @interface IResponse
             * @property {string|null} [deviceId] Response deviceId
             * @property {string|null} [token] Response token
             * @property {user.ISSOUserInfo|null} [userInfo] Response userInfo
             */

            /**
             * Constructs a new Response.
             * @memberof user.UpdateAnonymousUserProfile
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {user.UpdateAnonymousUserProfile.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response deviceId.
             * @member {string} deviceId
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @instance
             */
            Response.prototype.deviceId = "";

            /**
             * Response token.
             * @member {string} token
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @instance
             */
            Response.prototype.token = "";

            /**
             * Response userInfo.
             * @member {user.ISSOUserInfo|null|undefined} userInfo
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @instance
             */
            Response.prototype.userInfo = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {user.UpdateAnonymousUserProfile.IResponse=} [properties] Properties to set
             * @returns {user.UpdateAnonymousUserProfile.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link user.UpdateAnonymousUserProfile.Response.verify|verify} messages.
             * @function encode
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {user.UpdateAnonymousUserProfile.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
                if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
                    $root.user.SSOUserInfo.encode(message.userInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link user.UpdateAnonymousUserProfile.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {user.UpdateAnonymousUserProfile.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UpdateAnonymousUserProfile.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UpdateAnonymousUserProfile.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deviceId = reader.string();
                        break;
                    case 2:
                        message.token = reader.string();
                        break;
                    case 3:
                        message.userInfo = $root.user.SSOUserInfo.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UpdateAnonymousUserProfile.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
                    var error = $root.user.SSOUserInfo.verify(message.userInfo);
                    if (error)
                        return "userInfo." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UpdateAnonymousUserProfile.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UpdateAnonymousUserProfile.Response)
                    return object;
                var message = new $root.user.UpdateAnonymousUserProfile.Response();
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.token != null)
                    message.token = String(object.token);
                if (object.userInfo != null) {
                    if (typeof object.userInfo !== "object")
                        throw TypeError(".user.UpdateAnonymousUserProfile.Response.userInfo: object expected");
                    message.userInfo = $root.user.SSOUserInfo.fromObject(object.userInfo);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {user.UpdateAnonymousUserProfile.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.deviceId = "";
                    object.token = "";
                    object.userInfo = null;
                }
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.userInfo != null && message.hasOwnProperty("userInfo"))
                    object.userInfo = $root.user.SSOUserInfo.toObject(message.userInfo, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return UpdateAnonymousUserProfile;
    })();

    user.GetAnonymousUserTokenByCloneUserData = (function() {

        /**
         * Properties of a GetAnonymousUserTokenByCloneUserData.
         * @memberof user
         * @interface IGetAnonymousUserTokenByCloneUserData
         */

        /**
         * Constructs a new GetAnonymousUserTokenByCloneUserData.
         * @memberof user
         * @classdesc Represents a GetAnonymousUserTokenByCloneUserData.
         * @implements IGetAnonymousUserTokenByCloneUserData
         * @constructor
         * @param {user.IGetAnonymousUserTokenByCloneUserData=} [properties] Properties to set
         */
        function GetAnonymousUserTokenByCloneUserData(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetAnonymousUserTokenByCloneUserData instance using the specified properties.
         * @function create
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {user.IGetAnonymousUserTokenByCloneUserData=} [properties] Properties to set
         * @returns {user.GetAnonymousUserTokenByCloneUserData} GetAnonymousUserTokenByCloneUserData instance
         */
        GetAnonymousUserTokenByCloneUserData.create = function create(properties) {
            return new GetAnonymousUserTokenByCloneUserData(properties);
        };

        /**
         * Encodes the specified GetAnonymousUserTokenByCloneUserData message. Does not implicitly {@link user.GetAnonymousUserTokenByCloneUserData.verify|verify} messages.
         * @function encode
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {user.IGetAnonymousUserTokenByCloneUserData} message GetAnonymousUserTokenByCloneUserData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAnonymousUserTokenByCloneUserData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetAnonymousUserTokenByCloneUserData message, length delimited. Does not implicitly {@link user.GetAnonymousUserTokenByCloneUserData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {user.IGetAnonymousUserTokenByCloneUserData} message GetAnonymousUserTokenByCloneUserData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAnonymousUserTokenByCloneUserData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetAnonymousUserTokenByCloneUserData message from the specified reader or buffer.
         * @function decode
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.GetAnonymousUserTokenByCloneUserData} GetAnonymousUserTokenByCloneUserData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAnonymousUserTokenByCloneUserData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.GetAnonymousUserTokenByCloneUserData();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetAnonymousUserTokenByCloneUserData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.GetAnonymousUserTokenByCloneUserData} GetAnonymousUserTokenByCloneUserData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAnonymousUserTokenByCloneUserData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetAnonymousUserTokenByCloneUserData message.
         * @function verify
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetAnonymousUserTokenByCloneUserData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetAnonymousUserTokenByCloneUserData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.GetAnonymousUserTokenByCloneUserData} GetAnonymousUserTokenByCloneUserData
         */
        GetAnonymousUserTokenByCloneUserData.fromObject = function fromObject(object) {
            if (object instanceof $root.user.GetAnonymousUserTokenByCloneUserData)
                return object;
            return new $root.user.GetAnonymousUserTokenByCloneUserData();
        };

        /**
         * Creates a plain object from a GetAnonymousUserTokenByCloneUserData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {user.GetAnonymousUserTokenByCloneUserData} message GetAnonymousUserTokenByCloneUserData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetAnonymousUserTokenByCloneUserData.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetAnonymousUserTokenByCloneUserData to JSON.
         * @function toJSON
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetAnonymousUserTokenByCloneUserData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetAnonymousUserTokenByCloneUserData.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof user.GetAnonymousUserTokenByCloneUserData
             * @interface IRequest
             * @property {string|null} [cloneUserToken] Request cloneUserToken
             * @property {string|null} [cloneUserDeviceId] Request cloneUserDeviceId
             */

            /**
             * Constructs a new Request.
             * @memberof user.GetAnonymousUserTokenByCloneUserData
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {user.GetAnonymousUserTokenByCloneUserData.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request cloneUserToken.
             * @member {string} cloneUserToken
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @instance
             */
            Request.prototype.cloneUserToken = "";

            /**
             * Request cloneUserDeviceId.
             * @member {string} cloneUserDeviceId
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @instance
             */
            Request.prototype.cloneUserDeviceId = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.IRequest=} [properties] Properties to set
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link user.GetAnonymousUserTokenByCloneUserData.Request.verify|verify} messages.
             * @function encode
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.cloneUserToken != null && Object.hasOwnProperty.call(message, "cloneUserToken"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.cloneUserToken);
                if (message.cloneUserDeviceId != null && Object.hasOwnProperty.call(message, "cloneUserDeviceId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.cloneUserDeviceId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link user.GetAnonymousUserTokenByCloneUserData.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.GetAnonymousUserTokenByCloneUserData.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.cloneUserToken = reader.string();
                        break;
                    case 2:
                        message.cloneUserDeviceId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.cloneUserToken != null && message.hasOwnProperty("cloneUserToken"))
                    if (!$util.isString(message.cloneUserToken))
                        return "cloneUserToken: string expected";
                if (message.cloneUserDeviceId != null && message.hasOwnProperty("cloneUserDeviceId"))
                    if (!$util.isString(message.cloneUserDeviceId))
                        return "cloneUserDeviceId: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.user.GetAnonymousUserTokenByCloneUserData.Request)
                    return object;
                var message = new $root.user.GetAnonymousUserTokenByCloneUserData.Request();
                if (object.cloneUserToken != null)
                    message.cloneUserToken = String(object.cloneUserToken);
                if (object.cloneUserDeviceId != null)
                    message.cloneUserDeviceId = String(object.cloneUserDeviceId);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.cloneUserToken = "";
                    object.cloneUserDeviceId = "";
                }
                if (message.cloneUserToken != null && message.hasOwnProperty("cloneUserToken"))
                    object.cloneUserToken = message.cloneUserToken;
                if (message.cloneUserDeviceId != null && message.hasOwnProperty("cloneUserDeviceId"))
                    object.cloneUserDeviceId = message.cloneUserDeviceId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetAnonymousUserTokenByCloneUserData.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof user.GetAnonymousUserTokenByCloneUserData
             * @interface IResponse
             * @property {string|null} [deviceId] Response deviceId
             * @property {string|null} [token] Response token
             * @property {user.ISSOUserInfo|null} [userInfo] Response userInfo
             */

            /**
             * Constructs a new Response.
             * @memberof user.GetAnonymousUserTokenByCloneUserData
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {user.GetAnonymousUserTokenByCloneUserData.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response deviceId.
             * @member {string} deviceId
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @instance
             */
            Response.prototype.deviceId = "";

            /**
             * Response token.
             * @member {string} token
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @instance
             */
            Response.prototype.token = "";

            /**
             * Response userInfo.
             * @member {user.ISSOUserInfo|null|undefined} userInfo
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @instance
             */
            Response.prototype.userInfo = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.IResponse=} [properties] Properties to set
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link user.GetAnonymousUserTokenByCloneUserData.Response.verify|verify} messages.
             * @function encode
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
                if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
                    $root.user.SSOUserInfo.encode(message.userInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link user.GetAnonymousUserTokenByCloneUserData.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.GetAnonymousUserTokenByCloneUserData.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deviceId = reader.string();
                        break;
                    case 2:
                        message.token = reader.string();
                        break;
                    case 3:
                        message.userInfo = $root.user.SSOUserInfo.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
                    var error = $root.user.SSOUserInfo.verify(message.userInfo);
                    if (error)
                        return "userInfo." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.user.GetAnonymousUserTokenByCloneUserData.Response)
                    return object;
                var message = new $root.user.GetAnonymousUserTokenByCloneUserData.Response();
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.token != null)
                    message.token = String(object.token);
                if (object.userInfo != null) {
                    if (typeof object.userInfo !== "object")
                        throw TypeError(".user.GetAnonymousUserTokenByCloneUserData.Response.userInfo: object expected");
                    message.userInfo = $root.user.SSOUserInfo.fromObject(object.userInfo);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.deviceId = "";
                    object.token = "";
                    object.userInfo = null;
                }
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.userInfo != null && message.hasOwnProperty("userInfo"))
                    object.userInfo = $root.user.SSOUserInfo.toObject(message.userInfo, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetAnonymousUserTokenByCloneUserData;
    })();

    user.UserAgent = (function() {

        /**
         * Properties of a UserAgent.
         * @memberof user
         * @interface IUserAgent
         * @property {user.UserAgent.IBrowser|null} [browser] UserAgent browser
         * @property {user.UserAgent.IDevice|null} [device] UserAgent device
         * @property {user.UserAgent.IOS|null} [os] UserAgent os
         * @property {string|null} [deviceName] UserAgent deviceName
         */

        /**
         * Constructs a new UserAgent.
         * @memberof user
         * @classdesc Represents a UserAgent.
         * @implements IUserAgent
         * @constructor
         * @param {user.IUserAgent=} [properties] Properties to set
         */
        function UserAgent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserAgent browser.
         * @member {user.UserAgent.IBrowser|null|undefined} browser
         * @memberof user.UserAgent
         * @instance
         */
        UserAgent.prototype.browser = null;

        /**
         * UserAgent device.
         * @member {user.UserAgent.IDevice|null|undefined} device
         * @memberof user.UserAgent
         * @instance
         */
        UserAgent.prototype.device = null;

        /**
         * UserAgent os.
         * @member {user.UserAgent.IOS|null|undefined} os
         * @memberof user.UserAgent
         * @instance
         */
        UserAgent.prototype.os = null;

        /**
         * UserAgent deviceName.
         * @member {string} deviceName
         * @memberof user.UserAgent
         * @instance
         */
        UserAgent.prototype.deviceName = "";

        /**
         * Creates a new UserAgent instance using the specified properties.
         * @function create
         * @memberof user.UserAgent
         * @static
         * @param {user.IUserAgent=} [properties] Properties to set
         * @returns {user.UserAgent} UserAgent instance
         */
        UserAgent.create = function create(properties) {
            return new UserAgent(properties);
        };

        /**
         * Encodes the specified UserAgent message. Does not implicitly {@link user.UserAgent.verify|verify} messages.
         * @function encode
         * @memberof user.UserAgent
         * @static
         * @param {user.IUserAgent} message UserAgent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserAgent.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.browser != null && Object.hasOwnProperty.call(message, "browser"))
                $root.user.UserAgent.Browser.encode(message.browser, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.device != null && Object.hasOwnProperty.call(message, "device"))
                $root.user.UserAgent.Device.encode(message.device, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.os != null && Object.hasOwnProperty.call(message, "os"))
                $root.user.UserAgent.OS.encode(message.os, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.deviceName != null && Object.hasOwnProperty.call(message, "deviceName"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.deviceName);
            return writer;
        };

        /**
         * Encodes the specified UserAgent message, length delimited. Does not implicitly {@link user.UserAgent.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.UserAgent
         * @static
         * @param {user.IUserAgent} message UserAgent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserAgent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserAgent message from the specified reader or buffer.
         * @function decode
         * @memberof user.UserAgent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.UserAgent} UserAgent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserAgent.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UserAgent();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.browser = $root.user.UserAgent.Browser.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.device = $root.user.UserAgent.Device.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.os = $root.user.UserAgent.OS.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.deviceName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserAgent message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.UserAgent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.UserAgent} UserAgent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserAgent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserAgent message.
         * @function verify
         * @memberof user.UserAgent
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserAgent.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.browser != null && message.hasOwnProperty("browser")) {
                var error = $root.user.UserAgent.Browser.verify(message.browser);
                if (error)
                    return "browser." + error;
            }
            if (message.device != null && message.hasOwnProperty("device")) {
                var error = $root.user.UserAgent.Device.verify(message.device);
                if (error)
                    return "device." + error;
            }
            if (message.os != null && message.hasOwnProperty("os")) {
                var error = $root.user.UserAgent.OS.verify(message.os);
                if (error)
                    return "os." + error;
            }
            if (message.deviceName != null && message.hasOwnProperty("deviceName"))
                if (!$util.isString(message.deviceName))
                    return "deviceName: string expected";
            return null;
        };

        /**
         * Creates a UserAgent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.UserAgent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.UserAgent} UserAgent
         */
        UserAgent.fromObject = function fromObject(object) {
            if (object instanceof $root.user.UserAgent)
                return object;
            var message = new $root.user.UserAgent();
            if (object.browser != null) {
                if (typeof object.browser !== "object")
                    throw TypeError(".user.UserAgent.browser: object expected");
                message.browser = $root.user.UserAgent.Browser.fromObject(object.browser);
            }
            if (object.device != null) {
                if (typeof object.device !== "object")
                    throw TypeError(".user.UserAgent.device: object expected");
                message.device = $root.user.UserAgent.Device.fromObject(object.device);
            }
            if (object.os != null) {
                if (typeof object.os !== "object")
                    throw TypeError(".user.UserAgent.os: object expected");
                message.os = $root.user.UserAgent.OS.fromObject(object.os);
            }
            if (object.deviceName != null)
                message.deviceName = String(object.deviceName);
            return message;
        };

        /**
         * Creates a plain object from a UserAgent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.UserAgent
         * @static
         * @param {user.UserAgent} message UserAgent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserAgent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.browser = null;
                object.device = null;
                object.os = null;
                object.deviceName = "";
            }
            if (message.browser != null && message.hasOwnProperty("browser"))
                object.browser = $root.user.UserAgent.Browser.toObject(message.browser, options);
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = $root.user.UserAgent.Device.toObject(message.device, options);
            if (message.os != null && message.hasOwnProperty("os"))
                object.os = $root.user.UserAgent.OS.toObject(message.os, options);
            if (message.deviceName != null && message.hasOwnProperty("deviceName"))
                object.deviceName = message.deviceName;
            return object;
        };

        /**
         * Converts this UserAgent to JSON.
         * @function toJSON
         * @memberof user.UserAgent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserAgent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        UserAgent.Browser = (function() {

            /**
             * Properties of a Browser.
             * @memberof user.UserAgent
             * @interface IBrowser
             * @property {string|null} [name] Browser name
             * @property {string|null} [major] Browser major
             * @property {string|null} [version] Browser version
             */

            /**
             * Constructs a new Browser.
             * @memberof user.UserAgent
             * @classdesc Represents a Browser.
             * @implements IBrowser
             * @constructor
             * @param {user.UserAgent.IBrowser=} [properties] Properties to set
             */
            function Browser(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Browser name.
             * @member {string} name
             * @memberof user.UserAgent.Browser
             * @instance
             */
            Browser.prototype.name = "";

            /**
             * Browser major.
             * @member {string} major
             * @memberof user.UserAgent.Browser
             * @instance
             */
            Browser.prototype.major = "";

            /**
             * Browser version.
             * @member {string} version
             * @memberof user.UserAgent.Browser
             * @instance
             */
            Browser.prototype.version = "";

            /**
             * Creates a new Browser instance using the specified properties.
             * @function create
             * @memberof user.UserAgent.Browser
             * @static
             * @param {user.UserAgent.IBrowser=} [properties] Properties to set
             * @returns {user.UserAgent.Browser} Browser instance
             */
            Browser.create = function create(properties) {
                return new Browser(properties);
            };

            /**
             * Encodes the specified Browser message. Does not implicitly {@link user.UserAgent.Browser.verify|verify} messages.
             * @function encode
             * @memberof user.UserAgent.Browser
             * @static
             * @param {user.UserAgent.IBrowser} message Browser message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Browser.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.major != null && Object.hasOwnProperty.call(message, "major"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.major);
                if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.version);
                return writer;
            };

            /**
             * Encodes the specified Browser message, length delimited. Does not implicitly {@link user.UserAgent.Browser.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UserAgent.Browser
             * @static
             * @param {user.UserAgent.IBrowser} message Browser message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Browser.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Browser message from the specified reader or buffer.
             * @function decode
             * @memberof user.UserAgent.Browser
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UserAgent.Browser} Browser
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Browser.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UserAgent.Browser();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.major = reader.string();
                        break;
                    case 3:
                        message.version = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Browser message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UserAgent.Browser
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UserAgent.Browser} Browser
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Browser.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Browser message.
             * @function verify
             * @memberof user.UserAgent.Browser
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Browser.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.major != null && message.hasOwnProperty("major"))
                    if (!$util.isString(message.major))
                        return "major: string expected";
                if (message.version != null && message.hasOwnProperty("version"))
                    if (!$util.isString(message.version))
                        return "version: string expected";
                return null;
            };

            /**
             * Creates a Browser message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UserAgent.Browser
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UserAgent.Browser} Browser
             */
            Browser.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UserAgent.Browser)
                    return object;
                var message = new $root.user.UserAgent.Browser();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.major != null)
                    message.major = String(object.major);
                if (object.version != null)
                    message.version = String(object.version);
                return message;
            };

            /**
             * Creates a plain object from a Browser message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UserAgent.Browser
             * @static
             * @param {user.UserAgent.Browser} message Browser
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Browser.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.major = "";
                    object.version = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.major != null && message.hasOwnProperty("major"))
                    object.major = message.major;
                if (message.version != null && message.hasOwnProperty("version"))
                    object.version = message.version;
                return object;
            };

            /**
             * Converts this Browser to JSON.
             * @function toJSON
             * @memberof user.UserAgent.Browser
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Browser.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Browser;
        })();

        UserAgent.Device = (function() {

            /**
             * Properties of a Device.
             * @memberof user.UserAgent
             * @interface IDevice
             * @property {string|null} [model] Device model
             * @property {string|null} [type] Device type
             * @property {string|null} [vendor] Device vendor
             */

            /**
             * Constructs a new Device.
             * @memberof user.UserAgent
             * @classdesc Represents a Device.
             * @implements IDevice
             * @constructor
             * @param {user.UserAgent.IDevice=} [properties] Properties to set
             */
            function Device(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Device model.
             * @member {string} model
             * @memberof user.UserAgent.Device
             * @instance
             */
            Device.prototype.model = "";

            /**
             * Device type.
             * @member {string} type
             * @memberof user.UserAgent.Device
             * @instance
             */
            Device.prototype.type = "";

            /**
             * Device vendor.
             * @member {string} vendor
             * @memberof user.UserAgent.Device
             * @instance
             */
            Device.prototype.vendor = "";

            /**
             * Creates a new Device instance using the specified properties.
             * @function create
             * @memberof user.UserAgent.Device
             * @static
             * @param {user.UserAgent.IDevice=} [properties] Properties to set
             * @returns {user.UserAgent.Device} Device instance
             */
            Device.create = function create(properties) {
                return new Device(properties);
            };

            /**
             * Encodes the specified Device message. Does not implicitly {@link user.UserAgent.Device.verify|verify} messages.
             * @function encode
             * @memberof user.UserAgent.Device
             * @static
             * @param {user.UserAgent.IDevice} message Device message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Device.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.model);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
                if (message.vendor != null && Object.hasOwnProperty.call(message, "vendor"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.vendor);
                return writer;
            };

            /**
             * Encodes the specified Device message, length delimited. Does not implicitly {@link user.UserAgent.Device.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UserAgent.Device
             * @static
             * @param {user.UserAgent.IDevice} message Device message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Device.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Device message from the specified reader or buffer.
             * @function decode
             * @memberof user.UserAgent.Device
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UserAgent.Device} Device
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Device.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UserAgent.Device();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.model = reader.string();
                        break;
                    case 2:
                        message.type = reader.string();
                        break;
                    case 3:
                        message.vendor = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Device message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UserAgent.Device
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UserAgent.Device} Device
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Device.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Device message.
             * @function verify
             * @memberof user.UserAgent.Device
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Device.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.model != null && message.hasOwnProperty("model"))
                    if (!$util.isString(message.model))
                        return "model: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.vendor != null && message.hasOwnProperty("vendor"))
                    if (!$util.isString(message.vendor))
                        return "vendor: string expected";
                return null;
            };

            /**
             * Creates a Device message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UserAgent.Device
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UserAgent.Device} Device
             */
            Device.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UserAgent.Device)
                    return object;
                var message = new $root.user.UserAgent.Device();
                if (object.model != null)
                    message.model = String(object.model);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.vendor != null)
                    message.vendor = String(object.vendor);
                return message;
            };

            /**
             * Creates a plain object from a Device message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UserAgent.Device
             * @static
             * @param {user.UserAgent.Device} message Device
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Device.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.model = "";
                    object.type = "";
                    object.vendor = "";
                }
                if (message.model != null && message.hasOwnProperty("model"))
                    object.model = message.model;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.vendor != null && message.hasOwnProperty("vendor"))
                    object.vendor = message.vendor;
                return object;
            };

            /**
             * Converts this Device to JSON.
             * @function toJSON
             * @memberof user.UserAgent.Device
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Device.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Device;
        })();

        UserAgent.OS = (function() {

            /**
             * Properties of a OS.
             * @memberof user.UserAgent
             * @interface IOS
             * @property {string|null} [name] OS name
             * @property {string|null} [version] OS version
             */

            /**
             * Constructs a new OS.
             * @memberof user.UserAgent
             * @classdesc Represents a OS.
             * @implements IOS
             * @constructor
             * @param {user.UserAgent.IOS=} [properties] Properties to set
             */
            function OS(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OS name.
             * @member {string} name
             * @memberof user.UserAgent.OS
             * @instance
             */
            OS.prototype.name = "";

            /**
             * OS version.
             * @member {string} version
             * @memberof user.UserAgent.OS
             * @instance
             */
            OS.prototype.version = "";

            /**
             * Creates a new OS instance using the specified properties.
             * @function create
             * @memberof user.UserAgent.OS
             * @static
             * @param {user.UserAgent.IOS=} [properties] Properties to set
             * @returns {user.UserAgent.OS} OS instance
             */
            OS.create = function create(properties) {
                return new OS(properties);
            };

            /**
             * Encodes the specified OS message. Does not implicitly {@link user.UserAgent.OS.verify|verify} messages.
             * @function encode
             * @memberof user.UserAgent.OS
             * @static
             * @param {user.UserAgent.IOS} message OS message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OS.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.version);
                return writer;
            };

            /**
             * Encodes the specified OS message, length delimited. Does not implicitly {@link user.UserAgent.OS.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UserAgent.OS
             * @static
             * @param {user.UserAgent.IOS} message OS message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OS.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a OS message from the specified reader or buffer.
             * @function decode
             * @memberof user.UserAgent.OS
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UserAgent.OS} OS
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OS.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UserAgent.OS();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.version = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a OS message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UserAgent.OS
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UserAgent.OS} OS
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OS.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a OS message.
             * @function verify
             * @memberof user.UserAgent.OS
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OS.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.version != null && message.hasOwnProperty("version"))
                    if (!$util.isString(message.version))
                        return "version: string expected";
                return null;
            };

            /**
             * Creates a OS message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UserAgent.OS
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UserAgent.OS} OS
             */
            OS.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UserAgent.OS)
                    return object;
                var message = new $root.user.UserAgent.OS();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.version != null)
                    message.version = String(object.version);
                return message;
            };

            /**
             * Creates a plain object from a OS message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UserAgent.OS
             * @static
             * @param {user.UserAgent.OS} message OS
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OS.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.version = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.version != null && message.hasOwnProperty("version"))
                    object.version = message.version;
                return object;
            };

            /**
             * Converts this OS to JSON.
             * @function toJSON
             * @memberof user.UserAgent.OS
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OS.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OS;
        })();

        return UserAgent;
    })();

    return user;
})();

$root.base = (function() {

    /**
     * Namespace base.
     * @exports base
     * @namespace
     */
    var base = {};

    base.RequestType = (function() {

        /**
         * Properties of a RequestType.
         * @memberof base
         * @interface IRequestType
         * @property {string|null} [data] RequestType data
         * @property {string|null} [token] RequestType token
         * @property {string|null} [deviceId] RequestType deviceId
         * @property {user.IUserAgent|null} [userAgent] RequestType userAgent
         */

        /**
         * Constructs a new RequestType.
         * @memberof base
         * @classdesc Represents a RequestType.
         * @implements IRequestType
         * @constructor
         * @param {base.IRequestType=} [properties] Properties to set
         */
        function RequestType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestType data.
         * @member {string} data
         * @memberof base.RequestType
         * @instance
         */
        RequestType.prototype.data = "";

        /**
         * RequestType token.
         * @member {string} token
         * @memberof base.RequestType
         * @instance
         */
        RequestType.prototype.token = "";

        /**
         * RequestType deviceId.
         * @member {string} deviceId
         * @memberof base.RequestType
         * @instance
         */
        RequestType.prototype.deviceId = "";

        /**
         * RequestType userAgent.
         * @member {user.IUserAgent|null|undefined} userAgent
         * @memberof base.RequestType
         * @instance
         */
        RequestType.prototype.userAgent = null;

        /**
         * Creates a new RequestType instance using the specified properties.
         * @function create
         * @memberof base.RequestType
         * @static
         * @param {base.IRequestType=} [properties] Properties to set
         * @returns {base.RequestType} RequestType instance
         */
        RequestType.create = function create(properties) {
            return new RequestType(properties);
        };

        /**
         * Encodes the specified RequestType message. Does not implicitly {@link base.RequestType.verify|verify} messages.
         * @function encode
         * @memberof base.RequestType
         * @static
         * @param {base.IRequestType} message RequestType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
            if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.deviceId);
            if (message.userAgent != null && Object.hasOwnProperty.call(message, "userAgent"))
                $root.user.UserAgent.encode(message.userAgent, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified RequestType message, length delimited. Does not implicitly {@link base.RequestType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof base.RequestType
         * @static
         * @param {base.IRequestType} message RequestType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RequestType message from the specified reader or buffer.
         * @function decode
         * @memberof base.RequestType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {base.RequestType} RequestType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.base.RequestType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.token = reader.string();
                    break;
                case 3:
                    message.deviceId = reader.string();
                    break;
                case 4:
                    message.userAgent = $root.user.UserAgent.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RequestType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof base.RequestType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {base.RequestType} RequestType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestType message.
         * @function verify
         * @memberof base.RequestType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!$util.isString(message.data))
                    return "data: string expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!$util.isString(message.token))
                    return "token: string expected";
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (!$util.isString(message.deviceId))
                    return "deviceId: string expected";
            if (message.userAgent != null && message.hasOwnProperty("userAgent")) {
                var error = $root.user.UserAgent.verify(message.userAgent);
                if (error)
                    return "userAgent." + error;
            }
            return null;
        };

        /**
         * Creates a RequestType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof base.RequestType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {base.RequestType} RequestType
         */
        RequestType.fromObject = function fromObject(object) {
            if (object instanceof $root.base.RequestType)
                return object;
            var message = new $root.base.RequestType();
            if (object.data != null)
                message.data = String(object.data);
            if (object.token != null)
                message.token = String(object.token);
            if (object.deviceId != null)
                message.deviceId = String(object.deviceId);
            if (object.userAgent != null) {
                if (typeof object.userAgent !== "object")
                    throw TypeError(".base.RequestType.userAgent: object expected");
                message.userAgent = $root.user.UserAgent.fromObject(object.userAgent);
            }
            return message;
        };

        /**
         * Creates a plain object from a RequestType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof base.RequestType
         * @static
         * @param {base.RequestType} message RequestType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data = "";
                object.token = "";
                object.deviceId = "";
                object.userAgent = null;
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = message.data;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = message.token;
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                object.deviceId = message.deviceId;
            if (message.userAgent != null && message.hasOwnProperty("userAgent"))
                object.userAgent = $root.user.UserAgent.toObject(message.userAgent, options);
            return object;
        };

        /**
         * Converts this RequestType to JSON.
         * @function toJSON
         * @memberof base.RequestType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RequestType;
    })();

    base.ResponseType = (function() {

        /**
         * Properties of a ResponseType.
         * @memberof base
         * @interface IResponseType
         * @property {number|null} [code] ResponseType code
         * @property {string|null} [msg] ResponseType msg
         * @property {string|null} [cnMsg] ResponseType cnMsg
         * @property {string|null} [error] ResponseType error
         * @property {string|null} [requestId] ResponseType requestId
         * @property {number|null} [requestTime] ResponseType requestTime
         * @property {string|null} [author] ResponseType author
         * @property {string|null} [platform] ResponseType platform
         * @property {string|null} [data] ResponseType data
         */

        /**
         * Constructs a new ResponseType.
         * @memberof base
         * @classdesc Represents a ResponseType.
         * @implements IResponseType
         * @constructor
         * @param {base.IResponseType=} [properties] Properties to set
         */
        function ResponseType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseType code.
         * @member {number} code
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ResponseType msg.
         * @member {string} msg
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.msg = "";

        /**
         * ResponseType cnMsg.
         * @member {string} cnMsg
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.cnMsg = "";

        /**
         * ResponseType error.
         * @member {string} error
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.error = "";

        /**
         * ResponseType requestId.
         * @member {string} requestId
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.requestId = "";

        /**
         * ResponseType requestTime.
         * @member {number} requestTime
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.requestTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ResponseType author.
         * @member {string} author
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.author = "";

        /**
         * ResponseType platform.
         * @member {string} platform
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.platform = "";

        /**
         * ResponseType data.
         * @member {string} data
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.data = "";

        /**
         * Creates a new ResponseType instance using the specified properties.
         * @function create
         * @memberof base.ResponseType
         * @static
         * @param {base.IResponseType=} [properties] Properties to set
         * @returns {base.ResponseType} ResponseType instance
         */
        ResponseType.create = function create(properties) {
            return new ResponseType(properties);
        };

        /**
         * Encodes the specified ResponseType message. Does not implicitly {@link base.ResponseType.verify|verify} messages.
         * @function encode
         * @memberof base.ResponseType
         * @static
         * @param {base.IResponseType} message ResponseType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.code);
            if (message.msg != null && Object.hasOwnProperty.call(message, "msg"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.msg);
            if (message.cnMsg != null && Object.hasOwnProperty.call(message, "cnMsg"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.cnMsg);
            if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.error);
            if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.requestId);
            if (message.requestTime != null && Object.hasOwnProperty.call(message, "requestTime"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.requestTime);
            if (message.author != null && Object.hasOwnProperty.call(message, "author"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.author);
            if (message.platform != null && Object.hasOwnProperty.call(message, "platform"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.platform);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.data);
            return writer;
        };

        /**
         * Encodes the specified ResponseType message, length delimited. Does not implicitly {@link base.ResponseType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof base.ResponseType
         * @static
         * @param {base.IResponseType} message ResponseType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResponseType message from the specified reader or buffer.
         * @function decode
         * @memberof base.ResponseType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {base.ResponseType} ResponseType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.base.ResponseType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.code = reader.int64();
                    break;
                case 2:
                    message.msg = reader.string();
                    break;
                case 3:
                    message.cnMsg = reader.string();
                    break;
                case 4:
                    message.error = reader.string();
                    break;
                case 5:
                    message.requestId = reader.string();
                    break;
                case 6:
                    message.requestTime = reader.int64();
                    break;
                case 7:
                    message.author = reader.string();
                    break;
                case 8:
                    message.platform = reader.string();
                    break;
                case 9:
                    message.data = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ResponseType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof base.ResponseType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {base.ResponseType} ResponseType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseType message.
         * @function verify
         * @memberof base.ResponseType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code) && !(message.code && $util.isInteger(message.code.low) && $util.isInteger(message.code.high)))
                    return "code: integer|Long expected";
            if (message.msg != null && message.hasOwnProperty("msg"))
                if (!$util.isString(message.msg))
                    return "msg: string expected";
            if (message.cnMsg != null && message.hasOwnProperty("cnMsg"))
                if (!$util.isString(message.cnMsg))
                    return "cnMsg: string expected";
            if (message.error != null && message.hasOwnProperty("error"))
                if (!$util.isString(message.error))
                    return "error: string expected";
            if (message.requestId != null && message.hasOwnProperty("requestId"))
                if (!$util.isString(message.requestId))
                    return "requestId: string expected";
            if (message.requestTime != null && message.hasOwnProperty("requestTime"))
                if (!$util.isInteger(message.requestTime) && !(message.requestTime && $util.isInteger(message.requestTime.low) && $util.isInteger(message.requestTime.high)))
                    return "requestTime: integer|Long expected";
            if (message.author != null && message.hasOwnProperty("author"))
                if (!$util.isString(message.author))
                    return "author: string expected";
            if (message.platform != null && message.hasOwnProperty("platform"))
                if (!$util.isString(message.platform))
                    return "platform: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!$util.isString(message.data))
                    return "data: string expected";
            return null;
        };

        /**
         * Creates a ResponseType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof base.ResponseType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {base.ResponseType} ResponseType
         */
        ResponseType.fromObject = function fromObject(object) {
            if (object instanceof $root.base.ResponseType)
                return object;
            var message = new $root.base.ResponseType();
            if (object.code != null)
                if ($util.Long)
                    (message.code = $util.Long.fromValue(object.code)).unsigned = false;
                else if (typeof object.code === "string")
                    message.code = parseInt(object.code, 10);
                else if (typeof object.code === "number")
                    message.code = object.code;
                else if (typeof object.code === "object")
                    message.code = new $util.LongBits(object.code.low >>> 0, object.code.high >>> 0).toNumber();
            if (object.msg != null)
                message.msg = String(object.msg);
            if (object.cnMsg != null)
                message.cnMsg = String(object.cnMsg);
            if (object.error != null)
                message.error = String(object.error);
            if (object.requestId != null)
                message.requestId = String(object.requestId);
            if (object.requestTime != null)
                if ($util.Long)
                    (message.requestTime = $util.Long.fromValue(object.requestTime)).unsigned = false;
                else if (typeof object.requestTime === "string")
                    message.requestTime = parseInt(object.requestTime, 10);
                else if (typeof object.requestTime === "number")
                    message.requestTime = object.requestTime;
                else if (typeof object.requestTime === "object")
                    message.requestTime = new $util.LongBits(object.requestTime.low >>> 0, object.requestTime.high >>> 0).toNumber();
            if (object.author != null)
                message.author = String(object.author);
            if (object.platform != null)
                message.platform = String(object.platform);
            if (object.data != null)
                message.data = String(object.data);
            return message;
        };

        /**
         * Creates a plain object from a ResponseType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof base.ResponseType
         * @static
         * @param {base.ResponseType} message ResponseType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.code = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.code = options.longs === String ? "0" : 0;
                object.msg = "";
                object.cnMsg = "";
                object.error = "";
                object.requestId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.requestTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.requestTime = options.longs === String ? "0" : 0;
                object.author = "";
                object.platform = "";
                object.data = "";
            }
            if (message.code != null && message.hasOwnProperty("code"))
                if (typeof message.code === "number")
                    object.code = options.longs === String ? String(message.code) : message.code;
                else
                    object.code = options.longs === String ? $util.Long.prototype.toString.call(message.code) : options.longs === Number ? new $util.LongBits(message.code.low >>> 0, message.code.high >>> 0).toNumber() : message.code;
            if (message.msg != null && message.hasOwnProperty("msg"))
                object.msg = message.msg;
            if (message.cnMsg != null && message.hasOwnProperty("cnMsg"))
                object.cnMsg = message.cnMsg;
            if (message.error != null && message.hasOwnProperty("error"))
                object.error = message.error;
            if (message.requestId != null && message.hasOwnProperty("requestId"))
                object.requestId = message.requestId;
            if (message.requestTime != null && message.hasOwnProperty("requestTime"))
                if (typeof message.requestTime === "number")
                    object.requestTime = options.longs === String ? String(message.requestTime) : message.requestTime;
                else
                    object.requestTime = options.longs === String ? $util.Long.prototype.toString.call(message.requestTime) : options.longs === Number ? new $util.LongBits(message.requestTime.low >>> 0, message.requestTime.high >>> 0).toNumber() : message.requestTime;
            if (message.author != null && message.hasOwnProperty("author"))
                object.author = message.author;
            if (message.platform != null && message.hasOwnProperty("platform"))
                object.platform = message.platform;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = message.data;
            return object;
        };

        /**
         * Converts this ResponseType to JSON.
         * @function toJSON
         * @memberof base.ResponseType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResponseType;
    })();

    base.ResponseEncryptDataType = (function() {

        /**
         * Properties of a ResponseEncryptDataType.
         * @memberof base
         * @interface IResponseEncryptDataType
         * @property {string|null} [data] ResponseEncryptDataType data
         * @property {string|null} [key] ResponseEncryptDataType key
         */

        /**
         * Constructs a new ResponseEncryptDataType.
         * @memberof base
         * @classdesc Represents a ResponseEncryptDataType.
         * @implements IResponseEncryptDataType
         * @constructor
         * @param {base.IResponseEncryptDataType=} [properties] Properties to set
         */
        function ResponseEncryptDataType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseEncryptDataType data.
         * @member {string} data
         * @memberof base.ResponseEncryptDataType
         * @instance
         */
        ResponseEncryptDataType.prototype.data = "";

        /**
         * ResponseEncryptDataType key.
         * @member {string} key
         * @memberof base.ResponseEncryptDataType
         * @instance
         */
        ResponseEncryptDataType.prototype.key = "";

        /**
         * Creates a new ResponseEncryptDataType instance using the specified properties.
         * @function create
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {base.IResponseEncryptDataType=} [properties] Properties to set
         * @returns {base.ResponseEncryptDataType} ResponseEncryptDataType instance
         */
        ResponseEncryptDataType.create = function create(properties) {
            return new ResponseEncryptDataType(properties);
        };

        /**
         * Encodes the specified ResponseEncryptDataType message. Does not implicitly {@link base.ResponseEncryptDataType.verify|verify} messages.
         * @function encode
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {base.IResponseEncryptDataType} message ResponseEncryptDataType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseEncryptDataType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.key);
            return writer;
        };

        /**
         * Encodes the specified ResponseEncryptDataType message, length delimited. Does not implicitly {@link base.ResponseEncryptDataType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {base.IResponseEncryptDataType} message ResponseEncryptDataType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseEncryptDataType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResponseEncryptDataType message from the specified reader or buffer.
         * @function decode
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {base.ResponseEncryptDataType} ResponseEncryptDataType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseEncryptDataType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.base.ResponseEncryptDataType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.key = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ResponseEncryptDataType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {base.ResponseEncryptDataType} ResponseEncryptDataType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseEncryptDataType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseEncryptDataType message.
         * @function verify
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseEncryptDataType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!$util.isString(message.data))
                    return "data: string expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            return null;
        };

        /**
         * Creates a ResponseEncryptDataType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {base.ResponseEncryptDataType} ResponseEncryptDataType
         */
        ResponseEncryptDataType.fromObject = function fromObject(object) {
            if (object instanceof $root.base.ResponseEncryptDataType)
                return object;
            var message = new $root.base.ResponseEncryptDataType();
            if (object.data != null)
                message.data = String(object.data);
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a ResponseEncryptDataType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {base.ResponseEncryptDataType} message ResponseEncryptDataType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseEncryptDataType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data = "";
                object.key = "";
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = message.data;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this ResponseEncryptDataType to JSON.
         * @function toJSON
         * @memberof base.ResponseEncryptDataType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseEncryptDataType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResponseEncryptDataType;
    })();

    base.RequestEncryptDataType = (function() {

        /**
         * Properties of a RequestEncryptDataType.
         * @memberof base
         * @interface IRequestEncryptDataType
         * @property {string|null} [data] RequestEncryptDataType data
         * @property {string|null} [key] RequestEncryptDataType key
         */

        /**
         * Constructs a new RequestEncryptDataType.
         * @memberof base
         * @classdesc Represents a RequestEncryptDataType.
         * @implements IRequestEncryptDataType
         * @constructor
         * @param {base.IRequestEncryptDataType=} [properties] Properties to set
         */
        function RequestEncryptDataType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestEncryptDataType data.
         * @member {string} data
         * @memberof base.RequestEncryptDataType
         * @instance
         */
        RequestEncryptDataType.prototype.data = "";

        /**
         * RequestEncryptDataType key.
         * @member {string} key
         * @memberof base.RequestEncryptDataType
         * @instance
         */
        RequestEncryptDataType.prototype.key = "";

        /**
         * Creates a new RequestEncryptDataType instance using the specified properties.
         * @function create
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {base.IRequestEncryptDataType=} [properties] Properties to set
         * @returns {base.RequestEncryptDataType} RequestEncryptDataType instance
         */
        RequestEncryptDataType.create = function create(properties) {
            return new RequestEncryptDataType(properties);
        };

        /**
         * Encodes the specified RequestEncryptDataType message. Does not implicitly {@link base.RequestEncryptDataType.verify|verify} messages.
         * @function encode
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {base.IRequestEncryptDataType} message RequestEncryptDataType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestEncryptDataType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.key);
            return writer;
        };

        /**
         * Encodes the specified RequestEncryptDataType message, length delimited. Does not implicitly {@link base.RequestEncryptDataType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {base.IRequestEncryptDataType} message RequestEncryptDataType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestEncryptDataType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RequestEncryptDataType message from the specified reader or buffer.
         * @function decode
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {base.RequestEncryptDataType} RequestEncryptDataType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestEncryptDataType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.base.RequestEncryptDataType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.key = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RequestEncryptDataType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {base.RequestEncryptDataType} RequestEncryptDataType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestEncryptDataType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestEncryptDataType message.
         * @function verify
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestEncryptDataType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!$util.isString(message.data))
                    return "data: string expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            return null;
        };

        /**
         * Creates a RequestEncryptDataType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {base.RequestEncryptDataType} RequestEncryptDataType
         */
        RequestEncryptDataType.fromObject = function fromObject(object) {
            if (object instanceof $root.base.RequestEncryptDataType)
                return object;
            var message = new $root.base.RequestEncryptDataType();
            if (object.data != null)
                message.data = String(object.data);
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a RequestEncryptDataType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {base.RequestEncryptDataType} message RequestEncryptDataType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestEncryptDataType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data = "";
                object.key = "";
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = message.data;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this RequestEncryptDataType to JSON.
         * @function toJSON
         * @memberof base.RequestEncryptDataType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestEncryptDataType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RequestEncryptDataType;
    })();

    return base;
})();

$root.file = (function() {

    /**
     * Namespace file.
     * @exports file
     * @namespace
     */
    var file = {};

    file.Urls = (function() {

        /**
         * Properties of an Urls.
         * @memberof file
         * @interface IUrls
         * @property {string|null} [domainUrl] Urls domainUrl
         * @property {string|null} [shortUrl] Urls shortUrl
         * @property {string|null} [url] Urls url
         */

        /**
         * Constructs a new Urls.
         * @memberof file
         * @classdesc Represents an Urls.
         * @implements IUrls
         * @constructor
         * @param {file.IUrls=} [properties] Properties to set
         */
        function Urls(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Urls domainUrl.
         * @member {string} domainUrl
         * @memberof file.Urls
         * @instance
         */
        Urls.prototype.domainUrl = "";

        /**
         * Urls shortUrl.
         * @member {string} shortUrl
         * @memberof file.Urls
         * @instance
         */
        Urls.prototype.shortUrl = "";

        /**
         * Urls url.
         * @member {string} url
         * @memberof file.Urls
         * @instance
         */
        Urls.prototype.url = "";

        /**
         * Creates a new Urls instance using the specified properties.
         * @function create
         * @memberof file.Urls
         * @static
         * @param {file.IUrls=} [properties] Properties to set
         * @returns {file.Urls} Urls instance
         */
        Urls.create = function create(properties) {
            return new Urls(properties);
        };

        /**
         * Encodes the specified Urls message. Does not implicitly {@link file.Urls.verify|verify} messages.
         * @function encode
         * @memberof file.Urls
         * @static
         * @param {file.IUrls} message Urls message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Urls.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.domainUrl != null && Object.hasOwnProperty.call(message, "domainUrl"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.domainUrl);
            if (message.shortUrl != null && Object.hasOwnProperty.call(message, "shortUrl"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.shortUrl);
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.url);
            return writer;
        };

        /**
         * Encodes the specified Urls message, length delimited. Does not implicitly {@link file.Urls.verify|verify} messages.
         * @function encodeDelimited
         * @memberof file.Urls
         * @static
         * @param {file.IUrls} message Urls message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Urls.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Urls message from the specified reader or buffer.
         * @function decode
         * @memberof file.Urls
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {file.Urls} Urls
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Urls.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.Urls();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.domainUrl = reader.string();
                    break;
                case 2:
                    message.shortUrl = reader.string();
                    break;
                case 3:
                    message.url = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Urls message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof file.Urls
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {file.Urls} Urls
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Urls.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Urls message.
         * @function verify
         * @memberof file.Urls
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Urls.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.domainUrl != null && message.hasOwnProperty("domainUrl"))
                if (!$util.isString(message.domainUrl))
                    return "domainUrl: string expected";
            if (message.shortUrl != null && message.hasOwnProperty("shortUrl"))
                if (!$util.isString(message.shortUrl))
                    return "shortUrl: string expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            return null;
        };

        /**
         * Creates an Urls message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof file.Urls
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {file.Urls} Urls
         */
        Urls.fromObject = function fromObject(object) {
            if (object instanceof $root.file.Urls)
                return object;
            var message = new $root.file.Urls();
            if (object.domainUrl != null)
                message.domainUrl = String(object.domainUrl);
            if (object.shortUrl != null)
                message.shortUrl = String(object.shortUrl);
            if (object.url != null)
                message.url = String(object.url);
            return message;
        };

        /**
         * Creates a plain object from an Urls message. Also converts values to other types if specified.
         * @function toObject
         * @memberof file.Urls
         * @static
         * @param {file.Urls} message Urls
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Urls.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.domainUrl = "";
                object.shortUrl = "";
                object.url = "";
            }
            if (message.domainUrl != null && message.hasOwnProperty("domainUrl"))
                object.domainUrl = message.domainUrl;
            if (message.shortUrl != null && message.hasOwnProperty("shortUrl"))
                object.shortUrl = message.shortUrl;
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            return object;
        };

        /**
         * Converts this Urls to JSON.
         * @function toJSON
         * @memberof file.Urls
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Urls.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Urls;
    })();

    file.UrlsItem = (function() {

        /**
         * Properties of an UrlsItem.
         * @memberof file
         * @interface IUrlsItem
         * @property {file.IUrls|null} [urls] UrlsItem urls
         * @property {string|null} [id] UrlsItem id
         * @property {number|null} [createTime] UrlsItem createTime
         * @property {number|null} [lastUpdateTime] UrlsItem lastUpdateTime
         */

        /**
         * Constructs a new UrlsItem.
         * @memberof file
         * @classdesc Represents an UrlsItem.
         * @implements IUrlsItem
         * @constructor
         * @param {file.IUrlsItem=} [properties] Properties to set
         */
        function UrlsItem(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UrlsItem urls.
         * @member {file.IUrls|null|undefined} urls
         * @memberof file.UrlsItem
         * @instance
         */
        UrlsItem.prototype.urls = null;

        /**
         * UrlsItem id.
         * @member {string} id
         * @memberof file.UrlsItem
         * @instance
         */
        UrlsItem.prototype.id = "";

        /**
         * UrlsItem createTime.
         * @member {number} createTime
         * @memberof file.UrlsItem
         * @instance
         */
        UrlsItem.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * UrlsItem lastUpdateTime.
         * @member {number} lastUpdateTime
         * @memberof file.UrlsItem
         * @instance
         */
        UrlsItem.prototype.lastUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new UrlsItem instance using the specified properties.
         * @function create
         * @memberof file.UrlsItem
         * @static
         * @param {file.IUrlsItem=} [properties] Properties to set
         * @returns {file.UrlsItem} UrlsItem instance
         */
        UrlsItem.create = function create(properties) {
            return new UrlsItem(properties);
        };

        /**
         * Encodes the specified UrlsItem message. Does not implicitly {@link file.UrlsItem.verify|verify} messages.
         * @function encode
         * @memberof file.UrlsItem
         * @static
         * @param {file.IUrlsItem} message UrlsItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UrlsItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.urls != null && Object.hasOwnProperty.call(message, "urls"))
                $root.file.Urls.encode(message.urls, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.id);
            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.createTime);
            if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.lastUpdateTime);
            return writer;
        };

        /**
         * Encodes the specified UrlsItem message, length delimited. Does not implicitly {@link file.UrlsItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof file.UrlsItem
         * @static
         * @param {file.IUrlsItem} message UrlsItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UrlsItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UrlsItem message from the specified reader or buffer.
         * @function decode
         * @memberof file.UrlsItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {file.UrlsItem} UrlsItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UrlsItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.UrlsItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.urls = $root.file.Urls.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.id = reader.string();
                    break;
                case 3:
                    message.createTime = reader.int64();
                    break;
                case 4:
                    message.lastUpdateTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UrlsItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof file.UrlsItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {file.UrlsItem} UrlsItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UrlsItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UrlsItem message.
         * @function verify
         * @memberof file.UrlsItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UrlsItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.urls != null && message.hasOwnProperty("urls")) {
                var error = $root.file.Urls.verify(message.urls);
                if (error)
                    return "urls." + error;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                    return "createTime: integer|Long expected";
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (!$util.isInteger(message.lastUpdateTime) && !(message.lastUpdateTime && $util.isInteger(message.lastUpdateTime.low) && $util.isInteger(message.lastUpdateTime.high)))
                    return "lastUpdateTime: integer|Long expected";
            return null;
        };

        /**
         * Creates an UrlsItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof file.UrlsItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {file.UrlsItem} UrlsItem
         */
        UrlsItem.fromObject = function fromObject(object) {
            if (object instanceof $root.file.UrlsItem)
                return object;
            var message = new $root.file.UrlsItem();
            if (object.urls != null) {
                if (typeof object.urls !== "object")
                    throw TypeError(".file.UrlsItem.urls: object expected");
                message.urls = $root.file.Urls.fromObject(object.urls);
            }
            if (object.id != null)
                message.id = String(object.id);
            if (object.createTime != null)
                if ($util.Long)
                    (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                else if (typeof object.createTime === "string")
                    message.createTime = parseInt(object.createTime, 10);
                else if (typeof object.createTime === "number")
                    message.createTime = object.createTime;
                else if (typeof object.createTime === "object")
                    message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
            if (object.lastUpdateTime != null)
                if ($util.Long)
                    (message.lastUpdateTime = $util.Long.fromValue(object.lastUpdateTime)).unsigned = false;
                else if (typeof object.lastUpdateTime === "string")
                    message.lastUpdateTime = parseInt(object.lastUpdateTime, 10);
                else if (typeof object.lastUpdateTime === "number")
                    message.lastUpdateTime = object.lastUpdateTime;
                else if (typeof object.lastUpdateTime === "object")
                    message.lastUpdateTime = new $util.LongBits(object.lastUpdateTime.low >>> 0, object.lastUpdateTime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from an UrlsItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof file.UrlsItem
         * @static
         * @param {file.UrlsItem} message UrlsItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UrlsItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.urls = null;
                object.id = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastUpdateTime = options.longs === String ? "0" : 0;
            }
            if (message.urls != null && message.hasOwnProperty("urls"))
                object.urls = $root.file.Urls.toObject(message.urls, options);
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (typeof message.createTime === "number")
                    object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                else
                    object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (typeof message.lastUpdateTime === "number")
                    object.lastUpdateTime = options.longs === String ? String(message.lastUpdateTime) : message.lastUpdateTime;
                else
                    object.lastUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTime) : options.longs === Number ? new $util.LongBits(message.lastUpdateTime.low >>> 0, message.lastUpdateTime.high >>> 0).toNumber() : message.lastUpdateTime;
            return object;
        };

        /**
         * Converts this UrlsItem to JSON.
         * @function toJSON
         * @memberof file.UrlsItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UrlsItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UrlsItem;
    })();

    file.FileInfo = (function() {

        /**
         * Properties of a FileInfo.
         * @memberof file
         * @interface IFileInfo
         * @property {string|null} [name] FileInfo name
         * @property {number|null} [size] FileInfo size
         * @property {string|null} [type] FileInfo type
         * @property {string|null} [suffix] FileInfo suffix
         * @property {number|null} [lastModified] FileInfo lastModified
         * @property {string|null} [hash] FileInfo hash
         */

        /**
         * Constructs a new FileInfo.
         * @memberof file
         * @classdesc Represents a FileInfo.
         * @implements IFileInfo
         * @constructor
         * @param {file.IFileInfo=} [properties] Properties to set
         */
        function FileInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileInfo name.
         * @member {string} name
         * @memberof file.FileInfo
         * @instance
         */
        FileInfo.prototype.name = "";

        /**
         * FileInfo size.
         * @member {number} size
         * @memberof file.FileInfo
         * @instance
         */
        FileInfo.prototype.size = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * FileInfo type.
         * @member {string} type
         * @memberof file.FileInfo
         * @instance
         */
        FileInfo.prototype.type = "";

        /**
         * FileInfo suffix.
         * @member {string} suffix
         * @memberof file.FileInfo
         * @instance
         */
        FileInfo.prototype.suffix = "";

        /**
         * FileInfo lastModified.
         * @member {number} lastModified
         * @memberof file.FileInfo
         * @instance
         */
        FileInfo.prototype.lastModified = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * FileInfo hash.
         * @member {string} hash
         * @memberof file.FileInfo
         * @instance
         */
        FileInfo.prototype.hash = "";

        /**
         * Creates a new FileInfo instance using the specified properties.
         * @function create
         * @memberof file.FileInfo
         * @static
         * @param {file.IFileInfo=} [properties] Properties to set
         * @returns {file.FileInfo} FileInfo instance
         */
        FileInfo.create = function create(properties) {
            return new FileInfo(properties);
        };

        /**
         * Encodes the specified FileInfo message. Does not implicitly {@link file.FileInfo.verify|verify} messages.
         * @function encode
         * @memberof file.FileInfo
         * @static
         * @param {file.IFileInfo} message FileInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.size);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.type);
            if (message.suffix != null && Object.hasOwnProperty.call(message, "suffix"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.suffix);
            if (message.lastModified != null && Object.hasOwnProperty.call(message, "lastModified"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.lastModified);
            if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.hash);
            return writer;
        };

        /**
         * Encodes the specified FileInfo message, length delimited. Does not implicitly {@link file.FileInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof file.FileInfo
         * @static
         * @param {file.IFileInfo} message FileInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileInfo message from the specified reader or buffer.
         * @function decode
         * @memberof file.FileInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {file.FileInfo} FileInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.FileInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.size = reader.int64();
                    break;
                case 3:
                    message.type = reader.string();
                    break;
                case 4:
                    message.suffix = reader.string();
                    break;
                case 5:
                    message.lastModified = reader.int64();
                    break;
                case 6:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof file.FileInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {file.FileInfo} FileInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileInfo message.
         * @function verify
         * @memberof file.FileInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.size != null && message.hasOwnProperty("size"))
                if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                    return "size: integer|Long expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.suffix != null && message.hasOwnProperty("suffix"))
                if (!$util.isString(message.suffix))
                    return "suffix: string expected";
            if (message.lastModified != null && message.hasOwnProperty("lastModified"))
                if (!$util.isInteger(message.lastModified) && !(message.lastModified && $util.isInteger(message.lastModified.low) && $util.isInteger(message.lastModified.high)))
                    return "lastModified: integer|Long expected";
            if (message.hash != null && message.hasOwnProperty("hash"))
                if (!$util.isString(message.hash))
                    return "hash: string expected";
            return null;
        };

        /**
         * Creates a FileInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof file.FileInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {file.FileInfo} FileInfo
         */
        FileInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.file.FileInfo)
                return object;
            var message = new $root.file.FileInfo();
            if (object.name != null)
                message.name = String(object.name);
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = false;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber();
            if (object.type != null)
                message.type = String(object.type);
            if (object.suffix != null)
                message.suffix = String(object.suffix);
            if (object.lastModified != null)
                if ($util.Long)
                    (message.lastModified = $util.Long.fromValue(object.lastModified)).unsigned = false;
                else if (typeof object.lastModified === "string")
                    message.lastModified = parseInt(object.lastModified, 10);
                else if (typeof object.lastModified === "number")
                    message.lastModified = object.lastModified;
                else if (typeof object.lastModified === "object")
                    message.lastModified = new $util.LongBits(object.lastModified.low >>> 0, object.lastModified.high >>> 0).toNumber();
            if (object.hash != null)
                message.hash = String(object.hash);
            return message;
        };

        /**
         * Creates a plain object from a FileInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof file.FileInfo
         * @static
         * @param {file.FileInfo} message FileInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.size = options.longs === String ? "0" : 0;
                object.type = "";
                object.suffix = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastModified = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastModified = options.longs === String ? "0" : 0;
                object.hash = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.size != null && message.hasOwnProperty("size"))
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber() : message.size;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.suffix != null && message.hasOwnProperty("suffix"))
                object.suffix = message.suffix;
            if (message.lastModified != null && message.hasOwnProperty("lastModified"))
                if (typeof message.lastModified === "number")
                    object.lastModified = options.longs === String ? String(message.lastModified) : message.lastModified;
                else
                    object.lastModified = options.longs === String ? $util.Long.prototype.toString.call(message.lastModified) : options.longs === Number ? new $util.LongBits(message.lastModified.low >>> 0, message.lastModified.high >>> 0).toNumber() : message.lastModified;
            if (message.hash != null && message.hasOwnProperty("hash"))
                object.hash = message.hash;
            return object;
        };

        /**
         * Converts this FileInfo to JSON.
         * @function toJSON
         * @memberof file.FileInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FileInfo;
    })();

    file.GetUploadToken = (function() {

        /**
         * Properties of a GetUploadToken.
         * @memberof file
         * @interface IGetUploadToken
         */

        /**
         * Constructs a new GetUploadToken.
         * @memberof file
         * @classdesc Represents a GetUploadToken.
         * @implements IGetUploadToken
         * @constructor
         * @param {file.IGetUploadToken=} [properties] Properties to set
         */
        function GetUploadToken(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetUploadToken instance using the specified properties.
         * @function create
         * @memberof file.GetUploadToken
         * @static
         * @param {file.IGetUploadToken=} [properties] Properties to set
         * @returns {file.GetUploadToken} GetUploadToken instance
         */
        GetUploadToken.create = function create(properties) {
            return new GetUploadToken(properties);
        };

        /**
         * Encodes the specified GetUploadToken message. Does not implicitly {@link file.GetUploadToken.verify|verify} messages.
         * @function encode
         * @memberof file.GetUploadToken
         * @static
         * @param {file.IGetUploadToken} message GetUploadToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUploadToken.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetUploadToken message, length delimited. Does not implicitly {@link file.GetUploadToken.verify|verify} messages.
         * @function encodeDelimited
         * @memberof file.GetUploadToken
         * @static
         * @param {file.IGetUploadToken} message GetUploadToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUploadToken.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetUploadToken message from the specified reader or buffer.
         * @function decode
         * @memberof file.GetUploadToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {file.GetUploadToken} GetUploadToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUploadToken.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.GetUploadToken();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetUploadToken message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof file.GetUploadToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {file.GetUploadToken} GetUploadToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUploadToken.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetUploadToken message.
         * @function verify
         * @memberof file.GetUploadToken
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetUploadToken.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetUploadToken message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof file.GetUploadToken
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {file.GetUploadToken} GetUploadToken
         */
        GetUploadToken.fromObject = function fromObject(object) {
            if (object instanceof $root.file.GetUploadToken)
                return object;
            return new $root.file.GetUploadToken();
        };

        /**
         * Creates a plain object from a GetUploadToken message. Also converts values to other types if specified.
         * @function toObject
         * @memberof file.GetUploadToken
         * @static
         * @param {file.GetUploadToken} message GetUploadToken
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUploadToken.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetUploadToken to JSON.
         * @function toJSON
         * @memberof file.GetUploadToken
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUploadToken.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetUploadToken.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof file.GetUploadToken
             * @interface IRequest
             * @property {file.IFileInfo|null} [fileInfo] Request fileInfo
             */

            /**
             * Constructs a new Request.
             * @memberof file.GetUploadToken
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {file.GetUploadToken.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request fileInfo.
             * @member {file.IFileInfo|null|undefined} fileInfo
             * @memberof file.GetUploadToken.Request
             * @instance
             */
            Request.prototype.fileInfo = null;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof file.GetUploadToken.Request
             * @static
             * @param {file.GetUploadToken.IRequest=} [properties] Properties to set
             * @returns {file.GetUploadToken.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link file.GetUploadToken.Request.verify|verify} messages.
             * @function encode
             * @memberof file.GetUploadToken.Request
             * @static
             * @param {file.GetUploadToken.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.fileInfo != null && Object.hasOwnProperty.call(message, "fileInfo"))
                    $root.file.FileInfo.encode(message.fileInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link file.GetUploadToken.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof file.GetUploadToken.Request
             * @static
             * @param {file.GetUploadToken.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof file.GetUploadToken.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {file.GetUploadToken.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.GetUploadToken.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.fileInfo = $root.file.FileInfo.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof file.GetUploadToken.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {file.GetUploadToken.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof file.GetUploadToken.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.fileInfo != null && message.hasOwnProperty("fileInfo")) {
                    var error = $root.file.FileInfo.verify(message.fileInfo);
                    if (error)
                        return "fileInfo." + error;
                }
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof file.GetUploadToken.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {file.GetUploadToken.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.file.GetUploadToken.Request)
                    return object;
                var message = new $root.file.GetUploadToken.Request();
                if (object.fileInfo != null) {
                    if (typeof object.fileInfo !== "object")
                        throw TypeError(".file.GetUploadToken.Request.fileInfo: object expected");
                    message.fileInfo = $root.file.FileInfo.fromObject(object.fileInfo);
                }
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof file.GetUploadToken.Request
             * @static
             * @param {file.GetUploadToken.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.fileInfo = null;
                if (message.fileInfo != null && message.hasOwnProperty("fileInfo"))
                    object.fileInfo = $root.file.FileInfo.toObject(message.fileInfo, options);
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof file.GetUploadToken.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetUploadToken.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof file.GetUploadToken
             * @interface IResponse
             * @property {file.IUrls|null} [urls] Response urls
             * @property {string|null} [apiUrl] Response apiUrl
             * @property {string|null} [token] Response token
             * @property {number|null} [chunkSize] Response chunkSize
             * @property {Array.<number>|null} [uploadedOffset] Response uploadedOffset
             */

            /**
             * Constructs a new Response.
             * @memberof file.GetUploadToken
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {file.GetUploadToken.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.uploadedOffset = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response urls.
             * @member {file.IUrls|null|undefined} urls
             * @memberof file.GetUploadToken.Response
             * @instance
             */
            Response.prototype.urls = null;

            /**
             * Response apiUrl.
             * @member {string} apiUrl
             * @memberof file.GetUploadToken.Response
             * @instance
             */
            Response.prototype.apiUrl = "";

            /**
             * Response token.
             * @member {string} token
             * @memberof file.GetUploadToken.Response
             * @instance
             */
            Response.prototype.token = "";

            /**
             * Response chunkSize.
             * @member {number} chunkSize
             * @memberof file.GetUploadToken.Response
             * @instance
             */
            Response.prototype.chunkSize = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Response uploadedOffset.
             * @member {Array.<number>} uploadedOffset
             * @memberof file.GetUploadToken.Response
             * @instance
             */
            Response.prototype.uploadedOffset = $util.emptyArray;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof file.GetUploadToken.Response
             * @static
             * @param {file.GetUploadToken.IResponse=} [properties] Properties to set
             * @returns {file.GetUploadToken.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link file.GetUploadToken.Response.verify|verify} messages.
             * @function encode
             * @memberof file.GetUploadToken.Response
             * @static
             * @param {file.GetUploadToken.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.urls != null && Object.hasOwnProperty.call(message, "urls"))
                    $root.file.Urls.encode(message.urls, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.apiUrl != null && Object.hasOwnProperty.call(message, "apiUrl"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.apiUrl);
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.token);
                if (message.chunkSize != null && Object.hasOwnProperty.call(message, "chunkSize"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.chunkSize);
                if (message.uploadedOffset != null && message.uploadedOffset.length) {
                    writer.uint32(/* id 5, wireType 2 =*/42).fork();
                    for (var i = 0; i < message.uploadedOffset.length; ++i)
                        writer.int64(message.uploadedOffset[i]);
                    writer.ldelim();
                }
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link file.GetUploadToken.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof file.GetUploadToken.Response
             * @static
             * @param {file.GetUploadToken.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof file.GetUploadToken.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {file.GetUploadToken.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.GetUploadToken.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.urls = $root.file.Urls.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.apiUrl = reader.string();
                        break;
                    case 3:
                        message.token = reader.string();
                        break;
                    case 4:
                        message.chunkSize = reader.int64();
                        break;
                    case 5:
                        if (!(message.uploadedOffset && message.uploadedOffset.length))
                            message.uploadedOffset = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.uploadedOffset.push(reader.int64());
                        } else
                            message.uploadedOffset.push(reader.int64());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof file.GetUploadToken.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {file.GetUploadToken.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof file.GetUploadToken.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.urls != null && message.hasOwnProperty("urls")) {
                    var error = $root.file.Urls.verify(message.urls);
                    if (error)
                        return "urls." + error;
                }
                if (message.apiUrl != null && message.hasOwnProperty("apiUrl"))
                    if (!$util.isString(message.apiUrl))
                        return "apiUrl: string expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.chunkSize != null && message.hasOwnProperty("chunkSize"))
                    if (!$util.isInteger(message.chunkSize) && !(message.chunkSize && $util.isInteger(message.chunkSize.low) && $util.isInteger(message.chunkSize.high)))
                        return "chunkSize: integer|Long expected";
                if (message.uploadedOffset != null && message.hasOwnProperty("uploadedOffset")) {
                    if (!Array.isArray(message.uploadedOffset))
                        return "uploadedOffset: array expected";
                    for (var i = 0; i < message.uploadedOffset.length; ++i)
                        if (!$util.isInteger(message.uploadedOffset[i]) && !(message.uploadedOffset[i] && $util.isInteger(message.uploadedOffset[i].low) && $util.isInteger(message.uploadedOffset[i].high)))
                            return "uploadedOffset: integer|Long[] expected";
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof file.GetUploadToken.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {file.GetUploadToken.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.file.GetUploadToken.Response)
                    return object;
                var message = new $root.file.GetUploadToken.Response();
                if (object.urls != null) {
                    if (typeof object.urls !== "object")
                        throw TypeError(".file.GetUploadToken.Response.urls: object expected");
                    message.urls = $root.file.Urls.fromObject(object.urls);
                }
                if (object.apiUrl != null)
                    message.apiUrl = String(object.apiUrl);
                if (object.token != null)
                    message.token = String(object.token);
                if (object.chunkSize != null)
                    if ($util.Long)
                        (message.chunkSize = $util.Long.fromValue(object.chunkSize)).unsigned = false;
                    else if (typeof object.chunkSize === "string")
                        message.chunkSize = parseInt(object.chunkSize, 10);
                    else if (typeof object.chunkSize === "number")
                        message.chunkSize = object.chunkSize;
                    else if (typeof object.chunkSize === "object")
                        message.chunkSize = new $util.LongBits(object.chunkSize.low >>> 0, object.chunkSize.high >>> 0).toNumber();
                if (object.uploadedOffset) {
                    if (!Array.isArray(object.uploadedOffset))
                        throw TypeError(".file.GetUploadToken.Response.uploadedOffset: array expected");
                    message.uploadedOffset = [];
                    for (var i = 0; i < object.uploadedOffset.length; ++i)
                        if ($util.Long)
                            (message.uploadedOffset[i] = $util.Long.fromValue(object.uploadedOffset[i])).unsigned = false;
                        else if (typeof object.uploadedOffset[i] === "string")
                            message.uploadedOffset[i] = parseInt(object.uploadedOffset[i], 10);
                        else if (typeof object.uploadedOffset[i] === "number")
                            message.uploadedOffset[i] = object.uploadedOffset[i];
                        else if (typeof object.uploadedOffset[i] === "object")
                            message.uploadedOffset[i] = new $util.LongBits(object.uploadedOffset[i].low >>> 0, object.uploadedOffset[i].high >>> 0).toNumber();
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof file.GetUploadToken.Response
             * @static
             * @param {file.GetUploadToken.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uploadedOffset = [];
                if (options.defaults) {
                    object.urls = null;
                    object.apiUrl = "";
                    object.token = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.chunkSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.chunkSize = options.longs === String ? "0" : 0;
                }
                if (message.urls != null && message.hasOwnProperty("urls"))
                    object.urls = $root.file.Urls.toObject(message.urls, options);
                if (message.apiUrl != null && message.hasOwnProperty("apiUrl"))
                    object.apiUrl = message.apiUrl;
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.chunkSize != null && message.hasOwnProperty("chunkSize"))
                    if (typeof message.chunkSize === "number")
                        object.chunkSize = options.longs === String ? String(message.chunkSize) : message.chunkSize;
                    else
                        object.chunkSize = options.longs === String ? $util.Long.prototype.toString.call(message.chunkSize) : options.longs === Number ? new $util.LongBits(message.chunkSize.low >>> 0, message.chunkSize.high >>> 0).toNumber() : message.chunkSize;
                if (message.uploadedOffset && message.uploadedOffset.length) {
                    object.uploadedOffset = [];
                    for (var j = 0; j < message.uploadedOffset.length; ++j)
                        if (typeof message.uploadedOffset[j] === "number")
                            object.uploadedOffset[j] = options.longs === String ? String(message.uploadedOffset[j]) : message.uploadedOffset[j];
                        else
                            object.uploadedOffset[j] = options.longs === String ? $util.Long.prototype.toString.call(message.uploadedOffset[j]) : options.longs === Number ? new $util.LongBits(message.uploadedOffset[j].low >>> 0, message.uploadedOffset[j].high >>> 0).toNumber() : message.uploadedOffset[j];
                }
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof file.GetUploadToken.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetUploadToken;
    })();

    return file;
})();

$root.note = (function() {

    /**
     * Namespace note.
     * @exports note
     * @namespace
     */
    var note = {};

    note.NoteOptions = (function() {

        /**
         * Properties of a NoteOptions.
         * @memberof note
         * @interface INoteOptions
         * @property {string|null} [noteId] NoteOptions noteId
         * @property {string|null} [categoryId] NoteOptions categoryId
         * @property {string|null} [pageId] NoteOptions pageId
         * @property {string|null} [todoId] NoteOptions todoId
         */

        /**
         * Constructs a new NoteOptions.
         * @memberof note
         * @classdesc Represents a NoteOptions.
         * @implements INoteOptions
         * @constructor
         * @param {note.INoteOptions=} [properties] Properties to set
         */
        function NoteOptions(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NoteOptions noteId.
         * @member {string} noteId
         * @memberof note.NoteOptions
         * @instance
         */
        NoteOptions.prototype.noteId = "";

        /**
         * NoteOptions categoryId.
         * @member {string} categoryId
         * @memberof note.NoteOptions
         * @instance
         */
        NoteOptions.prototype.categoryId = "";

        /**
         * NoteOptions pageId.
         * @member {string} pageId
         * @memberof note.NoteOptions
         * @instance
         */
        NoteOptions.prototype.pageId = "";

        /**
         * NoteOptions todoId.
         * @member {string} todoId
         * @memberof note.NoteOptions
         * @instance
         */
        NoteOptions.prototype.todoId = "";

        /**
         * Creates a new NoteOptions instance using the specified properties.
         * @function create
         * @memberof note.NoteOptions
         * @static
         * @param {note.INoteOptions=} [properties] Properties to set
         * @returns {note.NoteOptions} NoteOptions instance
         */
        NoteOptions.create = function create(properties) {
            return new NoteOptions(properties);
        };

        /**
         * Encodes the specified NoteOptions message. Does not implicitly {@link note.NoteOptions.verify|verify} messages.
         * @function encode
         * @memberof note.NoteOptions
         * @static
         * @param {note.INoteOptions} message NoteOptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NoteOptions.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.noteId != null && Object.hasOwnProperty.call(message, "noteId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.noteId);
            if (message.categoryId != null && Object.hasOwnProperty.call(message, "categoryId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.categoryId);
            if (message.pageId != null && Object.hasOwnProperty.call(message, "pageId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageId);
            if (message.todoId != null && Object.hasOwnProperty.call(message, "todoId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.todoId);
            return writer;
        };

        /**
         * Encodes the specified NoteOptions message, length delimited. Does not implicitly {@link note.NoteOptions.verify|verify} messages.
         * @function encodeDelimited
         * @memberof note.NoteOptions
         * @static
         * @param {note.INoteOptions} message NoteOptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NoteOptions.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NoteOptions message from the specified reader or buffer.
         * @function decode
         * @memberof note.NoteOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {note.NoteOptions} NoteOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NoteOptions.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.NoteOptions();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.noteId = reader.string();
                    break;
                case 2:
                    message.categoryId = reader.string();
                    break;
                case 3:
                    message.pageId = reader.string();
                    break;
                case 4:
                    message.todoId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NoteOptions message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof note.NoteOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {note.NoteOptions} NoteOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NoteOptions.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NoteOptions message.
         * @function verify
         * @memberof note.NoteOptions
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NoteOptions.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.noteId != null && message.hasOwnProperty("noteId"))
                if (!$util.isString(message.noteId))
                    return "noteId: string expected";
            if (message.categoryId != null && message.hasOwnProperty("categoryId"))
                if (!$util.isString(message.categoryId))
                    return "categoryId: string expected";
            if (message.pageId != null && message.hasOwnProperty("pageId"))
                if (!$util.isString(message.pageId))
                    return "pageId: string expected";
            if (message.todoId != null && message.hasOwnProperty("todoId"))
                if (!$util.isString(message.todoId))
                    return "todoId: string expected";
            return null;
        };

        /**
         * Creates a NoteOptions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof note.NoteOptions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {note.NoteOptions} NoteOptions
         */
        NoteOptions.fromObject = function fromObject(object) {
            if (object instanceof $root.note.NoteOptions)
                return object;
            var message = new $root.note.NoteOptions();
            if (object.noteId != null)
                message.noteId = String(object.noteId);
            if (object.categoryId != null)
                message.categoryId = String(object.categoryId);
            if (object.pageId != null)
                message.pageId = String(object.pageId);
            if (object.todoId != null)
                message.todoId = String(object.todoId);
            return message;
        };

        /**
         * Creates a plain object from a NoteOptions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof note.NoteOptions
         * @static
         * @param {note.NoteOptions} message NoteOptions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NoteOptions.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.noteId = "";
                object.categoryId = "";
                object.pageId = "";
                object.todoId = "";
            }
            if (message.noteId != null && message.hasOwnProperty("noteId"))
                object.noteId = message.noteId;
            if (message.categoryId != null && message.hasOwnProperty("categoryId"))
                object.categoryId = message.categoryId;
            if (message.pageId != null && message.hasOwnProperty("pageId"))
                object.pageId = message.pageId;
            if (message.todoId != null && message.hasOwnProperty("todoId"))
                object.todoId = message.todoId;
            return object;
        };

        /**
         * Converts this NoteOptions to JSON.
         * @function toJSON
         * @memberof note.NoteOptions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NoteOptions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NoteOptions;
    })();

    note.NoteItem = (function() {

        /**
         * Properties of a NoteItem.
         * @memberof note
         * @interface INoteItem
         * @property {string|null} [id] NoteItem id
         * @property {string|null} [name] NoteItem name
         * @property {number|null} [createTime] NoteItem createTime
         * @property {number|null} [lastUpdateTime] NoteItem lastUpdateTime
         * @property {number|null} [sort] NoteItem sort
         * @property {Array.<note.ICategoryItem>|null} [categories] NoteItem categories
         * @property {string|null} [authorId] NoteItem authorId
         * @property {string|null} [version] NoteItem version
         * @property {boolean|null} [isSync] NoteItem isSync
         * @property {number|null} [syncTime] NoteItem syncTime
         * @property {number|null} [status] NoteItem status
         * @property {number|null} [deleteTime] NoteItem deleteTime
         * @property {Array.<string>|null} [deleteUserId] NoteItem deleteUserId
         * @property {number|null} [localUpdateTime] NoteItem localUpdateTime
         */

        /**
         * Constructs a new NoteItem.
         * @memberof note
         * @classdesc Represents a NoteItem.
         * @implements INoteItem
         * @constructor
         * @param {note.INoteItem=} [properties] Properties to set
         */
        function NoteItem(properties) {
            this.categories = [];
            this.deleteUserId = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NoteItem id.
         * @member {string} id
         * @memberof note.NoteItem
         * @instance
         */
        NoteItem.prototype.id = "";

        /**
         * NoteItem name.
         * @member {string} name
         * @memberof note.NoteItem
         * @instance
         */
        NoteItem.prototype.name = "";

        /**
         * NoteItem createTime.
         * @member {number} createTime
         * @memberof note.NoteItem
         * @instance
         */
        NoteItem.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * NoteItem lastUpdateTime.
         * @member {number} lastUpdateTime
         * @memberof note.NoteItem
         * @instance
         */
        NoteItem.prototype.lastUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * NoteItem sort.
         * @member {number} sort
         * @memberof note.NoteItem
         * @instance
         */
        NoteItem.prototype.sort = 0;

        /**
         * NoteItem categories.
         * @member {Array.<note.ICategoryItem>} categories
         * @memberof note.NoteItem
         * @instance
         */
        NoteItem.prototype.categories = $util.emptyArray;

        /**
         * NoteItem authorId.
         * @member {string} authorId
         * @memberof note.NoteItem
         * @instance
         */
        NoteItem.prototype.authorId = "";

        /**
         * NoteItem version.
         * @member {string} version
         * @memberof note.NoteItem
         * @instance
         */
        NoteItem.prototype.version = "";

        /**
         * NoteItem isSync.
         * @member {boolean} isSync
         * @memberof note.NoteItem
         * @instance
         */
        NoteItem.prototype.isSync = false;

        /**
         * NoteItem syncTime.
         * @member {number} syncTime
         * @memberof note.NoteItem
         * @instance
         */
        NoteItem.prototype.syncTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * NoteItem status.
         * @member {number} status
         * @memberof note.NoteItem
         * @instance
         */
        NoteItem.prototype.status = 0;

        /**
         * NoteItem deleteTime.
         * @member {number} deleteTime
         * @memberof note.NoteItem
         * @instance
         */
        NoteItem.prototype.deleteTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * NoteItem deleteUserId.
         * @member {Array.<string>} deleteUserId
         * @memberof note.NoteItem
         * @instance
         */
        NoteItem.prototype.deleteUserId = $util.emptyArray;

        /**
         * NoteItem localUpdateTime.
         * @member {number} localUpdateTime
         * @memberof note.NoteItem
         * @instance
         */
        NoteItem.prototype.localUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new NoteItem instance using the specified properties.
         * @function create
         * @memberof note.NoteItem
         * @static
         * @param {note.INoteItem=} [properties] Properties to set
         * @returns {note.NoteItem} NoteItem instance
         */
        NoteItem.create = function create(properties) {
            return new NoteItem(properties);
        };

        /**
         * Encodes the specified NoteItem message. Does not implicitly {@link note.NoteItem.verify|verify} messages.
         * @function encode
         * @memberof note.NoteItem
         * @static
         * @param {note.INoteItem} message NoteItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NoteItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.createTime);
            if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.lastUpdateTime);
            if (message.sort != null && Object.hasOwnProperty.call(message, "sort"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.sort);
            if (message.categories != null && message.categories.length)
                for (var i = 0; i < message.categories.length; ++i)
                    $root.note.CategoryItem.encode(message.categories[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.authorId != null && Object.hasOwnProperty.call(message, "authorId"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.authorId);
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.version);
            if (message.isSync != null && Object.hasOwnProperty.call(message, "isSync"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isSync);
            if (message.syncTime != null && Object.hasOwnProperty.call(message, "syncTime"))
                writer.uint32(/* id 10, wireType 0 =*/80).int64(message.syncTime);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.status);
            if (message.deleteTime != null && Object.hasOwnProperty.call(message, "deleteTime"))
                writer.uint32(/* id 12, wireType 0 =*/96).int64(message.deleteTime);
            if (message.deleteUserId != null && message.deleteUserId.length)
                for (var i = 0; i < message.deleteUserId.length; ++i)
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.deleteUserId[i]);
            if (message.localUpdateTime != null && Object.hasOwnProperty.call(message, "localUpdateTime"))
                writer.uint32(/* id 14, wireType 0 =*/112).int64(message.localUpdateTime);
            return writer;
        };

        /**
         * Encodes the specified NoteItem message, length delimited. Does not implicitly {@link note.NoteItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof note.NoteItem
         * @static
         * @param {note.INoteItem} message NoteItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NoteItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NoteItem message from the specified reader or buffer.
         * @function decode
         * @memberof note.NoteItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {note.NoteItem} NoteItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NoteItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.NoteItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.createTime = reader.int64();
                    break;
                case 4:
                    message.lastUpdateTime = reader.int64();
                    break;
                case 5:
                    message.sort = reader.int32();
                    break;
                case 6:
                    if (!(message.categories && message.categories.length))
                        message.categories = [];
                    message.categories.push($root.note.CategoryItem.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.authorId = reader.string();
                    break;
                case 8:
                    message.version = reader.string();
                    break;
                case 9:
                    message.isSync = reader.bool();
                    break;
                case 10:
                    message.syncTime = reader.int64();
                    break;
                case 11:
                    message.status = reader.int32();
                    break;
                case 12:
                    message.deleteTime = reader.int64();
                    break;
                case 13:
                    if (!(message.deleteUserId && message.deleteUserId.length))
                        message.deleteUserId = [];
                    message.deleteUserId.push(reader.string());
                    break;
                case 14:
                    message.localUpdateTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NoteItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof note.NoteItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {note.NoteItem} NoteItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NoteItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NoteItem message.
         * @function verify
         * @memberof note.NoteItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NoteItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                    return "createTime: integer|Long expected";
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (!$util.isInteger(message.lastUpdateTime) && !(message.lastUpdateTime && $util.isInteger(message.lastUpdateTime.low) && $util.isInteger(message.lastUpdateTime.high)))
                    return "lastUpdateTime: integer|Long expected";
            if (message.sort != null && message.hasOwnProperty("sort"))
                if (!$util.isInteger(message.sort))
                    return "sort: integer expected";
            if (message.categories != null && message.hasOwnProperty("categories")) {
                if (!Array.isArray(message.categories))
                    return "categories: array expected";
                for (var i = 0; i < message.categories.length; ++i) {
                    var error = $root.note.CategoryItem.verify(message.categories[i]);
                    if (error)
                        return "categories." + error;
                }
            }
            if (message.authorId != null && message.hasOwnProperty("authorId"))
                if (!$util.isString(message.authorId))
                    return "authorId: string expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isString(message.version))
                    return "version: string expected";
            if (message.isSync != null && message.hasOwnProperty("isSync"))
                if (typeof message.isSync !== "boolean")
                    return "isSync: boolean expected";
            if (message.syncTime != null && message.hasOwnProperty("syncTime"))
                if (!$util.isInteger(message.syncTime) && !(message.syncTime && $util.isInteger(message.syncTime.low) && $util.isInteger(message.syncTime.high)))
                    return "syncTime: integer|Long expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            if (message.deleteTime != null && message.hasOwnProperty("deleteTime"))
                if (!$util.isInteger(message.deleteTime) && !(message.deleteTime && $util.isInteger(message.deleteTime.low) && $util.isInteger(message.deleteTime.high)))
                    return "deleteTime: integer|Long expected";
            if (message.deleteUserId != null && message.hasOwnProperty("deleteUserId")) {
                if (!Array.isArray(message.deleteUserId))
                    return "deleteUserId: array expected";
                for (var i = 0; i < message.deleteUserId.length; ++i)
                    if (!$util.isString(message.deleteUserId[i]))
                        return "deleteUserId: string[] expected";
            }
            if (message.localUpdateTime != null && message.hasOwnProperty("localUpdateTime"))
                if (!$util.isInteger(message.localUpdateTime) && !(message.localUpdateTime && $util.isInteger(message.localUpdateTime.low) && $util.isInteger(message.localUpdateTime.high)))
                    return "localUpdateTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a NoteItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof note.NoteItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {note.NoteItem} NoteItem
         */
        NoteItem.fromObject = function fromObject(object) {
            if (object instanceof $root.note.NoteItem)
                return object;
            var message = new $root.note.NoteItem();
            if (object.id != null)
                message.id = String(object.id);
            if (object.name != null)
                message.name = String(object.name);
            if (object.createTime != null)
                if ($util.Long)
                    (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                else if (typeof object.createTime === "string")
                    message.createTime = parseInt(object.createTime, 10);
                else if (typeof object.createTime === "number")
                    message.createTime = object.createTime;
                else if (typeof object.createTime === "object")
                    message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
            if (object.lastUpdateTime != null)
                if ($util.Long)
                    (message.lastUpdateTime = $util.Long.fromValue(object.lastUpdateTime)).unsigned = false;
                else if (typeof object.lastUpdateTime === "string")
                    message.lastUpdateTime = parseInt(object.lastUpdateTime, 10);
                else if (typeof object.lastUpdateTime === "number")
                    message.lastUpdateTime = object.lastUpdateTime;
                else if (typeof object.lastUpdateTime === "object")
                    message.lastUpdateTime = new $util.LongBits(object.lastUpdateTime.low >>> 0, object.lastUpdateTime.high >>> 0).toNumber();
            if (object.sort != null)
                message.sort = object.sort | 0;
            if (object.categories) {
                if (!Array.isArray(object.categories))
                    throw TypeError(".note.NoteItem.categories: array expected");
                message.categories = [];
                for (var i = 0; i < object.categories.length; ++i) {
                    if (typeof object.categories[i] !== "object")
                        throw TypeError(".note.NoteItem.categories: object expected");
                    message.categories[i] = $root.note.CategoryItem.fromObject(object.categories[i]);
                }
            }
            if (object.authorId != null)
                message.authorId = String(object.authorId);
            if (object.version != null)
                message.version = String(object.version);
            if (object.isSync != null)
                message.isSync = Boolean(object.isSync);
            if (object.syncTime != null)
                if ($util.Long)
                    (message.syncTime = $util.Long.fromValue(object.syncTime)).unsigned = false;
                else if (typeof object.syncTime === "string")
                    message.syncTime = parseInt(object.syncTime, 10);
                else if (typeof object.syncTime === "number")
                    message.syncTime = object.syncTime;
                else if (typeof object.syncTime === "object")
                    message.syncTime = new $util.LongBits(object.syncTime.low >>> 0, object.syncTime.high >>> 0).toNumber();
            if (object.status != null)
                message.status = object.status | 0;
            if (object.deleteTime != null)
                if ($util.Long)
                    (message.deleteTime = $util.Long.fromValue(object.deleteTime)).unsigned = false;
                else if (typeof object.deleteTime === "string")
                    message.deleteTime = parseInt(object.deleteTime, 10);
                else if (typeof object.deleteTime === "number")
                    message.deleteTime = object.deleteTime;
                else if (typeof object.deleteTime === "object")
                    message.deleteTime = new $util.LongBits(object.deleteTime.low >>> 0, object.deleteTime.high >>> 0).toNumber();
            if (object.deleteUserId) {
                if (!Array.isArray(object.deleteUserId))
                    throw TypeError(".note.NoteItem.deleteUserId: array expected");
                message.deleteUserId = [];
                for (var i = 0; i < object.deleteUserId.length; ++i)
                    message.deleteUserId[i] = String(object.deleteUserId[i]);
            }
            if (object.localUpdateTime != null)
                if ($util.Long)
                    (message.localUpdateTime = $util.Long.fromValue(object.localUpdateTime)).unsigned = false;
                else if (typeof object.localUpdateTime === "string")
                    message.localUpdateTime = parseInt(object.localUpdateTime, 10);
                else if (typeof object.localUpdateTime === "number")
                    message.localUpdateTime = object.localUpdateTime;
                else if (typeof object.localUpdateTime === "object")
                    message.localUpdateTime = new $util.LongBits(object.localUpdateTime.low >>> 0, object.localUpdateTime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a NoteItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof note.NoteItem
         * @static
         * @param {note.NoteItem} message NoteItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NoteItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.categories = [];
                object.deleteUserId = [];
            }
            if (options.defaults) {
                object.id = "";
                object.name = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastUpdateTime = options.longs === String ? "0" : 0;
                object.sort = 0;
                object.authorId = "";
                object.version = "";
                object.isSync = false;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.syncTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.syncTime = options.longs === String ? "0" : 0;
                object.status = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.deleteTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deleteTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.localUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.localUpdateTime = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (typeof message.createTime === "number")
                    object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                else
                    object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (typeof message.lastUpdateTime === "number")
                    object.lastUpdateTime = options.longs === String ? String(message.lastUpdateTime) : message.lastUpdateTime;
                else
                    object.lastUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTime) : options.longs === Number ? new $util.LongBits(message.lastUpdateTime.low >>> 0, message.lastUpdateTime.high >>> 0).toNumber() : message.lastUpdateTime;
            if (message.sort != null && message.hasOwnProperty("sort"))
                object.sort = message.sort;
            if (message.categories && message.categories.length) {
                object.categories = [];
                for (var j = 0; j < message.categories.length; ++j)
                    object.categories[j] = $root.note.CategoryItem.toObject(message.categories[j], options);
            }
            if (message.authorId != null && message.hasOwnProperty("authorId"))
                object.authorId = message.authorId;
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.isSync != null && message.hasOwnProperty("isSync"))
                object.isSync = message.isSync;
            if (message.syncTime != null && message.hasOwnProperty("syncTime"))
                if (typeof message.syncTime === "number")
                    object.syncTime = options.longs === String ? String(message.syncTime) : message.syncTime;
                else
                    object.syncTime = options.longs === String ? $util.Long.prototype.toString.call(message.syncTime) : options.longs === Number ? new $util.LongBits(message.syncTime.low >>> 0, message.syncTime.high >>> 0).toNumber() : message.syncTime;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.deleteTime != null && message.hasOwnProperty("deleteTime"))
                if (typeof message.deleteTime === "number")
                    object.deleteTime = options.longs === String ? String(message.deleteTime) : message.deleteTime;
                else
                    object.deleteTime = options.longs === String ? $util.Long.prototype.toString.call(message.deleteTime) : options.longs === Number ? new $util.LongBits(message.deleteTime.low >>> 0, message.deleteTime.high >>> 0).toNumber() : message.deleteTime;
            if (message.deleteUserId && message.deleteUserId.length) {
                object.deleteUserId = [];
                for (var j = 0; j < message.deleteUserId.length; ++j)
                    object.deleteUserId[j] = message.deleteUserId[j];
            }
            if (message.localUpdateTime != null && message.hasOwnProperty("localUpdateTime"))
                if (typeof message.localUpdateTime === "number")
                    object.localUpdateTime = options.longs === String ? String(message.localUpdateTime) : message.localUpdateTime;
                else
                    object.localUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.localUpdateTime) : options.longs === Number ? new $util.LongBits(message.localUpdateTime.low >>> 0, message.localUpdateTime.high >>> 0).toNumber() : message.localUpdateTime;
            return object;
        };

        /**
         * Converts this NoteItem to JSON.
         * @function toJSON
         * @memberof note.NoteItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NoteItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NoteItem;
    })();

    note.CategoryItem = (function() {

        /**
         * Properties of a CategoryItem.
         * @memberof note
         * @interface ICategoryItem
         * @property {string|null} [id] CategoryItem id
         * @property {string|null} [name] CategoryItem name
         * @property {number|null} [createTime] CategoryItem createTime
         * @property {number|null} [lastUpdateTime] CategoryItem lastUpdateTime
         * @property {number|null} [sort] CategoryItem sort
         * @property {Array.<note.IPageItem>|null} [data] CategoryItem data
         * @property {number|null} [status] CategoryItem status
         * @property {number|null} [deleteTime] CategoryItem deleteTime
         * @property {Array.<string>|null} [deleteUserId] CategoryItem deleteUserId
         * @property {number|null} [localUpdateTime] CategoryItem localUpdateTime
         */

        /**
         * Constructs a new CategoryItem.
         * @memberof note
         * @classdesc Represents a CategoryItem.
         * @implements ICategoryItem
         * @constructor
         * @param {note.ICategoryItem=} [properties] Properties to set
         */
        function CategoryItem(properties) {
            this.data = [];
            this.deleteUserId = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CategoryItem id.
         * @member {string} id
         * @memberof note.CategoryItem
         * @instance
         */
        CategoryItem.prototype.id = "";

        /**
         * CategoryItem name.
         * @member {string} name
         * @memberof note.CategoryItem
         * @instance
         */
        CategoryItem.prototype.name = "";

        /**
         * CategoryItem createTime.
         * @member {number} createTime
         * @memberof note.CategoryItem
         * @instance
         */
        CategoryItem.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * CategoryItem lastUpdateTime.
         * @member {number} lastUpdateTime
         * @memberof note.CategoryItem
         * @instance
         */
        CategoryItem.prototype.lastUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * CategoryItem sort.
         * @member {number} sort
         * @memberof note.CategoryItem
         * @instance
         */
        CategoryItem.prototype.sort = 0;

        /**
         * CategoryItem data.
         * @member {Array.<note.IPageItem>} data
         * @memberof note.CategoryItem
         * @instance
         */
        CategoryItem.prototype.data = $util.emptyArray;

        /**
         * CategoryItem status.
         * @member {number} status
         * @memberof note.CategoryItem
         * @instance
         */
        CategoryItem.prototype.status = 0;

        /**
         * CategoryItem deleteTime.
         * @member {number} deleteTime
         * @memberof note.CategoryItem
         * @instance
         */
        CategoryItem.prototype.deleteTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * CategoryItem deleteUserId.
         * @member {Array.<string>} deleteUserId
         * @memberof note.CategoryItem
         * @instance
         */
        CategoryItem.prototype.deleteUserId = $util.emptyArray;

        /**
         * CategoryItem localUpdateTime.
         * @member {number} localUpdateTime
         * @memberof note.CategoryItem
         * @instance
         */
        CategoryItem.prototype.localUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new CategoryItem instance using the specified properties.
         * @function create
         * @memberof note.CategoryItem
         * @static
         * @param {note.ICategoryItem=} [properties] Properties to set
         * @returns {note.CategoryItem} CategoryItem instance
         */
        CategoryItem.create = function create(properties) {
            return new CategoryItem(properties);
        };

        /**
         * Encodes the specified CategoryItem message. Does not implicitly {@link note.CategoryItem.verify|verify} messages.
         * @function encode
         * @memberof note.CategoryItem
         * @static
         * @param {note.ICategoryItem} message CategoryItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CategoryItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.createTime);
            if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.lastUpdateTime);
            if (message.sort != null && Object.hasOwnProperty.call(message, "sort"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.sort);
            if (message.data != null && message.data.length)
                for (var i = 0; i < message.data.length; ++i)
                    $root.note.PageItem.encode(message.data[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.status);
            if (message.deleteTime != null && Object.hasOwnProperty.call(message, "deleteTime"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.deleteTime);
            if (message.deleteUserId != null && message.deleteUserId.length)
                for (var i = 0; i < message.deleteUserId.length; ++i)
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.deleteUserId[i]);
            if (message.localUpdateTime != null && Object.hasOwnProperty.call(message, "localUpdateTime"))
                writer.uint32(/* id 20, wireType 0 =*/160).int64(message.localUpdateTime);
            return writer;
        };

        /**
         * Encodes the specified CategoryItem message, length delimited. Does not implicitly {@link note.CategoryItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof note.CategoryItem
         * @static
         * @param {note.ICategoryItem} message CategoryItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CategoryItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CategoryItem message from the specified reader or buffer.
         * @function decode
         * @memberof note.CategoryItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {note.CategoryItem} CategoryItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CategoryItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.CategoryItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.createTime = reader.int64();
                    break;
                case 4:
                    message.lastUpdateTime = reader.int64();
                    break;
                case 5:
                    message.sort = reader.int32();
                    break;
                case 6:
                    if (!(message.data && message.data.length))
                        message.data = [];
                    message.data.push($root.note.PageItem.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.status = reader.int32();
                    break;
                case 8:
                    message.deleteTime = reader.int64();
                    break;
                case 9:
                    if (!(message.deleteUserId && message.deleteUserId.length))
                        message.deleteUserId = [];
                    message.deleteUserId.push(reader.string());
                    break;
                case 20:
                    message.localUpdateTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CategoryItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof note.CategoryItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {note.CategoryItem} CategoryItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CategoryItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CategoryItem message.
         * @function verify
         * @memberof note.CategoryItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CategoryItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                    return "createTime: integer|Long expected";
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (!$util.isInteger(message.lastUpdateTime) && !(message.lastUpdateTime && $util.isInteger(message.lastUpdateTime.low) && $util.isInteger(message.lastUpdateTime.high)))
                    return "lastUpdateTime: integer|Long expected";
            if (message.sort != null && message.hasOwnProperty("sort"))
                if (!$util.isInteger(message.sort))
                    return "sort: integer expected";
            if (message.data != null && message.hasOwnProperty("data")) {
                if (!Array.isArray(message.data))
                    return "data: array expected";
                for (var i = 0; i < message.data.length; ++i) {
                    var error = $root.note.PageItem.verify(message.data[i]);
                    if (error)
                        return "data." + error;
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            if (message.deleteTime != null && message.hasOwnProperty("deleteTime"))
                if (!$util.isInteger(message.deleteTime) && !(message.deleteTime && $util.isInteger(message.deleteTime.low) && $util.isInteger(message.deleteTime.high)))
                    return "deleteTime: integer|Long expected";
            if (message.deleteUserId != null && message.hasOwnProperty("deleteUserId")) {
                if (!Array.isArray(message.deleteUserId))
                    return "deleteUserId: array expected";
                for (var i = 0; i < message.deleteUserId.length; ++i)
                    if (!$util.isString(message.deleteUserId[i]))
                        return "deleteUserId: string[] expected";
            }
            if (message.localUpdateTime != null && message.hasOwnProperty("localUpdateTime"))
                if (!$util.isInteger(message.localUpdateTime) && !(message.localUpdateTime && $util.isInteger(message.localUpdateTime.low) && $util.isInteger(message.localUpdateTime.high)))
                    return "localUpdateTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a CategoryItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof note.CategoryItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {note.CategoryItem} CategoryItem
         */
        CategoryItem.fromObject = function fromObject(object) {
            if (object instanceof $root.note.CategoryItem)
                return object;
            var message = new $root.note.CategoryItem();
            if (object.id != null)
                message.id = String(object.id);
            if (object.name != null)
                message.name = String(object.name);
            if (object.createTime != null)
                if ($util.Long)
                    (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                else if (typeof object.createTime === "string")
                    message.createTime = parseInt(object.createTime, 10);
                else if (typeof object.createTime === "number")
                    message.createTime = object.createTime;
                else if (typeof object.createTime === "object")
                    message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
            if (object.lastUpdateTime != null)
                if ($util.Long)
                    (message.lastUpdateTime = $util.Long.fromValue(object.lastUpdateTime)).unsigned = false;
                else if (typeof object.lastUpdateTime === "string")
                    message.lastUpdateTime = parseInt(object.lastUpdateTime, 10);
                else if (typeof object.lastUpdateTime === "number")
                    message.lastUpdateTime = object.lastUpdateTime;
                else if (typeof object.lastUpdateTime === "object")
                    message.lastUpdateTime = new $util.LongBits(object.lastUpdateTime.low >>> 0, object.lastUpdateTime.high >>> 0).toNumber();
            if (object.sort != null)
                message.sort = object.sort | 0;
            if (object.data) {
                if (!Array.isArray(object.data))
                    throw TypeError(".note.CategoryItem.data: array expected");
                message.data = [];
                for (var i = 0; i < object.data.length; ++i) {
                    if (typeof object.data[i] !== "object")
                        throw TypeError(".note.CategoryItem.data: object expected");
                    message.data[i] = $root.note.PageItem.fromObject(object.data[i]);
                }
            }
            if (object.status != null)
                message.status = object.status | 0;
            if (object.deleteTime != null)
                if ($util.Long)
                    (message.deleteTime = $util.Long.fromValue(object.deleteTime)).unsigned = false;
                else if (typeof object.deleteTime === "string")
                    message.deleteTime = parseInt(object.deleteTime, 10);
                else if (typeof object.deleteTime === "number")
                    message.deleteTime = object.deleteTime;
                else if (typeof object.deleteTime === "object")
                    message.deleteTime = new $util.LongBits(object.deleteTime.low >>> 0, object.deleteTime.high >>> 0).toNumber();
            if (object.deleteUserId) {
                if (!Array.isArray(object.deleteUserId))
                    throw TypeError(".note.CategoryItem.deleteUserId: array expected");
                message.deleteUserId = [];
                for (var i = 0; i < object.deleteUserId.length; ++i)
                    message.deleteUserId[i] = String(object.deleteUserId[i]);
            }
            if (object.localUpdateTime != null)
                if ($util.Long)
                    (message.localUpdateTime = $util.Long.fromValue(object.localUpdateTime)).unsigned = false;
                else if (typeof object.localUpdateTime === "string")
                    message.localUpdateTime = parseInt(object.localUpdateTime, 10);
                else if (typeof object.localUpdateTime === "number")
                    message.localUpdateTime = object.localUpdateTime;
                else if (typeof object.localUpdateTime === "object")
                    message.localUpdateTime = new $util.LongBits(object.localUpdateTime.low >>> 0, object.localUpdateTime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a CategoryItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof note.CategoryItem
         * @static
         * @param {note.CategoryItem} message CategoryItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CategoryItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.data = [];
                object.deleteUserId = [];
            }
            if (options.defaults) {
                object.id = "";
                object.name = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastUpdateTime = options.longs === String ? "0" : 0;
                object.sort = 0;
                object.status = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.deleteTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deleteTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.localUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.localUpdateTime = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (typeof message.createTime === "number")
                    object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                else
                    object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (typeof message.lastUpdateTime === "number")
                    object.lastUpdateTime = options.longs === String ? String(message.lastUpdateTime) : message.lastUpdateTime;
                else
                    object.lastUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTime) : options.longs === Number ? new $util.LongBits(message.lastUpdateTime.low >>> 0, message.lastUpdateTime.high >>> 0).toNumber() : message.lastUpdateTime;
            if (message.sort != null && message.hasOwnProperty("sort"))
                object.sort = message.sort;
            if (message.data && message.data.length) {
                object.data = [];
                for (var j = 0; j < message.data.length; ++j)
                    object.data[j] = $root.note.PageItem.toObject(message.data[j], options);
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.deleteTime != null && message.hasOwnProperty("deleteTime"))
                if (typeof message.deleteTime === "number")
                    object.deleteTime = options.longs === String ? String(message.deleteTime) : message.deleteTime;
                else
                    object.deleteTime = options.longs === String ? $util.Long.prototype.toString.call(message.deleteTime) : options.longs === Number ? new $util.LongBits(message.deleteTime.low >>> 0, message.deleteTime.high >>> 0).toNumber() : message.deleteTime;
            if (message.deleteUserId && message.deleteUserId.length) {
                object.deleteUserId = [];
                for (var j = 0; j < message.deleteUserId.length; ++j)
                    object.deleteUserId[j] = message.deleteUserId[j];
            }
            if (message.localUpdateTime != null && message.hasOwnProperty("localUpdateTime"))
                if (typeof message.localUpdateTime === "number")
                    object.localUpdateTime = options.longs === String ? String(message.localUpdateTime) : message.localUpdateTime;
                else
                    object.localUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.localUpdateTime) : options.longs === Number ? new $util.LongBits(message.localUpdateTime.low >>> 0, message.localUpdateTime.high >>> 0).toNumber() : message.localUpdateTime;
            return object;
        };

        /**
         * Converts this CategoryItem to JSON.
         * @function toJSON
         * @memberof note.CategoryItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CategoryItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CategoryItem;
    })();

    note.PageItem = (function() {

        /**
         * Properties of a PageItem.
         * @memberof note
         * @interface IPageItem
         * @property {string|null} [id] PageItem id
         * @property {string|null} [title] PageItem title
         * @property {string|null} [content] PageItem content
         * @property {Array.<note.ITodoListPageItem>|null} [todoList] PageItem todoList
         * @property {number|null} [createTime] PageItem createTime
         * @property {number|null} [lastUpdateTime] PageItem lastUpdateTime
         * @property {number|null} [sort] PageItem sort
         * @property {string|null} [type] PageItem type
         * @property {number|null} [encryption] PageItem encryption
         * @property {number|null} [status] PageItem status
         * @property {number|null} [deleteTime] PageItem deleteTime
         * @property {Array.<string>|null} [deleteUserId] PageItem deleteUserId
         * @property {number|null} [localUpdateTime] PageItem localUpdateTime
         * @property {Array.<note.PageItem.ILabelItem>|null} [labels] PageItem labels
         */

        /**
         * Constructs a new PageItem.
         * @memberof note
         * @classdesc Represents a PageItem.
         * @implements IPageItem
         * @constructor
         * @param {note.IPageItem=} [properties] Properties to set
         */
        function PageItem(properties) {
            this.todoList = [];
            this.deleteUserId = [];
            this.labels = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PageItem id.
         * @member {string} id
         * @memberof note.PageItem
         * @instance
         */
        PageItem.prototype.id = "";

        /**
         * PageItem title.
         * @member {string} title
         * @memberof note.PageItem
         * @instance
         */
        PageItem.prototype.title = "";

        /**
         * PageItem content.
         * @member {string} content
         * @memberof note.PageItem
         * @instance
         */
        PageItem.prototype.content = "";

        /**
         * PageItem todoList.
         * @member {Array.<note.ITodoListPageItem>} todoList
         * @memberof note.PageItem
         * @instance
         */
        PageItem.prototype.todoList = $util.emptyArray;

        /**
         * PageItem createTime.
         * @member {number} createTime
         * @memberof note.PageItem
         * @instance
         */
        PageItem.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * PageItem lastUpdateTime.
         * @member {number} lastUpdateTime
         * @memberof note.PageItem
         * @instance
         */
        PageItem.prototype.lastUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * PageItem sort.
         * @member {number} sort
         * @memberof note.PageItem
         * @instance
         */
        PageItem.prototype.sort = 0;

        /**
         * PageItem type.
         * @member {string} type
         * @memberof note.PageItem
         * @instance
         */
        PageItem.prototype.type = "";

        /**
         * PageItem encryption.
         * @member {number} encryption
         * @memberof note.PageItem
         * @instance
         */
        PageItem.prototype.encryption = 0;

        /**
         * PageItem status.
         * @member {number} status
         * @memberof note.PageItem
         * @instance
         */
        PageItem.prototype.status = 0;

        /**
         * PageItem deleteTime.
         * @member {number} deleteTime
         * @memberof note.PageItem
         * @instance
         */
        PageItem.prototype.deleteTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * PageItem deleteUserId.
         * @member {Array.<string>} deleteUserId
         * @memberof note.PageItem
         * @instance
         */
        PageItem.prototype.deleteUserId = $util.emptyArray;

        /**
         * PageItem localUpdateTime.
         * @member {number} localUpdateTime
         * @memberof note.PageItem
         * @instance
         */
        PageItem.prototype.localUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * PageItem labels.
         * @member {Array.<note.PageItem.ILabelItem>} labels
         * @memberof note.PageItem
         * @instance
         */
        PageItem.prototype.labels = $util.emptyArray;

        /**
         * Creates a new PageItem instance using the specified properties.
         * @function create
         * @memberof note.PageItem
         * @static
         * @param {note.IPageItem=} [properties] Properties to set
         * @returns {note.PageItem} PageItem instance
         */
        PageItem.create = function create(properties) {
            return new PageItem(properties);
        };

        /**
         * Encodes the specified PageItem message. Does not implicitly {@link note.PageItem.verify|verify} messages.
         * @function encode
         * @memberof note.PageItem
         * @static
         * @param {note.IPageItem} message PageItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PageItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.content);
            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.createTime);
            if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.lastUpdateTime);
            if (message.sort != null && Object.hasOwnProperty.call(message, "sort"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.sort);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.type);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.status);
            if (message.deleteTime != null && Object.hasOwnProperty.call(message, "deleteTime"))
                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.deleteTime);
            if (message.deleteUserId != null && message.deleteUserId.length)
                for (var i = 0; i < message.deleteUserId.length; ++i)
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.deleteUserId[i]);
            if (message.localUpdateTime != null && Object.hasOwnProperty.call(message, "localUpdateTime"))
                writer.uint32(/* id 11, wireType 0 =*/88).int64(message.localUpdateTime);
            if (message.encryption != null && Object.hasOwnProperty.call(message, "encryption"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.encryption);
            if (message.todoList != null && message.todoList.length)
                for (var i = 0; i < message.todoList.length; ++i)
                    $root.note.TodoListPageItem.encode(message.todoList[i], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.labels != null && message.labels.length)
                for (var i = 0; i < message.labels.length; ++i)
                    $root.note.PageItem.LabelItem.encode(message.labels[i], writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PageItem message, length delimited. Does not implicitly {@link note.PageItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof note.PageItem
         * @static
         * @param {note.IPageItem} message PageItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PageItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PageItem message from the specified reader or buffer.
         * @function decode
         * @memberof note.PageItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {note.PageItem} PageItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PageItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.PageItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.title = reader.string();
                    break;
                case 3:
                    message.content = reader.string();
                    break;
                case 13:
                    if (!(message.todoList && message.todoList.length))
                        message.todoList = [];
                    message.todoList.push($root.note.TodoListPageItem.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.createTime = reader.int64();
                    break;
                case 5:
                    message.lastUpdateTime = reader.int64();
                    break;
                case 6:
                    message.sort = reader.int32();
                    break;
                case 7:
                    message.type = reader.string();
                    break;
                case 12:
                    message.encryption = reader.int32();
                    break;
                case 8:
                    message.status = reader.int32();
                    break;
                case 9:
                    message.deleteTime = reader.int64();
                    break;
                case 10:
                    if (!(message.deleteUserId && message.deleteUserId.length))
                        message.deleteUserId = [];
                    message.deleteUserId.push(reader.string());
                    break;
                case 11:
                    message.localUpdateTime = reader.int64();
                    break;
                case 14:
                    if (!(message.labels && message.labels.length))
                        message.labels = [];
                    message.labels.push($root.note.PageItem.LabelItem.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PageItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof note.PageItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {note.PageItem} PageItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PageItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PageItem message.
         * @function verify
         * @memberof note.PageItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PageItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!$util.isString(message.content))
                    return "content: string expected";
            if (message.todoList != null && message.hasOwnProperty("todoList")) {
                if (!Array.isArray(message.todoList))
                    return "todoList: array expected";
                for (var i = 0; i < message.todoList.length; ++i) {
                    var error = $root.note.TodoListPageItem.verify(message.todoList[i]);
                    if (error)
                        return "todoList." + error;
                }
            }
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                    return "createTime: integer|Long expected";
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (!$util.isInteger(message.lastUpdateTime) && !(message.lastUpdateTime && $util.isInteger(message.lastUpdateTime.low) && $util.isInteger(message.lastUpdateTime.high)))
                    return "lastUpdateTime: integer|Long expected";
            if (message.sort != null && message.hasOwnProperty("sort"))
                if (!$util.isInteger(message.sort))
                    return "sort: integer expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.encryption != null && message.hasOwnProperty("encryption"))
                if (!$util.isInteger(message.encryption))
                    return "encryption: integer expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            if (message.deleteTime != null && message.hasOwnProperty("deleteTime"))
                if (!$util.isInteger(message.deleteTime) && !(message.deleteTime && $util.isInteger(message.deleteTime.low) && $util.isInteger(message.deleteTime.high)))
                    return "deleteTime: integer|Long expected";
            if (message.deleteUserId != null && message.hasOwnProperty("deleteUserId")) {
                if (!Array.isArray(message.deleteUserId))
                    return "deleteUserId: array expected";
                for (var i = 0; i < message.deleteUserId.length; ++i)
                    if (!$util.isString(message.deleteUserId[i]))
                        return "deleteUserId: string[] expected";
            }
            if (message.localUpdateTime != null && message.hasOwnProperty("localUpdateTime"))
                if (!$util.isInteger(message.localUpdateTime) && !(message.localUpdateTime && $util.isInteger(message.localUpdateTime.low) && $util.isInteger(message.localUpdateTime.high)))
                    return "localUpdateTime: integer|Long expected";
            if (message.labels != null && message.hasOwnProperty("labels")) {
                if (!Array.isArray(message.labels))
                    return "labels: array expected";
                for (var i = 0; i < message.labels.length; ++i) {
                    var error = $root.note.PageItem.LabelItem.verify(message.labels[i]);
                    if (error)
                        return "labels." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PageItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof note.PageItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {note.PageItem} PageItem
         */
        PageItem.fromObject = function fromObject(object) {
            if (object instanceof $root.note.PageItem)
                return object;
            var message = new $root.note.PageItem();
            if (object.id != null)
                message.id = String(object.id);
            if (object.title != null)
                message.title = String(object.title);
            if (object.content != null)
                message.content = String(object.content);
            if (object.todoList) {
                if (!Array.isArray(object.todoList))
                    throw TypeError(".note.PageItem.todoList: array expected");
                message.todoList = [];
                for (var i = 0; i < object.todoList.length; ++i) {
                    if (typeof object.todoList[i] !== "object")
                        throw TypeError(".note.PageItem.todoList: object expected");
                    message.todoList[i] = $root.note.TodoListPageItem.fromObject(object.todoList[i]);
                }
            }
            if (object.createTime != null)
                if ($util.Long)
                    (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                else if (typeof object.createTime === "string")
                    message.createTime = parseInt(object.createTime, 10);
                else if (typeof object.createTime === "number")
                    message.createTime = object.createTime;
                else if (typeof object.createTime === "object")
                    message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
            if (object.lastUpdateTime != null)
                if ($util.Long)
                    (message.lastUpdateTime = $util.Long.fromValue(object.lastUpdateTime)).unsigned = false;
                else if (typeof object.lastUpdateTime === "string")
                    message.lastUpdateTime = parseInt(object.lastUpdateTime, 10);
                else if (typeof object.lastUpdateTime === "number")
                    message.lastUpdateTime = object.lastUpdateTime;
                else if (typeof object.lastUpdateTime === "object")
                    message.lastUpdateTime = new $util.LongBits(object.lastUpdateTime.low >>> 0, object.lastUpdateTime.high >>> 0).toNumber();
            if (object.sort != null)
                message.sort = object.sort | 0;
            if (object.type != null)
                message.type = String(object.type);
            if (object.encryption != null)
                message.encryption = object.encryption | 0;
            if (object.status != null)
                message.status = object.status | 0;
            if (object.deleteTime != null)
                if ($util.Long)
                    (message.deleteTime = $util.Long.fromValue(object.deleteTime)).unsigned = false;
                else if (typeof object.deleteTime === "string")
                    message.deleteTime = parseInt(object.deleteTime, 10);
                else if (typeof object.deleteTime === "number")
                    message.deleteTime = object.deleteTime;
                else if (typeof object.deleteTime === "object")
                    message.deleteTime = new $util.LongBits(object.deleteTime.low >>> 0, object.deleteTime.high >>> 0).toNumber();
            if (object.deleteUserId) {
                if (!Array.isArray(object.deleteUserId))
                    throw TypeError(".note.PageItem.deleteUserId: array expected");
                message.deleteUserId = [];
                for (var i = 0; i < object.deleteUserId.length; ++i)
                    message.deleteUserId[i] = String(object.deleteUserId[i]);
            }
            if (object.localUpdateTime != null)
                if ($util.Long)
                    (message.localUpdateTime = $util.Long.fromValue(object.localUpdateTime)).unsigned = false;
                else if (typeof object.localUpdateTime === "string")
                    message.localUpdateTime = parseInt(object.localUpdateTime, 10);
                else if (typeof object.localUpdateTime === "number")
                    message.localUpdateTime = object.localUpdateTime;
                else if (typeof object.localUpdateTime === "object")
                    message.localUpdateTime = new $util.LongBits(object.localUpdateTime.low >>> 0, object.localUpdateTime.high >>> 0).toNumber();
            if (object.labels) {
                if (!Array.isArray(object.labels))
                    throw TypeError(".note.PageItem.labels: array expected");
                message.labels = [];
                for (var i = 0; i < object.labels.length; ++i) {
                    if (typeof object.labels[i] !== "object")
                        throw TypeError(".note.PageItem.labels: object expected");
                    message.labels[i] = $root.note.PageItem.LabelItem.fromObject(object.labels[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PageItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof note.PageItem
         * @static
         * @param {note.PageItem} message PageItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PageItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.deleteUserId = [];
                object.todoList = [];
                object.labels = [];
            }
            if (options.defaults) {
                object.id = "";
                object.title = "";
                object.content = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastUpdateTime = options.longs === String ? "0" : 0;
                object.sort = 0;
                object.type = "";
                object.status = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.deleteTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deleteTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.localUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.localUpdateTime = options.longs === String ? "0" : 0;
                object.encryption = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = message.content;
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (typeof message.createTime === "number")
                    object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                else
                    object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (typeof message.lastUpdateTime === "number")
                    object.lastUpdateTime = options.longs === String ? String(message.lastUpdateTime) : message.lastUpdateTime;
                else
                    object.lastUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTime) : options.longs === Number ? new $util.LongBits(message.lastUpdateTime.low >>> 0, message.lastUpdateTime.high >>> 0).toNumber() : message.lastUpdateTime;
            if (message.sort != null && message.hasOwnProperty("sort"))
                object.sort = message.sort;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.deleteTime != null && message.hasOwnProperty("deleteTime"))
                if (typeof message.deleteTime === "number")
                    object.deleteTime = options.longs === String ? String(message.deleteTime) : message.deleteTime;
                else
                    object.deleteTime = options.longs === String ? $util.Long.prototype.toString.call(message.deleteTime) : options.longs === Number ? new $util.LongBits(message.deleteTime.low >>> 0, message.deleteTime.high >>> 0).toNumber() : message.deleteTime;
            if (message.deleteUserId && message.deleteUserId.length) {
                object.deleteUserId = [];
                for (var j = 0; j < message.deleteUserId.length; ++j)
                    object.deleteUserId[j] = message.deleteUserId[j];
            }
            if (message.localUpdateTime != null && message.hasOwnProperty("localUpdateTime"))
                if (typeof message.localUpdateTime === "number")
                    object.localUpdateTime = options.longs === String ? String(message.localUpdateTime) : message.localUpdateTime;
                else
                    object.localUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.localUpdateTime) : options.longs === Number ? new $util.LongBits(message.localUpdateTime.low >>> 0, message.localUpdateTime.high >>> 0).toNumber() : message.localUpdateTime;
            if (message.encryption != null && message.hasOwnProperty("encryption"))
                object.encryption = message.encryption;
            if (message.todoList && message.todoList.length) {
                object.todoList = [];
                for (var j = 0; j < message.todoList.length; ++j)
                    object.todoList[j] = $root.note.TodoListPageItem.toObject(message.todoList[j], options);
            }
            if (message.labels && message.labels.length) {
                object.labels = [];
                for (var j = 0; j < message.labels.length; ++j)
                    object.labels[j] = $root.note.PageItem.LabelItem.toObject(message.labels[j], options);
            }
            return object;
        };

        /**
         * Converts this PageItem to JSON.
         * @function toJSON
         * @memberof note.PageItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PageItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        PageItem.LabelItem = (function() {

            /**
             * Properties of a LabelItem.
             * @memberof note.PageItem
             * @interface ILabelItem
             * @property {string|null} [id] LabelItem id
             * @property {string|null} [name] LabelItem name
             * @property {number|null} [sort] LabelItem sort
             * @property {string|null} [color] LabelItem color
             * @property {number|null} [bindStatus] LabelItem bindStatus
             */

            /**
             * Constructs a new LabelItem.
             * @memberof note.PageItem
             * @classdesc Represents a LabelItem.
             * @implements ILabelItem
             * @constructor
             * @param {note.PageItem.ILabelItem=} [properties] Properties to set
             */
            function LabelItem(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LabelItem id.
             * @member {string} id
             * @memberof note.PageItem.LabelItem
             * @instance
             */
            LabelItem.prototype.id = "";

            /**
             * LabelItem name.
             * @member {string} name
             * @memberof note.PageItem.LabelItem
             * @instance
             */
            LabelItem.prototype.name = "";

            /**
             * LabelItem sort.
             * @member {number} sort
             * @memberof note.PageItem.LabelItem
             * @instance
             */
            LabelItem.prototype.sort = 0;

            /**
             * LabelItem color.
             * @member {string} color
             * @memberof note.PageItem.LabelItem
             * @instance
             */
            LabelItem.prototype.color = "";

            /**
             * LabelItem bindStatus.
             * @member {number} bindStatus
             * @memberof note.PageItem.LabelItem
             * @instance
             */
            LabelItem.prototype.bindStatus = 0;

            /**
             * Creates a new LabelItem instance using the specified properties.
             * @function create
             * @memberof note.PageItem.LabelItem
             * @static
             * @param {note.PageItem.ILabelItem=} [properties] Properties to set
             * @returns {note.PageItem.LabelItem} LabelItem instance
             */
            LabelItem.create = function create(properties) {
                return new LabelItem(properties);
            };

            /**
             * Encodes the specified LabelItem message. Does not implicitly {@link note.PageItem.LabelItem.verify|verify} messages.
             * @function encode
             * @memberof note.PageItem.LabelItem
             * @static
             * @param {note.PageItem.ILabelItem} message LabelItem message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LabelItem.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                if (message.sort != null && Object.hasOwnProperty.call(message, "sort"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.sort);
                if (message.color != null && Object.hasOwnProperty.call(message, "color"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.color);
                if (message.bindStatus != null && Object.hasOwnProperty.call(message, "bindStatus"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.bindStatus);
                return writer;
            };

            /**
             * Encodes the specified LabelItem message, length delimited. Does not implicitly {@link note.PageItem.LabelItem.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.PageItem.LabelItem
             * @static
             * @param {note.PageItem.ILabelItem} message LabelItem message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LabelItem.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LabelItem message from the specified reader or buffer.
             * @function decode
             * @memberof note.PageItem.LabelItem
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.PageItem.LabelItem} LabelItem
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LabelItem.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.PageItem.LabelItem();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.string();
                        break;
                    case 2:
                        message.name = reader.string();
                        break;
                    case 3:
                        message.sort = reader.int32();
                        break;
                    case 4:
                        message.color = reader.string();
                        break;
                    case 5:
                        message.bindStatus = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LabelItem message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.PageItem.LabelItem
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.PageItem.LabelItem} LabelItem
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LabelItem.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LabelItem message.
             * @function verify
             * @memberof note.PageItem.LabelItem
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LabelItem.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.sort != null && message.hasOwnProperty("sort"))
                    if (!$util.isInteger(message.sort))
                        return "sort: integer expected";
                if (message.color != null && message.hasOwnProperty("color"))
                    if (!$util.isString(message.color))
                        return "color: string expected";
                if (message.bindStatus != null && message.hasOwnProperty("bindStatus"))
                    if (!$util.isInteger(message.bindStatus))
                        return "bindStatus: integer expected";
                return null;
            };

            /**
             * Creates a LabelItem message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.PageItem.LabelItem
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.PageItem.LabelItem} LabelItem
             */
            LabelItem.fromObject = function fromObject(object) {
                if (object instanceof $root.note.PageItem.LabelItem)
                    return object;
                var message = new $root.note.PageItem.LabelItem();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.sort != null)
                    message.sort = object.sort | 0;
                if (object.color != null)
                    message.color = String(object.color);
                if (object.bindStatus != null)
                    message.bindStatus = object.bindStatus | 0;
                return message;
            };

            /**
             * Creates a plain object from a LabelItem message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.PageItem.LabelItem
             * @static
             * @param {note.PageItem.LabelItem} message LabelItem
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LabelItem.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.name = "";
                    object.sort = 0;
                    object.color = "";
                    object.bindStatus = 0;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.sort != null && message.hasOwnProperty("sort"))
                    object.sort = message.sort;
                if (message.color != null && message.hasOwnProperty("color"))
                    object.color = message.color;
                if (message.bindStatus != null && message.hasOwnProperty("bindStatus"))
                    object.bindStatus = message.bindStatus;
                return object;
            };

            /**
             * Converts this LabelItem to JSON.
             * @function toJSON
             * @memberof note.PageItem.LabelItem
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LabelItem.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return LabelItem;
        })();

        return PageItem;
    })();

    note.TodoListPageItem = (function() {

        /**
         * Properties of a TodoListPageItem.
         * @memberof note
         * @interface ITodoListPageItem
         * @property {string|null} [id] TodoListPageItem id
         * @property {string|null} [displayId] TodoListPageItem displayId
         * @property {string|null} [title] TodoListPageItem title
         * @property {string|null} [note] TodoListPageItem note
         * @property {number|null} [status] TodoListPageItem status
         * @property {number|null} [importance] TodoListPageItem importance
         * @property {number|null} [dueDate] TodoListPageItem dueDate
         * @property {number|null} [disable] TodoListPageItem disable
         * @property {string|null} [parentId] TodoListPageItem parentId
         * @property {number|null} [createTime] TodoListPageItem createTime
         * @property {number|null} [lastUpdateTime] TodoListPageItem lastUpdateTime
         * @property {number|null} [sort] TodoListPageItem sort
         * @property {number|null} [num] TodoListPageItem num
         * @property {number|null} [deleteTime] TodoListPageItem deleteTime
         * @property {Array.<string>|null} [deleteUserId] TodoListPageItem deleteUserId
         * @property {number|null} [localUpdateTime] TodoListPageItem localUpdateTime
         * @property {string|null} [labelId] TodoListPageItem labelId
         */

        /**
         * Constructs a new TodoListPageItem.
         * @memberof note
         * @classdesc Represents a TodoListPageItem.
         * @implements ITodoListPageItem
         * @constructor
         * @param {note.ITodoListPageItem=} [properties] Properties to set
         */
        function TodoListPageItem(properties) {
            this.deleteUserId = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TodoListPageItem id.
         * @member {string} id
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.id = "";

        /**
         * TodoListPageItem displayId.
         * @member {string} displayId
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.displayId = "";

        /**
         * TodoListPageItem title.
         * @member {string} title
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.title = "";

        /**
         * TodoListPageItem note.
         * @member {string} note
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.note = "";

        /**
         * TodoListPageItem status.
         * @member {number} status
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.status = 0;

        /**
         * TodoListPageItem importance.
         * @member {number} importance
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.importance = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TodoListPageItem dueDate.
         * @member {number} dueDate
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.dueDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TodoListPageItem disable.
         * @member {number} disable
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.disable = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TodoListPageItem parentId.
         * @member {string} parentId
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.parentId = "";

        /**
         * TodoListPageItem createTime.
         * @member {number} createTime
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TodoListPageItem lastUpdateTime.
         * @member {number} lastUpdateTime
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.lastUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TodoListPageItem sort.
         * @member {number} sort
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.sort = 0;

        /**
         * TodoListPageItem num.
         * @member {number} num
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.num = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TodoListPageItem deleteTime.
         * @member {number} deleteTime
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.deleteTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TodoListPageItem deleteUserId.
         * @member {Array.<string>} deleteUserId
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.deleteUserId = $util.emptyArray;

        /**
         * TodoListPageItem localUpdateTime.
         * @member {number} localUpdateTime
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.localUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TodoListPageItem labelId.
         * @member {string} labelId
         * @memberof note.TodoListPageItem
         * @instance
         */
        TodoListPageItem.prototype.labelId = "";

        /**
         * Creates a new TodoListPageItem instance using the specified properties.
         * @function create
         * @memberof note.TodoListPageItem
         * @static
         * @param {note.ITodoListPageItem=} [properties] Properties to set
         * @returns {note.TodoListPageItem} TodoListPageItem instance
         */
        TodoListPageItem.create = function create(properties) {
            return new TodoListPageItem(properties);
        };

        /**
         * Encodes the specified TodoListPageItem message. Does not implicitly {@link note.TodoListPageItem.verify|verify} messages.
         * @function encode
         * @memberof note.TodoListPageItem
         * @static
         * @param {note.ITodoListPageItem} message TodoListPageItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TodoListPageItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.status);
            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.createTime);
            if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.lastUpdateTime);
            if (message.sort != null && Object.hasOwnProperty.call(message, "sort"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.sort);
            if (message.importance != null && Object.hasOwnProperty.call(message, "importance"))
                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.importance);
            if (message.dueDate != null && Object.hasOwnProperty.call(message, "dueDate"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.dueDate);
            if (message.parentId != null && Object.hasOwnProperty.call(message, "parentId"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.parentId);
            if (message.num != null && Object.hasOwnProperty.call(message, "num"))
                writer.uint32(/* id 10, wireType 0 =*/80).int64(message.num);
            if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.note);
            if (message.deleteTime != null && Object.hasOwnProperty.call(message, "deleteTime"))
                writer.uint32(/* id 13, wireType 0 =*/104).int64(message.deleteTime);
            if (message.deleteUserId != null && message.deleteUserId.length)
                for (var i = 0; i < message.deleteUserId.length; ++i)
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.deleteUserId[i]);
            if (message.localUpdateTime != null && Object.hasOwnProperty.call(message, "localUpdateTime"))
                writer.uint32(/* id 15, wireType 0 =*/120).int64(message.localUpdateTime);
            if (message.displayId != null && Object.hasOwnProperty.call(message, "displayId"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.displayId);
            if (message.disable != null && Object.hasOwnProperty.call(message, "disable"))
                writer.uint32(/* id 17, wireType 0 =*/136).int64(message.disable);
            if (message.labelId != null && Object.hasOwnProperty.call(message, "labelId"))
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.labelId);
            return writer;
        };

        /**
         * Encodes the specified TodoListPageItem message, length delimited. Does not implicitly {@link note.TodoListPageItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof note.TodoListPageItem
         * @static
         * @param {note.ITodoListPageItem} message TodoListPageItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TodoListPageItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TodoListPageItem message from the specified reader or buffer.
         * @function decode
         * @memberof note.TodoListPageItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {note.TodoListPageItem} TodoListPageItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TodoListPageItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.TodoListPageItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 16:
                    message.displayId = reader.string();
                    break;
                case 2:
                    message.title = reader.string();
                    break;
                case 11:
                    message.note = reader.string();
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 7:
                    message.importance = reader.int64();
                    break;
                case 8:
                    message.dueDate = reader.int64();
                    break;
                case 17:
                    message.disable = reader.int64();
                    break;
                case 9:
                    message.parentId = reader.string();
                    break;
                case 4:
                    message.createTime = reader.int64();
                    break;
                case 5:
                    message.lastUpdateTime = reader.int64();
                    break;
                case 6:
                    message.sort = reader.int32();
                    break;
                case 10:
                    message.num = reader.int64();
                    break;
                case 13:
                    message.deleteTime = reader.int64();
                    break;
                case 14:
                    if (!(message.deleteUserId && message.deleteUserId.length))
                        message.deleteUserId = [];
                    message.deleteUserId.push(reader.string());
                    break;
                case 15:
                    message.localUpdateTime = reader.int64();
                    break;
                case 18:
                    message.labelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TodoListPageItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof note.TodoListPageItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {note.TodoListPageItem} TodoListPageItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TodoListPageItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TodoListPageItem message.
         * @function verify
         * @memberof note.TodoListPageItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TodoListPageItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.displayId != null && message.hasOwnProperty("displayId"))
                if (!$util.isString(message.displayId))
                    return "displayId: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.note != null && message.hasOwnProperty("note"))
                if (!$util.isString(message.note))
                    return "note: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            if (message.importance != null && message.hasOwnProperty("importance"))
                if (!$util.isInteger(message.importance) && !(message.importance && $util.isInteger(message.importance.low) && $util.isInteger(message.importance.high)))
                    return "importance: integer|Long expected";
            if (message.dueDate != null && message.hasOwnProperty("dueDate"))
                if (!$util.isInteger(message.dueDate) && !(message.dueDate && $util.isInteger(message.dueDate.low) && $util.isInteger(message.dueDate.high)))
                    return "dueDate: integer|Long expected";
            if (message.disable != null && message.hasOwnProperty("disable"))
                if (!$util.isInteger(message.disable) && !(message.disable && $util.isInteger(message.disable.low) && $util.isInteger(message.disable.high)))
                    return "disable: integer|Long expected";
            if (message.parentId != null && message.hasOwnProperty("parentId"))
                if (!$util.isString(message.parentId))
                    return "parentId: string expected";
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                    return "createTime: integer|Long expected";
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (!$util.isInteger(message.lastUpdateTime) && !(message.lastUpdateTime && $util.isInteger(message.lastUpdateTime.low) && $util.isInteger(message.lastUpdateTime.high)))
                    return "lastUpdateTime: integer|Long expected";
            if (message.sort != null && message.hasOwnProperty("sort"))
                if (!$util.isInteger(message.sort))
                    return "sort: integer expected";
            if (message.num != null && message.hasOwnProperty("num"))
                if (!$util.isInteger(message.num) && !(message.num && $util.isInteger(message.num.low) && $util.isInteger(message.num.high)))
                    return "num: integer|Long expected";
            if (message.deleteTime != null && message.hasOwnProperty("deleteTime"))
                if (!$util.isInteger(message.deleteTime) && !(message.deleteTime && $util.isInteger(message.deleteTime.low) && $util.isInteger(message.deleteTime.high)))
                    return "deleteTime: integer|Long expected";
            if (message.deleteUserId != null && message.hasOwnProperty("deleteUserId")) {
                if (!Array.isArray(message.deleteUserId))
                    return "deleteUserId: array expected";
                for (var i = 0; i < message.deleteUserId.length; ++i)
                    if (!$util.isString(message.deleteUserId[i]))
                        return "deleteUserId: string[] expected";
            }
            if (message.localUpdateTime != null && message.hasOwnProperty("localUpdateTime"))
                if (!$util.isInteger(message.localUpdateTime) && !(message.localUpdateTime && $util.isInteger(message.localUpdateTime.low) && $util.isInteger(message.localUpdateTime.high)))
                    return "localUpdateTime: integer|Long expected";
            if (message.labelId != null && message.hasOwnProperty("labelId"))
                if (!$util.isString(message.labelId))
                    return "labelId: string expected";
            return null;
        };

        /**
         * Creates a TodoListPageItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof note.TodoListPageItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {note.TodoListPageItem} TodoListPageItem
         */
        TodoListPageItem.fromObject = function fromObject(object) {
            if (object instanceof $root.note.TodoListPageItem)
                return object;
            var message = new $root.note.TodoListPageItem();
            if (object.id != null)
                message.id = String(object.id);
            if (object.displayId != null)
                message.displayId = String(object.displayId);
            if (object.title != null)
                message.title = String(object.title);
            if (object.note != null)
                message.note = String(object.note);
            if (object.status != null)
                message.status = object.status | 0;
            if (object.importance != null)
                if ($util.Long)
                    (message.importance = $util.Long.fromValue(object.importance)).unsigned = false;
                else if (typeof object.importance === "string")
                    message.importance = parseInt(object.importance, 10);
                else if (typeof object.importance === "number")
                    message.importance = object.importance;
                else if (typeof object.importance === "object")
                    message.importance = new $util.LongBits(object.importance.low >>> 0, object.importance.high >>> 0).toNumber();
            if (object.dueDate != null)
                if ($util.Long)
                    (message.dueDate = $util.Long.fromValue(object.dueDate)).unsigned = false;
                else if (typeof object.dueDate === "string")
                    message.dueDate = parseInt(object.dueDate, 10);
                else if (typeof object.dueDate === "number")
                    message.dueDate = object.dueDate;
                else if (typeof object.dueDate === "object")
                    message.dueDate = new $util.LongBits(object.dueDate.low >>> 0, object.dueDate.high >>> 0).toNumber();
            if (object.disable != null)
                if ($util.Long)
                    (message.disable = $util.Long.fromValue(object.disable)).unsigned = false;
                else if (typeof object.disable === "string")
                    message.disable = parseInt(object.disable, 10);
                else if (typeof object.disable === "number")
                    message.disable = object.disable;
                else if (typeof object.disable === "object")
                    message.disable = new $util.LongBits(object.disable.low >>> 0, object.disable.high >>> 0).toNumber();
            if (object.parentId != null)
                message.parentId = String(object.parentId);
            if (object.createTime != null)
                if ($util.Long)
                    (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                else if (typeof object.createTime === "string")
                    message.createTime = parseInt(object.createTime, 10);
                else if (typeof object.createTime === "number")
                    message.createTime = object.createTime;
                else if (typeof object.createTime === "object")
                    message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
            if (object.lastUpdateTime != null)
                if ($util.Long)
                    (message.lastUpdateTime = $util.Long.fromValue(object.lastUpdateTime)).unsigned = false;
                else if (typeof object.lastUpdateTime === "string")
                    message.lastUpdateTime = parseInt(object.lastUpdateTime, 10);
                else if (typeof object.lastUpdateTime === "number")
                    message.lastUpdateTime = object.lastUpdateTime;
                else if (typeof object.lastUpdateTime === "object")
                    message.lastUpdateTime = new $util.LongBits(object.lastUpdateTime.low >>> 0, object.lastUpdateTime.high >>> 0).toNumber();
            if (object.sort != null)
                message.sort = object.sort | 0;
            if (object.num != null)
                if ($util.Long)
                    (message.num = $util.Long.fromValue(object.num)).unsigned = false;
                else if (typeof object.num === "string")
                    message.num = parseInt(object.num, 10);
                else if (typeof object.num === "number")
                    message.num = object.num;
                else if (typeof object.num === "object")
                    message.num = new $util.LongBits(object.num.low >>> 0, object.num.high >>> 0).toNumber();
            if (object.deleteTime != null)
                if ($util.Long)
                    (message.deleteTime = $util.Long.fromValue(object.deleteTime)).unsigned = false;
                else if (typeof object.deleteTime === "string")
                    message.deleteTime = parseInt(object.deleteTime, 10);
                else if (typeof object.deleteTime === "number")
                    message.deleteTime = object.deleteTime;
                else if (typeof object.deleteTime === "object")
                    message.deleteTime = new $util.LongBits(object.deleteTime.low >>> 0, object.deleteTime.high >>> 0).toNumber();
            if (object.deleteUserId) {
                if (!Array.isArray(object.deleteUserId))
                    throw TypeError(".note.TodoListPageItem.deleteUserId: array expected");
                message.deleteUserId = [];
                for (var i = 0; i < object.deleteUserId.length; ++i)
                    message.deleteUserId[i] = String(object.deleteUserId[i]);
            }
            if (object.localUpdateTime != null)
                if ($util.Long)
                    (message.localUpdateTime = $util.Long.fromValue(object.localUpdateTime)).unsigned = false;
                else if (typeof object.localUpdateTime === "string")
                    message.localUpdateTime = parseInt(object.localUpdateTime, 10);
                else if (typeof object.localUpdateTime === "number")
                    message.localUpdateTime = object.localUpdateTime;
                else if (typeof object.localUpdateTime === "object")
                    message.localUpdateTime = new $util.LongBits(object.localUpdateTime.low >>> 0, object.localUpdateTime.high >>> 0).toNumber();
            if (object.labelId != null)
                message.labelId = String(object.labelId);
            return message;
        };

        /**
         * Creates a plain object from a TodoListPageItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof note.TodoListPageItem
         * @static
         * @param {note.TodoListPageItem} message TodoListPageItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TodoListPageItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.deleteUserId = [];
            if (options.defaults) {
                object.id = "";
                object.title = "";
                object.status = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastUpdateTime = options.longs === String ? "0" : 0;
                object.sort = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.importance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.importance = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.dueDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.dueDate = options.longs === String ? "0" : 0;
                object.parentId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.num = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.num = options.longs === String ? "0" : 0;
                object.note = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.deleteTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deleteTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.localUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.localUpdateTime = options.longs === String ? "0" : 0;
                object.displayId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.disable = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.disable = options.longs === String ? "0" : 0;
                object.labelId = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (typeof message.createTime === "number")
                    object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                else
                    object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (typeof message.lastUpdateTime === "number")
                    object.lastUpdateTime = options.longs === String ? String(message.lastUpdateTime) : message.lastUpdateTime;
                else
                    object.lastUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTime) : options.longs === Number ? new $util.LongBits(message.lastUpdateTime.low >>> 0, message.lastUpdateTime.high >>> 0).toNumber() : message.lastUpdateTime;
            if (message.sort != null && message.hasOwnProperty("sort"))
                object.sort = message.sort;
            if (message.importance != null && message.hasOwnProperty("importance"))
                if (typeof message.importance === "number")
                    object.importance = options.longs === String ? String(message.importance) : message.importance;
                else
                    object.importance = options.longs === String ? $util.Long.prototype.toString.call(message.importance) : options.longs === Number ? new $util.LongBits(message.importance.low >>> 0, message.importance.high >>> 0).toNumber() : message.importance;
            if (message.dueDate != null && message.hasOwnProperty("dueDate"))
                if (typeof message.dueDate === "number")
                    object.dueDate = options.longs === String ? String(message.dueDate) : message.dueDate;
                else
                    object.dueDate = options.longs === String ? $util.Long.prototype.toString.call(message.dueDate) : options.longs === Number ? new $util.LongBits(message.dueDate.low >>> 0, message.dueDate.high >>> 0).toNumber() : message.dueDate;
            if (message.parentId != null && message.hasOwnProperty("parentId"))
                object.parentId = message.parentId;
            if (message.num != null && message.hasOwnProperty("num"))
                if (typeof message.num === "number")
                    object.num = options.longs === String ? String(message.num) : message.num;
                else
                    object.num = options.longs === String ? $util.Long.prototype.toString.call(message.num) : options.longs === Number ? new $util.LongBits(message.num.low >>> 0, message.num.high >>> 0).toNumber() : message.num;
            if (message.note != null && message.hasOwnProperty("note"))
                object.note = message.note;
            if (message.deleteTime != null && message.hasOwnProperty("deleteTime"))
                if (typeof message.deleteTime === "number")
                    object.deleteTime = options.longs === String ? String(message.deleteTime) : message.deleteTime;
                else
                    object.deleteTime = options.longs === String ? $util.Long.prototype.toString.call(message.deleteTime) : options.longs === Number ? new $util.LongBits(message.deleteTime.low >>> 0, message.deleteTime.high >>> 0).toNumber() : message.deleteTime;
            if (message.deleteUserId && message.deleteUserId.length) {
                object.deleteUserId = [];
                for (var j = 0; j < message.deleteUserId.length; ++j)
                    object.deleteUserId[j] = message.deleteUserId[j];
            }
            if (message.localUpdateTime != null && message.hasOwnProperty("localUpdateTime"))
                if (typeof message.localUpdateTime === "number")
                    object.localUpdateTime = options.longs === String ? String(message.localUpdateTime) : message.localUpdateTime;
                else
                    object.localUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.localUpdateTime) : options.longs === Number ? new $util.LongBits(message.localUpdateTime.low >>> 0, message.localUpdateTime.high >>> 0).toNumber() : message.localUpdateTime;
            if (message.displayId != null && message.hasOwnProperty("displayId"))
                object.displayId = message.displayId;
            if (message.disable != null && message.hasOwnProperty("disable"))
                if (typeof message.disable === "number")
                    object.disable = options.longs === String ? String(message.disable) : message.disable;
                else
                    object.disable = options.longs === String ? $util.Long.prototype.toString.call(message.disable) : options.longs === Number ? new $util.LongBits(message.disable.low >>> 0, message.disable.high >>> 0).toNumber() : message.disable;
            if (message.labelId != null && message.hasOwnProperty("labelId"))
                object.labelId = message.labelId;
            return object;
        };

        /**
         * Converts this TodoListPageItem to JSON.
         * @function toJSON
         * @memberof note.TodoListPageItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TodoListPageItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TodoListPageItem;
    })();

    note.SortItem = (function() {

        /**
         * Properties of a SortItem.
         * @memberof note
         * @interface ISortItem
         * @property {number|null} [originalIndex] SortItem originalIndex
         * @property {number|null} [targetIndex] SortItem targetIndex
         * @property {Array.<note.SortItem.IListItem>|null} [list] SortItem list
         */

        /**
         * Constructs a new SortItem.
         * @memberof note
         * @classdesc Represents a SortItem.
         * @implements ISortItem
         * @constructor
         * @param {note.ISortItem=} [properties] Properties to set
         */
        function SortItem(properties) {
            this.list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SortItem originalIndex.
         * @member {number} originalIndex
         * @memberof note.SortItem
         * @instance
         */
        SortItem.prototype.originalIndex = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SortItem targetIndex.
         * @member {number} targetIndex
         * @memberof note.SortItem
         * @instance
         */
        SortItem.prototype.targetIndex = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SortItem list.
         * @member {Array.<note.SortItem.IListItem>} list
         * @memberof note.SortItem
         * @instance
         */
        SortItem.prototype.list = $util.emptyArray;

        /**
         * Creates a new SortItem instance using the specified properties.
         * @function create
         * @memberof note.SortItem
         * @static
         * @param {note.ISortItem=} [properties] Properties to set
         * @returns {note.SortItem} SortItem instance
         */
        SortItem.create = function create(properties) {
            return new SortItem(properties);
        };

        /**
         * Encodes the specified SortItem message. Does not implicitly {@link note.SortItem.verify|verify} messages.
         * @function encode
         * @memberof note.SortItem
         * @static
         * @param {note.ISortItem} message SortItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SortItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.originalIndex != null && Object.hasOwnProperty.call(message, "originalIndex"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.originalIndex);
            if (message.targetIndex != null && Object.hasOwnProperty.call(message, "targetIndex"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.targetIndex);
            if (message.list != null && message.list.length)
                for (var i = 0; i < message.list.length; ++i)
                    $root.note.SortItem.ListItem.encode(message.list[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SortItem message, length delimited. Does not implicitly {@link note.SortItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof note.SortItem
         * @static
         * @param {note.ISortItem} message SortItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SortItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SortItem message from the specified reader or buffer.
         * @function decode
         * @memberof note.SortItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {note.SortItem} SortItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SortItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.SortItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.originalIndex = reader.int64();
                    break;
                case 2:
                    message.targetIndex = reader.int64();
                    break;
                case 3:
                    if (!(message.list && message.list.length))
                        message.list = [];
                    message.list.push($root.note.SortItem.ListItem.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SortItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof note.SortItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {note.SortItem} SortItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SortItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SortItem message.
         * @function verify
         * @memberof note.SortItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SortItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.originalIndex != null && message.hasOwnProperty("originalIndex"))
                if (!$util.isInteger(message.originalIndex) && !(message.originalIndex && $util.isInteger(message.originalIndex.low) && $util.isInteger(message.originalIndex.high)))
                    return "originalIndex: integer|Long expected";
            if (message.targetIndex != null && message.hasOwnProperty("targetIndex"))
                if (!$util.isInteger(message.targetIndex) && !(message.targetIndex && $util.isInteger(message.targetIndex.low) && $util.isInteger(message.targetIndex.high)))
                    return "targetIndex: integer|Long expected";
            if (message.list != null && message.hasOwnProperty("list")) {
                if (!Array.isArray(message.list))
                    return "list: array expected";
                for (var i = 0; i < message.list.length; ++i) {
                    var error = $root.note.SortItem.ListItem.verify(message.list[i]);
                    if (error)
                        return "list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SortItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof note.SortItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {note.SortItem} SortItem
         */
        SortItem.fromObject = function fromObject(object) {
            if (object instanceof $root.note.SortItem)
                return object;
            var message = new $root.note.SortItem();
            if (object.originalIndex != null)
                if ($util.Long)
                    (message.originalIndex = $util.Long.fromValue(object.originalIndex)).unsigned = false;
                else if (typeof object.originalIndex === "string")
                    message.originalIndex = parseInt(object.originalIndex, 10);
                else if (typeof object.originalIndex === "number")
                    message.originalIndex = object.originalIndex;
                else if (typeof object.originalIndex === "object")
                    message.originalIndex = new $util.LongBits(object.originalIndex.low >>> 0, object.originalIndex.high >>> 0).toNumber();
            if (object.targetIndex != null)
                if ($util.Long)
                    (message.targetIndex = $util.Long.fromValue(object.targetIndex)).unsigned = false;
                else if (typeof object.targetIndex === "string")
                    message.targetIndex = parseInt(object.targetIndex, 10);
                else if (typeof object.targetIndex === "number")
                    message.targetIndex = object.targetIndex;
                else if (typeof object.targetIndex === "object")
                    message.targetIndex = new $util.LongBits(object.targetIndex.low >>> 0, object.targetIndex.high >>> 0).toNumber();
            if (object.list) {
                if (!Array.isArray(object.list))
                    throw TypeError(".note.SortItem.list: array expected");
                message.list = [];
                for (var i = 0; i < object.list.length; ++i) {
                    if (typeof object.list[i] !== "object")
                        throw TypeError(".note.SortItem.list: object expected");
                    message.list[i] = $root.note.SortItem.ListItem.fromObject(object.list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SortItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof note.SortItem
         * @static
         * @param {note.SortItem} message SortItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SortItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.list = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.originalIndex = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.originalIndex = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.targetIndex = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.targetIndex = options.longs === String ? "0" : 0;
            }
            if (message.originalIndex != null && message.hasOwnProperty("originalIndex"))
                if (typeof message.originalIndex === "number")
                    object.originalIndex = options.longs === String ? String(message.originalIndex) : message.originalIndex;
                else
                    object.originalIndex = options.longs === String ? $util.Long.prototype.toString.call(message.originalIndex) : options.longs === Number ? new $util.LongBits(message.originalIndex.low >>> 0, message.originalIndex.high >>> 0).toNumber() : message.originalIndex;
            if (message.targetIndex != null && message.hasOwnProperty("targetIndex"))
                if (typeof message.targetIndex === "number")
                    object.targetIndex = options.longs === String ? String(message.targetIndex) : message.targetIndex;
                else
                    object.targetIndex = options.longs === String ? $util.Long.prototype.toString.call(message.targetIndex) : options.longs === Number ? new $util.LongBits(message.targetIndex.low >>> 0, message.targetIndex.high >>> 0).toNumber() : message.targetIndex;
            if (message.list && message.list.length) {
                object.list = [];
                for (var j = 0; j < message.list.length; ++j)
                    object.list[j] = $root.note.SortItem.ListItem.toObject(message.list[j], options);
            }
            return object;
        };

        /**
         * Converts this SortItem to JSON.
         * @function toJSON
         * @memberof note.SortItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SortItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SortItem.ListItem = (function() {

            /**
             * Properties of a ListItem.
             * @memberof note.SortItem
             * @interface IListItem
             * @property {string|null} [id] ListItem id
             * @property {number|null} [sort] ListItem sort
             * @property {string|null} [parentId] ListItem parentId
             * @property {number|null} [lastUpdateTime] ListItem lastUpdateTime
             */

            /**
             * Constructs a new ListItem.
             * @memberof note.SortItem
             * @classdesc Represents a ListItem.
             * @implements IListItem
             * @constructor
             * @param {note.SortItem.IListItem=} [properties] Properties to set
             */
            function ListItem(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ListItem id.
             * @member {string} id
             * @memberof note.SortItem.ListItem
             * @instance
             */
            ListItem.prototype.id = "";

            /**
             * ListItem sort.
             * @member {number} sort
             * @memberof note.SortItem.ListItem
             * @instance
             */
            ListItem.prototype.sort = 0;

            /**
             * ListItem parentId.
             * @member {string} parentId
             * @memberof note.SortItem.ListItem
             * @instance
             */
            ListItem.prototype.parentId = "";

            /**
             * ListItem lastUpdateTime.
             * @member {number} lastUpdateTime
             * @memberof note.SortItem.ListItem
             * @instance
             */
            ListItem.prototype.lastUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new ListItem instance using the specified properties.
             * @function create
             * @memberof note.SortItem.ListItem
             * @static
             * @param {note.SortItem.IListItem=} [properties] Properties to set
             * @returns {note.SortItem.ListItem} ListItem instance
             */
            ListItem.create = function create(properties) {
                return new ListItem(properties);
            };

            /**
             * Encodes the specified ListItem message. Does not implicitly {@link note.SortItem.ListItem.verify|verify} messages.
             * @function encode
             * @memberof note.SortItem.ListItem
             * @static
             * @param {note.SortItem.IListItem} message ListItem message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListItem.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.sort != null && Object.hasOwnProperty.call(message, "sort"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.sort);
                if (message.parentId != null && Object.hasOwnProperty.call(message, "parentId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.parentId);
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.lastUpdateTime);
                return writer;
            };

            /**
             * Encodes the specified ListItem message, length delimited. Does not implicitly {@link note.SortItem.ListItem.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.SortItem.ListItem
             * @static
             * @param {note.SortItem.IListItem} message ListItem message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListItem.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ListItem message from the specified reader or buffer.
             * @function decode
             * @memberof note.SortItem.ListItem
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.SortItem.ListItem} ListItem
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListItem.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.SortItem.ListItem();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.string();
                        break;
                    case 2:
                        message.sort = reader.int32();
                        break;
                    case 3:
                        message.parentId = reader.string();
                        break;
                    case 4:
                        message.lastUpdateTime = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ListItem message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.SortItem.ListItem
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.SortItem.ListItem} ListItem
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListItem.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ListItem message.
             * @function verify
             * @memberof note.SortItem.ListItem
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ListItem.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.sort != null && message.hasOwnProperty("sort"))
                    if (!$util.isInteger(message.sort))
                        return "sort: integer expected";
                if (message.parentId != null && message.hasOwnProperty("parentId"))
                    if (!$util.isString(message.parentId))
                        return "parentId: string expected";
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    if (!$util.isInteger(message.lastUpdateTime) && !(message.lastUpdateTime && $util.isInteger(message.lastUpdateTime.low) && $util.isInteger(message.lastUpdateTime.high)))
                        return "lastUpdateTime: integer|Long expected";
                return null;
            };

            /**
             * Creates a ListItem message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.SortItem.ListItem
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.SortItem.ListItem} ListItem
             */
            ListItem.fromObject = function fromObject(object) {
                if (object instanceof $root.note.SortItem.ListItem)
                    return object;
                var message = new $root.note.SortItem.ListItem();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.sort != null)
                    message.sort = object.sort | 0;
                if (object.parentId != null)
                    message.parentId = String(object.parentId);
                if (object.lastUpdateTime != null)
                    if ($util.Long)
                        (message.lastUpdateTime = $util.Long.fromValue(object.lastUpdateTime)).unsigned = false;
                    else if (typeof object.lastUpdateTime === "string")
                        message.lastUpdateTime = parseInt(object.lastUpdateTime, 10);
                    else if (typeof object.lastUpdateTime === "number")
                        message.lastUpdateTime = object.lastUpdateTime;
                    else if (typeof object.lastUpdateTime === "object")
                        message.lastUpdateTime = new $util.LongBits(object.lastUpdateTime.low >>> 0, object.lastUpdateTime.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a ListItem message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.SortItem.ListItem
             * @static
             * @param {note.SortItem.ListItem} message ListItem
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ListItem.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.sort = 0;
                    object.parentId = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.lastUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.lastUpdateTime = options.longs === String ? "0" : 0;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.sort != null && message.hasOwnProperty("sort"))
                    object.sort = message.sort;
                if (message.parentId != null && message.hasOwnProperty("parentId"))
                    object.parentId = message.parentId;
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    if (typeof message.lastUpdateTime === "number")
                        object.lastUpdateTime = options.longs === String ? String(message.lastUpdateTime) : message.lastUpdateTime;
                    else
                        object.lastUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTime) : options.longs === Number ? new $util.LongBits(message.lastUpdateTime.low >>> 0, message.lastUpdateTime.high >>> 0).toNumber() : message.lastUpdateTime;
                return object;
            };

            /**
             * Converts this ListItem to JSON.
             * @function toJSON
             * @memberof note.SortItem.ListItem
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ListItem.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ListItem;
        })();

        return SortItem;
    })();

    note.SavePagePassword = (function() {

        /**
         * Properties of a SavePagePassword.
         * @memberof note
         * @interface ISavePagePassword
         */

        /**
         * Constructs a new SavePagePassword.
         * @memberof note
         * @classdesc Represents a SavePagePassword.
         * @implements ISavePagePassword
         * @constructor
         * @param {note.ISavePagePassword=} [properties] Properties to set
         */
        function SavePagePassword(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SavePagePassword instance using the specified properties.
         * @function create
         * @memberof note.SavePagePassword
         * @static
         * @param {note.ISavePagePassword=} [properties] Properties to set
         * @returns {note.SavePagePassword} SavePagePassword instance
         */
        SavePagePassword.create = function create(properties) {
            return new SavePagePassword(properties);
        };

        /**
         * Encodes the specified SavePagePassword message. Does not implicitly {@link note.SavePagePassword.verify|verify} messages.
         * @function encode
         * @memberof note.SavePagePassword
         * @static
         * @param {note.ISavePagePassword} message SavePagePassword message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SavePagePassword.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified SavePagePassword message, length delimited. Does not implicitly {@link note.SavePagePassword.verify|verify} messages.
         * @function encodeDelimited
         * @memberof note.SavePagePassword
         * @static
         * @param {note.ISavePagePassword} message SavePagePassword message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SavePagePassword.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SavePagePassword message from the specified reader or buffer.
         * @function decode
         * @memberof note.SavePagePassword
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {note.SavePagePassword} SavePagePassword
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SavePagePassword.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.SavePagePassword();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SavePagePassword message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof note.SavePagePassword
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {note.SavePagePassword} SavePagePassword
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SavePagePassword.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SavePagePassword message.
         * @function verify
         * @memberof note.SavePagePassword
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SavePagePassword.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a SavePagePassword message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof note.SavePagePassword
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {note.SavePagePassword} SavePagePassword
         */
        SavePagePassword.fromObject = function fromObject(object) {
            if (object instanceof $root.note.SavePagePassword)
                return object;
            return new $root.note.SavePagePassword();
        };

        /**
         * Creates a plain object from a SavePagePassword message. Also converts values to other types if specified.
         * @function toObject
         * @memberof note.SavePagePassword
         * @static
         * @param {note.SavePagePassword} message SavePagePassword
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SavePagePassword.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SavePagePassword to JSON.
         * @function toJSON
         * @memberof note.SavePagePassword
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SavePagePassword.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SavePagePassword.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof note.SavePagePassword
             * @interface IRequest
             * @property {string|null} [noteId] Request noteId
             * @property {string|null} [pageId] Request pageId
             * @property {string|null} [password] Request password
             */

            /**
             * Constructs a new Request.
             * @memberof note.SavePagePassword
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {note.SavePagePassword.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request noteId.
             * @member {string} noteId
             * @memberof note.SavePagePassword.Request
             * @instance
             */
            Request.prototype.noteId = "";

            /**
             * Request pageId.
             * @member {string} pageId
             * @memberof note.SavePagePassword.Request
             * @instance
             */
            Request.prototype.pageId = "";

            /**
             * Request password.
             * @member {string} password
             * @memberof note.SavePagePassword.Request
             * @instance
             */
            Request.prototype.password = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof note.SavePagePassword.Request
             * @static
             * @param {note.SavePagePassword.IRequest=} [properties] Properties to set
             * @returns {note.SavePagePassword.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link note.SavePagePassword.Request.verify|verify} messages.
             * @function encode
             * @memberof note.SavePagePassword.Request
             * @static
             * @param {note.SavePagePassword.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.noteId != null && Object.hasOwnProperty.call(message, "noteId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.noteId);
                if (message.pageId != null && Object.hasOwnProperty.call(message, "pageId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageId);
                if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.password);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link note.SavePagePassword.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.SavePagePassword.Request
             * @static
             * @param {note.SavePagePassword.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof note.SavePagePassword.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.SavePagePassword.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.SavePagePassword.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.noteId = reader.string();
                        break;
                    case 2:
                        message.pageId = reader.string();
                        break;
                    case 3:
                        message.password = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.SavePagePassword.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.SavePagePassword.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof note.SavePagePassword.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    if (!$util.isString(message.noteId))
                        return "noteId: string expected";
                if (message.pageId != null && message.hasOwnProperty("pageId"))
                    if (!$util.isString(message.pageId))
                        return "pageId: string expected";
                if (message.password != null && message.hasOwnProperty("password"))
                    if (!$util.isString(message.password))
                        return "password: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.SavePagePassword.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.SavePagePassword.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.note.SavePagePassword.Request)
                    return object;
                var message = new $root.note.SavePagePassword.Request();
                if (object.noteId != null)
                    message.noteId = String(object.noteId);
                if (object.pageId != null)
                    message.pageId = String(object.pageId);
                if (object.password != null)
                    message.password = String(object.password);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.SavePagePassword.Request
             * @static
             * @param {note.SavePagePassword.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.noteId = "";
                    object.pageId = "";
                    object.password = "";
                }
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    object.noteId = message.noteId;
                if (message.pageId != null && message.hasOwnProperty("pageId"))
                    object.pageId = message.pageId;
                if (message.password != null && message.hasOwnProperty("password"))
                    object.password = message.password;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof note.SavePagePassword.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        SavePagePassword.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof note.SavePagePassword
             * @interface IResponse
             */

            /**
             * Constructs a new Response.
             * @memberof note.SavePagePassword
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {note.SavePagePassword.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof note.SavePagePassword.Response
             * @static
             * @param {note.SavePagePassword.IResponse=} [properties] Properties to set
             * @returns {note.SavePagePassword.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link note.SavePagePassword.Response.verify|verify} messages.
             * @function encode
             * @memberof note.SavePagePassword.Response
             * @static
             * @param {note.SavePagePassword.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link note.SavePagePassword.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.SavePagePassword.Response
             * @static
             * @param {note.SavePagePassword.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof note.SavePagePassword.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.SavePagePassword.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.SavePagePassword.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.SavePagePassword.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.SavePagePassword.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof note.SavePagePassword.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.SavePagePassword.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.SavePagePassword.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.note.SavePagePassword.Response)
                    return object;
                return new $root.note.SavePagePassword.Response();
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.SavePagePassword.Response
             * @static
             * @param {note.SavePagePassword.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof note.SavePagePassword.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return SavePagePassword;
    })();

    note.GetPagePassword = (function() {

        /**
         * Properties of a GetPagePassword.
         * @memberof note
         * @interface IGetPagePassword
         */

        /**
         * Constructs a new GetPagePassword.
         * @memberof note
         * @classdesc Represents a GetPagePassword.
         * @implements IGetPagePassword
         * @constructor
         * @param {note.IGetPagePassword=} [properties] Properties to set
         */
        function GetPagePassword(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetPagePassword instance using the specified properties.
         * @function create
         * @memberof note.GetPagePassword
         * @static
         * @param {note.IGetPagePassword=} [properties] Properties to set
         * @returns {note.GetPagePassword} GetPagePassword instance
         */
        GetPagePassword.create = function create(properties) {
            return new GetPagePassword(properties);
        };

        /**
         * Encodes the specified GetPagePassword message. Does not implicitly {@link note.GetPagePassword.verify|verify} messages.
         * @function encode
         * @memberof note.GetPagePassword
         * @static
         * @param {note.IGetPagePassword} message GetPagePassword message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetPagePassword.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetPagePassword message, length delimited. Does not implicitly {@link note.GetPagePassword.verify|verify} messages.
         * @function encodeDelimited
         * @memberof note.GetPagePassword
         * @static
         * @param {note.IGetPagePassword} message GetPagePassword message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetPagePassword.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetPagePassword message from the specified reader or buffer.
         * @function decode
         * @memberof note.GetPagePassword
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {note.GetPagePassword} GetPagePassword
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetPagePassword.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.GetPagePassword();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetPagePassword message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof note.GetPagePassword
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {note.GetPagePassword} GetPagePassword
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetPagePassword.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetPagePassword message.
         * @function verify
         * @memberof note.GetPagePassword
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetPagePassword.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetPagePassword message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof note.GetPagePassword
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {note.GetPagePassword} GetPagePassword
         */
        GetPagePassword.fromObject = function fromObject(object) {
            if (object instanceof $root.note.GetPagePassword)
                return object;
            return new $root.note.GetPagePassword();
        };

        /**
         * Creates a plain object from a GetPagePassword message. Also converts values to other types if specified.
         * @function toObject
         * @memberof note.GetPagePassword
         * @static
         * @param {note.GetPagePassword} message GetPagePassword
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetPagePassword.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetPagePassword to JSON.
         * @function toJSON
         * @memberof note.GetPagePassword
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetPagePassword.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetPagePassword.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof note.GetPagePassword
             * @interface IRequest
             * @property {string|null} [noteId] Request noteId
             * @property {string|null} [pageId] Request pageId
             * @property {string|null} [token] Request token
             */

            /**
             * Constructs a new Request.
             * @memberof note.GetPagePassword
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {note.GetPagePassword.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request noteId.
             * @member {string} noteId
             * @memberof note.GetPagePassword.Request
             * @instance
             */
            Request.prototype.noteId = "";

            /**
             * Request pageId.
             * @member {string} pageId
             * @memberof note.GetPagePassword.Request
             * @instance
             */
            Request.prototype.pageId = "";

            /**
             * Request token.
             * @member {string} token
             * @memberof note.GetPagePassword.Request
             * @instance
             */
            Request.prototype.token = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof note.GetPagePassword.Request
             * @static
             * @param {note.GetPagePassword.IRequest=} [properties] Properties to set
             * @returns {note.GetPagePassword.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link note.GetPagePassword.Request.verify|verify} messages.
             * @function encode
             * @memberof note.GetPagePassword.Request
             * @static
             * @param {note.GetPagePassword.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.noteId != null && Object.hasOwnProperty.call(message, "noteId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.noteId);
                if (message.pageId != null && Object.hasOwnProperty.call(message, "pageId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageId);
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.token);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link note.GetPagePassword.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.GetPagePassword.Request
             * @static
             * @param {note.GetPagePassword.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof note.GetPagePassword.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.GetPagePassword.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.GetPagePassword.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.noteId = reader.string();
                        break;
                    case 2:
                        message.pageId = reader.string();
                        break;
                    case 3:
                        message.token = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.GetPagePassword.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.GetPagePassword.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof note.GetPagePassword.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    if (!$util.isString(message.noteId))
                        return "noteId: string expected";
                if (message.pageId != null && message.hasOwnProperty("pageId"))
                    if (!$util.isString(message.pageId))
                        return "pageId: string expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.GetPagePassword.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.GetPagePassword.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.note.GetPagePassword.Request)
                    return object;
                var message = new $root.note.GetPagePassword.Request();
                if (object.noteId != null)
                    message.noteId = String(object.noteId);
                if (object.pageId != null)
                    message.pageId = String(object.pageId);
                if (object.token != null)
                    message.token = String(object.token);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.GetPagePassword.Request
             * @static
             * @param {note.GetPagePassword.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.noteId = "";
                    object.pageId = "";
                    object.token = "";
                }
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    object.noteId = message.noteId;
                if (message.pageId != null && message.hasOwnProperty("pageId"))
                    object.pageId = message.pageId;
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof note.GetPagePassword.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetPagePassword.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof note.GetPagePassword
             * @interface IResponse
             * @property {string|null} [password] Response password
             */

            /**
             * Constructs a new Response.
             * @memberof note.GetPagePassword
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {note.GetPagePassword.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response password.
             * @member {string} password
             * @memberof note.GetPagePassword.Response
             * @instance
             */
            Response.prototype.password = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof note.GetPagePassword.Response
             * @static
             * @param {note.GetPagePassword.IResponse=} [properties] Properties to set
             * @returns {note.GetPagePassword.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link note.GetPagePassword.Response.verify|verify} messages.
             * @function encode
             * @memberof note.GetPagePassword.Response
             * @static
             * @param {note.GetPagePassword.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.password);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link note.GetPagePassword.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.GetPagePassword.Response
             * @static
             * @param {note.GetPagePassword.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof note.GetPagePassword.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.GetPagePassword.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.GetPagePassword.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.password = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.GetPagePassword.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.GetPagePassword.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof note.GetPagePassword.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.password != null && message.hasOwnProperty("password"))
                    if (!$util.isString(message.password))
                        return "password: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.GetPagePassword.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.GetPagePassword.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.note.GetPagePassword.Response)
                    return object;
                var message = new $root.note.GetPagePassword.Response();
                if (object.password != null)
                    message.password = String(object.password);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.GetPagePassword.Response
             * @static
             * @param {note.GetPagePassword.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.password = "";
                if (message.password != null && message.hasOwnProperty("password"))
                    object.password = message.password;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof note.GetPagePassword.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetPagePassword;
    })();

    note.DeletePagePassword = (function() {

        /**
         * Properties of a DeletePagePassword.
         * @memberof note
         * @interface IDeletePagePassword
         */

        /**
         * Constructs a new DeletePagePassword.
         * @memberof note
         * @classdesc Represents a DeletePagePassword.
         * @implements IDeletePagePassword
         * @constructor
         * @param {note.IDeletePagePassword=} [properties] Properties to set
         */
        function DeletePagePassword(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new DeletePagePassword instance using the specified properties.
         * @function create
         * @memberof note.DeletePagePassword
         * @static
         * @param {note.IDeletePagePassword=} [properties] Properties to set
         * @returns {note.DeletePagePassword} DeletePagePassword instance
         */
        DeletePagePassword.create = function create(properties) {
            return new DeletePagePassword(properties);
        };

        /**
         * Encodes the specified DeletePagePassword message. Does not implicitly {@link note.DeletePagePassword.verify|verify} messages.
         * @function encode
         * @memberof note.DeletePagePassword
         * @static
         * @param {note.IDeletePagePassword} message DeletePagePassword message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeletePagePassword.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified DeletePagePassword message, length delimited. Does not implicitly {@link note.DeletePagePassword.verify|verify} messages.
         * @function encodeDelimited
         * @memberof note.DeletePagePassword
         * @static
         * @param {note.IDeletePagePassword} message DeletePagePassword message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeletePagePassword.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeletePagePassword message from the specified reader or buffer.
         * @function decode
         * @memberof note.DeletePagePassword
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {note.DeletePagePassword} DeletePagePassword
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeletePagePassword.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.DeletePagePassword();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeletePagePassword message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof note.DeletePagePassword
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {note.DeletePagePassword} DeletePagePassword
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeletePagePassword.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeletePagePassword message.
         * @function verify
         * @memberof note.DeletePagePassword
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeletePagePassword.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a DeletePagePassword message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof note.DeletePagePassword
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {note.DeletePagePassword} DeletePagePassword
         */
        DeletePagePassword.fromObject = function fromObject(object) {
            if (object instanceof $root.note.DeletePagePassword)
                return object;
            return new $root.note.DeletePagePassword();
        };

        /**
         * Creates a plain object from a DeletePagePassword message. Also converts values to other types if specified.
         * @function toObject
         * @memberof note.DeletePagePassword
         * @static
         * @param {note.DeletePagePassword} message DeletePagePassword
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeletePagePassword.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this DeletePagePassword to JSON.
         * @function toJSON
         * @memberof note.DeletePagePassword
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeletePagePassword.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        DeletePagePassword.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof note.DeletePagePassword
             * @interface IRequest
             * @property {string|null} [noteId] Request noteId
             * @property {string|null} [pageId] Request pageId
             * @property {string|null} [token] Request token
             * @property {string|null} [password] Request password
             */

            /**
             * Constructs a new Request.
             * @memberof note.DeletePagePassword
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {note.DeletePagePassword.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request noteId.
             * @member {string} noteId
             * @memberof note.DeletePagePassword.Request
             * @instance
             */
            Request.prototype.noteId = "";

            /**
             * Request pageId.
             * @member {string} pageId
             * @memberof note.DeletePagePassword.Request
             * @instance
             */
            Request.prototype.pageId = "";

            /**
             * Request token.
             * @member {string} token
             * @memberof note.DeletePagePassword.Request
             * @instance
             */
            Request.prototype.token = "";

            /**
             * Request password.
             * @member {string} password
             * @memberof note.DeletePagePassword.Request
             * @instance
             */
            Request.prototype.password = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof note.DeletePagePassword.Request
             * @static
             * @param {note.DeletePagePassword.IRequest=} [properties] Properties to set
             * @returns {note.DeletePagePassword.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link note.DeletePagePassword.Request.verify|verify} messages.
             * @function encode
             * @memberof note.DeletePagePassword.Request
             * @static
             * @param {note.DeletePagePassword.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.noteId != null && Object.hasOwnProperty.call(message, "noteId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.noteId);
                if (message.pageId != null && Object.hasOwnProperty.call(message, "pageId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageId);
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.token);
                if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.password);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link note.DeletePagePassword.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.DeletePagePassword.Request
             * @static
             * @param {note.DeletePagePassword.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof note.DeletePagePassword.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.DeletePagePassword.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.DeletePagePassword.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.noteId = reader.string();
                        break;
                    case 2:
                        message.pageId = reader.string();
                        break;
                    case 3:
                        message.token = reader.string();
                        break;
                    case 4:
                        message.password = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.DeletePagePassword.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.DeletePagePassword.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof note.DeletePagePassword.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    if (!$util.isString(message.noteId))
                        return "noteId: string expected";
                if (message.pageId != null && message.hasOwnProperty("pageId"))
                    if (!$util.isString(message.pageId))
                        return "pageId: string expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.password != null && message.hasOwnProperty("password"))
                    if (!$util.isString(message.password))
                        return "password: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.DeletePagePassword.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.DeletePagePassword.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.note.DeletePagePassword.Request)
                    return object;
                var message = new $root.note.DeletePagePassword.Request();
                if (object.noteId != null)
                    message.noteId = String(object.noteId);
                if (object.pageId != null)
                    message.pageId = String(object.pageId);
                if (object.token != null)
                    message.token = String(object.token);
                if (object.password != null)
                    message.password = String(object.password);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.DeletePagePassword.Request
             * @static
             * @param {note.DeletePagePassword.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.noteId = "";
                    object.pageId = "";
                    object.token = "";
                    object.password = "";
                }
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    object.noteId = message.noteId;
                if (message.pageId != null && message.hasOwnProperty("pageId"))
                    object.pageId = message.pageId;
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.password != null && message.hasOwnProperty("password"))
                    object.password = message.password;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof note.DeletePagePassword.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        DeletePagePassword.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof note.DeletePagePassword
             * @interface IResponse
             */

            /**
             * Constructs a new Response.
             * @memberof note.DeletePagePassword
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {note.DeletePagePassword.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof note.DeletePagePassword.Response
             * @static
             * @param {note.DeletePagePassword.IResponse=} [properties] Properties to set
             * @returns {note.DeletePagePassword.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link note.DeletePagePassword.Response.verify|verify} messages.
             * @function encode
             * @memberof note.DeletePagePassword.Response
             * @static
             * @param {note.DeletePagePassword.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link note.DeletePagePassword.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.DeletePagePassword.Response
             * @static
             * @param {note.DeletePagePassword.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof note.DeletePagePassword.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.DeletePagePassword.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.DeletePagePassword.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.DeletePagePassword.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.DeletePagePassword.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof note.DeletePagePassword.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.DeletePagePassword.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.DeletePagePassword.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.note.DeletePagePassword.Response)
                    return object;
                return new $root.note.DeletePagePassword.Response();
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.DeletePagePassword.Response
             * @static
             * @param {note.DeletePagePassword.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof note.DeletePagePassword.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return DeletePagePassword;
    })();

    note.GetInvitationCode = (function() {

        /**
         * Properties of a GetInvitationCode.
         * @memberof note
         * @interface IGetInvitationCode
         */

        /**
         * Constructs a new GetInvitationCode.
         * @memberof note
         * @classdesc Represents a GetInvitationCode.
         * @implements IGetInvitationCode
         * @constructor
         * @param {note.IGetInvitationCode=} [properties] Properties to set
         */
        function GetInvitationCode(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetInvitationCode instance using the specified properties.
         * @function create
         * @memberof note.GetInvitationCode
         * @static
         * @param {note.IGetInvitationCode=} [properties] Properties to set
         * @returns {note.GetInvitationCode} GetInvitationCode instance
         */
        GetInvitationCode.create = function create(properties) {
            return new GetInvitationCode(properties);
        };

        /**
         * Encodes the specified GetInvitationCode message. Does not implicitly {@link note.GetInvitationCode.verify|verify} messages.
         * @function encode
         * @memberof note.GetInvitationCode
         * @static
         * @param {note.IGetInvitationCode} message GetInvitationCode message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetInvitationCode.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetInvitationCode message, length delimited. Does not implicitly {@link note.GetInvitationCode.verify|verify} messages.
         * @function encodeDelimited
         * @memberof note.GetInvitationCode
         * @static
         * @param {note.IGetInvitationCode} message GetInvitationCode message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetInvitationCode.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetInvitationCode message from the specified reader or buffer.
         * @function decode
         * @memberof note.GetInvitationCode
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {note.GetInvitationCode} GetInvitationCode
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetInvitationCode.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.GetInvitationCode();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetInvitationCode message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof note.GetInvitationCode
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {note.GetInvitationCode} GetInvitationCode
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetInvitationCode.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetInvitationCode message.
         * @function verify
         * @memberof note.GetInvitationCode
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetInvitationCode.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetInvitationCode message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof note.GetInvitationCode
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {note.GetInvitationCode} GetInvitationCode
         */
        GetInvitationCode.fromObject = function fromObject(object) {
            if (object instanceof $root.note.GetInvitationCode)
                return object;
            return new $root.note.GetInvitationCode();
        };

        /**
         * Creates a plain object from a GetInvitationCode message. Also converts values to other types if specified.
         * @function toObject
         * @memberof note.GetInvitationCode
         * @static
         * @param {note.GetInvitationCode} message GetInvitationCode
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetInvitationCode.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetInvitationCode to JSON.
         * @function toJSON
         * @memberof note.GetInvitationCode
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetInvitationCode.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetInvitationCode.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof note.GetInvitationCode
             * @interface IRequest
             * @property {string|null} [noteId] Request noteId
             * @property {number|null} [permission] Request permission
             */

            /**
             * Constructs a new Request.
             * @memberof note.GetInvitationCode
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {note.GetInvitationCode.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request noteId.
             * @member {string} noteId
             * @memberof note.GetInvitationCode.Request
             * @instance
             */
            Request.prototype.noteId = "";

            /**
             * Request permission.
             * @member {number} permission
             * @memberof note.GetInvitationCode.Request
             * @instance
             */
            Request.prototype.permission = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof note.GetInvitationCode.Request
             * @static
             * @param {note.GetInvitationCode.IRequest=} [properties] Properties to set
             * @returns {note.GetInvitationCode.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link note.GetInvitationCode.Request.verify|verify} messages.
             * @function encode
             * @memberof note.GetInvitationCode.Request
             * @static
             * @param {note.GetInvitationCode.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.noteId != null && Object.hasOwnProperty.call(message, "noteId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.noteId);
                if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.permission);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link note.GetInvitationCode.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.GetInvitationCode.Request
             * @static
             * @param {note.GetInvitationCode.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof note.GetInvitationCode.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.GetInvitationCode.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.GetInvitationCode.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.noteId = reader.string();
                        break;
                    case 2:
                        message.permission = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.GetInvitationCode.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.GetInvitationCode.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof note.GetInvitationCode.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    if (!$util.isString(message.noteId))
                        return "noteId: string expected";
                if (message.permission != null && message.hasOwnProperty("permission"))
                    if (!$util.isInteger(message.permission) && !(message.permission && $util.isInteger(message.permission.low) && $util.isInteger(message.permission.high)))
                        return "permission: integer|Long expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.GetInvitationCode.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.GetInvitationCode.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.note.GetInvitationCode.Request)
                    return object;
                var message = new $root.note.GetInvitationCode.Request();
                if (object.noteId != null)
                    message.noteId = String(object.noteId);
                if (object.permission != null)
                    if ($util.Long)
                        (message.permission = $util.Long.fromValue(object.permission)).unsigned = false;
                    else if (typeof object.permission === "string")
                        message.permission = parseInt(object.permission, 10);
                    else if (typeof object.permission === "number")
                        message.permission = object.permission;
                    else if (typeof object.permission === "object")
                        message.permission = new $util.LongBits(object.permission.low >>> 0, object.permission.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.GetInvitationCode.Request
             * @static
             * @param {note.GetInvitationCode.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.noteId = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.permission = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.permission = options.longs === String ? "0" : 0;
                }
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    object.noteId = message.noteId;
                if (message.permission != null && message.hasOwnProperty("permission"))
                    if (typeof message.permission === "number")
                        object.permission = options.longs === String ? String(message.permission) : message.permission;
                    else
                        object.permission = options.longs === String ? $util.Long.prototype.toString.call(message.permission) : options.longs === Number ? new $util.LongBits(message.permission.low >>> 0, message.permission.high >>> 0).toNumber() : message.permission;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof note.GetInvitationCode.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetInvitationCode.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof note.GetInvitationCode
             * @interface IResponse
             * @property {string|null} [invitationCode] Response invitationCode
             */

            /**
             * Constructs a new Response.
             * @memberof note.GetInvitationCode
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {note.GetInvitationCode.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response invitationCode.
             * @member {string} invitationCode
             * @memberof note.GetInvitationCode.Response
             * @instance
             */
            Response.prototype.invitationCode = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof note.GetInvitationCode.Response
             * @static
             * @param {note.GetInvitationCode.IResponse=} [properties] Properties to set
             * @returns {note.GetInvitationCode.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link note.GetInvitationCode.Response.verify|verify} messages.
             * @function encode
             * @memberof note.GetInvitationCode.Response
             * @static
             * @param {note.GetInvitationCode.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.invitationCode != null && Object.hasOwnProperty.call(message, "invitationCode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.invitationCode);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link note.GetInvitationCode.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.GetInvitationCode.Response
             * @static
             * @param {note.GetInvitationCode.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof note.GetInvitationCode.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.GetInvitationCode.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.GetInvitationCode.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.invitationCode = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.GetInvitationCode.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.GetInvitationCode.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof note.GetInvitationCode.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.invitationCode != null && message.hasOwnProperty("invitationCode"))
                    if (!$util.isString(message.invitationCode))
                        return "invitationCode: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.GetInvitationCode.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.GetInvitationCode.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.note.GetInvitationCode.Response)
                    return object;
                var message = new $root.note.GetInvitationCode.Response();
                if (object.invitationCode != null)
                    message.invitationCode = String(object.invitationCode);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.GetInvitationCode.Response
             * @static
             * @param {note.GetInvitationCode.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.invitationCode = "";
                if (message.invitationCode != null && message.hasOwnProperty("invitationCode"))
                    object.invitationCode = message.invitationCode;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof note.GetInvitationCode.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetInvitationCode;
    })();

    note.AgreeAndDownloadNote = (function() {

        /**
         * Properties of an AgreeAndDownloadNote.
         * @memberof note
         * @interface IAgreeAndDownloadNote
         */

        /**
         * Constructs a new AgreeAndDownloadNote.
         * @memberof note
         * @classdesc Represents an AgreeAndDownloadNote.
         * @implements IAgreeAndDownloadNote
         * @constructor
         * @param {note.IAgreeAndDownloadNote=} [properties] Properties to set
         */
        function AgreeAndDownloadNote(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new AgreeAndDownloadNote instance using the specified properties.
         * @function create
         * @memberof note.AgreeAndDownloadNote
         * @static
         * @param {note.IAgreeAndDownloadNote=} [properties] Properties to set
         * @returns {note.AgreeAndDownloadNote} AgreeAndDownloadNote instance
         */
        AgreeAndDownloadNote.create = function create(properties) {
            return new AgreeAndDownloadNote(properties);
        };

        /**
         * Encodes the specified AgreeAndDownloadNote message. Does not implicitly {@link note.AgreeAndDownloadNote.verify|verify} messages.
         * @function encode
         * @memberof note.AgreeAndDownloadNote
         * @static
         * @param {note.IAgreeAndDownloadNote} message AgreeAndDownloadNote message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AgreeAndDownloadNote.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified AgreeAndDownloadNote message, length delimited. Does not implicitly {@link note.AgreeAndDownloadNote.verify|verify} messages.
         * @function encodeDelimited
         * @memberof note.AgreeAndDownloadNote
         * @static
         * @param {note.IAgreeAndDownloadNote} message AgreeAndDownloadNote message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AgreeAndDownloadNote.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AgreeAndDownloadNote message from the specified reader or buffer.
         * @function decode
         * @memberof note.AgreeAndDownloadNote
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {note.AgreeAndDownloadNote} AgreeAndDownloadNote
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AgreeAndDownloadNote.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.AgreeAndDownloadNote();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AgreeAndDownloadNote message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof note.AgreeAndDownloadNote
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {note.AgreeAndDownloadNote} AgreeAndDownloadNote
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AgreeAndDownloadNote.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AgreeAndDownloadNote message.
         * @function verify
         * @memberof note.AgreeAndDownloadNote
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AgreeAndDownloadNote.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an AgreeAndDownloadNote message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof note.AgreeAndDownloadNote
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {note.AgreeAndDownloadNote} AgreeAndDownloadNote
         */
        AgreeAndDownloadNote.fromObject = function fromObject(object) {
            if (object instanceof $root.note.AgreeAndDownloadNote)
                return object;
            return new $root.note.AgreeAndDownloadNote();
        };

        /**
         * Creates a plain object from an AgreeAndDownloadNote message. Also converts values to other types if specified.
         * @function toObject
         * @memberof note.AgreeAndDownloadNote
         * @static
         * @param {note.AgreeAndDownloadNote} message AgreeAndDownloadNote
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AgreeAndDownloadNote.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this AgreeAndDownloadNote to JSON.
         * @function toJSON
         * @memberof note.AgreeAndDownloadNote
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AgreeAndDownloadNote.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        AgreeAndDownloadNote.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof note.AgreeAndDownloadNote
             * @interface IRequest
             * @property {string|null} [invitationCode] Request invitationCode
             */

            /**
             * Constructs a new Request.
             * @memberof note.AgreeAndDownloadNote
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {note.AgreeAndDownloadNote.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request invitationCode.
             * @member {string} invitationCode
             * @memberof note.AgreeAndDownloadNote.Request
             * @instance
             */
            Request.prototype.invitationCode = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof note.AgreeAndDownloadNote.Request
             * @static
             * @param {note.AgreeAndDownloadNote.IRequest=} [properties] Properties to set
             * @returns {note.AgreeAndDownloadNote.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link note.AgreeAndDownloadNote.Request.verify|verify} messages.
             * @function encode
             * @memberof note.AgreeAndDownloadNote.Request
             * @static
             * @param {note.AgreeAndDownloadNote.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.invitationCode != null && Object.hasOwnProperty.call(message, "invitationCode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.invitationCode);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link note.AgreeAndDownloadNote.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.AgreeAndDownloadNote.Request
             * @static
             * @param {note.AgreeAndDownloadNote.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof note.AgreeAndDownloadNote.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.AgreeAndDownloadNote.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.AgreeAndDownloadNote.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.invitationCode = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.AgreeAndDownloadNote.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.AgreeAndDownloadNote.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof note.AgreeAndDownloadNote.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.invitationCode != null && message.hasOwnProperty("invitationCode"))
                    if (!$util.isString(message.invitationCode))
                        return "invitationCode: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.AgreeAndDownloadNote.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.AgreeAndDownloadNote.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.note.AgreeAndDownloadNote.Request)
                    return object;
                var message = new $root.note.AgreeAndDownloadNote.Request();
                if (object.invitationCode != null)
                    message.invitationCode = String(object.invitationCode);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.AgreeAndDownloadNote.Request
             * @static
             * @param {note.AgreeAndDownloadNote.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.invitationCode = "";
                if (message.invitationCode != null && message.hasOwnProperty("invitationCode"))
                    object.invitationCode = message.invitationCode;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof note.AgreeAndDownloadNote.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        AgreeAndDownloadNote.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof note.AgreeAndDownloadNote
             * @interface IResponse
             * @property {file.IUrls|null} [urls] Response urls
             * @property {string|null} [noteId] Response noteId
             */

            /**
             * Constructs a new Response.
             * @memberof note.AgreeAndDownloadNote
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {note.AgreeAndDownloadNote.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response urls.
             * @member {file.IUrls|null|undefined} urls
             * @memberof note.AgreeAndDownloadNote.Response
             * @instance
             */
            Response.prototype.urls = null;

            /**
             * Response noteId.
             * @member {string} noteId
             * @memberof note.AgreeAndDownloadNote.Response
             * @instance
             */
            Response.prototype.noteId = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof note.AgreeAndDownloadNote.Response
             * @static
             * @param {note.AgreeAndDownloadNote.IResponse=} [properties] Properties to set
             * @returns {note.AgreeAndDownloadNote.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link note.AgreeAndDownloadNote.Response.verify|verify} messages.
             * @function encode
             * @memberof note.AgreeAndDownloadNote.Response
             * @static
             * @param {note.AgreeAndDownloadNote.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.urls != null && Object.hasOwnProperty.call(message, "urls"))
                    $root.file.Urls.encode(message.urls, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.noteId != null && Object.hasOwnProperty.call(message, "noteId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.noteId);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link note.AgreeAndDownloadNote.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.AgreeAndDownloadNote.Response
             * @static
             * @param {note.AgreeAndDownloadNote.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof note.AgreeAndDownloadNote.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.AgreeAndDownloadNote.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.AgreeAndDownloadNote.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.urls = $root.file.Urls.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.noteId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.AgreeAndDownloadNote.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.AgreeAndDownloadNote.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof note.AgreeAndDownloadNote.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.urls != null && message.hasOwnProperty("urls")) {
                    var error = $root.file.Urls.verify(message.urls);
                    if (error)
                        return "urls." + error;
                }
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    if (!$util.isString(message.noteId))
                        return "noteId: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.AgreeAndDownloadNote.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.AgreeAndDownloadNote.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.note.AgreeAndDownloadNote.Response)
                    return object;
                var message = new $root.note.AgreeAndDownloadNote.Response();
                if (object.urls != null) {
                    if (typeof object.urls !== "object")
                        throw TypeError(".note.AgreeAndDownloadNote.Response.urls: object expected");
                    message.urls = $root.file.Urls.fromObject(object.urls);
                }
                if (object.noteId != null)
                    message.noteId = String(object.noteId);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.AgreeAndDownloadNote.Response
             * @static
             * @param {note.AgreeAndDownloadNote.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.urls = null;
                    object.noteId = "";
                }
                if (message.urls != null && message.hasOwnProperty("urls"))
                    object.urls = $root.file.Urls.toObject(message.urls, options);
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    object.noteId = message.noteId;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof note.AgreeAndDownloadNote.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return AgreeAndDownloadNote;
    })();

    note.NotePermissionsItem = (function() {

        /**
         * Properties of a NotePermissionsItem.
         * @memberof note
         * @interface INotePermissionsItem
         * @property {string|null} [noteId] NotePermissionsItem noteId
         * @property {string|null} [ownerId] NotePermissionsItem ownerId
         * @property {string|null} [authorId] NotePermissionsItem authorId
         * @property {number|null} [permission] NotePermissionsItem permission
         * @property {number|null} [createTime] NotePermissionsItem createTime
         * @property {user.IBaseUserInfo|null} [userInfo] NotePermissionsItem userInfo
         */

        /**
         * Constructs a new NotePermissionsItem.
         * @memberof note
         * @classdesc Represents a NotePermissionsItem.
         * @implements INotePermissionsItem
         * @constructor
         * @param {note.INotePermissionsItem=} [properties] Properties to set
         */
        function NotePermissionsItem(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NotePermissionsItem noteId.
         * @member {string} noteId
         * @memberof note.NotePermissionsItem
         * @instance
         */
        NotePermissionsItem.prototype.noteId = "";

        /**
         * NotePermissionsItem ownerId.
         * @member {string} ownerId
         * @memberof note.NotePermissionsItem
         * @instance
         */
        NotePermissionsItem.prototype.ownerId = "";

        /**
         * NotePermissionsItem authorId.
         * @member {string} authorId
         * @memberof note.NotePermissionsItem
         * @instance
         */
        NotePermissionsItem.prototype.authorId = "";

        /**
         * NotePermissionsItem permission.
         * @member {number} permission
         * @memberof note.NotePermissionsItem
         * @instance
         */
        NotePermissionsItem.prototype.permission = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * NotePermissionsItem createTime.
         * @member {number} createTime
         * @memberof note.NotePermissionsItem
         * @instance
         */
        NotePermissionsItem.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * NotePermissionsItem userInfo.
         * @member {user.IBaseUserInfo|null|undefined} userInfo
         * @memberof note.NotePermissionsItem
         * @instance
         */
        NotePermissionsItem.prototype.userInfo = null;

        /**
         * Creates a new NotePermissionsItem instance using the specified properties.
         * @function create
         * @memberof note.NotePermissionsItem
         * @static
         * @param {note.INotePermissionsItem=} [properties] Properties to set
         * @returns {note.NotePermissionsItem} NotePermissionsItem instance
         */
        NotePermissionsItem.create = function create(properties) {
            return new NotePermissionsItem(properties);
        };

        /**
         * Encodes the specified NotePermissionsItem message. Does not implicitly {@link note.NotePermissionsItem.verify|verify} messages.
         * @function encode
         * @memberof note.NotePermissionsItem
         * @static
         * @param {note.INotePermissionsItem} message NotePermissionsItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NotePermissionsItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.noteId != null && Object.hasOwnProperty.call(message, "noteId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.noteId);
            if (message.ownerId != null && Object.hasOwnProperty.call(message, "ownerId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.ownerId);
            if (message.authorId != null && Object.hasOwnProperty.call(message, "authorId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.authorId);
            if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.permission);
            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createTime);
            if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
                $root.user.BaseUserInfo.encode(message.userInfo, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified NotePermissionsItem message, length delimited. Does not implicitly {@link note.NotePermissionsItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof note.NotePermissionsItem
         * @static
         * @param {note.INotePermissionsItem} message NotePermissionsItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NotePermissionsItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NotePermissionsItem message from the specified reader or buffer.
         * @function decode
         * @memberof note.NotePermissionsItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {note.NotePermissionsItem} NotePermissionsItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NotePermissionsItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.NotePermissionsItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.noteId = reader.string();
                    break;
                case 2:
                    message.ownerId = reader.string();
                    break;
                case 3:
                    message.authorId = reader.string();
                    break;
                case 4:
                    message.permission = reader.int64();
                    break;
                case 5:
                    message.createTime = reader.int64();
                    break;
                case 6:
                    message.userInfo = $root.user.BaseUserInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NotePermissionsItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof note.NotePermissionsItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {note.NotePermissionsItem} NotePermissionsItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NotePermissionsItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NotePermissionsItem message.
         * @function verify
         * @memberof note.NotePermissionsItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NotePermissionsItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.noteId != null && message.hasOwnProperty("noteId"))
                if (!$util.isString(message.noteId))
                    return "noteId: string expected";
            if (message.ownerId != null && message.hasOwnProperty("ownerId"))
                if (!$util.isString(message.ownerId))
                    return "ownerId: string expected";
            if (message.authorId != null && message.hasOwnProperty("authorId"))
                if (!$util.isString(message.authorId))
                    return "authorId: string expected";
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (!$util.isInteger(message.permission) && !(message.permission && $util.isInteger(message.permission.low) && $util.isInteger(message.permission.high)))
                    return "permission: integer|Long expected";
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                    return "createTime: integer|Long expected";
            if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
                var error = $root.user.BaseUserInfo.verify(message.userInfo);
                if (error)
                    return "userInfo." + error;
            }
            return null;
        };

        /**
         * Creates a NotePermissionsItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof note.NotePermissionsItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {note.NotePermissionsItem} NotePermissionsItem
         */
        NotePermissionsItem.fromObject = function fromObject(object) {
            if (object instanceof $root.note.NotePermissionsItem)
                return object;
            var message = new $root.note.NotePermissionsItem();
            if (object.noteId != null)
                message.noteId = String(object.noteId);
            if (object.ownerId != null)
                message.ownerId = String(object.ownerId);
            if (object.authorId != null)
                message.authorId = String(object.authorId);
            if (object.permission != null)
                if ($util.Long)
                    (message.permission = $util.Long.fromValue(object.permission)).unsigned = false;
                else if (typeof object.permission === "string")
                    message.permission = parseInt(object.permission, 10);
                else if (typeof object.permission === "number")
                    message.permission = object.permission;
                else if (typeof object.permission === "object")
                    message.permission = new $util.LongBits(object.permission.low >>> 0, object.permission.high >>> 0).toNumber();
            if (object.createTime != null)
                if ($util.Long)
                    (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                else if (typeof object.createTime === "string")
                    message.createTime = parseInt(object.createTime, 10);
                else if (typeof object.createTime === "number")
                    message.createTime = object.createTime;
                else if (typeof object.createTime === "object")
                    message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
            if (object.userInfo != null) {
                if (typeof object.userInfo !== "object")
                    throw TypeError(".note.NotePermissionsItem.userInfo: object expected");
                message.userInfo = $root.user.BaseUserInfo.fromObject(object.userInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from a NotePermissionsItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof note.NotePermissionsItem
         * @static
         * @param {note.NotePermissionsItem} message NotePermissionsItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NotePermissionsItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.noteId = "";
                object.ownerId = "";
                object.authorId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.permission = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.permission = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createTime = options.longs === String ? "0" : 0;
                object.userInfo = null;
            }
            if (message.noteId != null && message.hasOwnProperty("noteId"))
                object.noteId = message.noteId;
            if (message.ownerId != null && message.hasOwnProperty("ownerId"))
                object.ownerId = message.ownerId;
            if (message.authorId != null && message.hasOwnProperty("authorId"))
                object.authorId = message.authorId;
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (typeof message.permission === "number")
                    object.permission = options.longs === String ? String(message.permission) : message.permission;
                else
                    object.permission = options.longs === String ? $util.Long.prototype.toString.call(message.permission) : options.longs === Number ? new $util.LongBits(message.permission.low >>> 0, message.permission.high >>> 0).toNumber() : message.permission;
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (typeof message.createTime === "number")
                    object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                else
                    object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
            if (message.userInfo != null && message.hasOwnProperty("userInfo"))
                object.userInfo = $root.user.BaseUserInfo.toObject(message.userInfo, options);
            return object;
        };

        /**
         * Converts this NotePermissionsItem to JSON.
         * @function toJSON
         * @memberof note.NotePermissionsItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NotePermissionsItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NotePermissionsItem;
    })();

    note.GetNotePermissions = (function() {

        /**
         * Properties of a GetNotePermissions.
         * @memberof note
         * @interface IGetNotePermissions
         */

        /**
         * Constructs a new GetNotePermissions.
         * @memberof note
         * @classdesc Represents a GetNotePermissions.
         * @implements IGetNotePermissions
         * @constructor
         * @param {note.IGetNotePermissions=} [properties] Properties to set
         */
        function GetNotePermissions(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetNotePermissions instance using the specified properties.
         * @function create
         * @memberof note.GetNotePermissions
         * @static
         * @param {note.IGetNotePermissions=} [properties] Properties to set
         * @returns {note.GetNotePermissions} GetNotePermissions instance
         */
        GetNotePermissions.create = function create(properties) {
            return new GetNotePermissions(properties);
        };

        /**
         * Encodes the specified GetNotePermissions message. Does not implicitly {@link note.GetNotePermissions.verify|verify} messages.
         * @function encode
         * @memberof note.GetNotePermissions
         * @static
         * @param {note.IGetNotePermissions} message GetNotePermissions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetNotePermissions.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetNotePermissions message, length delimited. Does not implicitly {@link note.GetNotePermissions.verify|verify} messages.
         * @function encodeDelimited
         * @memberof note.GetNotePermissions
         * @static
         * @param {note.IGetNotePermissions} message GetNotePermissions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetNotePermissions.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetNotePermissions message from the specified reader or buffer.
         * @function decode
         * @memberof note.GetNotePermissions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {note.GetNotePermissions} GetNotePermissions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetNotePermissions.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.GetNotePermissions();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetNotePermissions message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof note.GetNotePermissions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {note.GetNotePermissions} GetNotePermissions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetNotePermissions.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetNotePermissions message.
         * @function verify
         * @memberof note.GetNotePermissions
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetNotePermissions.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetNotePermissions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof note.GetNotePermissions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {note.GetNotePermissions} GetNotePermissions
         */
        GetNotePermissions.fromObject = function fromObject(object) {
            if (object instanceof $root.note.GetNotePermissions)
                return object;
            return new $root.note.GetNotePermissions();
        };

        /**
         * Creates a plain object from a GetNotePermissions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof note.GetNotePermissions
         * @static
         * @param {note.GetNotePermissions} message GetNotePermissions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetNotePermissions.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetNotePermissions to JSON.
         * @function toJSON
         * @memberof note.GetNotePermissions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetNotePermissions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetNotePermissions.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof note.GetNotePermissions
             * @interface IRequest
             * @property {string|null} [noteId] Request noteId
             */

            /**
             * Constructs a new Request.
             * @memberof note.GetNotePermissions
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {note.GetNotePermissions.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request noteId.
             * @member {string} noteId
             * @memberof note.GetNotePermissions.Request
             * @instance
             */
            Request.prototype.noteId = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof note.GetNotePermissions.Request
             * @static
             * @param {note.GetNotePermissions.IRequest=} [properties] Properties to set
             * @returns {note.GetNotePermissions.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link note.GetNotePermissions.Request.verify|verify} messages.
             * @function encode
             * @memberof note.GetNotePermissions.Request
             * @static
             * @param {note.GetNotePermissions.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.noteId != null && Object.hasOwnProperty.call(message, "noteId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.noteId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link note.GetNotePermissions.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.GetNotePermissions.Request
             * @static
             * @param {note.GetNotePermissions.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof note.GetNotePermissions.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.GetNotePermissions.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.GetNotePermissions.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.noteId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.GetNotePermissions.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.GetNotePermissions.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof note.GetNotePermissions.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    if (!$util.isString(message.noteId))
                        return "noteId: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.GetNotePermissions.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.GetNotePermissions.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.note.GetNotePermissions.Request)
                    return object;
                var message = new $root.note.GetNotePermissions.Request();
                if (object.noteId != null)
                    message.noteId = String(object.noteId);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.GetNotePermissions.Request
             * @static
             * @param {note.GetNotePermissions.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.noteId = "";
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    object.noteId = message.noteId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof note.GetNotePermissions.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetNotePermissions.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof note.GetNotePermissions
             * @interface IResponse
             * @property {Array.<note.INotePermissionsItem>|null} [list] Response list
             * @property {number|null} [total] Response total
             */

            /**
             * Constructs a new Response.
             * @memberof note.GetNotePermissions
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {note.GetNotePermissions.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response list.
             * @member {Array.<note.INotePermissionsItem>} list
             * @memberof note.GetNotePermissions.Response
             * @instance
             */
            Response.prototype.list = $util.emptyArray;

            /**
             * Response total.
             * @member {number} total
             * @memberof note.GetNotePermissions.Response
             * @instance
             */
            Response.prototype.total = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof note.GetNotePermissions.Response
             * @static
             * @param {note.GetNotePermissions.IResponse=} [properties] Properties to set
             * @returns {note.GetNotePermissions.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link note.GetNotePermissions.Response.verify|verify} messages.
             * @function encode
             * @memberof note.GetNotePermissions.Response
             * @static
             * @param {note.GetNotePermissions.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.note.NotePermissionsItem.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.total);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link note.GetNotePermissions.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.GetNotePermissions.Response
             * @static
             * @param {note.GetNotePermissions.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof note.GetNotePermissions.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.GetNotePermissions.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.GetNotePermissions.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.note.NotePermissionsItem.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.GetNotePermissions.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.GetNotePermissions.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof note.GetNotePermissions.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.note.NotePermissionsItem.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total) && !(message.total && $util.isInteger(message.total.low) && $util.isInteger(message.total.high)))
                        return "total: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.GetNotePermissions.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.GetNotePermissions.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.note.GetNotePermissions.Response)
                    return object;
                var message = new $root.note.GetNotePermissions.Response();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".note.GetNotePermissions.Response.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".note.GetNotePermissions.Response.list: object expected");
                        message.list[i] = $root.note.NotePermissionsItem.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    if ($util.Long)
                        (message.total = $util.Long.fromValue(object.total)).unsigned = false;
                    else if (typeof object.total === "string")
                        message.total = parseInt(object.total, 10);
                    else if (typeof object.total === "number")
                        message.total = object.total;
                    else if (typeof object.total === "object")
                        message.total = new $util.LongBits(object.total.low >>> 0, object.total.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.GetNotePermissions.Response
             * @static
             * @param {note.GetNotePermissions.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.total = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.total = options.longs === String ? "0" : 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.note.NotePermissionsItem.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total === "number")
                        object.total = options.longs === String ? String(message.total) : message.total;
                    else
                        object.total = options.longs === String ? $util.Long.prototype.toString.call(message.total) : options.longs === Number ? new $util.LongBits(message.total.low >>> 0, message.total.high >>> 0).toNumber() : message.total;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof note.GetNotePermissions.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetNotePermissions;
    })();

    note.UpdateNotePermissions = (function() {

        /**
         * Properties of an UpdateNotePermissions.
         * @memberof note
         * @interface IUpdateNotePermissions
         */

        /**
         * Constructs a new UpdateNotePermissions.
         * @memberof note
         * @classdesc Represents an UpdateNotePermissions.
         * @implements IUpdateNotePermissions
         * @constructor
         * @param {note.IUpdateNotePermissions=} [properties] Properties to set
         */
        function UpdateNotePermissions(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateNotePermissions instance using the specified properties.
         * @function create
         * @memberof note.UpdateNotePermissions
         * @static
         * @param {note.IUpdateNotePermissions=} [properties] Properties to set
         * @returns {note.UpdateNotePermissions} UpdateNotePermissions instance
         */
        UpdateNotePermissions.create = function create(properties) {
            return new UpdateNotePermissions(properties);
        };

        /**
         * Encodes the specified UpdateNotePermissions message. Does not implicitly {@link note.UpdateNotePermissions.verify|verify} messages.
         * @function encode
         * @memberof note.UpdateNotePermissions
         * @static
         * @param {note.IUpdateNotePermissions} message UpdateNotePermissions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateNotePermissions.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified UpdateNotePermissions message, length delimited. Does not implicitly {@link note.UpdateNotePermissions.verify|verify} messages.
         * @function encodeDelimited
         * @memberof note.UpdateNotePermissions
         * @static
         * @param {note.IUpdateNotePermissions} message UpdateNotePermissions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateNotePermissions.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateNotePermissions message from the specified reader or buffer.
         * @function decode
         * @memberof note.UpdateNotePermissions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {note.UpdateNotePermissions} UpdateNotePermissions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateNotePermissions.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.UpdateNotePermissions();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateNotePermissions message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof note.UpdateNotePermissions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {note.UpdateNotePermissions} UpdateNotePermissions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateNotePermissions.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateNotePermissions message.
         * @function verify
         * @memberof note.UpdateNotePermissions
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateNotePermissions.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an UpdateNotePermissions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof note.UpdateNotePermissions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {note.UpdateNotePermissions} UpdateNotePermissions
         */
        UpdateNotePermissions.fromObject = function fromObject(object) {
            if (object instanceof $root.note.UpdateNotePermissions)
                return object;
            return new $root.note.UpdateNotePermissions();
        };

        /**
         * Creates a plain object from an UpdateNotePermissions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof note.UpdateNotePermissions
         * @static
         * @param {note.UpdateNotePermissions} message UpdateNotePermissions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateNotePermissions.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateNotePermissions to JSON.
         * @function toJSON
         * @memberof note.UpdateNotePermissions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateNotePermissions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        UpdateNotePermissions.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof note.UpdateNotePermissions
             * @interface IRequest
             * @property {string|null} [noteId] Request noteId
             * @property {string|null} [userId] Request userId
             * @property {number|null} [permission] Request permission
             */

            /**
             * Constructs a new Request.
             * @memberof note.UpdateNotePermissions
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {note.UpdateNotePermissions.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request noteId.
             * @member {string} noteId
             * @memberof note.UpdateNotePermissions.Request
             * @instance
             */
            Request.prototype.noteId = "";

            /**
             * Request userId.
             * @member {string} userId
             * @memberof note.UpdateNotePermissions.Request
             * @instance
             */
            Request.prototype.userId = "";

            /**
             * Request permission.
             * @member {number} permission
             * @memberof note.UpdateNotePermissions.Request
             * @instance
             */
            Request.prototype.permission = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof note.UpdateNotePermissions.Request
             * @static
             * @param {note.UpdateNotePermissions.IRequest=} [properties] Properties to set
             * @returns {note.UpdateNotePermissions.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link note.UpdateNotePermissions.Request.verify|verify} messages.
             * @function encode
             * @memberof note.UpdateNotePermissions.Request
             * @static
             * @param {note.UpdateNotePermissions.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.noteId != null && Object.hasOwnProperty.call(message, "noteId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.noteId);
                if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.userId);
                if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int64(message.permission);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link note.UpdateNotePermissions.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.UpdateNotePermissions.Request
             * @static
             * @param {note.UpdateNotePermissions.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof note.UpdateNotePermissions.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.UpdateNotePermissions.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.UpdateNotePermissions.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.noteId = reader.string();
                        break;
                    case 2:
                        message.userId = reader.string();
                        break;
                    case 3:
                        message.permission = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.UpdateNotePermissions.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.UpdateNotePermissions.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof note.UpdateNotePermissions.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    if (!$util.isString(message.noteId))
                        return "noteId: string expected";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    if (!$util.isString(message.userId))
                        return "userId: string expected";
                if (message.permission != null && message.hasOwnProperty("permission"))
                    if (!$util.isInteger(message.permission) && !(message.permission && $util.isInteger(message.permission.low) && $util.isInteger(message.permission.high)))
                        return "permission: integer|Long expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.UpdateNotePermissions.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.UpdateNotePermissions.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.note.UpdateNotePermissions.Request)
                    return object;
                var message = new $root.note.UpdateNotePermissions.Request();
                if (object.noteId != null)
                    message.noteId = String(object.noteId);
                if (object.userId != null)
                    message.userId = String(object.userId);
                if (object.permission != null)
                    if ($util.Long)
                        (message.permission = $util.Long.fromValue(object.permission)).unsigned = false;
                    else if (typeof object.permission === "string")
                        message.permission = parseInt(object.permission, 10);
                    else if (typeof object.permission === "number")
                        message.permission = object.permission;
                    else if (typeof object.permission === "object")
                        message.permission = new $util.LongBits(object.permission.low >>> 0, object.permission.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.UpdateNotePermissions.Request
             * @static
             * @param {note.UpdateNotePermissions.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.noteId = "";
                    object.userId = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.permission = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.permission = options.longs === String ? "0" : 0;
                }
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    object.noteId = message.noteId;
                if (message.userId != null && message.hasOwnProperty("userId"))
                    object.userId = message.userId;
                if (message.permission != null && message.hasOwnProperty("permission"))
                    if (typeof message.permission === "number")
                        object.permission = options.longs === String ? String(message.permission) : message.permission;
                    else
                        object.permission = options.longs === String ? $util.Long.prototype.toString.call(message.permission) : options.longs === Number ? new $util.LongBits(message.permission.low >>> 0, message.permission.high >>> 0).toNumber() : message.permission;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof note.UpdateNotePermissions.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        UpdateNotePermissions.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof note.UpdateNotePermissions
             * @interface IResponse
             */

            /**
             * Constructs a new Response.
             * @memberof note.UpdateNotePermissions
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {note.UpdateNotePermissions.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof note.UpdateNotePermissions.Response
             * @static
             * @param {note.UpdateNotePermissions.IResponse=} [properties] Properties to set
             * @returns {note.UpdateNotePermissions.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link note.UpdateNotePermissions.Response.verify|verify} messages.
             * @function encode
             * @memberof note.UpdateNotePermissions.Response
             * @static
             * @param {note.UpdateNotePermissions.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link note.UpdateNotePermissions.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof note.UpdateNotePermissions.Response
             * @static
             * @param {note.UpdateNotePermissions.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof note.UpdateNotePermissions.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {note.UpdateNotePermissions.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.note.UpdateNotePermissions.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof note.UpdateNotePermissions.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {note.UpdateNotePermissions.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof note.UpdateNotePermissions.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof note.UpdateNotePermissions.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {note.UpdateNotePermissions.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.note.UpdateNotePermissions.Response)
                    return object;
                return new $root.note.UpdateNotePermissions.Response();
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof note.UpdateNotePermissions.Response
             * @static
             * @param {note.UpdateNotePermissions.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof note.UpdateNotePermissions.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return UpdateNotePermissions;
    })();

    return note;
})();

$root.sync = (function() {

    /**
     * Namespace sync.
     * @exports sync
     * @namespace
     */
    var sync = {};

    sync.GetUrls = (function() {

        /**
         * Properties of a GetUrls.
         * @memberof sync
         * @interface IGetUrls
         */

        /**
         * Constructs a new GetUrls.
         * @memberof sync
         * @classdesc Represents a GetUrls.
         * @implements IGetUrls
         * @constructor
         * @param {sync.IGetUrls=} [properties] Properties to set
         */
        function GetUrls(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetUrls instance using the specified properties.
         * @function create
         * @memberof sync.GetUrls
         * @static
         * @param {sync.IGetUrls=} [properties] Properties to set
         * @returns {sync.GetUrls} GetUrls instance
         */
        GetUrls.create = function create(properties) {
            return new GetUrls(properties);
        };

        /**
         * Encodes the specified GetUrls message. Does not implicitly {@link sync.GetUrls.verify|verify} messages.
         * @function encode
         * @memberof sync.GetUrls
         * @static
         * @param {sync.IGetUrls} message GetUrls message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUrls.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetUrls message, length delimited. Does not implicitly {@link sync.GetUrls.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync.GetUrls
         * @static
         * @param {sync.IGetUrls} message GetUrls message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUrls.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetUrls message from the specified reader or buffer.
         * @function decode
         * @memberof sync.GetUrls
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync.GetUrls} GetUrls
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUrls.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetUrls();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetUrls message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync.GetUrls
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync.GetUrls} GetUrls
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUrls.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetUrls message.
         * @function verify
         * @memberof sync.GetUrls
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetUrls.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetUrls message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync.GetUrls
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync.GetUrls} GetUrls
         */
        GetUrls.fromObject = function fromObject(object) {
            if (object instanceof $root.sync.GetUrls)
                return object;
            return new $root.sync.GetUrls();
        };

        /**
         * Creates a plain object from a GetUrls message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync.GetUrls
         * @static
         * @param {sync.GetUrls} message GetUrls
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUrls.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetUrls to JSON.
         * @function toJSON
         * @memberof sync.GetUrls
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUrls.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetUrls.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof sync.GetUrls
             * @interface IRequest
             * @property {string|null} [noteId] Request noteId
             */

            /**
             * Constructs a new Request.
             * @memberof sync.GetUrls
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {sync.GetUrls.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request noteId.
             * @member {string} noteId
             * @memberof sync.GetUrls.Request
             * @instance
             */
            Request.prototype.noteId = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof sync.GetUrls.Request
             * @static
             * @param {sync.GetUrls.IRequest=} [properties] Properties to set
             * @returns {sync.GetUrls.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link sync.GetUrls.Request.verify|verify} messages.
             * @function encode
             * @memberof sync.GetUrls.Request
             * @static
             * @param {sync.GetUrls.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.noteId != null && Object.hasOwnProperty.call(message, "noteId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.noteId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link sync.GetUrls.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync.GetUrls.Request
             * @static
             * @param {sync.GetUrls.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof sync.GetUrls.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync.GetUrls.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetUrls.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.noteId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync.GetUrls.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync.GetUrls.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof sync.GetUrls.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    if (!$util.isString(message.noteId))
                        return "noteId: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync.GetUrls.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync.GetUrls.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.sync.GetUrls.Request)
                    return object;
                var message = new $root.sync.GetUrls.Request();
                if (object.noteId != null)
                    message.noteId = String(object.noteId);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync.GetUrls.Request
             * @static
             * @param {sync.GetUrls.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.noteId = "";
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    object.noteId = message.noteId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof sync.GetUrls.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetUrls.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof sync.GetUrls
             * @interface IResponse
             * @property {file.IUrls|null} [urls] Response urls
             */

            /**
             * Constructs a new Response.
             * @memberof sync.GetUrls
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {sync.GetUrls.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response urls.
             * @member {file.IUrls|null|undefined} urls
             * @memberof sync.GetUrls.Response
             * @instance
             */
            Response.prototype.urls = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof sync.GetUrls.Response
             * @static
             * @param {sync.GetUrls.IResponse=} [properties] Properties to set
             * @returns {sync.GetUrls.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link sync.GetUrls.Response.verify|verify} messages.
             * @function encode
             * @memberof sync.GetUrls.Response
             * @static
             * @param {sync.GetUrls.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.urls != null && Object.hasOwnProperty.call(message, "urls"))
                    $root.file.Urls.encode(message.urls, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link sync.GetUrls.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync.GetUrls.Response
             * @static
             * @param {sync.GetUrls.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof sync.GetUrls.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync.GetUrls.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetUrls.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.urls = $root.file.Urls.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync.GetUrls.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync.GetUrls.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof sync.GetUrls.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.urls != null && message.hasOwnProperty("urls")) {
                    var error = $root.file.Urls.verify(message.urls);
                    if (error)
                        return "urls." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync.GetUrls.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync.GetUrls.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.sync.GetUrls.Response)
                    return object;
                var message = new $root.sync.GetUrls.Response();
                if (object.urls != null) {
                    if (typeof object.urls !== "object")
                        throw TypeError(".sync.GetUrls.Response.urls: object expected");
                    message.urls = $root.file.Urls.fromObject(object.urls);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync.GetUrls.Response
             * @static
             * @param {sync.GetUrls.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.urls = null;
                if (message.urls != null && message.hasOwnProperty("urls"))
                    object.urls = $root.file.Urls.toObject(message.urls, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof sync.GetUrls.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetUrls;
    })();

    sync.GetFolderFiles = (function() {

        /**
         * Properties of a GetFolderFiles.
         * @memberof sync
         * @interface IGetFolderFiles
         */

        /**
         * Constructs a new GetFolderFiles.
         * @memberof sync
         * @classdesc Represents a GetFolderFiles.
         * @implements IGetFolderFiles
         * @constructor
         * @param {sync.IGetFolderFiles=} [properties] Properties to set
         */
        function GetFolderFiles(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetFolderFiles instance using the specified properties.
         * @function create
         * @memberof sync.GetFolderFiles
         * @static
         * @param {sync.IGetFolderFiles=} [properties] Properties to set
         * @returns {sync.GetFolderFiles} GetFolderFiles instance
         */
        GetFolderFiles.create = function create(properties) {
            return new GetFolderFiles(properties);
        };

        /**
         * Encodes the specified GetFolderFiles message. Does not implicitly {@link sync.GetFolderFiles.verify|verify} messages.
         * @function encode
         * @memberof sync.GetFolderFiles
         * @static
         * @param {sync.IGetFolderFiles} message GetFolderFiles message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetFolderFiles.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetFolderFiles message, length delimited. Does not implicitly {@link sync.GetFolderFiles.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync.GetFolderFiles
         * @static
         * @param {sync.IGetFolderFiles} message GetFolderFiles message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetFolderFiles.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetFolderFiles message from the specified reader or buffer.
         * @function decode
         * @memberof sync.GetFolderFiles
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync.GetFolderFiles} GetFolderFiles
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetFolderFiles.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetFolderFiles();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetFolderFiles message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync.GetFolderFiles
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync.GetFolderFiles} GetFolderFiles
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetFolderFiles.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetFolderFiles message.
         * @function verify
         * @memberof sync.GetFolderFiles
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetFolderFiles.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetFolderFiles message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync.GetFolderFiles
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync.GetFolderFiles} GetFolderFiles
         */
        GetFolderFiles.fromObject = function fromObject(object) {
            if (object instanceof $root.sync.GetFolderFiles)
                return object;
            return new $root.sync.GetFolderFiles();
        };

        /**
         * Creates a plain object from a GetFolderFiles message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync.GetFolderFiles
         * @static
         * @param {sync.GetFolderFiles} message GetFolderFiles
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetFolderFiles.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetFolderFiles to JSON.
         * @function toJSON
         * @memberof sync.GetFolderFiles
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetFolderFiles.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetFolderFiles.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof sync.GetFolderFiles
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof sync.GetFolderFiles
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {sync.GetFolderFiles.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof sync.GetFolderFiles.Request
             * @static
             * @param {sync.GetFolderFiles.IRequest=} [properties] Properties to set
             * @returns {sync.GetFolderFiles.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link sync.GetFolderFiles.Request.verify|verify} messages.
             * @function encode
             * @memberof sync.GetFolderFiles.Request
             * @static
             * @param {sync.GetFolderFiles.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link sync.GetFolderFiles.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync.GetFolderFiles.Request
             * @static
             * @param {sync.GetFolderFiles.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof sync.GetFolderFiles.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync.GetFolderFiles.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetFolderFiles.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync.GetFolderFiles.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync.GetFolderFiles.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof sync.GetFolderFiles.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync.GetFolderFiles.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync.GetFolderFiles.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.sync.GetFolderFiles.Request)
                    return object;
                return new $root.sync.GetFolderFiles.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync.GetFolderFiles.Request
             * @static
             * @param {sync.GetFolderFiles.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof sync.GetFolderFiles.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetFolderFiles.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof sync.GetFolderFiles
             * @interface IResponse
             * @property {Array.<file.IUrlsItem>|null} [list] Response list
             * @property {number|null} [total] Response total
             */

            /**
             * Constructs a new Response.
             * @memberof sync.GetFolderFiles
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {sync.GetFolderFiles.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response list.
             * @member {Array.<file.IUrlsItem>} list
             * @memberof sync.GetFolderFiles.Response
             * @instance
             */
            Response.prototype.list = $util.emptyArray;

            /**
             * Response total.
             * @member {number} total
             * @memberof sync.GetFolderFiles.Response
             * @instance
             */
            Response.prototype.total = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof sync.GetFolderFiles.Response
             * @static
             * @param {sync.GetFolderFiles.IResponse=} [properties] Properties to set
             * @returns {sync.GetFolderFiles.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link sync.GetFolderFiles.Response.verify|verify} messages.
             * @function encode
             * @memberof sync.GetFolderFiles.Response
             * @static
             * @param {sync.GetFolderFiles.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.file.UrlsItem.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.total);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link sync.GetFolderFiles.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync.GetFolderFiles.Response
             * @static
             * @param {sync.GetFolderFiles.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof sync.GetFolderFiles.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync.GetFolderFiles.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetFolderFiles.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.file.UrlsItem.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync.GetFolderFiles.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync.GetFolderFiles.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof sync.GetFolderFiles.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.file.UrlsItem.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total) && !(message.total && $util.isInteger(message.total.low) && $util.isInteger(message.total.high)))
                        return "total: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync.GetFolderFiles.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync.GetFolderFiles.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.sync.GetFolderFiles.Response)
                    return object;
                var message = new $root.sync.GetFolderFiles.Response();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".sync.GetFolderFiles.Response.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".sync.GetFolderFiles.Response.list: object expected");
                        message.list[i] = $root.file.UrlsItem.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    if ($util.Long)
                        (message.total = $util.Long.fromValue(object.total)).unsigned = false;
                    else if (typeof object.total === "string")
                        message.total = parseInt(object.total, 10);
                    else if (typeof object.total === "number")
                        message.total = object.total;
                    else if (typeof object.total === "object")
                        message.total = new $util.LongBits(object.total.low >>> 0, object.total.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync.GetFolderFiles.Response
             * @static
             * @param {sync.GetFolderFiles.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.total = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.total = options.longs === String ? "0" : 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.file.UrlsItem.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total === "number")
                        object.total = options.longs === String ? String(message.total) : message.total;
                    else
                        object.total = options.longs === String ? $util.Long.prototype.toString.call(message.total) : options.longs === Number ? new $util.LongBits(message.total.low >>> 0, message.total.high >>> 0).toNumber() : message.total;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof sync.GetFolderFiles.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetFolderFiles;
    })();

    sync.GetHistoricalVersionNote = (function() {

        /**
         * Properties of a GetHistoricalVersionNote.
         * @memberof sync
         * @interface IGetHistoricalVersionNote
         */

        /**
         * Constructs a new GetHistoricalVersionNote.
         * @memberof sync
         * @classdesc Represents a GetHistoricalVersionNote.
         * @implements IGetHistoricalVersionNote
         * @constructor
         * @param {sync.IGetHistoricalVersionNote=} [properties] Properties to set
         */
        function GetHistoricalVersionNote(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetHistoricalVersionNote instance using the specified properties.
         * @function create
         * @memberof sync.GetHistoricalVersionNote
         * @static
         * @param {sync.IGetHistoricalVersionNote=} [properties] Properties to set
         * @returns {sync.GetHistoricalVersionNote} GetHistoricalVersionNote instance
         */
        GetHistoricalVersionNote.create = function create(properties) {
            return new GetHistoricalVersionNote(properties);
        };

        /**
         * Encodes the specified GetHistoricalVersionNote message. Does not implicitly {@link sync.GetHistoricalVersionNote.verify|verify} messages.
         * @function encode
         * @memberof sync.GetHistoricalVersionNote
         * @static
         * @param {sync.IGetHistoricalVersionNote} message GetHistoricalVersionNote message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetHistoricalVersionNote.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetHistoricalVersionNote message, length delimited. Does not implicitly {@link sync.GetHistoricalVersionNote.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync.GetHistoricalVersionNote
         * @static
         * @param {sync.IGetHistoricalVersionNote} message GetHistoricalVersionNote message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetHistoricalVersionNote.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetHistoricalVersionNote message from the specified reader or buffer.
         * @function decode
         * @memberof sync.GetHistoricalVersionNote
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync.GetHistoricalVersionNote} GetHistoricalVersionNote
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetHistoricalVersionNote.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetHistoricalVersionNote();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetHistoricalVersionNote message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync.GetHistoricalVersionNote
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync.GetHistoricalVersionNote} GetHistoricalVersionNote
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetHistoricalVersionNote.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetHistoricalVersionNote message.
         * @function verify
         * @memberof sync.GetHistoricalVersionNote
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetHistoricalVersionNote.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetHistoricalVersionNote message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync.GetHistoricalVersionNote
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync.GetHistoricalVersionNote} GetHistoricalVersionNote
         */
        GetHistoricalVersionNote.fromObject = function fromObject(object) {
            if (object instanceof $root.sync.GetHistoricalVersionNote)
                return object;
            return new $root.sync.GetHistoricalVersionNote();
        };

        /**
         * Creates a plain object from a GetHistoricalVersionNote message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync.GetHistoricalVersionNote
         * @static
         * @param {sync.GetHistoricalVersionNote} message GetHistoricalVersionNote
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetHistoricalVersionNote.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetHistoricalVersionNote to JSON.
         * @function toJSON
         * @memberof sync.GetHistoricalVersionNote
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetHistoricalVersionNote.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetHistoricalVersionNote.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof sync.GetHistoricalVersionNote
             * @interface IRequest
             * @property {string|null} [versionId] Request versionId
             * @property {string|null} [noteId] Request noteId
             * @property {string|null} [categoryId] Request categoryId
             * @property {string|null} [pageId] Request pageId
             */

            /**
             * Constructs a new Request.
             * @memberof sync.GetHistoricalVersionNote
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {sync.GetHistoricalVersionNote.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request versionId.
             * @member {string} versionId
             * @memberof sync.GetHistoricalVersionNote.Request
             * @instance
             */
            Request.prototype.versionId = "";

            /**
             * Request noteId.
             * @member {string} noteId
             * @memberof sync.GetHistoricalVersionNote.Request
             * @instance
             */
            Request.prototype.noteId = "";

            /**
             * Request categoryId.
             * @member {string} categoryId
             * @memberof sync.GetHistoricalVersionNote.Request
             * @instance
             */
            Request.prototype.categoryId = "";

            /**
             * Request pageId.
             * @member {string} pageId
             * @memberof sync.GetHistoricalVersionNote.Request
             * @instance
             */
            Request.prototype.pageId = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof sync.GetHistoricalVersionNote.Request
             * @static
             * @param {sync.GetHistoricalVersionNote.IRequest=} [properties] Properties to set
             * @returns {sync.GetHistoricalVersionNote.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link sync.GetHistoricalVersionNote.Request.verify|verify} messages.
             * @function encode
             * @memberof sync.GetHistoricalVersionNote.Request
             * @static
             * @param {sync.GetHistoricalVersionNote.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.versionId != null && Object.hasOwnProperty.call(message, "versionId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.versionId);
                if (message.noteId != null && Object.hasOwnProperty.call(message, "noteId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.noteId);
                if (message.categoryId != null && Object.hasOwnProperty.call(message, "categoryId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.categoryId);
                if (message.pageId != null && Object.hasOwnProperty.call(message, "pageId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link sync.GetHistoricalVersionNote.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync.GetHistoricalVersionNote.Request
             * @static
             * @param {sync.GetHistoricalVersionNote.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof sync.GetHistoricalVersionNote.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync.GetHistoricalVersionNote.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetHistoricalVersionNote.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.versionId = reader.string();
                        break;
                    case 2:
                        message.noteId = reader.string();
                        break;
                    case 3:
                        message.categoryId = reader.string();
                        break;
                    case 4:
                        message.pageId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync.GetHistoricalVersionNote.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync.GetHistoricalVersionNote.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof sync.GetHistoricalVersionNote.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.versionId != null && message.hasOwnProperty("versionId"))
                    if (!$util.isString(message.versionId))
                        return "versionId: string expected";
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    if (!$util.isString(message.noteId))
                        return "noteId: string expected";
                if (message.categoryId != null && message.hasOwnProperty("categoryId"))
                    if (!$util.isString(message.categoryId))
                        return "categoryId: string expected";
                if (message.pageId != null && message.hasOwnProperty("pageId"))
                    if (!$util.isString(message.pageId))
                        return "pageId: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync.GetHistoricalVersionNote.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync.GetHistoricalVersionNote.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.sync.GetHistoricalVersionNote.Request)
                    return object;
                var message = new $root.sync.GetHistoricalVersionNote.Request();
                if (object.versionId != null)
                    message.versionId = String(object.versionId);
                if (object.noteId != null)
                    message.noteId = String(object.noteId);
                if (object.categoryId != null)
                    message.categoryId = String(object.categoryId);
                if (object.pageId != null)
                    message.pageId = String(object.pageId);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync.GetHistoricalVersionNote.Request
             * @static
             * @param {sync.GetHistoricalVersionNote.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.versionId = "";
                    object.noteId = "";
                    object.categoryId = "";
                    object.pageId = "";
                }
                if (message.versionId != null && message.hasOwnProperty("versionId"))
                    object.versionId = message.versionId;
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    object.noteId = message.noteId;
                if (message.categoryId != null && message.hasOwnProperty("categoryId"))
                    object.categoryId = message.categoryId;
                if (message.pageId != null && message.hasOwnProperty("pageId"))
                    object.pageId = message.pageId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof sync.GetHistoricalVersionNote.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetHistoricalVersionNote.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof sync.GetHistoricalVersionNote
             * @interface IResponse
             * @property {note.INoteItem|null} [note] Response note
             * @property {note.ICategoryItem|null} [category] Response category
             * @property {note.IPageItem|null} [page] Response page
             */

            /**
             * Constructs a new Response.
             * @memberof sync.GetHistoricalVersionNote
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {sync.GetHistoricalVersionNote.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response note.
             * @member {note.INoteItem|null|undefined} note
             * @memberof sync.GetHistoricalVersionNote.Response
             * @instance
             */
            Response.prototype.note = null;

            /**
             * Response category.
             * @member {note.ICategoryItem|null|undefined} category
             * @memberof sync.GetHistoricalVersionNote.Response
             * @instance
             */
            Response.prototype.category = null;

            /**
             * Response page.
             * @member {note.IPageItem|null|undefined} page
             * @memberof sync.GetHistoricalVersionNote.Response
             * @instance
             */
            Response.prototype.page = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof sync.GetHistoricalVersionNote.Response
             * @static
             * @param {sync.GetHistoricalVersionNote.IResponse=} [properties] Properties to set
             * @returns {sync.GetHistoricalVersionNote.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link sync.GetHistoricalVersionNote.Response.verify|verify} messages.
             * @function encode
             * @memberof sync.GetHistoricalVersionNote.Response
             * @static
             * @param {sync.GetHistoricalVersionNote.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                    $root.note.NoteItem.encode(message.note, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                    $root.note.CategoryItem.encode(message.category, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.page != null && Object.hasOwnProperty.call(message, "page"))
                    $root.note.PageItem.encode(message.page, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link sync.GetHistoricalVersionNote.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync.GetHistoricalVersionNote.Response
             * @static
             * @param {sync.GetHistoricalVersionNote.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof sync.GetHistoricalVersionNote.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync.GetHistoricalVersionNote.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetHistoricalVersionNote.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.note = $root.note.NoteItem.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.category = $root.note.CategoryItem.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.page = $root.note.PageItem.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync.GetHistoricalVersionNote.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync.GetHistoricalVersionNote.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof sync.GetHistoricalVersionNote.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.note != null && message.hasOwnProperty("note")) {
                    var error = $root.note.NoteItem.verify(message.note);
                    if (error)
                        return "note." + error;
                }
                if (message.category != null && message.hasOwnProperty("category")) {
                    var error = $root.note.CategoryItem.verify(message.category);
                    if (error)
                        return "category." + error;
                }
                if (message.page != null && message.hasOwnProperty("page")) {
                    var error = $root.note.PageItem.verify(message.page);
                    if (error)
                        return "page." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync.GetHistoricalVersionNote.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync.GetHistoricalVersionNote.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.sync.GetHistoricalVersionNote.Response)
                    return object;
                var message = new $root.sync.GetHistoricalVersionNote.Response();
                if (object.note != null) {
                    if (typeof object.note !== "object")
                        throw TypeError(".sync.GetHistoricalVersionNote.Response.note: object expected");
                    message.note = $root.note.NoteItem.fromObject(object.note);
                }
                if (object.category != null) {
                    if (typeof object.category !== "object")
                        throw TypeError(".sync.GetHistoricalVersionNote.Response.category: object expected");
                    message.category = $root.note.CategoryItem.fromObject(object.category);
                }
                if (object.page != null) {
                    if (typeof object.page !== "object")
                        throw TypeError(".sync.GetHistoricalVersionNote.Response.page: object expected");
                    message.page = $root.note.PageItem.fromObject(object.page);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync.GetHistoricalVersionNote.Response
             * @static
             * @param {sync.GetHistoricalVersionNote.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.note = null;
                    object.category = null;
                    object.page = null;
                }
                if (message.note != null && message.hasOwnProperty("note"))
                    object.note = $root.note.NoteItem.toObject(message.note, options);
                if (message.category != null && message.hasOwnProperty("category"))
                    object.category = $root.note.CategoryItem.toObject(message.category, options);
                if (message.page != null && message.hasOwnProperty("page"))
                    object.page = $root.note.PageItem.toObject(message.page, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof sync.GetHistoricalVersionNote.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetHistoricalVersionNote;
    })();

    sync.GetHistoricalVersionNoteUrls = (function() {

        /**
         * Properties of a GetHistoricalVersionNoteUrls.
         * @memberof sync
         * @interface IGetHistoricalVersionNoteUrls
         */

        /**
         * Constructs a new GetHistoricalVersionNoteUrls.
         * @memberof sync
         * @classdesc Represents a GetHistoricalVersionNoteUrls.
         * @implements IGetHistoricalVersionNoteUrls
         * @constructor
         * @param {sync.IGetHistoricalVersionNoteUrls=} [properties] Properties to set
         */
        function GetHistoricalVersionNoteUrls(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetHistoricalVersionNoteUrls instance using the specified properties.
         * @function create
         * @memberof sync.GetHistoricalVersionNoteUrls
         * @static
         * @param {sync.IGetHistoricalVersionNoteUrls=} [properties] Properties to set
         * @returns {sync.GetHistoricalVersionNoteUrls} GetHistoricalVersionNoteUrls instance
         */
        GetHistoricalVersionNoteUrls.create = function create(properties) {
            return new GetHistoricalVersionNoteUrls(properties);
        };

        /**
         * Encodes the specified GetHistoricalVersionNoteUrls message. Does not implicitly {@link sync.GetHistoricalVersionNoteUrls.verify|verify} messages.
         * @function encode
         * @memberof sync.GetHistoricalVersionNoteUrls
         * @static
         * @param {sync.IGetHistoricalVersionNoteUrls} message GetHistoricalVersionNoteUrls message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetHistoricalVersionNoteUrls.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetHistoricalVersionNoteUrls message, length delimited. Does not implicitly {@link sync.GetHistoricalVersionNoteUrls.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync.GetHistoricalVersionNoteUrls
         * @static
         * @param {sync.IGetHistoricalVersionNoteUrls} message GetHistoricalVersionNoteUrls message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetHistoricalVersionNoteUrls.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetHistoricalVersionNoteUrls message from the specified reader or buffer.
         * @function decode
         * @memberof sync.GetHistoricalVersionNoteUrls
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync.GetHistoricalVersionNoteUrls} GetHistoricalVersionNoteUrls
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetHistoricalVersionNoteUrls.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetHistoricalVersionNoteUrls();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetHistoricalVersionNoteUrls message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync.GetHistoricalVersionNoteUrls
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync.GetHistoricalVersionNoteUrls} GetHistoricalVersionNoteUrls
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetHistoricalVersionNoteUrls.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetHistoricalVersionNoteUrls message.
         * @function verify
         * @memberof sync.GetHistoricalVersionNoteUrls
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetHistoricalVersionNoteUrls.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetHistoricalVersionNoteUrls message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync.GetHistoricalVersionNoteUrls
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync.GetHistoricalVersionNoteUrls} GetHistoricalVersionNoteUrls
         */
        GetHistoricalVersionNoteUrls.fromObject = function fromObject(object) {
            if (object instanceof $root.sync.GetHistoricalVersionNoteUrls)
                return object;
            return new $root.sync.GetHistoricalVersionNoteUrls();
        };

        /**
         * Creates a plain object from a GetHistoricalVersionNoteUrls message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync.GetHistoricalVersionNoteUrls
         * @static
         * @param {sync.GetHistoricalVersionNoteUrls} message GetHistoricalVersionNoteUrls
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetHistoricalVersionNoteUrls.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetHistoricalVersionNoteUrls to JSON.
         * @function toJSON
         * @memberof sync.GetHistoricalVersionNoteUrls
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetHistoricalVersionNoteUrls.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetHistoricalVersionNoteUrls.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof sync.GetHistoricalVersionNoteUrls
             * @interface IRequest
             * @property {string|null} [noteId] Request noteId
             * @property {string|null} [categoryId] Request categoryId
             * @property {string|null} [pageId] Request pageId
             * @property {number|null} [pageNum] Request pageNum
             * @property {number|null} [pageSize] Request pageSize
             * @property {Array.<number>|null} [timeLimit] Request timeLimit
             */

            /**
             * Constructs a new Request.
             * @memberof sync.GetHistoricalVersionNoteUrls
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {sync.GetHistoricalVersionNoteUrls.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.timeLimit = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request noteId.
             * @member {string} noteId
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @instance
             */
            Request.prototype.noteId = "";

            /**
             * Request categoryId.
             * @member {string} categoryId
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @instance
             */
            Request.prototype.categoryId = "";

            /**
             * Request pageId.
             * @member {string} pageId
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @instance
             */
            Request.prototype.pageId = "";

            /**
             * Request pageNum.
             * @member {number} pageNum
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @instance
             */
            Request.prototype.pageNum = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Request pageSize.
             * @member {number} pageSize
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @instance
             */
            Request.prototype.pageSize = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Request timeLimit.
             * @member {Array.<number>} timeLimit
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @instance
             */
            Request.prototype.timeLimit = $util.emptyArray;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @static
             * @param {sync.GetHistoricalVersionNoteUrls.IRequest=} [properties] Properties to set
             * @returns {sync.GetHistoricalVersionNoteUrls.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link sync.GetHistoricalVersionNoteUrls.Request.verify|verify} messages.
             * @function encode
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @static
             * @param {sync.GetHistoricalVersionNoteUrls.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.noteId != null && Object.hasOwnProperty.call(message, "noteId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.noteId);
                if (message.pageNum != null && Object.hasOwnProperty.call(message, "pageNum"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.pageNum);
                if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int64(message.pageSize);
                if (message.timeLimit != null && message.timeLimit.length) {
                    writer.uint32(/* id 4, wireType 2 =*/34).fork();
                    for (var i = 0; i < message.timeLimit.length; ++i)
                        writer.int64(message.timeLimit[i]);
                    writer.ldelim();
                }
                if (message.categoryId != null && Object.hasOwnProperty.call(message, "categoryId"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.categoryId);
                if (message.pageId != null && Object.hasOwnProperty.call(message, "pageId"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.pageId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link sync.GetHistoricalVersionNoteUrls.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @static
             * @param {sync.GetHistoricalVersionNoteUrls.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync.GetHistoricalVersionNoteUrls.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetHistoricalVersionNoteUrls.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.noteId = reader.string();
                        break;
                    case 5:
                        message.categoryId = reader.string();
                        break;
                    case 6:
                        message.pageId = reader.string();
                        break;
                    case 2:
                        message.pageNum = reader.int64();
                        break;
                    case 3:
                        message.pageSize = reader.int64();
                        break;
                    case 4:
                        if (!(message.timeLimit && message.timeLimit.length))
                            message.timeLimit = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.timeLimit.push(reader.int64());
                        } else
                            message.timeLimit.push(reader.int64());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync.GetHistoricalVersionNoteUrls.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    if (!$util.isString(message.noteId))
                        return "noteId: string expected";
                if (message.categoryId != null && message.hasOwnProperty("categoryId"))
                    if (!$util.isString(message.categoryId))
                        return "categoryId: string expected";
                if (message.pageId != null && message.hasOwnProperty("pageId"))
                    if (!$util.isString(message.pageId))
                        return "pageId: string expected";
                if (message.pageNum != null && message.hasOwnProperty("pageNum"))
                    if (!$util.isInteger(message.pageNum) && !(message.pageNum && $util.isInteger(message.pageNum.low) && $util.isInteger(message.pageNum.high)))
                        return "pageNum: integer|Long expected";
                if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                    if (!$util.isInteger(message.pageSize) && !(message.pageSize && $util.isInteger(message.pageSize.low) && $util.isInteger(message.pageSize.high)))
                        return "pageSize: integer|Long expected";
                if (message.timeLimit != null && message.hasOwnProperty("timeLimit")) {
                    if (!Array.isArray(message.timeLimit))
                        return "timeLimit: array expected";
                    for (var i = 0; i < message.timeLimit.length; ++i)
                        if (!$util.isInteger(message.timeLimit[i]) && !(message.timeLimit[i] && $util.isInteger(message.timeLimit[i].low) && $util.isInteger(message.timeLimit[i].high)))
                            return "timeLimit: integer|Long[] expected";
                }
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync.GetHistoricalVersionNoteUrls.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.sync.GetHistoricalVersionNoteUrls.Request)
                    return object;
                var message = new $root.sync.GetHistoricalVersionNoteUrls.Request();
                if (object.noteId != null)
                    message.noteId = String(object.noteId);
                if (object.categoryId != null)
                    message.categoryId = String(object.categoryId);
                if (object.pageId != null)
                    message.pageId = String(object.pageId);
                if (object.pageNum != null)
                    if ($util.Long)
                        (message.pageNum = $util.Long.fromValue(object.pageNum)).unsigned = false;
                    else if (typeof object.pageNum === "string")
                        message.pageNum = parseInt(object.pageNum, 10);
                    else if (typeof object.pageNum === "number")
                        message.pageNum = object.pageNum;
                    else if (typeof object.pageNum === "object")
                        message.pageNum = new $util.LongBits(object.pageNum.low >>> 0, object.pageNum.high >>> 0).toNumber();
                if (object.pageSize != null)
                    if ($util.Long)
                        (message.pageSize = $util.Long.fromValue(object.pageSize)).unsigned = false;
                    else if (typeof object.pageSize === "string")
                        message.pageSize = parseInt(object.pageSize, 10);
                    else if (typeof object.pageSize === "number")
                        message.pageSize = object.pageSize;
                    else if (typeof object.pageSize === "object")
                        message.pageSize = new $util.LongBits(object.pageSize.low >>> 0, object.pageSize.high >>> 0).toNumber();
                if (object.timeLimit) {
                    if (!Array.isArray(object.timeLimit))
                        throw TypeError(".sync.GetHistoricalVersionNoteUrls.Request.timeLimit: array expected");
                    message.timeLimit = [];
                    for (var i = 0; i < object.timeLimit.length; ++i)
                        if ($util.Long)
                            (message.timeLimit[i] = $util.Long.fromValue(object.timeLimit[i])).unsigned = false;
                        else if (typeof object.timeLimit[i] === "string")
                            message.timeLimit[i] = parseInt(object.timeLimit[i], 10);
                        else if (typeof object.timeLimit[i] === "number")
                            message.timeLimit[i] = object.timeLimit[i];
                        else if (typeof object.timeLimit[i] === "object")
                            message.timeLimit[i] = new $util.LongBits(object.timeLimit[i].low >>> 0, object.timeLimit[i].high >>> 0).toNumber();
                }
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @static
             * @param {sync.GetHistoricalVersionNoteUrls.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.timeLimit = [];
                if (options.defaults) {
                    object.noteId = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.pageNum = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.pageNum = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.pageSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.pageSize = options.longs === String ? "0" : 0;
                    object.categoryId = "";
                    object.pageId = "";
                }
                if (message.noteId != null && message.hasOwnProperty("noteId"))
                    object.noteId = message.noteId;
                if (message.pageNum != null && message.hasOwnProperty("pageNum"))
                    if (typeof message.pageNum === "number")
                        object.pageNum = options.longs === String ? String(message.pageNum) : message.pageNum;
                    else
                        object.pageNum = options.longs === String ? $util.Long.prototype.toString.call(message.pageNum) : options.longs === Number ? new $util.LongBits(message.pageNum.low >>> 0, message.pageNum.high >>> 0).toNumber() : message.pageNum;
                if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                    if (typeof message.pageSize === "number")
                        object.pageSize = options.longs === String ? String(message.pageSize) : message.pageSize;
                    else
                        object.pageSize = options.longs === String ? $util.Long.prototype.toString.call(message.pageSize) : options.longs === Number ? new $util.LongBits(message.pageSize.low >>> 0, message.pageSize.high >>> 0).toNumber() : message.pageSize;
                if (message.timeLimit && message.timeLimit.length) {
                    object.timeLimit = [];
                    for (var j = 0; j < message.timeLimit.length; ++j)
                        if (typeof message.timeLimit[j] === "number")
                            object.timeLimit[j] = options.longs === String ? String(message.timeLimit[j]) : message.timeLimit[j];
                        else
                            object.timeLimit[j] = options.longs === String ? $util.Long.prototype.toString.call(message.timeLimit[j]) : options.longs === Number ? new $util.LongBits(message.timeLimit[j].low >>> 0, message.timeLimit[j].high >>> 0).toNumber() : message.timeLimit[j];
                }
                if (message.categoryId != null && message.hasOwnProperty("categoryId"))
                    object.categoryId = message.categoryId;
                if (message.pageId != null && message.hasOwnProperty("pageId"))
                    object.pageId = message.pageId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof sync.GetHistoricalVersionNoteUrls.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetHistoricalVersionNoteUrls.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof sync.GetHistoricalVersionNoteUrls
             * @interface IResponse
             * @property {Array.<sync.GetHistoricalVersionNoteUrls.Response.IStaticFileUrlsItem>|null} [list] Response list
             * @property {number|null} [total] Response total
             */

            /**
             * Constructs a new Response.
             * @memberof sync.GetHistoricalVersionNoteUrls
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {sync.GetHistoricalVersionNoteUrls.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response list.
             * @member {Array.<sync.GetHistoricalVersionNoteUrls.Response.IStaticFileUrlsItem>} list
             * @memberof sync.GetHistoricalVersionNoteUrls.Response
             * @instance
             */
            Response.prototype.list = $util.emptyArray;

            /**
             * Response total.
             * @member {number} total
             * @memberof sync.GetHistoricalVersionNoteUrls.Response
             * @instance
             */
            Response.prototype.total = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof sync.GetHistoricalVersionNoteUrls.Response
             * @static
             * @param {sync.GetHistoricalVersionNoteUrls.IResponse=} [properties] Properties to set
             * @returns {sync.GetHistoricalVersionNoteUrls.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link sync.GetHistoricalVersionNoteUrls.Response.verify|verify} messages.
             * @function encode
             * @memberof sync.GetHistoricalVersionNoteUrls.Response
             * @static
             * @param {sync.GetHistoricalVersionNoteUrls.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.total);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link sync.GetHistoricalVersionNoteUrls.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync.GetHistoricalVersionNoteUrls.Response
             * @static
             * @param {sync.GetHistoricalVersionNoteUrls.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof sync.GetHistoricalVersionNoteUrls.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync.GetHistoricalVersionNoteUrls.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetHistoricalVersionNoteUrls.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync.GetHistoricalVersionNoteUrls.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync.GetHistoricalVersionNoteUrls.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof sync.GetHistoricalVersionNoteUrls.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total) && !(message.total && $util.isInteger(message.total.low) && $util.isInteger(message.total.high)))
                        return "total: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync.GetHistoricalVersionNoteUrls.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync.GetHistoricalVersionNoteUrls.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.sync.GetHistoricalVersionNoteUrls.Response)
                    return object;
                var message = new $root.sync.GetHistoricalVersionNoteUrls.Response();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".sync.GetHistoricalVersionNoteUrls.Response.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".sync.GetHistoricalVersionNoteUrls.Response.list: object expected");
                        message.list[i] = $root.sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    if ($util.Long)
                        (message.total = $util.Long.fromValue(object.total)).unsigned = false;
                    else if (typeof object.total === "string")
                        message.total = parseInt(object.total, 10);
                    else if (typeof object.total === "number")
                        message.total = object.total;
                    else if (typeof object.total === "object")
                        message.total = new $util.LongBits(object.total.low >>> 0, object.total.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync.GetHistoricalVersionNoteUrls.Response
             * @static
             * @param {sync.GetHistoricalVersionNoteUrls.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.total = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.total = options.longs === String ? "0" : 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total === "number")
                        object.total = options.longs === String ? String(message.total) : message.total;
                    else
                        object.total = options.longs === String ? $util.Long.prototype.toString.call(message.total) : options.longs === Number ? new $util.LongBits(message.total.low >>> 0, message.total.high >>> 0).toNumber() : message.total;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof sync.GetHistoricalVersionNoteUrls.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            Response.StaticFileUrlsItem = (function() {

                /**
                 * Properties of a StaticFileUrlsItem.
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response
                 * @interface IStaticFileUrlsItem
                 * @property {file.IUrls|null} [urls] StaticFileUrlsItem urls
                 * @property {string|null} [id] StaticFileUrlsItem id
                 * @property {file.IFileInfo|null} [fileInfo] StaticFileUrlsItem fileInfo
                 * @property {number|null} [createTime] StaticFileUrlsItem createTime
                 * @property {number|null} [lastUpdateTime] StaticFileUrlsItem lastUpdateTime
                 * @property {user.IBaseUserInfo|null} [uploadUser] StaticFileUrlsItem uploadUser
                 * @property {Array.<string>|null} [ids] StaticFileUrlsItem ids
                 */

                /**
                 * Constructs a new StaticFileUrlsItem.
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response
                 * @classdesc Represents a StaticFileUrlsItem.
                 * @implements IStaticFileUrlsItem
                 * @constructor
                 * @param {sync.GetHistoricalVersionNoteUrls.Response.IStaticFileUrlsItem=} [properties] Properties to set
                 */
                function StaticFileUrlsItem(properties) {
                    this.ids = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StaticFileUrlsItem urls.
                 * @member {file.IUrls|null|undefined} urls
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @instance
                 */
                StaticFileUrlsItem.prototype.urls = null;

                /**
                 * StaticFileUrlsItem id.
                 * @member {string} id
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @instance
                 */
                StaticFileUrlsItem.prototype.id = "";

                /**
                 * StaticFileUrlsItem fileInfo.
                 * @member {file.IFileInfo|null|undefined} fileInfo
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @instance
                 */
                StaticFileUrlsItem.prototype.fileInfo = null;

                /**
                 * StaticFileUrlsItem createTime.
                 * @member {number} createTime
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @instance
                 */
                StaticFileUrlsItem.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * StaticFileUrlsItem lastUpdateTime.
                 * @member {number} lastUpdateTime
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @instance
                 */
                StaticFileUrlsItem.prototype.lastUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * StaticFileUrlsItem uploadUser.
                 * @member {user.IBaseUserInfo|null|undefined} uploadUser
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @instance
                 */
                StaticFileUrlsItem.prototype.uploadUser = null;

                /**
                 * StaticFileUrlsItem ids.
                 * @member {Array.<string>} ids
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @instance
                 */
                StaticFileUrlsItem.prototype.ids = $util.emptyArray;

                /**
                 * Creates a new StaticFileUrlsItem instance using the specified properties.
                 * @function create
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @static
                 * @param {sync.GetHistoricalVersionNoteUrls.Response.IStaticFileUrlsItem=} [properties] Properties to set
                 * @returns {sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem} StaticFileUrlsItem instance
                 */
                StaticFileUrlsItem.create = function create(properties) {
                    return new StaticFileUrlsItem(properties);
                };

                /**
                 * Encodes the specified StaticFileUrlsItem message. Does not implicitly {@link sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem.verify|verify} messages.
                 * @function encode
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @static
                 * @param {sync.GetHistoricalVersionNoteUrls.Response.IStaticFileUrlsItem} message StaticFileUrlsItem message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaticFileUrlsItem.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.urls != null && Object.hasOwnProperty.call(message, "urls"))
                        $root.file.Urls.encode(message.urls, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.id);
                    if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.createTime);
                    if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.lastUpdateTime);
                    if (message.uploadUser != null && Object.hasOwnProperty.call(message, "uploadUser"))
                        $root.user.BaseUserInfo.encode(message.uploadUser, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.fileInfo != null && Object.hasOwnProperty.call(message, "fileInfo"))
                        $root.file.FileInfo.encode(message.fileInfo, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.ids != null && message.ids.length)
                        for (var i = 0; i < message.ids.length; ++i)
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.ids[i]);
                    return writer;
                };

                /**
                 * Encodes the specified StaticFileUrlsItem message, length delimited. Does not implicitly {@link sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @static
                 * @param {sync.GetHistoricalVersionNoteUrls.Response.IStaticFileUrlsItem} message StaticFileUrlsItem message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaticFileUrlsItem.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StaticFileUrlsItem message from the specified reader or buffer.
                 * @function decode
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem} StaticFileUrlsItem
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaticFileUrlsItem.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.urls = $root.file.Urls.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.id = reader.string();
                            break;
                        case 6:
                            message.fileInfo = $root.file.FileInfo.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.createTime = reader.int64();
                            break;
                        case 4:
                            message.lastUpdateTime = reader.int64();
                            break;
                        case 5:
                            message.uploadUser = $root.user.BaseUserInfo.decode(reader, reader.uint32());
                            break;
                        case 7:
                            if (!(message.ids && message.ids.length))
                                message.ids = [];
                            message.ids.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StaticFileUrlsItem message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem} StaticFileUrlsItem
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaticFileUrlsItem.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StaticFileUrlsItem message.
                 * @function verify
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StaticFileUrlsItem.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.urls != null && message.hasOwnProperty("urls")) {
                        var error = $root.file.Urls.verify(message.urls);
                        if (error)
                            return "urls." + error;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.fileInfo != null && message.hasOwnProperty("fileInfo")) {
                        var error = $root.file.FileInfo.verify(message.fileInfo);
                        if (error)
                            return "fileInfo." + error;
                    }
                    if (message.createTime != null && message.hasOwnProperty("createTime"))
                        if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                            return "createTime: integer|Long expected";
                    if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                        if (!$util.isInteger(message.lastUpdateTime) && !(message.lastUpdateTime && $util.isInteger(message.lastUpdateTime.low) && $util.isInteger(message.lastUpdateTime.high)))
                            return "lastUpdateTime: integer|Long expected";
                    if (message.uploadUser != null && message.hasOwnProperty("uploadUser")) {
                        var error = $root.user.BaseUserInfo.verify(message.uploadUser);
                        if (error)
                            return "uploadUser." + error;
                    }
                    if (message.ids != null && message.hasOwnProperty("ids")) {
                        if (!Array.isArray(message.ids))
                            return "ids: array expected";
                        for (var i = 0; i < message.ids.length; ++i)
                            if (!$util.isString(message.ids[i]))
                                return "ids: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a StaticFileUrlsItem message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem} StaticFileUrlsItem
                 */
                StaticFileUrlsItem.fromObject = function fromObject(object) {
                    if (object instanceof $root.sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem)
                        return object;
                    var message = new $root.sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem();
                    if (object.urls != null) {
                        if (typeof object.urls !== "object")
                            throw TypeError(".sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem.urls: object expected");
                        message.urls = $root.file.Urls.fromObject(object.urls);
                    }
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.fileInfo != null) {
                        if (typeof object.fileInfo !== "object")
                            throw TypeError(".sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem.fileInfo: object expected");
                        message.fileInfo = $root.file.FileInfo.fromObject(object.fileInfo);
                    }
                    if (object.createTime != null)
                        if ($util.Long)
                            (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                        else if (typeof object.createTime === "string")
                            message.createTime = parseInt(object.createTime, 10);
                        else if (typeof object.createTime === "number")
                            message.createTime = object.createTime;
                        else if (typeof object.createTime === "object")
                            message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
                    if (object.lastUpdateTime != null)
                        if ($util.Long)
                            (message.lastUpdateTime = $util.Long.fromValue(object.lastUpdateTime)).unsigned = false;
                        else if (typeof object.lastUpdateTime === "string")
                            message.lastUpdateTime = parseInt(object.lastUpdateTime, 10);
                        else if (typeof object.lastUpdateTime === "number")
                            message.lastUpdateTime = object.lastUpdateTime;
                        else if (typeof object.lastUpdateTime === "object")
                            message.lastUpdateTime = new $util.LongBits(object.lastUpdateTime.low >>> 0, object.lastUpdateTime.high >>> 0).toNumber();
                    if (object.uploadUser != null) {
                        if (typeof object.uploadUser !== "object")
                            throw TypeError(".sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem.uploadUser: object expected");
                        message.uploadUser = $root.user.BaseUserInfo.fromObject(object.uploadUser);
                    }
                    if (object.ids) {
                        if (!Array.isArray(object.ids))
                            throw TypeError(".sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem.ids: array expected");
                        message.ids = [];
                        for (var i = 0; i < object.ids.length; ++i)
                            message.ids[i] = String(object.ids[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StaticFileUrlsItem message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @static
                 * @param {sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem} message StaticFileUrlsItem
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StaticFileUrlsItem.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.ids = [];
                    if (options.defaults) {
                        object.urls = null;
                        object.id = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTime = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.lastUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lastUpdateTime = options.longs === String ? "0" : 0;
                        object.uploadUser = null;
                        object.fileInfo = null;
                    }
                    if (message.urls != null && message.hasOwnProperty("urls"))
                        object.urls = $root.file.Urls.toObject(message.urls, options);
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.createTime != null && message.hasOwnProperty("createTime"))
                        if (typeof message.createTime === "number")
                            object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                        else
                            object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
                    if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                        if (typeof message.lastUpdateTime === "number")
                            object.lastUpdateTime = options.longs === String ? String(message.lastUpdateTime) : message.lastUpdateTime;
                        else
                            object.lastUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTime) : options.longs === Number ? new $util.LongBits(message.lastUpdateTime.low >>> 0, message.lastUpdateTime.high >>> 0).toNumber() : message.lastUpdateTime;
                    if (message.uploadUser != null && message.hasOwnProperty("uploadUser"))
                        object.uploadUser = $root.user.BaseUserInfo.toObject(message.uploadUser, options);
                    if (message.fileInfo != null && message.hasOwnProperty("fileInfo"))
                        object.fileInfo = $root.file.FileInfo.toObject(message.fileInfo, options);
                    if (message.ids && message.ids.length) {
                        object.ids = [];
                        for (var j = 0; j < message.ids.length; ++j)
                            object.ids[j] = message.ids[j];
                    }
                    return object;
                };

                /**
                 * Converts this StaticFileUrlsItem to JSON.
                 * @function toJSON
                 * @memberof sync.GetHistoricalVersionNoteUrls.Response.StaticFileUrlsItem
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StaticFileUrlsItem.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return StaticFileUrlsItem;
            })();

            return Response;
        })();

        return GetHistoricalVersionNoteUrls;
    })();

    sync.GetNote = (function() {

        /**
         * Properties of a GetNote.
         * @memberof sync
         * @interface IGetNote
         */

        /**
         * Constructs a new GetNote.
         * @memberof sync
         * @classdesc Represents a GetNote.
         * @implements IGetNote
         * @constructor
         * @param {sync.IGetNote=} [properties] Properties to set
         */
        function GetNote(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetNote instance using the specified properties.
         * @function create
         * @memberof sync.GetNote
         * @static
         * @param {sync.IGetNote=} [properties] Properties to set
         * @returns {sync.GetNote} GetNote instance
         */
        GetNote.create = function create(properties) {
            return new GetNote(properties);
        };

        /**
         * Encodes the specified GetNote message. Does not implicitly {@link sync.GetNote.verify|verify} messages.
         * @function encode
         * @memberof sync.GetNote
         * @static
         * @param {sync.IGetNote} message GetNote message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetNote.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetNote message, length delimited. Does not implicitly {@link sync.GetNote.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync.GetNote
         * @static
         * @param {sync.IGetNote} message GetNote message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetNote.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetNote message from the specified reader or buffer.
         * @function decode
         * @memberof sync.GetNote
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync.GetNote} GetNote
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetNote.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetNote();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetNote message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync.GetNote
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync.GetNote} GetNote
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetNote.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetNote message.
         * @function verify
         * @memberof sync.GetNote
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetNote.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetNote message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync.GetNote
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync.GetNote} GetNote
         */
        GetNote.fromObject = function fromObject(object) {
            if (object instanceof $root.sync.GetNote)
                return object;
            return new $root.sync.GetNote();
        };

        /**
         * Creates a plain object from a GetNote message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync.GetNote
         * @static
         * @param {sync.GetNote} message GetNote
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetNote.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetNote to JSON.
         * @function toJSON
         * @memberof sync.GetNote
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetNote.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetNote.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof sync.GetNote
             * @interface IRequest
             * @property {string|null} [id] Request id
             * @property {string|null} [type] Request type
             */

            /**
             * Constructs a new Request.
             * @memberof sync.GetNote
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {sync.GetNote.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request id.
             * @member {string} id
             * @memberof sync.GetNote.Request
             * @instance
             */
            Request.prototype.id = "";

            /**
             * Request type.
             * @member {string} type
             * @memberof sync.GetNote.Request
             * @instance
             */
            Request.prototype.type = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof sync.GetNote.Request
             * @static
             * @param {sync.GetNote.IRequest=} [properties] Properties to set
             * @returns {sync.GetNote.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link sync.GetNote.Request.verify|verify} messages.
             * @function encode
             * @memberof sync.GetNote.Request
             * @static
             * @param {sync.GetNote.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link sync.GetNote.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync.GetNote.Request
             * @static
             * @param {sync.GetNote.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof sync.GetNote.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync.GetNote.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetNote.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.string();
                        break;
                    case 2:
                        message.type = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync.GetNote.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync.GetNote.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof sync.GetNote.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync.GetNote.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync.GetNote.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.sync.GetNote.Request)
                    return object;
                var message = new $root.sync.GetNote.Request();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.type != null)
                    message.type = String(object.type);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync.GetNote.Request
             * @static
             * @param {sync.GetNote.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.type = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof sync.GetNote.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetNote.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof sync.GetNote
             * @interface IResponse
             * @property {note.INoteItem|null} [note] Response note
             */

            /**
             * Constructs a new Response.
             * @memberof sync.GetNote
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {sync.GetNote.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response note.
             * @member {note.INoteItem|null|undefined} note
             * @memberof sync.GetNote.Response
             * @instance
             */
            Response.prototype.note = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof sync.GetNote.Response
             * @static
             * @param {sync.GetNote.IResponse=} [properties] Properties to set
             * @returns {sync.GetNote.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link sync.GetNote.Response.verify|verify} messages.
             * @function encode
             * @memberof sync.GetNote.Response
             * @static
             * @param {sync.GetNote.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                    $root.note.NoteItem.encode(message.note, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link sync.GetNote.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync.GetNote.Response
             * @static
             * @param {sync.GetNote.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof sync.GetNote.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync.GetNote.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.GetNote.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.note = $root.note.NoteItem.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync.GetNote.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync.GetNote.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof sync.GetNote.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.note != null && message.hasOwnProperty("note")) {
                    var error = $root.note.NoteItem.verify(message.note);
                    if (error)
                        return "note." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync.GetNote.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync.GetNote.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.sync.GetNote.Response)
                    return object;
                var message = new $root.sync.GetNote.Response();
                if (object.note != null) {
                    if (typeof object.note !== "object")
                        throw TypeError(".sync.GetNote.Response.note: object expected");
                    message.note = $root.note.NoteItem.fromObject(object.note);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync.GetNote.Response
             * @static
             * @param {sync.GetNote.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.note = null;
                if (message.note != null && message.hasOwnProperty("note"))
                    object.note = $root.note.NoteItem.toObject(message.note, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof sync.GetNote.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetNote;
    })();

    sync.SyncData = (function() {

        /**
         * Properties of a SyncData.
         * @memberof sync
         * @interface ISyncData
         */

        /**
         * Constructs a new SyncData.
         * @memberof sync
         * @classdesc Represents a SyncData.
         * @implements ISyncData
         * @constructor
         * @param {sync.ISyncData=} [properties] Properties to set
         */
        function SyncData(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SyncData instance using the specified properties.
         * @function create
         * @memberof sync.SyncData
         * @static
         * @param {sync.ISyncData=} [properties] Properties to set
         * @returns {sync.SyncData} SyncData instance
         */
        SyncData.create = function create(properties) {
            return new SyncData(properties);
        };

        /**
         * Encodes the specified SyncData message. Does not implicitly {@link sync.SyncData.verify|verify} messages.
         * @function encode
         * @memberof sync.SyncData
         * @static
         * @param {sync.ISyncData} message SyncData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified SyncData message, length delimited. Does not implicitly {@link sync.SyncData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync.SyncData
         * @static
         * @param {sync.ISyncData} message SyncData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncData message from the specified reader or buffer.
         * @function decode
         * @memberof sync.SyncData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync.SyncData} SyncData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.SyncData();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync.SyncData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync.SyncData} SyncData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncData message.
         * @function verify
         * @memberof sync.SyncData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a SyncData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync.SyncData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync.SyncData} SyncData
         */
        SyncData.fromObject = function fromObject(object) {
            if (object instanceof $root.sync.SyncData)
                return object;
            return new $root.sync.SyncData();
        };

        /**
         * Creates a plain object from a SyncData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync.SyncData
         * @static
         * @param {sync.SyncData} message SyncData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncData.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SyncData to JSON.
         * @function toJSON
         * @memberof sync.SyncData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SyncData.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof sync.SyncData
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof sync.SyncData
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {sync.SyncData.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof sync.SyncData.Request
             * @static
             * @param {sync.SyncData.IRequest=} [properties] Properties to set
             * @returns {sync.SyncData.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link sync.SyncData.Request.verify|verify} messages.
             * @function encode
             * @memberof sync.SyncData.Request
             * @static
             * @param {sync.SyncData.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link sync.SyncData.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync.SyncData.Request
             * @static
             * @param {sync.SyncData.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof sync.SyncData.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync.SyncData.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.SyncData.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync.SyncData.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync.SyncData.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof sync.SyncData.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync.SyncData.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync.SyncData.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.sync.SyncData.Request)
                    return object;
                return new $root.sync.SyncData.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync.SyncData.Request
             * @static
             * @param {sync.SyncData.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof sync.SyncData.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        SyncData.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof sync.SyncData
             * @interface IResponse
             * @property {string|null} [type] Response type
             * @property {string|null} [methods] Response methods
             * @property {note.INoteOptions|null} [options] Response options
             * @property {Array.<string>|null} [changedField] Response changedField
             * @property {sync.SyncData.Response.IData|null} [data] Response data
             * @property {number|null} [lastUpdateTime] Response lastUpdateTime
             */

            /**
             * Constructs a new Response.
             * @memberof sync.SyncData
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {sync.SyncData.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.changedField = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response type.
             * @member {string} type
             * @memberof sync.SyncData.Response
             * @instance
             */
            Response.prototype.type = "";

            /**
             * Response methods.
             * @member {string} methods
             * @memberof sync.SyncData.Response
             * @instance
             */
            Response.prototype.methods = "";

            /**
             * Response options.
             * @member {note.INoteOptions|null|undefined} options
             * @memberof sync.SyncData.Response
             * @instance
             */
            Response.prototype.options = null;

            /**
             * Response changedField.
             * @member {Array.<string>} changedField
             * @memberof sync.SyncData.Response
             * @instance
             */
            Response.prototype.changedField = $util.emptyArray;

            /**
             * Response data.
             * @member {sync.SyncData.Response.IData|null|undefined} data
             * @memberof sync.SyncData.Response
             * @instance
             */
            Response.prototype.data = null;

            /**
             * Response lastUpdateTime.
             * @member {number} lastUpdateTime
             * @memberof sync.SyncData.Response
             * @instance
             */
            Response.prototype.lastUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof sync.SyncData.Response
             * @static
             * @param {sync.SyncData.IResponse=} [properties] Properties to set
             * @returns {sync.SyncData.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link sync.SyncData.Response.verify|verify} messages.
             * @function encode
             * @memberof sync.SyncData.Response
             * @static
             * @param {sync.SyncData.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                if (message.methods != null && Object.hasOwnProperty.call(message, "methods"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.methods);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.note.NoteOptions.encode(message.options, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    $root.sync.SyncData.Response.Data.encode(message.data, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int64(message.lastUpdateTime);
                if (message.changedField != null && message.changedField.length)
                    for (var i = 0; i < message.changedField.length; ++i)
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.changedField[i]);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link sync.SyncData.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync.SyncData.Response
             * @static
             * @param {sync.SyncData.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof sync.SyncData.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync.SyncData.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.SyncData.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.string();
                        break;
                    case 2:
                        message.methods = reader.string();
                        break;
                    case 3:
                        message.options = $root.note.NoteOptions.decode(reader, reader.uint32());
                        break;
                    case 6:
                        if (!(message.changedField && message.changedField.length))
                            message.changedField = [];
                        message.changedField.push(reader.string());
                        break;
                    case 4:
                        message.data = $root.sync.SyncData.Response.Data.decode(reader, reader.uint32());
                        break;
                    case 5:
                        message.lastUpdateTime = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync.SyncData.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync.SyncData.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof sync.SyncData.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.methods != null && message.hasOwnProperty("methods"))
                    if (!$util.isString(message.methods))
                        return "methods: string expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.note.NoteOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                if (message.changedField != null && message.hasOwnProperty("changedField")) {
                    if (!Array.isArray(message.changedField))
                        return "changedField: array expected";
                    for (var i = 0; i < message.changedField.length; ++i)
                        if (!$util.isString(message.changedField[i]))
                            return "changedField: string[] expected";
                }
                if (message.data != null && message.hasOwnProperty("data")) {
                    var error = $root.sync.SyncData.Response.Data.verify(message.data);
                    if (error)
                        return "data." + error;
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    if (!$util.isInteger(message.lastUpdateTime) && !(message.lastUpdateTime && $util.isInteger(message.lastUpdateTime.low) && $util.isInteger(message.lastUpdateTime.high)))
                        return "lastUpdateTime: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync.SyncData.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync.SyncData.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.sync.SyncData.Response)
                    return object;
                var message = new $root.sync.SyncData.Response();
                if (object.type != null)
                    message.type = String(object.type);
                if (object.methods != null)
                    message.methods = String(object.methods);
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".sync.SyncData.Response.options: object expected");
                    message.options = $root.note.NoteOptions.fromObject(object.options);
                }
                if (object.changedField) {
                    if (!Array.isArray(object.changedField))
                        throw TypeError(".sync.SyncData.Response.changedField: array expected");
                    message.changedField = [];
                    for (var i = 0; i < object.changedField.length; ++i)
                        message.changedField[i] = String(object.changedField[i]);
                }
                if (object.data != null) {
                    if (typeof object.data !== "object")
                        throw TypeError(".sync.SyncData.Response.data: object expected");
                    message.data = $root.sync.SyncData.Response.Data.fromObject(object.data);
                }
                if (object.lastUpdateTime != null)
                    if ($util.Long)
                        (message.lastUpdateTime = $util.Long.fromValue(object.lastUpdateTime)).unsigned = false;
                    else if (typeof object.lastUpdateTime === "string")
                        message.lastUpdateTime = parseInt(object.lastUpdateTime, 10);
                    else if (typeof object.lastUpdateTime === "number")
                        message.lastUpdateTime = object.lastUpdateTime;
                    else if (typeof object.lastUpdateTime === "object")
                        message.lastUpdateTime = new $util.LongBits(object.lastUpdateTime.low >>> 0, object.lastUpdateTime.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync.SyncData.Response
             * @static
             * @param {sync.SyncData.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.changedField = [];
                if (options.defaults) {
                    object.type = "";
                    object.methods = "";
                    object.options = null;
                    object.data = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.lastUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.lastUpdateTime = options.longs === String ? "0" : 0;
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.methods != null && message.hasOwnProperty("methods"))
                    object.methods = message.methods;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.note.NoteOptions.toObject(message.options, options);
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = $root.sync.SyncData.Response.Data.toObject(message.data, options);
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    if (typeof message.lastUpdateTime === "number")
                        object.lastUpdateTime = options.longs === String ? String(message.lastUpdateTime) : message.lastUpdateTime;
                    else
                        object.lastUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTime) : options.longs === Number ? new $util.LongBits(message.lastUpdateTime.low >>> 0, message.lastUpdateTime.high >>> 0).toNumber() : message.lastUpdateTime;
                if (message.changedField && message.changedField.length) {
                    object.changedField = [];
                    for (var j = 0; j < message.changedField.length; ++j)
                        object.changedField[j] = message.changedField[j];
                }
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof sync.SyncData.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            Response.Data = (function() {

                /**
                 * Properties of a Data.
                 * @memberof sync.SyncData.Response
                 * @interface IData
                 * @property {note.INoteItem|null} [note] Data note
                 * @property {note.ICategoryItem|null} [category] Data category
                 * @property {note.IPageItem|null} [page] Data page
                 * @property {note.ITodoListPageItem|null} [todo] Data todo
                 * @property {note.ISortItem|null} [sort] Data sort
                 */

                /**
                 * Constructs a new Data.
                 * @memberof sync.SyncData.Response
                 * @classdesc Represents a Data.
                 * @implements IData
                 * @constructor
                 * @param {sync.SyncData.Response.IData=} [properties] Properties to set
                 */
                function Data(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Data note.
                 * @member {note.INoteItem|null|undefined} note
                 * @memberof sync.SyncData.Response.Data
                 * @instance
                 */
                Data.prototype.note = null;

                /**
                 * Data category.
                 * @member {note.ICategoryItem|null|undefined} category
                 * @memberof sync.SyncData.Response.Data
                 * @instance
                 */
                Data.prototype.category = null;

                /**
                 * Data page.
                 * @member {note.IPageItem|null|undefined} page
                 * @memberof sync.SyncData.Response.Data
                 * @instance
                 */
                Data.prototype.page = null;

                /**
                 * Data todo.
                 * @member {note.ITodoListPageItem|null|undefined} todo
                 * @memberof sync.SyncData.Response.Data
                 * @instance
                 */
                Data.prototype.todo = null;

                /**
                 * Data sort.
                 * @member {note.ISortItem|null|undefined} sort
                 * @memberof sync.SyncData.Response.Data
                 * @instance
                 */
                Data.prototype.sort = null;

                /**
                 * Creates a new Data instance using the specified properties.
                 * @function create
                 * @memberof sync.SyncData.Response.Data
                 * @static
                 * @param {sync.SyncData.Response.IData=} [properties] Properties to set
                 * @returns {sync.SyncData.Response.Data} Data instance
                 */
                Data.create = function create(properties) {
                    return new Data(properties);
                };

                /**
                 * Encodes the specified Data message. Does not implicitly {@link sync.SyncData.Response.Data.verify|verify} messages.
                 * @function encode
                 * @memberof sync.SyncData.Response.Data
                 * @static
                 * @param {sync.SyncData.Response.IData} message Data message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Data.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                        $root.note.NoteItem.encode(message.note, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        $root.note.CategoryItem.encode(message.category, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.page != null && Object.hasOwnProperty.call(message, "page"))
                        $root.note.PageItem.encode(message.page, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.todo != null && Object.hasOwnProperty.call(message, "todo"))
                        $root.note.TodoListPageItem.encode(message.todo, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.sort != null && Object.hasOwnProperty.call(message, "sort"))
                        $root.note.SortItem.encode(message.sort, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Data message, length delimited. Does not implicitly {@link sync.SyncData.Response.Data.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof sync.SyncData.Response.Data
                 * @static
                 * @param {sync.SyncData.Response.IData} message Data message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Data.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Data message from the specified reader or buffer.
                 * @function decode
                 * @memberof sync.SyncData.Response.Data
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {sync.SyncData.Response.Data} Data
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Data.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.SyncData.Response.Data();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.note = $root.note.NoteItem.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.category = $root.note.CategoryItem.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.page = $root.note.PageItem.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.todo = $root.note.TodoListPageItem.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.sort = $root.note.SortItem.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Data message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof sync.SyncData.Response.Data
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {sync.SyncData.Response.Data} Data
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Data.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Data message.
                 * @function verify
                 * @memberof sync.SyncData.Response.Data
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Data.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.note != null && message.hasOwnProperty("note")) {
                        var error = $root.note.NoteItem.verify(message.note);
                        if (error)
                            return "note." + error;
                    }
                    if (message.category != null && message.hasOwnProperty("category")) {
                        var error = $root.note.CategoryItem.verify(message.category);
                        if (error)
                            return "category." + error;
                    }
                    if (message.page != null && message.hasOwnProperty("page")) {
                        var error = $root.note.PageItem.verify(message.page);
                        if (error)
                            return "page." + error;
                    }
                    if (message.todo != null && message.hasOwnProperty("todo")) {
                        var error = $root.note.TodoListPageItem.verify(message.todo);
                        if (error)
                            return "todo." + error;
                    }
                    if (message.sort != null && message.hasOwnProperty("sort")) {
                        var error = $root.note.SortItem.verify(message.sort);
                        if (error)
                            return "sort." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Data message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof sync.SyncData.Response.Data
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {sync.SyncData.Response.Data} Data
                 */
                Data.fromObject = function fromObject(object) {
                    if (object instanceof $root.sync.SyncData.Response.Data)
                        return object;
                    var message = new $root.sync.SyncData.Response.Data();
                    if (object.note != null) {
                        if (typeof object.note !== "object")
                            throw TypeError(".sync.SyncData.Response.Data.note: object expected");
                        message.note = $root.note.NoteItem.fromObject(object.note);
                    }
                    if (object.category != null) {
                        if (typeof object.category !== "object")
                            throw TypeError(".sync.SyncData.Response.Data.category: object expected");
                        message.category = $root.note.CategoryItem.fromObject(object.category);
                    }
                    if (object.page != null) {
                        if (typeof object.page !== "object")
                            throw TypeError(".sync.SyncData.Response.Data.page: object expected");
                        message.page = $root.note.PageItem.fromObject(object.page);
                    }
                    if (object.todo != null) {
                        if (typeof object.todo !== "object")
                            throw TypeError(".sync.SyncData.Response.Data.todo: object expected");
                        message.todo = $root.note.TodoListPageItem.fromObject(object.todo);
                    }
                    if (object.sort != null) {
                        if (typeof object.sort !== "object")
                            throw TypeError(".sync.SyncData.Response.Data.sort: object expected");
                        message.sort = $root.note.SortItem.fromObject(object.sort);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Data message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof sync.SyncData.Response.Data
                 * @static
                 * @param {sync.SyncData.Response.Data} message Data
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Data.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.note = null;
                        object.category = null;
                        object.page = null;
                        object.todo = null;
                        object.sort = null;
                    }
                    if (message.note != null && message.hasOwnProperty("note"))
                        object.note = $root.note.NoteItem.toObject(message.note, options);
                    if (message.category != null && message.hasOwnProperty("category"))
                        object.category = $root.note.CategoryItem.toObject(message.category, options);
                    if (message.page != null && message.hasOwnProperty("page"))
                        object.page = $root.note.PageItem.toObject(message.page, options);
                    if (message.todo != null && message.hasOwnProperty("todo"))
                        object.todo = $root.note.TodoListPageItem.toObject(message.todo, options);
                    if (message.sort != null && message.hasOwnProperty("sort"))
                        object.sort = $root.note.SortItem.toObject(message.sort, options);
                    return object;
                };

                /**
                 * Converts this Data to JSON.
                 * @function toJSON
                 * @memberof sync.SyncData.Response.Data
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Data.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Data;
            })();

            return Response;
        })();

        return SyncData;
    })();

    sync.SyncToServer = (function() {

        /**
         * Properties of a SyncToServer.
         * @memberof sync
         * @interface ISyncToServer
         */

        /**
         * Constructs a new SyncToServer.
         * @memberof sync
         * @classdesc Represents a SyncToServer.
         * @implements ISyncToServer
         * @constructor
         * @param {sync.ISyncToServer=} [properties] Properties to set
         */
        function SyncToServer(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SyncToServer instance using the specified properties.
         * @function create
         * @memberof sync.SyncToServer
         * @static
         * @param {sync.ISyncToServer=} [properties] Properties to set
         * @returns {sync.SyncToServer} SyncToServer instance
         */
        SyncToServer.create = function create(properties) {
            return new SyncToServer(properties);
        };

        /**
         * Encodes the specified SyncToServer message. Does not implicitly {@link sync.SyncToServer.verify|verify} messages.
         * @function encode
         * @memberof sync.SyncToServer
         * @static
         * @param {sync.ISyncToServer} message SyncToServer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncToServer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified SyncToServer message, length delimited. Does not implicitly {@link sync.SyncToServer.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync.SyncToServer
         * @static
         * @param {sync.ISyncToServer} message SyncToServer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncToServer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncToServer message from the specified reader or buffer.
         * @function decode
         * @memberof sync.SyncToServer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync.SyncToServer} SyncToServer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncToServer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.SyncToServer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncToServer message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync.SyncToServer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync.SyncToServer} SyncToServer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncToServer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncToServer message.
         * @function verify
         * @memberof sync.SyncToServer
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncToServer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a SyncToServer message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync.SyncToServer
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync.SyncToServer} SyncToServer
         */
        SyncToServer.fromObject = function fromObject(object) {
            if (object instanceof $root.sync.SyncToServer)
                return object;
            return new $root.sync.SyncToServer();
        };

        /**
         * Creates a plain object from a SyncToServer message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync.SyncToServer
         * @static
         * @param {sync.SyncToServer} message SyncToServer
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncToServer.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SyncToServer to JSON.
         * @function toJSON
         * @memberof sync.SyncToServer
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncToServer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SyncToServer.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof sync.SyncToServer
             * @interface IRequest
             * @property {string|null} [type] Request type
             * @property {string|null} [methods] Request methods
             * @property {note.INoteOptions|null} [options] Request options
             * @property {Array.<string>|null} [changedField] Request changedField
             * @property {sync.SyncToServer.Request.IData|null} [data] Request data
             */

            /**
             * Constructs a new Request.
             * @memberof sync.SyncToServer
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {sync.SyncToServer.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.changedField = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request type.
             * @member {string} type
             * @memberof sync.SyncToServer.Request
             * @instance
             */
            Request.prototype.type = "";

            /**
             * Request methods.
             * @member {string} methods
             * @memberof sync.SyncToServer.Request
             * @instance
             */
            Request.prototype.methods = "";

            /**
             * Request options.
             * @member {note.INoteOptions|null|undefined} options
             * @memberof sync.SyncToServer.Request
             * @instance
             */
            Request.prototype.options = null;

            /**
             * Request changedField.
             * @member {Array.<string>} changedField
             * @memberof sync.SyncToServer.Request
             * @instance
             */
            Request.prototype.changedField = $util.emptyArray;

            /**
             * Request data.
             * @member {sync.SyncToServer.Request.IData|null|undefined} data
             * @memberof sync.SyncToServer.Request
             * @instance
             */
            Request.prototype.data = null;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof sync.SyncToServer.Request
             * @static
             * @param {sync.SyncToServer.IRequest=} [properties] Properties to set
             * @returns {sync.SyncToServer.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link sync.SyncToServer.Request.verify|verify} messages.
             * @function encode
             * @memberof sync.SyncToServer.Request
             * @static
             * @param {sync.SyncToServer.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                if (message.methods != null && Object.hasOwnProperty.call(message, "methods"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.methods);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.note.NoteOptions.encode(message.options, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    $root.sync.SyncToServer.Request.Data.encode(message.data, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.changedField != null && message.changedField.length)
                    for (var i = 0; i < message.changedField.length; ++i)
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.changedField[i]);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link sync.SyncToServer.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync.SyncToServer.Request
             * @static
             * @param {sync.SyncToServer.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof sync.SyncToServer.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync.SyncToServer.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.SyncToServer.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.string();
                        break;
                    case 2:
                        message.methods = reader.string();
                        break;
                    case 3:
                        message.options = $root.note.NoteOptions.decode(reader, reader.uint32());
                        break;
                    case 6:
                        if (!(message.changedField && message.changedField.length))
                            message.changedField = [];
                        message.changedField.push(reader.string());
                        break;
                    case 4:
                        message.data = $root.sync.SyncToServer.Request.Data.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync.SyncToServer.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync.SyncToServer.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof sync.SyncToServer.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.methods != null && message.hasOwnProperty("methods"))
                    if (!$util.isString(message.methods))
                        return "methods: string expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.note.NoteOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                if (message.changedField != null && message.hasOwnProperty("changedField")) {
                    if (!Array.isArray(message.changedField))
                        return "changedField: array expected";
                    for (var i = 0; i < message.changedField.length; ++i)
                        if (!$util.isString(message.changedField[i]))
                            return "changedField: string[] expected";
                }
                if (message.data != null && message.hasOwnProperty("data")) {
                    var error = $root.sync.SyncToServer.Request.Data.verify(message.data);
                    if (error)
                        return "data." + error;
                }
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync.SyncToServer.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync.SyncToServer.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.sync.SyncToServer.Request)
                    return object;
                var message = new $root.sync.SyncToServer.Request();
                if (object.type != null)
                    message.type = String(object.type);
                if (object.methods != null)
                    message.methods = String(object.methods);
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".sync.SyncToServer.Request.options: object expected");
                    message.options = $root.note.NoteOptions.fromObject(object.options);
                }
                if (object.changedField) {
                    if (!Array.isArray(object.changedField))
                        throw TypeError(".sync.SyncToServer.Request.changedField: array expected");
                    message.changedField = [];
                    for (var i = 0; i < object.changedField.length; ++i)
                        message.changedField[i] = String(object.changedField[i]);
                }
                if (object.data != null) {
                    if (typeof object.data !== "object")
                        throw TypeError(".sync.SyncToServer.Request.data: object expected");
                    message.data = $root.sync.SyncToServer.Request.Data.fromObject(object.data);
                }
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync.SyncToServer.Request
             * @static
             * @param {sync.SyncToServer.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.changedField = [];
                if (options.defaults) {
                    object.type = "";
                    object.methods = "";
                    object.options = null;
                    object.data = null;
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.methods != null && message.hasOwnProperty("methods"))
                    object.methods = message.methods;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.note.NoteOptions.toObject(message.options, options);
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = $root.sync.SyncToServer.Request.Data.toObject(message.data, options);
                if (message.changedField && message.changedField.length) {
                    object.changedField = [];
                    for (var j = 0; j < message.changedField.length; ++j)
                        object.changedField[j] = message.changedField[j];
                }
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof sync.SyncToServer.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            Request.Data = (function() {

                /**
                 * Properties of a Data.
                 * @memberof sync.SyncToServer.Request
                 * @interface IData
                 * @property {note.INoteItem|null} [note] Data note
                 * @property {note.ICategoryItem|null} [category] Data category
                 * @property {note.IPageItem|null} [page] Data page
                 * @property {note.ITodoListPageItem|null} [todo] Data todo
                 * @property {note.ISortItem|null} [sort] Data sort
                 */

                /**
                 * Constructs a new Data.
                 * @memberof sync.SyncToServer.Request
                 * @classdesc Represents a Data.
                 * @implements IData
                 * @constructor
                 * @param {sync.SyncToServer.Request.IData=} [properties] Properties to set
                 */
                function Data(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Data note.
                 * @member {note.INoteItem|null|undefined} note
                 * @memberof sync.SyncToServer.Request.Data
                 * @instance
                 */
                Data.prototype.note = null;

                /**
                 * Data category.
                 * @member {note.ICategoryItem|null|undefined} category
                 * @memberof sync.SyncToServer.Request.Data
                 * @instance
                 */
                Data.prototype.category = null;

                /**
                 * Data page.
                 * @member {note.IPageItem|null|undefined} page
                 * @memberof sync.SyncToServer.Request.Data
                 * @instance
                 */
                Data.prototype.page = null;

                /**
                 * Data todo.
                 * @member {note.ITodoListPageItem|null|undefined} todo
                 * @memberof sync.SyncToServer.Request.Data
                 * @instance
                 */
                Data.prototype.todo = null;

                /**
                 * Data sort.
                 * @member {note.ISortItem|null|undefined} sort
                 * @memberof sync.SyncToServer.Request.Data
                 * @instance
                 */
                Data.prototype.sort = null;

                /**
                 * Creates a new Data instance using the specified properties.
                 * @function create
                 * @memberof sync.SyncToServer.Request.Data
                 * @static
                 * @param {sync.SyncToServer.Request.IData=} [properties] Properties to set
                 * @returns {sync.SyncToServer.Request.Data} Data instance
                 */
                Data.create = function create(properties) {
                    return new Data(properties);
                };

                /**
                 * Encodes the specified Data message. Does not implicitly {@link sync.SyncToServer.Request.Data.verify|verify} messages.
                 * @function encode
                 * @memberof sync.SyncToServer.Request.Data
                 * @static
                 * @param {sync.SyncToServer.Request.IData} message Data message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Data.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                        $root.note.NoteItem.encode(message.note, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        $root.note.CategoryItem.encode(message.category, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.page != null && Object.hasOwnProperty.call(message, "page"))
                        $root.note.PageItem.encode(message.page, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.todo != null && Object.hasOwnProperty.call(message, "todo"))
                        $root.note.TodoListPageItem.encode(message.todo, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.sort != null && Object.hasOwnProperty.call(message, "sort"))
                        $root.note.SortItem.encode(message.sort, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Data message, length delimited. Does not implicitly {@link sync.SyncToServer.Request.Data.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof sync.SyncToServer.Request.Data
                 * @static
                 * @param {sync.SyncToServer.Request.IData} message Data message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Data.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Data message from the specified reader or buffer.
                 * @function decode
                 * @memberof sync.SyncToServer.Request.Data
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {sync.SyncToServer.Request.Data} Data
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Data.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.SyncToServer.Request.Data();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.note = $root.note.NoteItem.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.category = $root.note.CategoryItem.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.page = $root.note.PageItem.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.todo = $root.note.TodoListPageItem.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.sort = $root.note.SortItem.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Data message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof sync.SyncToServer.Request.Data
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {sync.SyncToServer.Request.Data} Data
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Data.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Data message.
                 * @function verify
                 * @memberof sync.SyncToServer.Request.Data
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Data.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.note != null && message.hasOwnProperty("note")) {
                        var error = $root.note.NoteItem.verify(message.note);
                        if (error)
                            return "note." + error;
                    }
                    if (message.category != null && message.hasOwnProperty("category")) {
                        var error = $root.note.CategoryItem.verify(message.category);
                        if (error)
                            return "category." + error;
                    }
                    if (message.page != null && message.hasOwnProperty("page")) {
                        var error = $root.note.PageItem.verify(message.page);
                        if (error)
                            return "page." + error;
                    }
                    if (message.todo != null && message.hasOwnProperty("todo")) {
                        var error = $root.note.TodoListPageItem.verify(message.todo);
                        if (error)
                            return "todo." + error;
                    }
                    if (message.sort != null && message.hasOwnProperty("sort")) {
                        var error = $root.note.SortItem.verify(message.sort);
                        if (error)
                            return "sort." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Data message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof sync.SyncToServer.Request.Data
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {sync.SyncToServer.Request.Data} Data
                 */
                Data.fromObject = function fromObject(object) {
                    if (object instanceof $root.sync.SyncToServer.Request.Data)
                        return object;
                    var message = new $root.sync.SyncToServer.Request.Data();
                    if (object.note != null) {
                        if (typeof object.note !== "object")
                            throw TypeError(".sync.SyncToServer.Request.Data.note: object expected");
                        message.note = $root.note.NoteItem.fromObject(object.note);
                    }
                    if (object.category != null) {
                        if (typeof object.category !== "object")
                            throw TypeError(".sync.SyncToServer.Request.Data.category: object expected");
                        message.category = $root.note.CategoryItem.fromObject(object.category);
                    }
                    if (object.page != null) {
                        if (typeof object.page !== "object")
                            throw TypeError(".sync.SyncToServer.Request.Data.page: object expected");
                        message.page = $root.note.PageItem.fromObject(object.page);
                    }
                    if (object.todo != null) {
                        if (typeof object.todo !== "object")
                            throw TypeError(".sync.SyncToServer.Request.Data.todo: object expected");
                        message.todo = $root.note.TodoListPageItem.fromObject(object.todo);
                    }
                    if (object.sort != null) {
                        if (typeof object.sort !== "object")
                            throw TypeError(".sync.SyncToServer.Request.Data.sort: object expected");
                        message.sort = $root.note.SortItem.fromObject(object.sort);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Data message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof sync.SyncToServer.Request.Data
                 * @static
                 * @param {sync.SyncToServer.Request.Data} message Data
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Data.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.note = null;
                        object.category = null;
                        object.page = null;
                        object.todo = null;
                        object.sort = null;
                    }
                    if (message.note != null && message.hasOwnProperty("note"))
                        object.note = $root.note.NoteItem.toObject(message.note, options);
                    if (message.category != null && message.hasOwnProperty("category"))
                        object.category = $root.note.CategoryItem.toObject(message.category, options);
                    if (message.page != null && message.hasOwnProperty("page"))
                        object.page = $root.note.PageItem.toObject(message.page, options);
                    if (message.todo != null && message.hasOwnProperty("todo"))
                        object.todo = $root.note.TodoListPageItem.toObject(message.todo, options);
                    if (message.sort != null && message.hasOwnProperty("sort"))
                        object.sort = $root.note.SortItem.toObject(message.sort, options);
                    return object;
                };

                /**
                 * Converts this Data to JSON.
                 * @function toJSON
                 * @memberof sync.SyncToServer.Request.Data
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Data.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Data;
            })();

            return Request;
        })();

        SyncToServer.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof sync.SyncToServer
             * @interface IResponse
             * @property {number|null} [lastUpdateTime] Response lastUpdateTime
             */

            /**
             * Constructs a new Response.
             * @memberof sync.SyncToServer
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {sync.SyncToServer.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response lastUpdateTime.
             * @member {number} lastUpdateTime
             * @memberof sync.SyncToServer.Response
             * @instance
             */
            Response.prototype.lastUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof sync.SyncToServer.Response
             * @static
             * @param {sync.SyncToServer.IResponse=} [properties] Properties to set
             * @returns {sync.SyncToServer.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link sync.SyncToServer.Response.verify|verify} messages.
             * @function encode
             * @memberof sync.SyncToServer.Response
             * @static
             * @param {sync.SyncToServer.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.lastUpdateTime);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link sync.SyncToServer.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync.SyncToServer.Response
             * @static
             * @param {sync.SyncToServer.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof sync.SyncToServer.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync.SyncToServer.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync.SyncToServer.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.lastUpdateTime = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync.SyncToServer.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync.SyncToServer.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof sync.SyncToServer.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    if (!$util.isInteger(message.lastUpdateTime) && !(message.lastUpdateTime && $util.isInteger(message.lastUpdateTime.low) && $util.isInteger(message.lastUpdateTime.high)))
                        return "lastUpdateTime: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync.SyncToServer.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync.SyncToServer.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.sync.SyncToServer.Response)
                    return object;
                var message = new $root.sync.SyncToServer.Response();
                if (object.lastUpdateTime != null)
                    if ($util.Long)
                        (message.lastUpdateTime = $util.Long.fromValue(object.lastUpdateTime)).unsigned = false;
                    else if (typeof object.lastUpdateTime === "string")
                        message.lastUpdateTime = parseInt(object.lastUpdateTime, 10);
                    else if (typeof object.lastUpdateTime === "number")
                        message.lastUpdateTime = object.lastUpdateTime;
                    else if (typeof object.lastUpdateTime === "object")
                        message.lastUpdateTime = new $util.LongBits(object.lastUpdateTime.low >>> 0, object.lastUpdateTime.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync.SyncToServer.Response
             * @static
             * @param {sync.SyncToServer.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.lastUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.lastUpdateTime = options.longs === String ? "0" : 0;
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    if (typeof message.lastUpdateTime === "number")
                        object.lastUpdateTime = options.longs === String ? String(message.lastUpdateTime) : message.lastUpdateTime;
                    else
                        object.lastUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTime) : options.longs === Number ? new $util.LongBits(message.lastUpdateTime.low >>> 0, message.lastUpdateTime.high >>> 0).toNumber() : message.lastUpdateTime;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof sync.SyncToServer.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return SyncToServer;
    })();

    return sync;
})();

module.exports = $root;
